webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/xIzIzp/%3F1737194764094&title=The%20Epistle%20to%20the%20Romans%2C%20Eerdmans%20Classic%20Biblical%20Commentaries%20%28ECBC%29&summary=In%20this%20now-classic%20commentary%2C%20first%20published%20in%201988%20in%20the%20Pillar%20New%20Testament%20Commentary%20series%2C%20noted%20biblical%20scholar%20Leon%20Morris%20unravels%20Romans%20and%20the%20complexities%20of%20faith%20and%20interpretation%20associated%20with%20the%20epistle.In%20his%20introdu&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/xIzIzp/%3F1737194764094",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=In%20this%20now-classic%20commentary%2C%20first%20published%20in%201988%20in%20the%20Pillar%20New%20Testament%20Commentary%20series%2C%20noted%20biblical%20scholar%20Leon%20Morris%20unr%0Dhttps://textcafe.co/books/xIzIzp/%3F1737194764094&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/xIzIzp/%3F1737194764094&posttype=link&caption=In%20this%20now-classic%20commentary%2C%20first%20published%20in%201988%20in%20the%20Pillar%20New%20Testament%20Commentary%20series%2C%20noted%20biblical%20scholar%20Leon%20Morris%20unravels%20Romans%20and%20the%20complexities%20of%20faith%20and%20interpretation%20associated%20with%20the%20epistle.In%20his%20introdu",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/xIzIzp/%3F1737194764094&description=In%20this%20now-classic%20commentary%2C%20first%20published%20in%201988%20in%20the%20Pillar%20New%20Testament%20Commentary%20series%2C%20noted%20biblical%20scholar%20Leon%20Morris%20unravels%20Romans%20and%20the%20complexities%20of%20faith%20and%20interpretation%20associated%20with%20the%20epistle.In%20his%20introdu&media=https://textcafe.co/books/xIzIzp/tc-custom/9781467451444.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/0802875947?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=-cqAEAAAQBAJ&amp;rdid=book--cqAEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467451444').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/xIzIzp/tc-custom/9781467451444.jpg?1737194764094',
        alt: 'The Epistle to the Romans, Eerdmans Classic Biblical Commentaries (ECBC)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "005_Contents", "006_Preface", "007_ChiefAbbreviations", "008_Halftitle", "009_Introduction", "010_Analysis", "011_Chapter01", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/xIzIzp/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_FM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Titlepage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_Titlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_Titlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_ChiefAbbreviations__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_ChiefAbbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_ChiefAbbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Halftitle__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Introduction__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_009_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Analysis__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Analysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_010_Analysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter01__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_011_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter02__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_012_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_012_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Chapter03__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_013_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_013_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter04__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_014_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_014_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter05__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_015_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_015_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_016_Chapter06__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_016_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_016_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_017_Chapter07__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_017_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_017_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_018_Chapter08__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_018_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_018_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_019_Chapter09__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_019_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_019_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_020_Chapter10__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_020_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_020_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_021_Chapter11__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_021_Chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_021_Chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_022_Chapter12__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_022_Chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_022_Chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_023_Chapter13__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_023_Chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_023_Chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_024_Chapter14__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_024_Chapter14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_024_Chapter14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_025_Chapter15__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_025_Chapter15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_025_Chapter15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_026_Chapter16__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_026_Chapter16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_026_Chapter16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_last__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_last__);
/*jshint esversion: 6 */


































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/005_Contents",
    "name": "005_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default.a
  }, {
    "path": "/006_Preface",
    "name": "006_Preface",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default.a
  }, {
    "path": "/007_ChiefAbbreviations",
    "name": "007_ChiefAbbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_ChiefAbbreviations___default.a
  }, {
    "path": "/008_Halftitle",
    "name": "008_Halftitle",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Halftitle___default.a
  }, {
    "path": "/009_Introduction",
    "name": "009_Introduction",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_009_Introduction___default.a
  }, {
    "path": "/010_Analysis",
    "name": "010_Analysis",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_010_Analysis___default.a
  }, {
    "path": "/011_Chapter01",
    "name": "011_Chapter01",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_011_Chapter01___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_31__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Leon Morris\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Leon Morris")]), _vm._v(" (1914-2006) was one of Australia's most prolific Bible scholars. He wrote over forty other books, including commentaries on Matthew, John, and Thessalonians.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xIzIzp/tc-custom/9781467451444.jpg?1737194764094",
      "alt": "This image is the cover for the book The Epistle to the Romans, Eerdmans Classic Biblical Commentaries (ECBC)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Epistle to the Romans, Eerdmans Classic Biblical Commentaries (ECBC)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this now-classic commentary, first published in 1988 in the Pillar New Testament Commentary series, noted biblical scholar Leon Morris unravels Romans and the complexities of faith and interpretation associated with the epistle.")]), _c('p', [_vm._v("In his introduction Morris deals with matters of authorship, destination, date, occasion, and contents in a brief but helpful way. The commentary proper consists of careful verse-by-verse exposition of the text along with full and informative footnotes. Though he interacts considerably with the immense body of literature on Romans, Morris’s approach to the study of the epistle remains clearly his own. His thorough exegesis enables readers to understand Romans as one of the greatest and most spiritually significant books in the Bible.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_ChiefAbbreviations#fm-2"
    }
  }, [_c('em', [_vm._v("Chief Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#fm-3"
    }
  }, [_c('strong', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-1"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTHORSHIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-2"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTINATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-3"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATE AND")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LACE OF")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RITING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-4"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CCASION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-5"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-6"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HORTER")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DITION(S)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#sec-7"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTINATION OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER")]), _vm._v(" 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Analysis#fm-4"
    }
  }, [_c('strong', [_vm._v("ANALYSIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_c('strong', [_vm._v("TEXT, EXPOSITION, AND NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secn"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-8"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDITIONAL")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE")]), _vm._v(" A: THE RIGHTEOUSNESS OF GOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secn"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-9"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDITIONAL")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE")]), _vm._v(" B: TRUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secn"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDITIONAL")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE")]), _vm._v(" C: THE LAW IN ROMANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secn"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDITIONAL")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE")]), _vm._v(" D: JUSTIFICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secn"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDITIONAL")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE")]), _vm._v(" E: JUDGMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secn"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDITIONAL")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE")]), _vm._v(" F: SIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" 16")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout the years I have frequently been occupied with Romans. I have worked with it extensively while writing books on theology (especially on the cross). I have lectured on it many times, and am indebted to students in Britain, Canada, the United States, and Australia for their interaction. But prior to this I have never written at length on Romans. Now in my retirement I have finally had the opportunity to devote time to a commentary on this great epistle. I offer it as my tribute to an apostle to whom I owe so much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I have included the text of the New International Version as an aid to the reader. Occasionally I have made my own translation (without specifically drawing attention to it) in order to bring out some feature of the original. But the commentary is based on the Greek text, not the translation. It has been my aim to make clear to the general reader what I see in the Greek text, and it is my hope that this will be of some help to others who are grappling with the thought of this great epistle.")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("LEON MORRIS")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('em', [_vm._v("Chief Abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ABR")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Australian Biblical Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Achtemeier")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paul J. Achtemeier: "), _c('em', [_vm._v("Romans")]), _vm._v(" (Atlanta, 1985)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Alford")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Henry Alford: "), _c('em', [_vm._v("The Greek Testament"), _c('sup', [_vm._v("7")])]), _vm._v(" (London, 1874)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Althaus")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paul Althaus: "), _c('em', [_vm._v("Der Brief an die Römer")]), _vm._v(" (Göttingen, 1970)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ANF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ante-Nicene Fathers (American repr. of the Edinburgh edn.; Grand Rapids, n.d.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ARV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The American Revised Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G. Abbott-Smith: "), _c('em', [_vm._v("A Manual Greek Lexicon of the New Testament")]), _vm._v(" (Edinburgh, 1954)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ASV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The American Standard Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BAGD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Walter Bauer: "), _c('em', [_vm._v("A Greek-English Lexicon of the New Testament and Other Early Christian Literature,")]), _vm._v(" rev. and aug. by F. Wilbur Gingrich and Frederick W. Danker from the 5th edn. (Chicago, 1979)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barclay")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Barclay: "), _c('em', [_vm._v("The Letter to the Romans")]), _vm._v(" (Edinburgh, 1957)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barrett")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. K. Barrett: "), _c('em', [_vm._v("A Commentary on the Epistle to the Romans")]), _vm._v(" (London, 1957)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barth")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl Barth: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (Oxford, 1933)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F. Blass and A. Debrunner: "), _c('em', [_vm._v("A Greek Grammar of the New Testament,")]), _vm._v(" trans, and rev. R. W. Funk (Chicago, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bengel")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Albert Bengel: "), _c('em', [_vm._v("Gnomon of the New Testament,")]), _vm._v(" II (Edinburgh, 1873)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Black")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Matthew Black: "), _c('em', [_vm._v("Romans")]), _vm._v(" (London, 1973)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bowen")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roger Bowen: "), _c('em', [_vm._v("A Guide to Romans")]), _vm._v(" (London, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Boylan")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrick Boylan: "), _c('em', [_vm._v("St. Paul’s Epistle to the Romans")]), _vm._v(" (Dublin, 1947)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Brown: "), _c('em', [_vm._v("Analytical Exposition of the Epistle of Paul the Apostle to the Romans")]), _vm._v(" (Grand Rapids, 1981 repr. of 1857 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bruce")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F. F. Bruce: "), _c('em', [_vm._v("The Letter of Paul to the Romans"), _c('sup', [_vm._v("2")])]), _vm._v(" (Leicester, 1985)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brunner")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Emil Brunner: "), _c('em', [_vm._v("The Letter to the Romans")]), _vm._v(" (London, 1959)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Calvin")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Calvin: "), _c('em', [_vm._v("The Epistles of Paul the Apostle to the Romans and to the Thessalonians")]), _vm._v(" (Edinburgh, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBQ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBSC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Cambridge Bible for Schools and Colleges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CGT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cambridge Greek Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Chamberlain")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Douglas Chamberlain: "), _c('em', [_vm._v("An Exegetical Grammar of the Greek New Testament")]), _vm._v(" (New York, 1941)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Christian Words")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nigel Turner: "), _c('em', [_vm._v("Christian Words")]), _vm._v(" (Edinburgh, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Cragg")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Interpreter’s Bible,")]), _vm._v(" IX, “The Epistle to the Romans,” exposition by Gerald R. Cragg")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Cranfield")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. Ε. B. Cranfield: "), _c('em', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans")]), _vm._v(" (Edinburgh, I [1975]; II [1979])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Denney")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James Denney: “St. Paul’s Epistle to the Romans” in "), _c('em', [_vm._v("The Expositor’s Greek Testament,")]), _vm._v(" II (Grand Rapids, 1979 repr.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("H. E. Dana and Julius R. Mantey: "), _c('em', [_vm._v("A Manual Grammar of the Greek New Testament")]), _vm._v(" (New York, 1927)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Dodd")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. H. Dodd: "), _c('em', [_vm._v("The Epistle of Paul to the Romans")]), _vm._v(" (London, 1944)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Donfried")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl P. Donfried: "), _c('em', [_vm._v("The Romans Debate")]), _vm._v(" (Minneapolis, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Earle")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ralph Earle: "), _c('em', [_vm._v("Word Meanings in the New Testament,")]), _vm._v(" III, "), _c('em', [_vm._v("Romans")]), _vm._v(" (Grand Rapids, 1974)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("EGT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("W. Robertson Nicoll, ed.: "), _c('em', [_vm._v("The Expositor’s Greek Testament,")]), _vm._v(" 5 vols. (Grand Rapids, 1979 repr.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ET")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Expository Times")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Foreman")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("K. J. Foreman: "), _c('em', [_vm._v("Romans, I & II Corinthians")]), _vm._v(" (London, 1962)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gamble")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harry Gamble, Jr. : "), _c('em', [_vm._v("The Textual History of the Letter to the Romans")]), _vm._v(" (Grand Rapids, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gifford")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ε. H. Gifford: "), _c('em', [_vm._v("The Epistle of St. Paul to the Romans")]), _vm._v(" (London, 1886)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GNB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Good News Bible (Today’s English Version)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Godet")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("F. Godet: "), _c('em', [_vm._v("Commentary on St. Paul’s Epistle to the Romans,")]), _vm._v(" 2 vols. (Edinburgh, 1895)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Goodspeed")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Edgar J. Goodspeed: "), _c('em', [_vm._v("The New Testament: An American Translation")]), _vm._v(" (Chicago, 1923)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gore")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Charles Gore: "), _c('em', [_vm._v("St. Paul’s Epistle to the Romans,")]), _vm._v(" 2 vols. (London, I [1902]; II [1907])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Grammatical Insights")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nigel Turner: "), _c('em', [_vm._v("Grammatical Insights into the New Testament")]), _vm._v(" (Edinburgh, 1965)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Griffith")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Gwilym O. Griffith: "), _c('em', [_vm._v("St. Paul’s Gospel to the Romans")]), _vm._v(" (Oxford, 1949)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Greek-English Lexicon of the New Testament,")]), _vm._v(" being Grimm’s Wilke’s "), _c('em', [_vm._v("Clavis Novi Testamenti,")]), _vm._v(" trans, and rev. J. H. Thayer (Edinburgh, 1888)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Haldane")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Robert Haldane: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (London, 1966 repr.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harrison")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Everett F. Harrison: “Romans” in "), _c('em', [_vm._v("The Expositor’s Bible Commentary,")]), _vm._v(" 10 (Grand Rapids, 1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harrisville")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Roy A. Harrisville: "), _c('em', [_vm._v("Romans")]), _vm._v(" (Minneapolis, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hendriksen")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Hendriksen: "), _c('em', [_vm._v("New Testament Commentary: Exposition of Paul’s Epistle to the Romans")]), _vm._v(" (Grand Rapids, I [1980]; II [1981])")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hodge")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Charles Hodge: "), _c('em', [_vm._v("A Commentary on Romans")]), _vm._v(" (London, 1972 repr. of 1864 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hunter")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A. M. Hunter: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (London, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IBNTG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. F. D. Moule: "), _c('em', [_vm._v("An Idiom Book of New Testament Greek")]), _vm._v(" (Cambridge, 1953)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IDB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Interpreter’s Dictionary of the Bible,")]), _vm._v(" 4 vols. (Nashville, 1962); Supplementary Volume (1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  })])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Jerusalem Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JBL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Käsemann")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ernst Käsemann: "), _c('em', [_vm._v("Commentary on Romans")]), _vm._v(" (Grand Rapids, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kertelge")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Karl Kertelge and Gerhard Schneider: "), _c('em', [_vm._v("The Epistles to the Romans and Galatians for Spiritual Reading")]), _vm._v(" (London, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Knox")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Interpreter’s Bible,")]), _vm._v(" IX, introduction and exegesis by John Knox (Nashville, 1978)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Knox, R")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. Knox: "), _c('em', [_vm._v("The Holy Bible, A Translation from the Latin Vulgate")]), _vm._v(" (London, 1955)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LAE")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A. Deissmann: "), _c('em', [_vm._v("Light from the Ancient East")]), _vm._v(" (London, 1927)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lagrange")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M.-J. Lagrange: "), _c('em', [_vm._v("Saint Paul Épitre aux Romains")]), _vm._v(" (Paris, 1922)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Living Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Leenhardt")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Franz J. Leenhardt: "), _c('em', [_vm._v("The Epistle to the Romans")]), _vm._v(" (London, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lenski")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. C. H. Lenski: "), _c('em', [_vm._v("The Interpretation of St. Paul’s Epistle to the Romans")]), _vm._v(" (Minneapolis, n.d.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lightfoot")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. B. Lightfoot: Noies "), _c('em', [_vm._v("on Epistles of St Paul")]), _vm._v(" (London, 1904)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lloyd-Jones")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("D. M. Lloyd-Jones: "), _c('em', [_vm._v("Romans: An Exposition of Chapters 3:20-8:39,")]), _vm._v(" 6 vols. (London, 1970-75)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loane")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Marcus Loane: "), _c('em', [_vm._v("God’s Mere Mercy")]), _vm._v(" (Blackwood, South Australia, 1986)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LSJ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Greek-English Lexicon,")]), _vm._v(" comp. H. G. Liddell and R. Scott, rev. H. S. Jones and R. McKenzie, 2 vols. (Oxford, 1940)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Luther")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Martin Luther: "), _c('em', [_vm._v("Lectures on Romans")]), _vm._v(" (Library of Christian Classics; London, 1961)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M, I")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. H. Moulton: "), _c('em', [_vm._v("A Grammar of New Testament Greek,")]), _vm._v(" I, "), _c('em', [_vm._v("Prolegomena")]), _vm._v(" (Edinburgh, 1906)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Μ, Π")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ibid.,")]), _vm._v(" II, "), _c('em', [_vm._v("Accidence and Word-Formation,")]), _vm._v(" ed. W. F. Howard (Edinburgh, 1919)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Μ, ΠΙ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ibid.,")]), _vm._v(" Ill, "), _c('em', [_vm._v("Syntax,")]), _vm._v(" by Nigel Turner (Edinburgh, 1963)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("M, IV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ibid.,")]), _vm._v(" IV, "), _c('em', [_vm._v("Style,")]), _vm._v(" by Nigel Turner (Edinburgh, 1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Manson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("T. W. Manson: “Romans” in "), _c('em', [_vm._v("Peake’s Commentary on the Bible,")]), _vm._v("ed. Matthew Black and H. H. Rowley (London, 1980)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Metzger")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bruce M. Metzger: "), _c('em', [_vm._v("A Textual Commentary on the Greek NewTestament")]), _vm._v(" (London and New York, 1971)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Michel")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Otto Michel: "), _c('em', [_vm._v("Der Brief an die Römer")]), _vm._v(" (Göttingen, 1966)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Minear")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Paul S. Minear: "), _c('em', [_vm._v("The Obedience of Faith")]), _vm._v(" (London, 1971)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. H. Moulton and G. Milligan: "), _c('em', [_vm._v("The Vocabulary of the GreekTestament")]), _vm._v(" (London, 1914-29)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Moffatt")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James Moffatt: "), _c('em', [_vm._v("The New Testament: A New Translation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Morison")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James Morison: "), _c('em', [_vm._v("A Critical Exposition of the Third Chapter of Paul’s Epistle to the Romans")]), _vm._v(" (London, 1866)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Moule")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Handley C. G. Moule: "), _c('em', [_vm._v("The Epistle of St. Paul to the Romans")]), _vm._v(" (London, 1896)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MS(S)")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Manuscript(s)")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ernest de Witt Burton: "), _c('em', [_vm._v("Syntax of the Moods and Tenses in New Testament Greek")]), _vm._v(" (Edinburgh, 1955)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Murray")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Murray: "), _c('em', [_vm._v("The Epistle to the Romans,")]), _vm._v(" 2 vols. (Grand Rapids, 1960 and 1965)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NASB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New American Standard Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NBCR")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New Bible Commentary Revised,")]), _vm._v(" ed. D. Guthrie "), _c('em', [_vm._v("et al.")]), _vm._v(" (London, 1970)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NEB")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New English Bible")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIDNTT")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The New International Dictionary of New Testament Theology,")]), _vm._v(" ed. Colin Brown, 3 vols. (Exeter, 1975-78)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New International Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nicene and Post-Nicene Fathers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTS")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nygren")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anders Nygren: "), _c('em', [_vm._v("Commentary on Romans")]), _vm._v(" (London, 1952)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Olshausen")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hermann Olshausen: "), _c('em', [_vm._v("Studies in the Epistle to the Romans")]), _vm._v(" (Minneapolis, 1983 repr. of 1849 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("O’Neill")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. C. O’Neill: "), _c('em', [_vm._v("Paul’s Letter to the Romans")]), _vm._v(" (Harmondsworth, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Parry")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. St John Parry: "), _c('em', [_vm._v("The Epistle of Paul the Apostle to the Romans")]), _vm._v(" (Cambridge, 1912)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Phillips")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("J. B. Phillips: "), _c('em', [_vm._v("Letters to Young Churches")]), _vm._v(" (Melbourne, 1952)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Rhymer")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joseph Rhymer: "), _c('em', [_vm._v("Good News in Romans")]), _vm._v(" (London, 1974)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ridderbos")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herman Ridderbos: "), _c('em', [_vm._v("Paul")]), _vm._v(" (Grand Rapids, 1975)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Robertson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("A. T. Robertson: "), _c('em', [_vm._v("A Grammar of the Greek New Testament in the Light of Historical Research")]), _vm._v(" (London, n.d.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Robinson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John A. T. Robinson: "), _c('em', [_vm._v("Wrestling with Romans")]), _vm._v(" (London, 1979)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RSV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Revised Standard Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RThR")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Reformed Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("RV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Revised Version")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBk")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("H. L. Strack und P. Billerbeck: "), _c('em', [_vm._v("Kommentar zum Neuen Testament aus Talmud und Midrasch,")]), _vm._v(" 4 vols. (München, 1922-28)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Schonfield")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hugh J. Schonfield: "), _c('em', [_vm._v("The Authentic New Testament")]), _vm._v(" (London, 1956)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Scott")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("E. F. Scott: "), _c('em', [_vm._v("Paul’s Epistle to the Romans")]), _vm._v(" (London, 1947)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SH")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William Sanday and Arthur C. Headlam: "), _c('em', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans")]), _vm._v(" (Edinburgh, 1907)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Shedd")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("William G. T. Shedd: "), _c('em', [_vm._v("Commentary on Romans")]), _vm._v(" (Grand Rapids, 1980 repr. of 1879 edn.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Simeon")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Charles Simeon: "), _c('em', [_vm._v("Horae Homileticae,")]), _vm._v(" XV, "), _c('em', [_vm._v("Romans")]), _vm._v(" (London, 1847)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Smart")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("James D. Smart: "), _c('em', [_vm._v("Doorway to a New Age")]), _vm._v(" (New York, 1972)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Stott")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John R. W. Stott: "), _c('em', [_vm._v("Men Made New")]), _vm._v(" (Downers Grove, 1966)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Synonyms")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Richard Chevenix Trench: "), _c('em', [_vm._v("Synonyms of the New Testament")]), _vm._v(" (London, 1880)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tasker")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. V. G. Tasker, ed.: "), _c('em', [_vm._v("The Greek New Testament")]), _vm._v(" (Oxford and Cambridge, 1964)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the New Testament,")]), _vm._v(" a translation by Geoffrey W. Bromiley of "), _c('em', [_vm._v("Theologisches Wörterbuch zum Neuen Testament")]), _vm._v(" (Grand Rapids, 1964-76)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TH")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Barclay M. Newman and Eugene A. Nida: "), _c('em', [_vm._v("A Translator’s Handbook on Paul’s Letter to the Romans")]), _vm._v(" (New York, 1973)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Thomas")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("W. H. Griffith Thomas: "), _c('em', [_vm._v("Romans,")]), _vm._v(" 3 vols. (London, 1911-12)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vaughan")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("C. J. Vaughan: "), _c('em', [_vm._v("St. Paul’s Epistle to the Romans")]), _vm._v(" (London, 1880)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vermes")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("G. Vermes: "), _c('em', [_vm._v("The Dead Sea Scrolls in English")]), _vm._v(" (Harmondsworth, 1972)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Way")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Arthur S. Way: "), _c('em', [_vm._v("The Letters of St. Paul")]), _vm._v(" (London, 1921)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wesley")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("John Wesley: "), _c('em', [_vm._v("Explanatory Notes upon the New Testament")]), _vm._v(" (London, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Weymouth")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("R. F. Weymouth: "), _c('em', [_vm._v("The New Testament in Modern Speech")]), _vm._v(" (London, 1907)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WH")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("B. F. Westcott and F.J. Hort: "), _c('em', [_vm._v("The New Testament in the Original Greek")]), _vm._v(" (London, 1907)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wilckens")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ulrich Wilckens: "), _c('em', [_vm._v("Der Brief an die Römer,")]), _vm._v(" 3 vols. (Zürich, 1978-82)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wilson")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Geoffrey B. Wilson: "), _c('em', [_vm._v("Romans")]), _vm._v(" (Edinburgh, 1976)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WTJ")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Westminster Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid20"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wuest")])]), _vm._v(" "), _c('td', {
    staticClass: "wid75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kenneth S. Wuest: "), _c('em', [_vm._v("Romans in the Greek New Testament")]), _vm._v(" (London, n.d.)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Quotations from the Talmud are from the Soncino edition, and the Mishnah is cited from Danby’s translation.")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/xiii.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  })])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("It is commonly agreed that the Epistle to the Romans is one of the greatest Christian writings. Its power has been demonstrated again and again at critical points in the history of the Christian church. Augustine of Hippo, for example, was converted through reading a passage from this letter, and thus began a period of the greatest importance for the church. It is not too much to say that at a later time Martin Luther’s spiritual experience was shaped by his coming to grips with what Paul says in this epistle. The Reformation may be regarded as the unleashing of new spiritual life as a result of a renewed understanding of the teaching of Romans. Again, John Wesley’s conversion was triggered by hearing Luther’s Preface to Romans read, a Preface, of course, inspired by the epistle. Nearer to our own day it was Karl Barth’s coming to grips with the message of the book that ended an era of sterile liberalism and ushered in a more fruitful period of biblical theology. But Romans is not for great minds only. The humble believer also finds inspiration and direction in these pages. Romans is not an easy book. But it has always yielded rich dividends to anyone who has taken the time to study it seriously, and it does so still.")]), _c('a', {
    attrs: {
      "href": "#/#foot-1",
      "id": "foot_1"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is one of a large number of letters, some 14,000 in all, that have come down to us from antiquity. Many are in copies only, but quite often we have the originals. Some letters are very private, being intimate communications within the family or among friends; others are plainly meant for a wider public. In the papyri private letters range in length from 18 words to 209."), _c('a', {
    attrs: {
      "href": "#/#foot-2",
      "id": "foot_2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" More literary letters"), _c('a', {
    attrs: {
      "href": "#/#foot-3",
      "id": "foot_3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" tend to be longer, the subject matter obviously having an influence on length. Cicero’s 796 letters average 295 words with a range from 22 to 2,530 words, while Seneca’s 124 letters range from 149 to 4,134 words "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("with an average length of 995 words. The New Testament letters tend to be longer, though 2 and 3 John are quite short. The 13 Pauline letters average around 1,300 words. Clearly Paul took letter writing very seriously and made it much more of a vehicle for significant teaching than did most people of the ancient world. Romans is his longest letter, with about 7,100 words. Its length as well as the profundity of its subject matter marks it out as a most unusual letter.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_vm._v("AUTHORSHIP")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The letter claims to have been written by the apostle Paul (1:1), and no serious objection appears ever to have been urged against this claim. The few who have objected have not been able to convince many that their arguments have weight. The style and contents are what we expect of Paul, and the tradition of the church has always accepted this letter as a genuine work of the great apostle.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_vm._v("DESTINATION")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("As it stands, the letter is addressed to the church")]), _c('a', {
    attrs: {
      "href": "#/#foot-4",
      "id": "foot_4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" at Rome (1:7, 15). This is supported by the geographical note in which Paul writes of going to Spain "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("and proceeds, “I hope to visit you while passing through” (15:24). Some scholars have been so impressed by the fact that the words “in Rome” (1:7, 15) are absent from a few manuscripts that they have concluded that the Roman church was not the epistle’s original destination. They hold that it was meant as a circular letter, perhaps sent to Rome as one of its addressees. However, the evidence is not strong and there is no reasonable doubt about the text.")]), _c('a', {
    attrs: {
      "href": "#/#foot-5",
      "id": "foot_5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" But the question is not as simple as this, for there are many who deny that we should take the letter as it stands. Quite a few hold that "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" was not originally part of this letter but was meant for the church at Ephesus (see below, pp. 24ff.). Usually this is understood to mean that all or part of a letter to Ephesus has somehow been attached to a letter to Rome. A different line is taken by T. W. Manson. From the fact that P"), _c('sup', [_vm._v("46")]), _vm._v(" (our oldest copy of Romans) has the doxology at the end of "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" he argues that Paul wrote a 15-chapter edition. Manson thinks that the apostle sent a copy to Ephesus with the addition of "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" and sent another copy, without the addition, to Rome."), _c('a', {
    attrs: {
      "href": "#/#foot-6",
      "id": "foot_6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" On this view we have the letter to Ephesus. I shall discuss this view more fully later. Here it is enough to say that the personal references in "), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("chapters 1")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" make it difficult to accept any circular-letter hypothesis. It would not have been insuperably difficult to remove them or, if this copy was meant for Ephesus, to replace them with matter more appropriate to that city. And we should not overlook the fact that even on Manson’s view the bulk of the letter was intended for the Roman church just as much as for that in Ephesus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We have no precise information about how and when and by whom the church was established at Rome. Acts 2:10 informs us that visitors from Rome were among those in Jerusalem who heard the Christians preach on the day of Pentecost. There is nothing improbable in the suggestion that some of them responded to Peter’s sermon and became Christians, though we must immediately add that we have no knowledge of this. There is a tradition that Peter and Paul founded the church. But this epistle shows that the church was flourishing in Rome long before Paul visited that city. If Peter was the founder in the same sense as Paul, this can mean only that he was interested in the church, that he may have visited it at some time, and that it accepted his "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("teaching. It cannot mean that he was responsible for its first converts. This is in any case unlikely, for Peter’s primary responsibility was to the Jews, just as Paul’s was to the Gentiles (Gal. 2:7-8). It is most improbable that Peter settled in Rome as bishop of the church as some traditions hold, for he seems to have exercised a wandering ministry (1 Cor. 9:5). There is no record of his ever settling down anywhere. As for Paul, it is impossible to hold that he had much to do with the church in Rome in its early years. When he wrote this epistle he had never been to Rome (1:10-13), and he makes it clear that there was already a significant group of believers there (1:6, 7, 8; 15:14).")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("There is then no reliable tradition about the founding of this church, and we are left to speculation. The probability is that traders and other travellers first brought Christianity to Rome. As they witnessed to their faith they brought others to believe, and in this way a church was born. It seems likely that the first converts were won from among the Jews, and they may even have been organized as a synagogue (or synagogues).")]), _c('a', {
    attrs: {
      "href": "#/#foot-7",
      "id": "foot_7"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" This is speculation, but it is supported by a note in the Roman historian Suetonius. This man tells us that the Emperor Claudius expelled the Jews"), _c('a', {
    attrs: {
      "href": "#/#foot-8",
      "id": "foot_8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" from Rome because they “constantly made disturbances at the instigation of Chrestus "), _c('em', [_vm._v("(impulsore Chresto).”"), _c('a', {
    attrs: {
      "href": "#/#foot-9",
      "id": "foot_9"
    }
  }, [_c('sup', [_vm._v("9")])])]), _vm._v(" Most scholars take “Chrestus” as equivalent to “Christus” (the two words had similar pronunciations), that is, Christ. If this understanding of it is correct, it would seem that the fairly large group of Jews in Rome"), _c('a', {
    attrs: {
      "href": "#/#foot-10",
      "id": "foot_10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" had "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("mixed feelings about Christianity. Some followed Christ. But others objected so violently that there were riots. Orosius’s dating of this in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 49 is generally accepted, so the passage points to an early establishment of the church in the capital city. An early establishment is indicated also by the fact that Paul says that he had for a long time wanted to visit them (1:13).")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("But if the first converts were Jews, this was a condition that did not last. By the time Romans was written a large Gentile element was clearly in the number (1:5-6,13; 11:13-32; cf. 9:3ff.; 10:1-2; 15:15-16). The church can scarcely have been completely Gentile, as the many references to views held by Jews (Christian and otherwise) throughout the epistle show. Paul speaks of Abraham as “our” forefather (4:1) and writes to people who know law (7:1) and have “died” to the law (7:4; these passages may include others than Jews but they certainly include Jews). The charge of nullifying the law (3:31) looks like a Jewish charge, as do objections to Paul’s view of freedom from the law (6:17:6). Justification by faith, not law, is said to be an argument against a Jewish position. It would not have been impossible for Paul to have written these words to Gentile Christians (cf. 1 Cor. 10:1), but at least they are congruous with Jewish recipients.")]), _c('a', {
    attrs: {
      "href": "#/#foot-11",
      "id": "foot_11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" But when Paul writes “Accept one another” and goes on to speak of Christ as having “become a servant of the Jews on behalf of God’s truth, to confirm the promises made to the patriarchs so that the Gentiles may glorify God for his mercy” (15:7-9), it is plain that he is writing to members of both groups. We should also bear in mind what W. G. Kümmel calls “the equal responsibility of Jews and Greeks before God”,"), _c('a', {
    attrs: {
      "href": "#/#foot-12",
      "id": "foot_12"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" which finds expression in a number of places (e.g., 1:16; 2:9ff., 25ff.; 3:29; 10:12). Such expressions are pointless unless representatives of both groups are to read the letter. It is not clear which group predominated,"), _c('a', {
    attrs: {
      "href": "#/#foot-13",
      "id": "foot_13"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" though the general tone of the letter and the fact that Paul clearly believed that the Roman church had come within his sphere of responsibility as apostle to the Gentiles may be held to point to some preponderance of Gentiles.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-3"
    }
  }, [_vm._v("DATE AND PLACE OF WRITING")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The epistle seems to have been written in Corinth. Paul commends Phoebe, a lady from Cenchraea, the port of that city (16:1). His host is Gaius (16:23), and "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Gaius is the name of a man Paul baptized at Corinth (1 Cor. 1:14). Erastus, Timothy, and Sopater were with Paul when Romans was written (16:21, 23) and also when he was in Greece (Acts 19:22; 20:2-4). Both times Paul intended to go to Jerusalem and then to Rome (Acts 19:21; Rom. 15:24-26, 28). The object of his immediate journey was to take money to the poor saints at Jerusalem (Acts 24:17; Rom. 15:26-28). All this makes it conclusive that Paul was writing from Corinth just before he travelled to Jerusalem.")]), _c('a', {
    attrs: {
      "href": "#/#foot-14",
      "id": "foot_14"
    }
  }, [_c('sup', [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But dating this with any precision is something of a problem. The fixed point for Pauline chronology is the proconsulship of Gallio in Corinth, for there is an inscription that tells us that this man was in office in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 52."), _c('a', {
    attrs: {
      "href": "#/#foot-15",
      "id": "foot_15"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" Proconsuls held office for a year, though on occasion their terms might be extended to two years. Depending on whether the inscription refers to a time near the beginning or end of Gallio’s term of office, Paul would have been in Corinth at some time during the period "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 50-54. We do not know at exactly what point Paul was brought before him (Acts 18:12). But it is not unreasonable to suppose that it was early in his term of office (the Jews might hope to get their wish granted by a new official) and not so very long before the end of Paul’s own ministry in the city. If Paul was before Gallio in the summer of "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 51"), _c('a', {
    attrs: {
      "href": "#/#foot-16",
      "id": "foot_16"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" and left in the autumn for Antioch (Acts 18:18-22), his return to Galatia (Acts 18:23) would be in the following spring, that of "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 52. His visits to the churches and journey to Ephesus would bring him to that city at the autumn period. He stayed there for three months (Acts 19:8) and then apparently for two years more (Acts 19:10; cf. 20:31). This brings us to "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 55. It was apparently the Pentecost of that year that he wished to spend in Jerusalem (Acts 20:16). This means that the three months he spent in Greece just prior to the journey (Acts 20:3), during which he wrote Romans (he was about to go to Jerusalem, Rom. 15:25), would be the early months of "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 55."), _c('a', {
    attrs: {
      "href": "#/#foot-17",
      "id": "foot_17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" This would be supported if Acts 24:27, “when two years had passed”, means when Felix had been in office for two years (not when Paul had been a prisoner for two years), and if Festus succeeded Felix in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 55."), _c('a', {
    attrs: {
      "href": "#/#foot-18",
      "id": "foot_18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" There are, of course, many "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("uncertainties, and no dating can ever be more than approximate. Some date Romans as early as "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 53.")]), _c('a', {
    attrs: {
      "href": "#/#foot-19",
      "id": "foot_19"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" But "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D.")]), _vm._v(" 55 seems to satisfy the data as well as any year.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-4"
    }
  }, [_vm._v("OCCASION")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("From its situation in the capital city the Roman church would have had good means of communication with the churches in other cities. Christians would be coming and going. This church might well have a widespread influence, and from the respectful way Paul addresses it the inference is that it had not only had such an influence but had used it well. It had set a good example to believers everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Two questions arise then. Why did Paul write to such a church? And if he did write, why write such a letter as this? It is curious that, despite the importance everyone concedes to this epistle, there is no agreement about the answers we should give."), _c('a', {
    attrs: {
      "href": "#/#foot-20",
      "id": "foot_20"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One searches the epistle carefully for information that might help with the answers. What emerges is that Paul had never been to Rome, though for a long time he had wanted to visit the Christians there (1:8-13; 15:23). He says that he had been hindered from coming to Rome (1:13; 15:22), which seems to mean that he had tried to come but had been stopped. When he wrote, however, he had the prospect of a trip to Spain (15:22-29), which would give him the opportunity to visit the Roman Christians along the way. Some of the things he says are not easy to harmonize with one another. Thus, on the one hand he wanted to impart some spiritual gift to the Roman Christians, to have “some fruit” among them, and to preach the gospel among them (1:11, 13, 15). On the other hand he says that it was not his custom to preach the gospel where Christ was already named lest he build on someone else’s foundation (15:20). Why did the man who did not build on other people’s foundations want to preach in the flourishing church in Rome? It is not at all obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Romans does not deal with local issues in the manner of, say, 1 Corinthians. It is a majestic epistle, dealing with grand themes. It has proved relevant to the needs of Christians in a great variety of situations. But sometimes Paul addresses himself to specific difficulties in Rome. Most students feel, for example, that the discussion of the weak and the strong (14:1-15:13) shows that Paul had information about one of the problems at Rome."), _c('a', {
    attrs: {
      "href": "#/#foot-21",
      "id": "foot_21"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("From all this a broad classification emerges. Some scholars are impressed by the paucity of references to Rome and see the letter as originating in questions outside that city. Others hold that it was written to meet some specific need in the Roman church.")]), _c('a', {
    attrs: {
      "href": "#/#foot-22",
      "id": "foot_22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" There is great variety in both camps and no approach to agreement. We notice a number of suggestions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("1. A Compendium of Christian Teaching.")]), _vm._v(" This is the traditional view."), _c('a', {
    attrs: {
      "href": "#/#foot-23",
      "id": "foot_23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" Something like it has been expressed in recent times by Anders Nygren."), _c('a', {
    attrs: {
      "href": "#/#foot-24",
      "id": "foot_24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" This approach is based on the steady treatment of great themes throughout the epistle. But it does not allow for the specific references to Rome. Nor does it appear why Paul should write such a compendium to Rome (Colossians, another letter to a church Paul had never visited, is quite different). Nor does it account for some important omissions. Much needs to be added in some areas for a compendium, such as christology (cf. Ephesians, Philippians, Colossians), the resurrection (1 Corinthians), the church (Ephesians), and eschatology (1 and 2 Thessalonians). Nothing is said about holy communion. If Romans is a compendium of theology, there are some curious gaps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("2. Paul’s Mature Thinking on Essential Christianity.")]), _vm._v(" Günther Bornkamm calls it Paul’s “last will and testament”."), _c('a', {
    attrs: {
      "href": "#/#foot-25",
      "id": "foot_25"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" Bornkamm finds many topics in Romans already dealt with in earlier epistles, but there in polemical contexts. In Romans they are given “a strongly universal meaning”."), _c('a', {
    attrs: {
      "href": "#/#foot-26",
      "id": "foot_26"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" Bornkamm thinks that Paul has gone back to his conversion experience and that Romans reflects his history and struggles. He sums it up in this way: “This great document, which summarizes and develops the most important themes and thoughts of the Pauline message and theology and which elevates his theology above the moment of definite situations and conflicts into the sphere of the eternally and universally valid, this letter to the Romans is the last will and testament of the Apostle Paul.”"), _c('a', {
    attrs: {
      "href": "#/#foot-27",
      "id": "foot_27"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" One cannot but agree with much of this. But "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("it scarcely gives a reason why Paul should have written the letter. Granted that Romans contains the apostle’s mature reflection on what Christianity is all about, we must still ask, Why did Paul set this mature reflection down in writing? And if he did, Why send it to Rome?")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('em', [_vm._v("3. A Discussion of the Church.")]), _vm._v(" Franz J. Leenhardt finds the occasion in Paul’s preparation for his missionary work in Spain. He had concluded his work in the East, where he had fully proclaimed the gospel from Jerusalem to Illyrica (15:19). Thus far the church had what we might call geographical unity. There was no problem in all the converts Paul had made looking to Jerusalem as the mother church. But “for regions as distant as Spain, what specific role could this church still claim?”")]), _c('a', {
    attrs: {
      "href": "#/#foot-28",
      "id": "foot_28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" Where he might have written a “Doctrine of the Church” Paul preferred to tackle the problem another way. “The object of his letter is to show that all believers benefit from the promises made to Abraham and that, by faith and baptism, they are thus incorporated into the people of God, thanks to the secret operation of the Holy Ghost.”"), _c('a', {
    attrs: {
      "href": "#/#foot-29",
      "id": "foot_29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" But it is not easy to see this in the letter. Baptism comes before us only in 6:3-4, while the term “church” is confined to "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(". It is not Protestant prejudice but careful attention to the language of the letter that compels us to see the aim elsewhere. And in any case, Why Rome? Leenhardt does not produce a sufficient reason for addressing a treatment of the nature of the church to the Roman Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("4. A Circular Letter.")]), _vm._v(" Some who emphasize the wide applicability of the letter see it as originally a circular. There is convincing evidence that at one time there was a 14-chapter edition and some indication also of a 15-chapter edition (see below, pp. 21ff.)· It is also true that in some MSS the words “in Rome” are lacking in 1:7, 15 (see above, "), _c('a', {
    attrs: {
      "href": "#/009_Introduction#page_3"
    }
  }, [_vm._v("p. 3")]), _vm._v("). The suggestion is made that Paul wrote an original letter of 14 (or 15) chapters to be sent to a number of churches. Rome was, of course, one of them, and it is in the form addressed to the church in that city that the letter has come down to us. T. W. Manson sees an original 15-chapter edition of which one copy went to Rome and another, with "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" added, to Ephesus."), _c('a', {
    attrs: {
      "href": "#/#foot-30",
      "id": "foot_30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" The letter was written at the end of a very controversial period, as we see from the earlier letters. Manson reminds us that throughout Romans Paul frequently answers objections, and he holds that “we have here a record made by Paul and his clerical helpers of a real discussion.”"), _c('a', {
    attrs: {
      "href": "#/#foot-31",
      "id": "foot_31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" It represents Paul’s summing up of positions he and his friends had reached. “Looked at in this way Romans ceases to be just a letter of self "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("introduction from Paul to the Roman church, and becomes a manifesto setting forth his deepest convictions on central issues, a manifesto calling for the widest publicity, which the Apostle did his best—not without success—to give it.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-32",
      "id": "foot_32"
    }
  }, [_c('sup', [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is something undeniably attractive about such views. But the question persists, Why Rome? That Paul was setting down his deep convietions after a period of conflict is no reason for sending the result to a church to which he was a stranger. Further, there must be a reason for a circular, just as for a letter to a definite destination. What is the reason for this one? No really convincing suggestion has been made. Nor is there any real evidence that it was ever sent anywhere but to Rome. Most scholars find a decisive argument against all circular-letter theories in the very personal tone of some parts of the letter, for example, 1:8-15."), _c('a', {
    attrs: {
      "href": "#/#foot-33",
      "id": "foot_33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" It is very difficult indeed to think that 1:10-11 was originally written to no one in particular. Moreover, it would be strange to have a record of controversies without one reference to a specific opponent."), _c('a', {
    attrs: {
      "href": "#/#foot-34",
      "id": "foot_34"
    }
  }, [_c('sup', [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("5. The Jerusalem Church.")]), _vm._v(" Paul was about to start for Jerusalem when this letter was written. He was taking a large sum of money for the church there but was obviously doubtful about the reception he would get. Some hold that it is this that gives us the key to Romans. Jacob Jervell entitles his study of our letter, “The Letter to Jerusalem”."), _c('a', {
    attrs: {
      "href": "#/#foot-35",
      "id": "foot_35"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" He points to our inability to be certain about the composition of the church in Rome (was it Jewish? or Gentile? or both?) and its circumstances. We cannot accordingly show that Paul was writing with the circumstances of the Roman church primarily in mind. Moreover, “the letter itself states clearly that its raison d’etre does not stem from the situation in the Roman congregation, but is to be found in Paul himself at the time of writing.”"), _c('a', {
    attrs: {
      "href": "#/#foot-36",
      "id": "foot_36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" His major concern at that time was the reception of his gift of money by the saints in Jerusalem."), _c('a', {
    attrs: {
      "href": "#/#foot-37",
      "id": "foot_37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" Thus “The essential and primary "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("content of Romans (1:18–11:36) is a reflection upon its major content, the ‘collection speech,’ or more precisely, the defence which Paul plans to give before the church in Jerusalem.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-38",
      "id": "foot_38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" Why then write to Rome? Because Paul wants the Romans to pray for him and to stand behind him so that he can claim their support. “Paul wants to represent the entire Gentile world in Jerusalem, including the West.”"), _c('a', {
    attrs: {
      "href": "#/#foot-39",
      "id": "foot_39"
    }
  }, [_c('sup', [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is, of course, highly probable that when Paul wrote to the Romans he had in mind that he would face a difficult task in Jerusalem. We need not doubt that some of the things he writes in Romans he would say in Jerusalem. But there still remains the stubborn question, “If his letter really was ‘The Letter to Jerusalem’ why send it to Rome?” That makes no sense. The reason Jervell gives is insufficient. In any case, nothing in Romans indicates that Paul wanted assurance that he would represent Rome in the coming debate. If he wanted Roman support, why does he not ask for it? And how would Roman support (if he could get it) be brought to bear, or even be known, in Jerusalem? This view points to some interesting facts, but it does not carry convietion. It does not account for the epistle as a whole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("6. Personal Claims.")]), _vm._v(" Another view which roots the origin of the letter in Paul’s own circumstances is that of Käsemann. “The most important theological epistle in Christian history is undoubtedly also the record of an existence struggling for recognition and of an apostolicity called into question. Apart from this insight Romans cannot be interpreted correctly.”"), _c('a', {
    attrs: {
      "href": "#/#foot-40",
      "id": "foot_40"
    }
  }, [_c('sup', [_vm._v("40")])]), _vm._v(" Käsemann holds that Paul continually asserts an apostolic authority which many in the church refused to concede to him. We may freely accept this without drawing the conclusion that Paul was continually worried and embarrassed by the rejection of his claims (his list of troubles in 2 Cor. 11:23-29 would not lead to such a conclusion). Romans does not read like the desperate product of a man on the defensive and worried that people will not recognize him. Its calm, magisterial tone has often been noted, and passages like 1:11-12 do not prove Käsemann’s point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("7. Apostolic Foundation.")]), _vm._v(" Günter Klein is impressed by the statement that Paul does not build on another’s foundation (15:20). But he does plan to preach the gospel in Rome (1:15). Klein sees the reconciliation of these passages in the fact that the Roman church had not been founded by an apostle. The situation was unique. Paul “was dealing with addressees whose faith was beyond question but who still were lacking the authentic apostolic stamp.”"), _c('a', {
    attrs: {
      "href": "#/#foot-41",
      "id": "foot_41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" Paul’s aim in this writing and in the preaching he planned in Rome was to give this “authentic apostolic stamp” to the church in Rome."), _c('a', {
    attrs: {
      "href": "#/#foot-42",
      "id": "foot_42"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("But this is more than the letter says and it smacks of an ecclesiasticism that is foreign to all we know of Paul. It is more than difficult to see how, on New Testament premises, preaching the gospel to Christians whose faith was well known (1:8) and who were full of goodness and knowledge and able to admonish one another (15:14) could be justified. Klein simply says, “Paul can consider an apostolic effort in Rome because he does not regard the local Christian community there as having an apostolic foundation”;")]), _c('a', {
    attrs: {
      "href": "#/#foot-43",
      "id": "foot_43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" the Romans lacked “the fundamental kerygma.”"), _c('a', {
    attrs: {
      "href": "#/#foot-44",
      "id": "foot_44"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" He recognizes that his view points to “a shockingly authoritarian understanding of the apostolic office”"), _c('a', {
    attrs: {
      "href": "#/#foot-45",
      "id": "foot_45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" but gives no reason for seeing Paul in this shockingly authoritarian role. There must have been many churches in the first century which, had been founded by itinerant Christians of the rank and file."), _c('a', {
    attrs: {
      "href": "#/#foot-46",
      "id": "foot_46"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" Must some apostle have visited each of them before it could be accepted as a Christian church?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A related but more acceptable view is that of A. Fridrichsen: “I believe that the main motive of Romans is to assert, in a discreet way, the apostolic authority and teaching of Paul in the church of Rome.”"), _c('a', {
    attrs: {
      "href": "#/#foot-47",
      "id": "foot_47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" But even this way of putting it goes beyond the evidence. If the view of E. A. Judge and G. S. R. Thomas were accepted, namely that there was no church in Rome at the time Paul wrote,"), _c('a', {
    attrs: {
      "href": "#/#foot-48",
      "id": "foot_48"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" it might be possible to work out the view that Paul wrote to gather the scattered Christians in Rome into a church. But in the form Klein gives it the theory can scarcely be accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("8. The “Weak” and the “Strong”.")]), _vm._v(" Quite a number of scholars have in recent times seen the key to understanding this letter in the references to the “weak” and the “strong” in 14:1–15:13."), _c('a', {
    attrs: {
      "href": "#/#foot-49",
      "id": "foot_49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" They usually see the weak as Jewish Christians who had long been accustomed to the Jewish food regulations and to the observance of special days such as the Sabbath and the feast days laid down in the Old Testament. The strong, then, are the Gentile Christians who have no such inhibitions but enter more wholeheartedly into Christian "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("freedom. Sometimes this is given precision by referring to the edict of Claudius which caused all Jews to be expelled from Rome (Acts 18:2).")]), _c('a', {
    attrs: {
      "href": "#/#foot-50",
      "id": "foot_50"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" The reasoning is that the Roman church consisted originally almost entirely of Jews who presumably worshipped in synagogues (see above, "), _c('a', {
    attrs: {
      "href": "#/009_Introduction#page_4"
    }
  }, [_vm._v("p. 4")]), _vm._v("). When the Jews were driven out, the Gentile Christians remained. Their numbers grew. Then when the edict of banishment was rescinded, Jewish Christians returned and found Gentiles in control of the church. The two groups found it difficult to adjust to one another."), _c('a', {
    attrs: {
      "href": "#/#foot-51",
      "id": "foot_51"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" Wolfgang Wiefel thinks that at first the authorities did not permit the returning Jews to organize synagogues and that this stimulated the development of Christian house churches with a multiplicity of small congregations and obvious possibilities of friction."), _c('a', {
    attrs: {
      "href": "#/#foot-52",
      "id": "foot_52"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" This was assisted by the fact that the synagogues were originally independent and that in Rome there was no coordinating figure like the ethnarch in Alexandria."), _c('a', {
    attrs: {
      "href": "#/#foot-53",
      "id": "foot_53"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" Paul wrote to the Roman church to admonish the two factions to live at peace."), _c('a', {
    attrs: {
      "href": "#/#foot-54",
      "id": "foot_54"
    }
  }, [_c('sup', [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Against all such views is the fact that nowhere in Romans does Paul appear as the mediator between warring factions. He indicates that he wanted to come to Rome to preach the gospel (1:15) and to impart some spiritual gift (1:11). There is not a word, however, about bringing fighting factions together. It is, moreover, incredible that if such a problem existed, and indeed was the reason for writing the letter, he would wait until ")]), _c('span', {
    attrs: {
      "href": "#/024_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 14")]), _vm._v(" to deal with it. When he did face factions, as in the church at Corinth, he put off everything, even the letter the church had written to him with specific questions for which they wanted answers, until he had repudiated division in the strongest of terms. “Is Christ divided?” he asked. “Was Paul crucified for you?” (1 Cor. 1:13). There is no equivalent in Romans. There Paul’s tone is consistently mild. It is also curious on this view that he addresses the Roman church as Gentiles (1:5-6,13; 15:15-16). This is no way to maintain the balance between feuding factions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It must also be borne in mind that it is far from certain that 14:1–15:13 refers to Jews and Gentiles."), _c('a', {
    attrs: {
      "href": "#/#foot-55",
      "id": "foot_55"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" The positions assigned to the weak are not known to have been held by Jews and some seem very difficult to assign to them, namely the use of vegetables and the abstention from wine. These practices could just as easily be seen as characteristic of Gentiles. Further, when Paul does refer to Jews, a good deal of what he says applies to non-Christian Jews, not Jewish Christians (especially in chs. 9–11). It is also true that views of this kind are usually far too confident in their descriptions of the church in Rome. The origins and early history of that church are lost in obscurity. It has never been proved that 14:1–15:13 refers to parties rather than to individuals, and if it does, to the precise membership of those parties. Robert J. Karris argues strongly against views which make this section the key to the epistle."), _c('a', {
    attrs: {
      "href": "#/#foot-56",
      "id": "foot_56"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" He holds that no such specific reference can be demonstrated. “Rom 14:1–15:31 has no specific referent within the Roman community. It is part of a letter which sums up Paul’s missionary theology and paraenesis.”"), _c('a', {
    attrs: {
      "href": "#/#foot-57",
      "id": "foot_57"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" Karris is not so much outlining how he thinks the letter came to be written as denying that the section 14:1–15:31 describes a concrete situation with sufficient clarity for us to see in it the occasion for the letter. I do not see how his argument can be resisted."), _c('a', {
    attrs: {
      "href": "#/#foot-58",
      "id": "foot_58"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('em', [_vm._v("9. Liberalizing a Reactionary Church.")]), _vm._v(" Matthew Black thinks that the Roman church was a large one (“next to Jerusalem, it was probably the largest in the Empire”), and that it was, from Paul’s point of view, “reactionary”, “imperfect”, “immature”, “still probably little more than a sect within Judaism”.")]), _c('a', {
    attrs: {
      "href": "#/#foot-59",
      "id": "foot_59"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" Paul wrote, accordingly, to win it over to his way of thinking. If the Roman church were as Black depicts it, we need not doubt that Paul would make strenuous efforts to see that it came to embrace the doctrine of God’s free grace. But do we know all this about the Roman church? On the same evidence Judge and Thomas argue that there was not even a church in Rome, let alone a strong one."), _c('a', {
    attrs: {
      "href": "#/#foot-60",
      "id": "foot_60"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" We must accept the fact that we do not know how the Roman church compared with other churches in respect of size or ecclesiastical outlook. The hypothesis is an attractive one, but there does not seem sufficient evidence to sustain it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("10. Rhetorical Genre.")]), _vm._v(" In an article entitled “Paul’s Rhetoric of Argumentation in Romans: An Alternative to the Donfried-Karris Debate over Romans”,"), _c('a', {
    attrs: {
      "href": "#/#foot-61",
      "id": "foot_61"
    }
  }, [_c('sup', [_vm._v("61")])]), _vm._v(" Wilhelm Wuellner finds the Donfried-Karris discussion of the epistle “unfruitful” and suggests a new approach: “I propose to replace the traditional priority on propositional theology and the more recent priority on letters as literature with the new priority on letters as argumentation.”"), _c('a', {
    attrs: {
      "href": "#/#foot-62",
      "id": "foot_62"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" He speaks of three basic rhetorical genres: the forensic/legal, the deliberative/symbouleutic, and the demonstrative/epideictic. Romans belongs to the last mentioned, “the epideictic genre, which is concerned with judgments about some present situation. The traditional categories for judgment are called ‘praise or blame’; we might call them today ‘0k or not ok’ judgments.”"), _c('a', {
    attrs: {
      "href": "#/#foot-63",
      "id": "foot_63"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The argumentation “sets out to increase the intensity of adherence to certain values, which might not be contested when considered on their own but may nevertheless not prevail against other values that might come into conflict with them.”"), _c('a', {
    attrs: {
      "href": "#/#foot-64",
      "id": "foot_64"
    }
  }, [_c('sup', [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is an interesting approach and one which draws attention to features of Romans which have received scant attention. But it is possible to feel uneasy at the rigidity of literary style it ascribes to such an unlikely conformist as Paul."), _c('a', {
    attrs: {
      "href": "#/#foot-65",
      "id": "foot_65"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" And in any case this approach scarcely answers the main question. Granted that this was the way Paul wrote, why did he write at all? Why did he decide that an epideictic communication to the Roman church was what was needed? Did this arise from Paul’s situation or that in Rome?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A more acceptable form of this view has been put forward by Robert "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Jewett.")]), _c('a', {
    attrs: {
      "href": "#/#foot-66",
      "id": "foot_66"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" He notes that there is a great variety in epideictic literature and demonstrates the point by reproducing Theodore C. Burgess’s list of 27 subtypes. He holds that Romans is properly to be understood as an ambassadorial letter, though with features of other subtypes, “the passionate letter, the hortatory letter, and the philosophical diatribe.”"), _c('a', {
    attrs: {
      "href": "#/#foot-67",
      "id": "foot_67"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" The need to include these other subtypes perhaps shows that Jewett is oversimplifying; Romans is too complex to be regarded as simply an example of the ambassadorial letter. But Jewett has done us a service in drawing attention to the many diplomatic touches in this epistle, and specifically to Paul’s acceptance of a variety of teachings as long as the essentials of the gospel are preserved. “It is the synthesis that constitutes Paul’s distinctive perspective, the serious effort to unite the Gentile and the Jewish Christian confessions, hymns, and interpretive traditions.”"), _c('a', {
    attrs: {
      "href": "#/#foot-68",
      "id": "foot_68"
    }
  }, [_c('sup', [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("11. A Dialogue with Judaism.")]), _vm._v(" J. Christiaan Beker holds that Paul is concerned in this letter to respond to questions Jews might ask, such as “What is Israel’s role in salvation-history?” and “What is the function of the Torah and circumcision?” He says that “Romans is a dialogue with Judaism” and again, “Romans must be characterized primarily as a dialogue with Jews.”"), _c('a', {
    attrs: {
      "href": "#/#foot-69",
      "id": "foot_69"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" It is a novel idea that this great Christian writing, possibly the greatest of them all, is really not directed at Christians but at Jews. The novelty need not disturb us, but the argumentation is not convincing. The letter is addressed to Roman Christians, and Beker has not given a convincing reason why it should not be understood as directed towards the addressees. While no one knows what the precise composition of the Roman church was at the time, it is usually held that there was a strong Gentile component. Moreover, Beker confines “The Jewish Character of the Argument” to 1:16–4:25, which leaves out most of the letter. And it includes 1:19-32, which most see as addressed to Gentiles (and which does seem pointless if directed at Jews; Beker’s idea that it is Paul’s intention here “to set a trap for the Jewish auditor”"), _c('a', {
    attrs: {
      "href": "#/#foot-70",
      "id": "foot_70"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" is not convincing). The viewpoint is interesting, but the evidence does not support it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("12. Preparation for a Visit.")]), _vm._v(" Paul had never been to Rome, but for a long time he had wanted to visit the Christians there (1:8-13; 15:23). He had been hindered from coming to them (1:13; 15:22), which appears to mean that he had tried to come but had been stopped. But when he wrote, he had the prospect of a trip to Spain. He saw this as a good opportunity to visit Rome. When he headed West, it was unthinkable that he would pass by this great church which he had so greatly longed to see. The epistle must be seen, then, as a means of preparing the way for a visit. Paul wanted to exercise a ministry in Rome (1:11-15). This was to be more than a halt by the way as he enlisted support for his mission to Spain. He wanted to get to know the Roman church "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("and to preach in the world’s greatest city. He wanted the support of the Roman Christians in his further missionary work as he had had that of the church of Antioch in the preceding period.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Since Paul was not the most popular of men in the early church, it is likely that he had been criticized in Rome as elsewhere (cf. 3:8). He clearly regarded it as important that the Roman church support him on his Spanish mission (15:24). If they were to support him, it was not unreasonable that they should know what he preached. Accordingly he sets forth a clear but profound statement of the essential message of Christianity as he proclaimed it.")]), _c('a', {
    attrs: {
      "href": "#/#foot-71",
      "id": "foot_71"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" This will show the Romans where he stands. The result is one of the most important Christian documents ever written."), _c('a', {
    attrs: {
      "href": "#/#foot-72",
      "id": "foot_72"
    }
  }, [_c('sup', [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-parat"
  }, [_vm._v("With the experts so divided, it is plain that the evidence does not all point in one direction. In my opinion the last-mentioned view is on the whole the most satisfactory (which is not to say that it clears up all the difficulties; it does not). It takes cognizance of the fact that Paul had been a missionary for 20 years or so. With the completion of his mission to the East (15:19) an important chapter of his life had closed. It is not unreasonable to suppose that, with this work done and with a mission field in Spain before his mind’s eye, Paul hoped to transfer his base from Antioch to Rome. But before anything else happened he had a little time when he could be quiet (the three months of Acts 20:3). He used the time to write to the Roman Christians to let them know of his plan to visit them and to set down in order something of what the gospel meant."), _c('a', {
    attrs: {
      "href": "#/#foot-73",
      "id": "foot_73"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" If Rome was to be his base, the Romans would need to be assured of his message and theological position. Thus such a weighty epistle is very much in place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We may discern at least three things Paul specifically says he wanted to accomplish by his letter. First, he wanted to prepare the way for a visit to Rome (1:13; 15:22-24). Second, he wanted to secure the support of the Roman Christians for his Spanish mission (15:24). Third, he sought the prayers of the "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Romans, specifically prayers that he might be delivered from unbelievers, that the Jerusalem church would welcome the gift he was bringing,")]), _c('a', {
    attrs: {
      "href": "#/#foot-74",
      "id": "foot_74"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" and that he might come to Rome “in joy” (15:30-32).")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-5"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Romans is not greatly taken up with local issues (as is, e.g., 1 Corinthians). It is true that Paul is apparently not unmindful of certain happenings at Rome. Thus he has a good deal to say about positions taken up by Jews. It would be pointless to mention such views unless the Roman Christians knew that Jews did teach such things (2:17; 3; 4:1; 7:13; 9:31-32; 11:11, etc.). There are references to antinomian objections to Christian discipline (3:8, 31; 6:1, 15; 7:7ff.) and to Gentile arrogance over against the Jews (11:18ff.), and a warning against people “who cause divisions and put obstacles in your way that are contrary to the teaching you have learned” (16:17). Paul knows of the faith of the Roman Christians (1:8) and of their obedience (16:19). He speaks of the “strong” and the “weak” in such a way as to lead to the conclusion that both groups were represented at Rome (14:1–15:13). But, though such aspects of the epistle show that Paul had some knowledge of conditions at Rome, the letter is much more concerned with teachings which are timeless and which do not arise from contemporary Roman circumstances. It may be significant that Paul nowhere indicates that he had had communications from the church at Rome as he had had, for example, from the Corinthians (they had written to him, 1 Cor. 7:1; Chloe’s people had given Paul news, 1 Cor. 1:11; and Stephanas and others had come from Corinth, 1 Cor. 16:17; there is no equivalent in Romans).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The letter is not to be understood apart from Paul’s own experience. He had been brought up an orthodox Jew, a loyal Pharisee, fanatical to the point of persecuting the Christians. But on the Damascus road he had come face to face with the risen Christ. This encounter revolutionized his entire way of thinking and living. He saw now that God had been active in Christ and that it was through the cross that he had brought salvation to mankind. Grace, not "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("law, was decisive. Romans puts great stress on the divine initiative and on the centrality of grace. Paul is not taking his own experience as normative. An important section of the epistle is taken up with God’s dealings with Abraham, and another with his activities with his own people Israel. But while God might deal with people in different ways, he has always acted by the way of grace.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("By the time he wrote this letter Paul had been a Christian preacher for something like 20 years. He had three months without pressing commitments (Acts 20:3). He may well have felt that this was a good time, as the projected visit to Rome was a good occasion, to set out in order a summary of the gospel and its consequences as he understood them. In view of the uncertainties surrounding his reception at Jerusalem he may have thought that if he could secure the approval of the Roman Christians this would have good results at Jerusalem too (though there appears to be no way by which any Roman approval could have been known in Jerusalem in time to be of help to him).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("After these preliminaries Paul states briefly the thesis of his letter, stressing the power of God manifest in the gospel and the importance of faith (1:16-17). Then he proceeds to a massive argument in which he shows that all people, Gentiles and Jews alike, are sinners and in danger of the judgment of God (1:18–3:20). This leads to the tremendous thought that by sending Christ to die on the cross God has opened the way for people to have right standing, “righteousness” before him. This means that their sin is put away, and that they are not required to earn their salvation by their own merit. Not that this is a new discovery. Paul goes back to Abraham to show that this had always been God’s way.")]), _c('a', {
    attrs: {
      "href": "#/#foot-75",
      "id": "foot_75"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" Then he goes right back to Adam to show that the entail of sin which has shackled the human race from the very first has been broken in Christ. Though he puts such emphasis on justification by faith, Paul is not insensitive to the need for upright living; his doctrine that forgiveness is God’s free gift in no way opens the door to a sluggard Christianity bereft of moral effort. He then goes on to the importance of a clean break with sin and to the gift of the Holy Spirit which enables the believer to walk in the ways of God (chs. 6–8).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Following this he gives himself over to a subject which clearly concerned him deeply, namely the problem posed by the fact that, though the Jews were God’s own people, they had rejected God’s Messiah when he came. For three chapters Paul wrestles with the question of whether God has rejected his people and concludes that God has acted and always will act in mercy (chs. 9–11). In the final major section of the letter (chs. 12–15) he writes of the way in which the life of faith is to be lived in the actual world in which we find ourselves, and he rounds it all off with a section of greetings and the like (ch. 16).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("This is a massive treatment of great themes, themes which are right at the heart of the Christian faith. Romans does not offer much that is new. In his earlier writings Paul has given expression to many of the themes he develops in this epistle.")]), _c('a', {
    attrs: {
      "href": "#/#foot-76",
      "id": "foot_76"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" But there is a sustained depth in Romans which is unmatched, and a concentration on the great, central doctrines of the Christian faith."), _c('a', {
    attrs: {
      "href": "#/#foot-77",
      "id": "foot_77"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" When these great thoughts are lost sight of, what remains is not authentic Christianity. But when they are affirmed, essential Christianity is proclaimed. Perhaps this is why Romans has a way of coming to the fore at any time of revival of vital Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One point that is often overlooked and should be stressed is that Romans is fundamentally a book about God."), _c('a', {
    attrs: {
      "href": "#/#foot-78",
      "id": "foot_78"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" It is obvious to all that Romans is concerned with the gospel, with salvation, and so on. But many students seem not to have noticed Paul’s preoccupation with God. The thought of God dominates this epistle. The word “God” occurs 153 times in Romans, an average of once every 46 words. This is more often than in any other New Testament writing (except the short 1 Peter and 1 John). Acts has the word 166 times, but since it is so much longer this works out to once in 110 words. The only other books with more than 100 occurrences are Luke with 122 and 1 Corinthians with 105. And not only does “God” occur in Romans more frequently than in any other writing, it occurs more often than any other theme in that book. Apart from a few prepositions, pronouns, and the like,"), _c('a', {
    attrs: {
      "href": "#/#foot-79",
      "id": "foot_79"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" no word is used in Romans with anything like the frequency of “God”. Next is “law” (72 times), then “Christ” (65), “sin” (48), “Lord” (43), and “faith” (40). Statistics must always be used with caution, but these figures draw attention to the important fact that in Romans the one great theme is God. Paul writes on a number of topics, but everything is related to God. He sees law, for example, not in the abstract but in relation to the way of God. He sees Christ as bringing about “the righteousness of God”. He sees sin as sin against God. And so on. Romans may truly be described in a way that no other book can be, as a book about God. It is perhaps this that gives it its importance and its appeal."), _c('a', {
    attrs: {
      "href": "#/#foot-80",
      "id": "foot_80"
    }
  }, [_c('sup', [_vm._v("80")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("THE SHORTER EDITION(S)")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("There are problems at the end of Romans. From the fact that the doxology (16:25-27) is found at the end of ")]), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" in the very important P"), _c('sup', [_vm._v("46")]), _vm._v(" (the oldest extant MS of the Pauline epistles) some, notably T. W. Manson, have reasoned that there was at one time a 15-chapter edition."), _c('a', {
    attrs: {
      "href": "#/#foot-81",
      "id": "foot_81"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" This cannot be dismissed as impossible. It is easy to conjecture that Paul wrote a 15-chapter edition or that "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" with all its local interest was omitted when the letter circulated outside Rome. But it remains conjecture, and the lack of supporting evidence tells against it. The occurrence of the doxology at the end of "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" may be significant. On the other hand it may mean no more than that one scribe did not think "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" suitable for reading to a congregation. And we must bear in mind that neither with nor without the doxology does the close of "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" conform to Paul’s normal way of closing letters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is more to be said for a 14-chapter edition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("1. The doxology")]), _vm._v(" is found at the end of "), _c('span', {
    attrs: {
      "href": "#/024_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 14")]), _vm._v(" in many MSS."), _c('a', {
    attrs: {
      "href": "#/#foot-82",
      "id": "foot_82"
    }
  }, [_c('sup', [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("2. Marcion")]), _vm._v(" appears to have had a 14-chapter edition. Tertullian says this,"), _c('a', {
    attrs: {
      "href": "#/#foot-83",
      "id": "foot_83"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" and Origen lends support."), _c('a', {
    attrs: {
      "href": "#/#foot-84",
      "id": "foot_84"
    }
  }, [_c('sup', [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("3. The Breves.")]), _vm._v(" One MS of the Vulgate, the Codex Amiatinus, has the usual 16 chapters, but it also has some numbered summaries of sections of the epistle, which are called "), _c('em', [_vm._v("breves.")]), _vm._v(" No. 50 reads, “Concerning the danger of "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("grieving a brother by one’s food, and that the kingdom of God is not food and drink, but righteousness and peace and joy in the Holy Spirit.” This clearly refers to 14:13-23. No. 51, however, reads, “Concerning the mystery of the Lord kept in silence before the passion, his truth having been revealed after the passion.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-85",
      "id": "foot_85"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" This surely refers to the doxology (16:25-27). Thus these summaries are no doubt based on a shorter edition and not on the 16-chapter edition to which they are now attached."), _c('a', {
    attrs: {
      "href": "#/#foot-86",
      "id": "foot_86"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" They are found in a number of other MSS, so the system was widely used. Harry Gamble also points to Codex Fuldensis, in which "), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("Romans 1–14")]), _vm._v(" is divided into 23 sections followed by the Amiatine divisions 24-51."), _c('a', {
    attrs: {
      "href": "#/#foot-87",
      "id": "foot_87"
    }
  }, [_c('sup', [_vm._v("87")])]), _vm._v(" There are problems here, but since the Fuldensian divisions end at "), _c('span', {
    attrs: {
      "href": "#/024_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 14")]), _vm._v(" this is further evidence for a 14-chapter edition. We should add a reference to an ancient concordance to the Pauline epistles found in some Vulgate MSS where heading no. 42 refers to Romans 14:17ff., and no. 43 to the doxology."), _c('a', {
    attrs: {
      "href": "#/#foot-88",
      "id": "foot_88"
    }
  }, [_c('sup', [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("4. Tertullian, Irenaeus, and Cyprian")]), _vm._v(" make no quotations from "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 15")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#foot-89",
      "id": "foot_89"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" They have left rather full writings, and some of the matter in these chapters would have been useful to them. They stand in contrast to Clement of Alexandria, who has quite a number of citations from these two chapters. But early Western writers generally make no appeal to "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 15–16")]), _vm._v(". As Gamble puts it, “the cumulative "), _c('em', [_vm._v("argumentum e silentio")]), _vm._v(" is quite strong: there is a consensus of Western writers through the third century, no part of the text is quoted even where its appropriateness is obvious, and the extent of the text is such that silence on it can have but one explanation: chs. 15 and 16 of the Roman letter were not generally known in the West for a long time.”"), _c('a', {
    attrs: {
      "href": "#/#foot-90",
      "id": "foot_90"
    }
  }, [_c('sup', [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("5. The Marcionite Prologue to Romans")]), _vm._v(" says that the letter was written “from Athens”."), _c('a', {
    attrs: {
      "href": "#/#foot-91",
      "id": "foot_91"
    }
  }, [_c('sup', [_vm._v("91")])]), _vm._v(" This presupposes the 14-chapter edition, since the last two chapters so clearly point to Corinth as the place of origin (15:25-27; 16:1, 23).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All this convinces most students that a 14-chapter edition did at one time exist. But it is not clear how this was related to the longer edition. One suggestion is that the shorter form came first and that it was written as a "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("circular.")]), _c('a', {
    attrs: {
      "href": "#/#foot-92",
      "id": "foot_92"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" Those who hold this remind us of the absence of “in Rome” from some MSS. They suggest that when Paul wanted to write to the Romans, he adapted an original circular with the insertion of the appropriate words in 1:7, 15 and the addition of the last two chapters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There are, however, strong objections. Thus it is not easy to think that the warm words of 1:8-15 were not originally meant for any specific people (see also 1:6). Again, there is not a great deal of evidence that the words “in Rome” were missing at the same time as "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapters 15")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#foot-93",
      "id": "foot_93"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" A very important consideration is that the argument does not break off at the end of "), _c('span', {
    attrs: {
      "href": "#/024_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 14")]), _vm._v(" but continues right on to 15:13. It is difficult to think of a reason why Paul should have ended the letter at 14:23. The authenticity of "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" seems obvious to most students. But if Paul did not write it when he wrote chapters 1–14, when did he write it? There is no obvious answer. Some scholars add that they find affinities between 1:8-13 and 15:14-32. These are not so much repetitions and the like as the kind of thinking natural in two parts of the same letter. For such reasons we should reject the idea that the 14-chapter edition was original, though it was certainly used very widely."), _c('a', {
    attrs: {
      "href": "#/#foot-94",
      "id": "foot_94"
    }
  }, [_c('sup', [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It seems, then, that we should take the longer edition as what Paul wrote. But this raises the interesting question of how the shorter edition came to exist. It is most unlikely that Paul himself should have cut off the end of his argument,"), _c('a', {
    attrs: {
      "href": "#/#foot-95",
      "id": "foot_95"
    }
  }, [_c('sup', [_vm._v("95")])]), _vm._v(" and in any case 14:23 is a curious place to end an epistle. A number of suggestions have been made.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("1.")]), _vm._v(" Scribes found little of value for general reading in the last two chapters, and thus omitted them. Gamble thinks that the shortening was due to a desire to make the letter more general."), _c('a', {
    attrs: {
      "href": "#/#foot-96",
      "id": "foot_96"
    }
  }, [_c('sup', [_vm._v("96")])]), _vm._v(" With the local features cut out, this great writing was seen to belong to the church at large. This is quite possible. But why stop at 14:23, in the middle of Paul’s argument?"), _c('a', {
    attrs: {
      "href": "#/#foot-97",
      "id": "foot_97"
    }
  }, [_c('sup', [_vm._v("97")])]), _vm._v(" It would be a strange proceeding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Some see the shortening as due to the demands of liturgy. When the letter was read during worship, the last two chapters were omitted as unsuitable for worship. This may be so, though it can never be more than a guess. "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("And again, why stop at 14:23? The early part of ")]), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" at any rate is quite suitable in the liturgy."), _c('a', {
    attrs: {
      "href": "#/#foot-98",
      "id": "foot_98"
    }
  }, [_c('sup', [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Many consider Marcion to be the most likely candidate. He would not have liked the way the Old Testament is used in "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(" (the quotations in vv. 9-12, and especially the way it is described in v. 4). Nor would he have cared to refer to Christ as “a servant to the circumcised” (v. 8)."), _c('a', {
    attrs: {
      "href": "#/#foot-99",
      "id": "foot_99"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" The principal objection to Marcion is that the shorter edition was used so widely. Could a heretic have had such a wide influence?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("4.")]), _vm._v(" The shortening may have been accidental. The end of a papyrus scroll could easily be damaged and break off. Against this is the widespread use of the shorter version. Could one damaged copy have had such wide influence? Or several copies break off at exactly the same place?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("None of the suggestions is entirely convincing. There are strong objections to them all. Perhaps the view with most in its favor is that Marcion was the culprit, but we can scarcely put it more strongly than that.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-7"
    }
  }, [_vm._v("THE DESTINATION OF CHAPTER 16")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Quite a different question is the original destination of "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(". Many scholars wonder whether this was meant for the Roman church, and some take it as axiomatic that it was not. Usually such hold that its original destination was Ephesus but that it has somehow become attached to Romans. The following points are relevant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("1. The salutations")]), _vm._v(" are surprisingly numerous when we recall that Paul had never been to Rome. He greets 26 individuals (24 by name) and five households or house churches. He speaks of three “fellow-workers”, two “fellow-prisoners”, three people whom he calls “beloved”, and a lady he greets as his mother. “Had Paul’s friends, it is asked, migrated in a body to Rome?”"), _c('a', {
    attrs: {
      "href": "#/#foot-100",
      "id": "foot_100"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" It is felt that he is more likely to have this number of friends at Ephesus (where he had ministered extensively) than at Rome (where he had never been).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But there is more to it than this. We must ask, for example, what would have been the reaction on others at Ephesus if 26 of their number were greeted in a letter read out in the assembly."), _c('a', {
    attrs: {
      "href": "#/#foot-101",
      "id": "foot_101"
    }
  }, [_c('sup', [_vm._v("101")])]), _vm._v(" Paul must have known more than 26 of "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("them quite well. It would have been invidious to make a selection. Moreover, Paul does not normally send greetings to members of churches he knew. Such a practice would create obvious difficulties. No such greetings are found in 1 and 2 Thessalonians, 1 and 2 Corinthians, Galatians, or Philippians. Indeed, the only Pauline letter with anything of the sort is Colossians, another letter to a church Paul had not visited. Even there he greets only one person by name (Nympha, Col. 4:15), the other greetings being from people Paul names.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('em', [_vm._v("2. Connections with Rome.")]), _vm._v(" Some point out that most of the names in Paul’s list are found in the inscriptions in Rome. But it is fairly countered that there are so many names in this vast list that inclusion proves nothing. Most names occur in it somewhere. The most we can say is that there is nothing improbable about the names Paul lists.")]), _c('a', {
    attrs: {
      "href": "#/#foot-102",
      "id": "foot_102"
    }
  }, [_c('sup', [_vm._v("102")])]), _vm._v(" Some of them may, however, be significant. For example, a Rufus (v. 13) is mentioned in Mark 15:21, apparently for no other reason than that he was known to Mark’s readers (he does nothing in Mark). Since our second Gospel is usually connected with Rome, we may well have a link here. Again, Paul mentions the household of Narcissus (v. 11). This is the name of a powerful freedman who was executed by Nero. According to custom his slaves would have passed to the Emperor, retaining the name of their former owner."), _c('a', {
    attrs: {
      "href": "#/#foot-103",
      "id": "foot_103"
    }
  }, [_c('sup', [_vm._v("103")])]), _vm._v(" There may be a similar link with Aristobulus (v. 10), for a grandson of Herod the Great bearing this name died in Rome. He was a friend of the Emperor Claudius, and his slaves may well have passed into imperial possession.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("3. Aquila and Prisca")]), _vm._v(" (v. 3) seem to have been wealthy (they had a house large enough for a church to meet in it) and to have travelled widely."), _c('a', {
    attrs: {
      "href": "#/#foot-104",
      "id": "foot_104"
    }
  }, [_c('sup', [_vm._v("104")])]), _vm._v(" They went to Ephesus with Paul (Acts 18:18), and they were there later on (1 Cor. 16:19; 2 Tim. 4:19)."), _c('a', {
    attrs: {
      "href": "#/#foot-105",
      "id": "foot_105"
    }
  }, [_c('sup', [_vm._v("105")])]), _vm._v(" Indeed, the last time they are mentioned they are at Ephesus, and that in both Acts and the Pauline writings (Acts 18:26; 2 Tim. 4:19). The church in their house there (1 Cor. 16:19) seems to indicate settled residence. It is this link with Ephesus which as much as anything inclines some to hold that the chapter was originally destined for that city."), _c('a', {
    attrs: {
      "href": "#/#foot-106",
      "id": "foot_106"
    }
  }, [_c('sup', [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("But this couple can be held to support Rome. They left the capital city when Claudius expelled the Jews (Acts 18:2), and there seems no reason why they should not have returned after that Emperor’s death.")]), _c('a', {
    attrs: {
      "href": "#/#foot-107",
      "id": "foot_107"
    }
  }, [_c('sup', [_vm._v("107")])]), _vm._v(" In fact, the expulsion of the Jews may be the explanation of Paul’s knowledge of some, at least, of those mentioned in this chapter. They would have scattered widely, and he would have had the opportunity of meeting some of them. There is nothing improbable about his sending greetings to any he knew who had now returned to Rome. Many Jews lived in Rome early in Nero’s reign, and some were well accepted at court.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("4. Ampliatus")]), _vm._v(" (v. 8) is a name found on a very ancient tomb in the cemetery of Domitilla which may possibly go back as far as the end of the first century. Some hold this to be the very Ampliatus Paul mentions. This seems to be going too far (the name was not uncommon). But at least the name is connected with Christian circles in Rome at an early date.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Perhaps we should also notice the tradition of the Roman church which links Nereus and Achilleus with Domitilla, who was punished as a Christian under her cousin, the Emperor Domitian. The tradition goes back to the fourth century and may be older. It is not likely to depend on Romans since the two names are always linked in the tradition, as they are not in Romans."), _c('a', {
    attrs: {
      "href": "#/#foot-108",
      "id": "foot_108"
    }
  }, [_c('sup', [_vm._v("108")])]), _vm._v(" But it is not conclusive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All this means that there is nothing unlikely in Paul’s knowing such a group of people in Rome as those mentioned in "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 16")]), _vm._v(". Some of the names do seem to have connections with that city. Certainly they do not prove Ephesus."), _c('a', {
    attrs: {
      "href": "#/#foot-109",
      "id": "foot_109"
    }
  }, [_c('sup', [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("5. Epaenetus")]), _vm._v(" is called “the first-fruits of Asia for Christ” (v. 5). Such a "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("man, it is said, is more likely to be in Ephesus than in Rome. But this can be put too strongly. People travelled widely at this time, and it is not unlikely for someone to move from the province of Asia to the capital, Rome. In fact, something like this may be necessary if there is to be point in mentioning that he was Asia’s firstfruits. In Ephesus this would be well known and scarcely worth mentioning. Not so at Rome.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('em', [_vm._v("6. The commendation of Phoebe")]), _vm._v(" (v. 1) would be more natural to a church Paul knew than to one where he had never been. To which it may fairly be retorted that Paul’s commendation would carry weight anywhere. He was not exactly unknown in the early church.")]), _c('a', {
    attrs: {
      "href": "#/#foot-110",
      "id": "foot_110"
    }
  }, [_c('sup', [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("7. The greeting in 16:16,")]), _vm._v(" “All the churches of Christ greet you”, looks like a warm expression of fellowship from the representatives of the churches gathered with Paul at the time he wrote his letter (Acts 20:3-4). It would be natural for the assembled provincials to send greetings to the church in the capital. But what would the words mean if written to Ephesus? Especially so as Ephesus was represented among Paul’s companions (Trophimus, Acts 20:4, was an Ephesian, Acts 21:29; possibly Tychicus also).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("8. The antinomianism of 16:17ff.")]), _vm._v(" seems more pronounced than anything in other parts of Romans. It is urged that it is more likely to be found in Asia than in Rome, and further that there are resemblances in Paul’s words to the Ephesian elders (Acts 20:28ff.). It is also said that there are points of contact with the false teaching mentioned in 1 and 2 Timothy and that this should be located at Ephesus. It is not unlike that encountered in Colossians, a church in the same region. Again, Romans has a good deal to say about the relationship between Jews and Gentiles (who apparently had some difficulty in adjusting to one another), but there is nothing Jewish here. The tone is also said to be different from that earlier in the epistle (which is eirenic) and more akin to that in letters to churches of Paul’s own foundation, like Galatians and Corinthians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But all this is highly subjective. As a matter of fact we have no way at all of knowing how well the words applied in either place. Paul is speaking of a danger, a threat, not something that was in actual existence. Such a warning would be as conceivable addressed to Rome as to Ephesus. It is also true that from time to time in this epistle Paul clearly has in mind unethical tendencies (cf. 6:1-4, 15ff.; 8:5-13; 12:2). It would, moreover, be not in the least surprising if when he was warning against possible false teaching in one place (Rome) he were to couch his warning in terms derived from false teaching with which he was familiar in another place (Ephesus). The difference in tone should not be exaggerated. Warm appreciation is expressed in verse 19. And Gamble draws attention to Carl Bjerkelund’s examination of the way the exhortation in "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("verses 17-20 is introduced. He shows that it “is not an expression of authoritative demand or admonition, but a fixed epistolary element which functions as a polite, ‘urbane’ expression of request. It carries no polemical import, and appears to be used by Paul when his authority is not in question.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-111",
      "id": "foot_111"
    }
  }, [_c('sup', [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("9. 15:33 Looks like the End of a Letter.")]), _c('a', {
    attrs: {
      "href": "#/#foot-112",
      "id": "foot_112"
    }
  }, [_c('sup', [_vm._v("112")])]), _vm._v(" Perhaps. But none of Paul’s other letters ends like this. And for that matter 15:13 looks as much like the end of a letter as does 15:33. Other possible “ends” could doubtless be picked out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("10. The Character of "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _vm._v(".")]), _vm._v(" The objection of Hans Lietzmann is often quoted: “A letter consisting almost entirely of greetings may be intelligible in the age of the picture-postcard; for any earlier period it is a monstrosity.”"), _c('a', {
    attrs: {
      "href": "#/#foot-113",
      "id": "foot_113"
    }
  }, [_c('sup', [_vm._v("113")])]), _vm._v(" Writing a letter in antiquity was not as easy as at present; thus when anyone did write he had something more serious to say than simply to pass on greetings. If it be retorted that an earlier part of the letter probably existed but that this is all that survives, it must be countered that this is to bolster up one hypothesis with another. There is no evidence of such a letter. It would be curious for the letter to be lost and the greetings to survive."), _c('a', {
    attrs: {
      "href": "#/#foot-114",
      "id": "foot_114"
    }
  }, [_c('sup', [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Lietzmann’s objection is not quite as strong as it seems, for there are examples of short letters with extensive greetings."), _c('a', {
    attrs: {
      "href": "#/#foot-115",
      "id": "foot_115"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" We must, however, notice the kind of letter. If "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" is an entire letter, then it is a letter of commendation of Phoebe. But greetings are almost invariably absent from letters of introduction."), _c('a', {
    attrs: {
      "href": "#/#foot-116",
      "id": "foot_116"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" “Of the eighty-three letters collected by Kim only three contain greetings (… all third and fourth century), and these have only one greetings-phrase each. Also, Cicero’s letters of recommendation characteristically lack greetings.”"), _c('a', {
    attrs: {
      "href": "#/#foot-117",
      "id": "foot_117"
    }
  }, [_c('sup', [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("But if letters of commendation do not normally contain greetings, letters written for other purposes often contain commendations.")]), _c('a', {
    attrs: {
      "href": "#/#foot-118",
      "id": "foot_118"
    }
  }, [_c('sup', [_vm._v("118")])]), _vm._v(" Paul himself does this sort of thing elsewhere (e.g., 1 Cor. 16:10-11, 15-18). Gamble concludes: “Thus in the secular letter tradition and in Paul’s own letters we have precise analogies for the commendation in Rom 16:1-2 in form, content, and position within the letter’s conclusion. We are thereby warned against detaching ch. 16 from the larger Roman letter on the grounds that it has the character of a note of recommendation. That vss. 1-2 have the character imposes no necessity and creates no likelihood that the chapter was originally independent.”"), _c('a', {
    attrs: {
      "href": "#/#foot-119",
      "id": "foot_119"
    }
  }, [_c('sup', [_vm._v("119")])]), _vm._v(" The character of "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(", then, is such as to make it likely that from the beginning it belonged at the end of this letter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("11. Rhetorical Structure.")]), _vm._v(" We noted earlier that Wilhelm Wuellner argues that the rhetorical character of Romans is very significant. When he comes to deal with the constituent parts of the writing, he takes 15:14–16:23 as the peroration. He can say, “It is my thesis that the "), _c('em', [_vm._v("pathos")]), _vm._v(" section of the peroration in Romans extends from 15:30 to 16:23.”"), _c('a', {
    attrs: {
      "href": "#/#foot-120",
      "id": "foot_120"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" That such a position can be taken up shows from another angle that "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" is not self-evidently detachable from "), _c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("12")]), _vm._v(". "), _c('em', [_vm._v("Epistolary Structure.")]), _vm._v(" Gamble has an important section in which he examines the endings of the Pauline letters. A good deal of attention has been given to the openings, but not so much to the endings. Gamble shows that the Pauline letters regularly end with the following sequence:")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. Hortatory remarks")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("2. Wish of peace")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("3. Greetings")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("4. Grace-benediction"), _c('a', {
    attrs: {
      "href": "#/#foot-121",
      "id": "foot_121"
    }
  }, [_c('sup', [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If the letter ended at 14:23 or at 15:33, the Pauline pattern has been disrupted. The ending sequence which is invariable elsewhere in Paul has then been abandoned on this occasion. Why? The other side of this argument is that "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 16")]), _vm._v(" contains the normal Pauline pattern for a letter ending (though with some minor problems like the possible double grace- "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("benediction, vv. 20b, 24). But the chapter does not comply with what we normally find in a complete letter.")]), _c('a', {
    attrs: {
      "href": "#/#foot-122",
      "id": "foot_122"
    }
  }, [_c('sup', [_vm._v("122")])]), _vm._v(" Its form indicates that, if it is not the end of Romans, it is the end of some other letter. Which?"), _c('a', {
    attrs: {
      "href": "#/#foot-123",
      "id": "foot_123"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" We can sum up the position in this way. We have:")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 1–16")]), _vm._v(", a Pauline letter with a Pauline ending")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("2. "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 16")]), _vm._v(", a normal Pauline ending")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("3. A manuscript tradition in which "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 16")]), _vm._v(" is invariably attached to "), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("Romans 1–15")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is not easy to escape the conclusion that "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 16")]), _vm._v(" is the intended and original conclusion to the letter."), _c('a', {
    attrs: {
      "href": "#/#foot-124",
      "id": "foot_124"
    }
  }, [_c('sup', [_vm._v("124")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("13")]), _vm._v(". "), _c('em', [_vm._v("The laudatory character of the greetings")]), _vm._v(" may be significant. Whenever Paul describes someone in this chapter to whom he sends a greeting, it is always complimentary (e.g., 16:4, 6, 7). This would result in the individual’s being accorded respect in the community. But it also classed the person with Paul. The link might be expected to cause such people to be his advocates. “That epistolary greetings should be turned to this effect would hardly be comprehensible if they were addressed to a community whose recognition of himself Paul could have presumed. Only if addressed to the Roman church, where such recognition could not be assumed—a fact acknowledged in Paul’s cautious and apologetic approach to it (15:14-21)—does the peculiar character of the greetings of Rom 16 make any sense.”"), _c('a', {
    attrs: {
      "href": "#/#foot-125",
      "id": "foot_125"
    }
  }, [_c('sup', [_vm._v("125")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("From all this it seems that we should regard "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" as an integral part of Romans. It is true that some have put forward arguments of greater or "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("less force to indicate that it should be seen as a separate letter or part of another letter. But the evidence for such views is not convincing. The presumption must always be that a writing that comes down to us as part of an ancient document is to be seen as part of that document until the contrary is proved.")]), _c('a', {
    attrs: {
      "href": "#/#foot-126",
      "id": "foot_126"
    }
  }, [_c('sup', [_vm._v("126")])]), _vm._v(" In this case sufficient evidence is not forthcoming, while on the contrary there are some strong indications that "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 16")]), _vm._v(" belongs with "), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("chapters 1–15")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_1",
      "id": "foot-1"
    }
  }, [_vm._v("1")]), _vm._v(". The continuing relevance of Romans is illustrated by the articles in the January 1980 issue of "), _c('em', [_vm._v("Interpretation.")]), _vm._v(" This whole number is given over to Romans. The articles cover a wide range and leave no doubt about the fact that this epistle still plays a vital role in the life of the church.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_2",
      "id": "foot-2"
    }
  }, [_vm._v("2")]), _vm._v(". The statistics in this section are taken from Alfred Wikenhauser, "), _c('em', [_vm._v("New Testament Introduction")]), _vm._v(" (New York, 1958), pp. 346-47.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_3",
      "id": "foot-3"
    }
  }, [_vm._v("3")]), _vm._v(". For a discussion of types of letters in antiquity see especially William G. Doty, “The Classification of Epistolary Literature”, CBQ, XXXI (1969), pp. 183-99; Martin Luther Stirewalt, Jr., “The Form and Function of the Greek Letter-Essay”, Donfried, pp. 175-206. Doty discerns eight classes with up to seven subclasses grouped under his headings, and he does not claim to be exhaustive. He points out that the Hellenistic school handbooks included 21 and later 41 specific types (pp. 196-97).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_4",
      "id": "foot-4"
    }
  }, [_vm._v("4")]), _vm._v(". E. A. Judge and G. S. R. Thomas argue that there was no church in Rome when Paul wrote, nor indeed right up to the time when he came to Rome as a prisoner. That was when he formed the individual Christians in that city into a church (“The Origin of the Church at Rome: A New Solution?” RThR, XXV [1966], pp. 81-94). They point to the lack of reference to an ἐϰϰλησία at Rome, or to officials like bishops, priests, and deacons, or to ordinances like baptism (though cf. Rom. 6:3-4) and the Lord’s Supper. But Paul rarely refers to these anywhere. He has general references to churches, but the only specific groups to which he applies the term are house churches (including Rom. 16:5) and those at Corinth, Cenchraea, Philippi, Laodicea, and Thessalonica. This despite the fact that his use of the plural (e.g., Gal. 1:2; 1 Thess. 2:14) shows that he saw the term as widely applicable. Apart from Rom. 6:4 the only occurrences of βάπτισμα in the Pauline corpus are in Eph. 4:5 and Col. 2:12, while the corresponding verb is used a number of times in 1 Corinthians, in Gal. 3:27, and nowhere else in the Pauline corpus except Romans. The discussion of the reference in Suetonius (see below, p. 4) I do not find convincing, while the failure of the Jews Paul met when he eventually came to Rome to mention a local church (Acts 28:22) does not mean that there was not one there. It may have been politic on their part to be silent on the matter, as William Neil thinks "), _c('em', [_vm._v("(The Acts of the Apostles")]), _vm._v(" [London, 1973], pp. 257-58). And Godet held that Roman Christianity was of Gentile origin; there had been no Christian preaching in the synagogues and thus no way the Jewish leaders would mention it (Godet, pp. 60-70). The article is a warning not to be overconfident and it reminds us that the small amount of evidence can be understood in more ways than one. But the best explanation of the evidence still seems to be that there was a church in Rome (Rom. 1:8). SH, of course, long ago suggested that Peter and Paul may have “founded” the church in Rome in the sense that they organized scattered groups into one whole (SH, p. xxxv).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_5",
      "id": "foot-5"
    }
  }, [_vm._v("5")]), _vm._v(". The words in question are lacking in 1:7 in the MSS designated G 1739"), _c('sup', [_vm._v("mg")]), _vm._v("1908"), _c('sup', [_vm._v("mg")]), _vm._v(" it"), _c('sup', [_vm._v("g")]), _vm._v(" Or"), _c('sup', [_vm._v("lat")]), _vm._v(". In 1:15 they are not found in G it"), _c('sup', [_vm._v("g")]), _vm._v(" Or"), _c('sup', [_vm._v("lat")]), _vm._v(". The case against the words can, however, be made a little stronger. The reading in G it"), _c('sup', [_vm._v("g")]), _vm._v(" in v. 7 may be translated “to all who are in the love of God”. Now the reading of some MSS, “to all who are in Rome in the love of God”, seems to be an adaptation of this reading to the more usual text (so, e.g., Bruce, pp. 25-26). If so, the scribes must have had both readings before them. We should also notice that the commentaries of Ambrosiaster and apparently also of Pelagius lacked the reference to Rome (see Gamble, p. 32). This is an interesting list, but even the combined testimony of these witnesses is scarcely enough to prove the point. They show that at some time the reference to Rome was missing. But the evidence of the overwhelming bulk of the MSS must be accepted as giving us the true reading.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_6",
      "id": "foot-6"
    }
  }, [_vm._v("6")]), _vm._v(". See his article “The Letter to the Romans—and Others”, BJRL, 31 (1948), pp. 224-40, reprinted in Manson’s book "), _c('em', [_vm._v("Studies in the Gospels and Epistles")]), _vm._v(" (Manchester, 1962), pp. 225-41. Quotations are from this reprint. Cf. also Manson, p. 941.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_7",
      "id": "foot-7"
    }
  }, [_vm._v("7")]), _vm._v(". Any ten adult male Jews could form a synagogue (Mishnah, Meg. 4:3; Sanh. 1:6; Ab. 3:6). There were many synagogues in Rome (W. Wiefel gives the names of 13 of them [Donfried, p. 106]). In Rome the term “synagogue” seems to have signified the community, the place of worship being called a "), _c('em', [_vm._v("proseucha")]), _vm._v(" (see R. Penna, NTS, 28 [1982], p. 327). It would be strange if Jewish Christians did not form synagogues of their own. The term is, of course, used of a Christian assembly (Jas. 2:2).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_8",
      "id": "foot-8"
    }
  }, [_vm._v("8")]), _vm._v(". For the relations between the Romans and the Jews see the note by Vincent M. Scramuzza, “The Policy of the Early Roman Emperors towards Judaism” (F. J. Foakes-Jackson and Kirsopp Lake, "), _c('em', [_vm._v("The Beginnings of Christianity,")]), _vm._v(" V [Grand Rapids, 1966], pp. 277-97).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_9",
      "id": "foot-9"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('em', [_vm._v("Life of Claudius")]), _vm._v(" xxv.4 (Loeb translation). Dio Cassius denies that Claudius expelled the Jews, saying that there were too many of them (lx.6.6). But he mentions the danger of rioting and speaks of the repressive measures adopted by Claudius. Clearly there was trouble, and this is the main point. Our interest is in “Chrestus” rather than in the precise action Claudius took. W. Wiefel understands Dio Cassius to mean that the Jews lost their right to assemble. He thinks that this refers not to the initial trouble but to the situation when the Jews were permitted to return. As a first step they were allowed to come back to Rome, but “synagogue assemblies were prohibited for some time since they were seen as seedbeds of dispute” (Donfried, p. 111). Judge and Thomas argue that “Chrestus” cannot refer to Jesus Christ (RThR, XXV, pp. 84ff.). Rather, it signifies “some religious star whose appearance at Rome caused an upheaval among the Jews, but whose fame was sufficiently ephemeral for his precise identity to have been lost” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 87). This is certainly possible. But riots instigated by Jews on account of Christian claims (like that at Ephesus, Acts 19:23ff.) seem more probable.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_10",
      "id": "foot-10"
    }
  }, [_vm._v("10")]), _vm._v(". J. Juster estimated that there were 50-60,000 Jews in Rome in the time of Tiberius (Les "), _c('em', [_vm._v("Juifs dans l’Empire Romain,")]), _vm._v(" I [Paris, 1914], p. 209). Penna thinks this number too high, as also the 30-40,000 of S. Collon, but regards "), _c('em', [_vm._v("Encyclopedia Judaica’s")]), _vm._v(" estimate of 10,000 as too low. Reasoning from the 8,000 Jews mentioned by Josephus ("), _c('em', [_vm._v("Ant")]), _vm._v(". xvii.299-303) and the 4,000 men of military age deported in "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 19 "), _c('em', [_vm._v("(Ant.")]), _vm._v(" xviii.81-84), he estimates the number as 20,000 in Nero’s day (NTS, 28, p. 328 and p. 341 nn.51-53).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_11",
      "id": "foot-11"
    }
  }, [_vm._v("11")]), _vm._v(". It is sometimes urged that the Roman church was predominantly Jewish-Christian, as by Theodor Zahn "), _c('em', [_vm._v("(Introduction to the New Testament,")]), _vm._v(" I [Edinburgh, 1909], pp. 421ff.). So, more recently, William Manson "), _c('em', [_vm._v("(The Epistle to the Hebrews")]), _vm._v(" [London, 1951], pp. 172-84). But not many have been persuaded. Paul was the apostle to the Gentiles (11:13). Why would he have written such a considerable letter to a predominantly Jewish church?")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_12",
      "id": "foot-12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('em', [_vm._v("Introduction to the New Testament")]), _vm._v(" (London, 1966), p. 219.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_13",
      "id": "foot-13"
    }
  }, [_vm._v("13")]), _vm._v(". Cf. A. F. J. Klijn, “It is impossible to determine which group formed the majority” "), _c('em', [_vm._v("(An Introduction to the New Testament")]), _vm._v(" [Leiden, 1967], p. 76); Martin Dibelius, “it appears to me to be useless to look for an answer in Romans to the much-discussed question whether the Roman Christians were Jewish or Gentile” "), _c('em', [_vm._v("(A Fresh Approach to the New Testament and Early Christian Literature")]), _vm._v(" [London, 1936], p. 162; he goes on to suggest that “the character of the church in the Capital was continually changing”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_14",
      "id": "foot-14"
    }
  }, [_vm._v("14")]), _vm._v(". Though perhaps we should notice the view of Robert M. Grant, who, on the basis of the names mentioned in ch. 16, judges it “likely that Romans was written not from Greece but from Macedonia, perhaps specifically from Philippi—or perhaps across the Aegean Sea, from Troas” "), _c('em', [_vm._v("(A Historical Introduction to the New Testament")]), _vm._v(" [London, 1963], p. 188). But the evidence is inadequate.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_15",
      "id": "foot-15"
    }
  }, [_vm._v("15")]), _vm._v(". See "), _c('em', [_vm._v("Beginnings,")]), _vm._v(" V, pp. 460-61; C. K. Barrett, "), _c('em', [_vm._v("The New Testament Background: Selected Documents")]), _vm._v(" (London, 1956), pp. 48-49. Jerome Murphy-O’Connor, "), _c('em', [_vm._v("St. Paul’s Corinth")]), _vm._v(" (Wilmington, DE, 1983), pp. 141-52, 173-76.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_16",
      "id": "foot-16"
    }
  }, [_vm._v("16")]), _vm._v(". Cf. Kümmel, “Paul’s encounter with Gallio perhaps took place in May or June of 51” "), _c('em', [_vm._v("(Introduction,")]), _vm._v(" p. 180).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_17",
      "id": "foot-17"
    }
  }, [_vm._v("17")]), _vm._v(". Cf. Günther Bornkamm, “in the winter of A.D. 55/56” (ABR, XI [1963], p. 2). Bruce thinks that Acts 20.2 covers more than a year, “say from the summer of A.D. 55 to the late part of A.D. 56” "), _c('em', [_vm._v("(Commentary on the Book of the Acts")]), _vm._v(" [London, 1954], p. 405). This would place Romans in early 57, a date which J. Α. T. Robinson accepts “confidently” "), _c('em', [_vm._v("(Redating the New Testament")]), _vm._v(" [London, 1976], p. 55). Cranfield regards the winter-spring of "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 55-56 or a year later as the most likely time (pp. 14, 16).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_18",
      "id": "foot-18"
    }
  }, [_vm._v("18")]), _vm._v(". See Ernst Haenchen, "), _c('em', [_vm._v("The Acts of the Apostles")]), _vm._v(" (Oxford, 1971), pp. 661-63; "), _c('em', [_vm._v("Beginnings,")]), _vm._v(" V, pp. 464-67, 471 n.1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_19",
      "id": "foot-19"
    }
  }, [_vm._v("19")]), _vm._v(". John Knox, IB, 9, p. 358. J. R. Richards argues for "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 54 (NTS, XIII [1966-67], p. 27).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_20",
      "id": "foot-20"
    }
  }, [_vm._v("20")]), _vm._v(". Despite the fact that J. A. T. Robinson says cheerfully that the occasion, as well as the author and date of the epistle, “are fortunately all beyond serious dispute” (Robinson, p. 1).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_21",
      "id": "foot-21"
    }
  }, [_vm._v("21")]), _vm._v(". In addition to this point Kümmel notes the references to “dissensions and difficulties, in opposition to the doctrine which you have been taught” (16:17-18); “Jewish errors and criticism of the gospel” (2:17; 3:1-31; 4:1; 7:13; 9:31-32; 11:11); “libertine-antinomian deductions from the message of the freedom of the Christians from the Law” (3:8, 31; 6:1,15; 7:7ff.); and “Gentile-Christian arrogance” (ll:13ff.). He does not see this as the account of a situation frequently encountered and thus a statement drawn up in the first place for general use, then adapted for Rome "), _c('em', [_vm._v("(Introduction,")]), _vm._v(" p. 221).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_22",
      "id": "foot-22"
    }
  }, [_vm._v("22")]), _vm._v(". Brevard S. Childs examines “The Problem of the Addressee” in this letter "), _c('em', [_vm._v("(The New Testament as Canon: An Introduction")]), _vm._v(" [London, 1984], pp. 260-63). He can say, “regardless of the concrete character of Paul’s original addressee, in their present literary form, the chapters serve to denote a genuine ambiguity. The occasional addressee recedes within the larger context and a universal referent emerges which far transcends local Roman party rivalries in order to speak a word for all” (p. 262).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_23",
      "id": "foot-23"
    }
  }, [_vm._v("23")]), _vm._v(". Cf. W. G. T. Shedd, “The object of the writer was to give to the Roman congregation, and ultimately to Christendom, a complete statement of religious truth” (Shedd, p. viii).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_24",
      "id": "foot-24"
    }
  }, [_vm._v("24")]), _vm._v(". He sees the epistle as addressed to “the great problem of all Christendom. What is the new that entered with Christ? What is it that the congregation has by faith in Him? And what is the relation between the new way of salvation, the way of faith, and the way in which the people of God had hitherto walked, the way of works?” (Nygren, p. 8).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_25",
      "id": "foot-25"
    }
  }, [_vm._v("25")]), _vm._v(". “The Letter to the Romans as Paul’s Last Will and Testament”, ABR, XI (1963), pp. 2-14.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_26",
      "id": "foot-26"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 12.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_27",
      "id": "foot-27"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 14. Barclay reminds us that Sanday called Romans “testamentary” and he comments, “It is as if Paul was writing his theological last will and testament” (Barclay, p. xxi). Gore quotes approvingly Hort’s view that the writing has the character of “last words” (Gore, p. 5).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_28",
      "id": "foot-28"
    }
  }, [_vm._v("28")]), _vm._v(". Leenhardt, p. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_29",
      "id": "foot-29"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 16. Later he asks, “Ought we to be surprised that the theme of the church, in spite of the absence of the word, should be as it were the horizon towards which all the main lines of the thought expounded in the letter tend?” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 20). In all honesty I can answer only, “Yes, we ought.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_30",
      "id": "foot-30"
    }
  }, [_vm._v("30")]), _vm._v(". See above, p. 3 n.6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_31",
      "id": "foot-31"
    }
  }, [_vm._v("31")]), _vm._v(". "), _c('em', [_vm._v("Studies,")]), _vm._v(" p. 240.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_32",
      "id": "foot-32"
    }
  }, [_vm._v("32")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 241.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_33",
      "id": "foot-33"
    }
  }, [_vm._v("33")]), _vm._v(". Interestingly, John Knox finds this section a principal argument for a circular letter (NTS, II [1955-56], pp. 191-93). He points to the fact that Paul does not indicate his destination anywhere in ch. 1; he says only that he “longs to see” the Romans (and similar expressions). He may accordingly be “leaving as it stood a letter which was originally composed for a type of Gentile church with which Paul is seeking to establish contact” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 192). But Knox pays no attention to the warmth of the personal tone of this section. Could Paul say of every Gentile church with which he sought to establish contact, “your faith is being reported all over the world” (1:8)? Or “I long to see you” (1:11)? Or that he had often tried to come to them (1:13)? This is particular, not general language.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_34",
      "id": "foot-34"
    }
  }, [_vm._v("34")]), _vm._v(". Cf. Bornkamm, “it seems to me very inadequate to understand Romans as a mere report and record of former controversies. In that case one would have to expect some concrete references to Paul’s opponents in the East; and those are completely lacking in our letter” (ABR, XI, p. 9).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_35",
      "id": "foot-35"
    }
  }, [_vm._v("35")]), _vm._v(". Donfried, pp. 61-74.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_36",
      "id": "foot-36"
    }
  }, [_vm._v("36")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 62. James Moffatt from a different point of view sees Paul’s own circumstances as primary, not anything in Rome: the aim is “to state, for the primary benefit of the Roman Christians, the χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ισμα πνευματιϰόν which Paul was conscious of possessing in his knowledge of the gospel” "), _c('em', [_vm._v("(An Introduction to the Literature of the New Testament")]), _vm._v(" [Edinburgh, 1927], p. 145).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_37",
      "id": "foot-37"
    }
  }, [_vm._v("37")]), _vm._v(". A. J. M. Wedderburn stresses the importance of the collection. It was not only a matter of money, but had symbolic significance. It was too late for the Romans to contribute, but they could at least support it and thus “endorse the Gentile mission and its gospel, whose fruits were being offered in the collection and in the persons of its bearers” (ET, XC [1978-79], p. 141).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_38",
      "id": "foot-38"
    }
  }, [_vm._v("38")]), _vm._v(". Jervell, in Donfried, p. 64.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_39",
      "id": "foot-39"
    }
  }, [_vm._v("39")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 74.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_40",
      "id": "foot-40"
    }
  }, [_vm._v("40")]), _vm._v(". Käsemann, p. 20,")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_41",
      "id": "foot-41"
    }
  }, [_vm._v("41")]), _vm._v(". Donfried, p. 46.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_42",
      "id": "foot-42"
    }
  }, [_vm._v("42")]), _vm._v(". “Paul’s Purpose in Writing the Epistle to the Romans”, "), _c('em', [_vm._v("ibid.,")]), _vm._v(" pp. 32-49.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_43",
      "id": "foot-43"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 44.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_44",
      "id": "foot-44"
    }
  }, [_vm._v("44")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 48.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_45",
      "id": "foot-45"
    }
  }, [_vm._v("45")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 49.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_46",
      "id": "foot-46"
    }
  }, [_vm._v("46")]), _vm._v(". The church at Antioch is a fairly clear example. Luke appears to connect its founding with the preaching of Christians scattered by the persecution that arose in connection with the death of Stephen (Acts 11:19ff.). But he expressly says that the aposties were not scattered with the rest (Acts 8:1).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_47",
      "id": "foot-47"
    }
  }, [_vm._v("47")]), _vm._v(". Cited in John Knox, NTS, II, p. 191.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_48",
      "id": "foot-48"
    }
  }, [_vm._v("48")]), _vm._v(". See above, p. 2 n.4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_49",
      "id": "foot-49"
    }
  }, [_vm._v("49")]), _vm._v(". See Karris’s list in CBQ, XXXV (1933), p. 155 n.6. Paul S. Minear gives an extended treatment of this theme in his book "), _c('em', [_vm._v("The Obedience of Faith")]), _vm._v(" (London, 1971). He distinguishes “at least five distinct factions, or, if faction be too strong a word, five different positions” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 8), namely “The ‘weak in faith’ who condemned the ‘strong in faith’”, “The strong in faith who scorned and despised the weak in faith”, “The doubters”, “The weak in faith who did not condemn the strong”, “The strong in faith who did not despise the weak” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" pp. 8-14). There is nothing improbable about such groups’ coming into existence, but the evidence for them is not convincing. Minear’s distinctions have not won wide acceptance, nor has his view that a number of passages in Romans are addressed primarily to one or another of these groups. Minear’s treatment is stimulating, but comes short of being an acceptable solution.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_50",
      "id": "foot-50"
    }
  }, [_vm._v("50")]), _vm._v(". This view is argued by, e.g., Willi Marxsen, "), _c('em', [_vm._v("Introduction to the New Testament")]), _vm._v(" (Philadelphia, 1980), pp. 95-104. Marxsen is supported by Karl Paul Donfried, “A Short Note on Romans 16” (JBL, LXXXIX [1970], pp. 441-49). Donfried is basically concerned to argue that ch. 16 is an integral part of Romans, and he maintains that this accords with the position of Marxsen.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_51",
      "id": "foot-51"
    }
  }, [_vm._v("51")]), _vm._v(". Raymond E. Brown has difficulty with the idea of “Jewish Christian” and “Gentile Christian” as early as this (though he allows that the distinction may be acceptable in the second century). Hebrew Christians were of more than one type and differed from one another more than they differed from the Gentiles whom they converted. He finds four groups: (1) Jewish Christians and their Gentile converts who held to the full observance of the law of Moses; (2) Jewish Christians and their Gentile converts who did not insist on circumcision for Gentiles but required the keeping of some Jewish purity laws; (3) Jewish Christians and their Gentile converts who did not insist on circumcision or food laws for Gentiles; and (4) Jewish Christians and their Gentile converts who did not insist on circumcision or food laws for Gentiles and saw no abiding significance in the cult of the temple (CBQ, 45 [1983], pp. 74-79). Whatever be thought of his four groups, a good deal can be said for the view that Gentile converts would tend to agree with the Jews who had converted them and that a hard division that lumps all Jewish Christians together as distinct from all Gentile Christians is most unlikely. Brown sees Roman Christianity as essentially his group 2 (Raymond E. Brown and John P. Meier, "), _c('em', [_vm._v("Antioch and Rome")]), _vm._v(" [New York, 1983], p. 184).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_52",
      "id": "foot-52"
    }
  }, [_vm._v("52")]), _vm._v(". Donfried, pp. 100-119.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_53",
      "id": "foot-53"
    }
  }, [_vm._v("53")]), _vm._v(". According to Josephus, in Alexandria “a great part of the city has been allocated to this nation. And an ethnarch of their own has been installed, who governs the people and adjudicates suits and supervises contracts and ordinances, just as if he were the head of a sovereign state” "), _c('em', [_vm._v("(Ant.")]), _vm._v(" xiv.117; Loeb translation).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_54",
      "id": "foot-54"
    }
  }, [_vm._v("54")]), _vm._v(". W. S. Campbell does not particularly stress chs. 14 and 15, but he holds that “A division had apparently arisen because the liberal-minded Gentile Christian majority (the strong in faith) were unwilling to have fellowship with the conservative Jewish Christian minority (the weak in faith).” Since the fault lay with the Gentile Christians, “Paul undertakes an exposition of the righteous purpose of God both for Jew and Gentile as fulfilled in Jesus Christ and revealed in the Gospel” (ET, LXXXV [1973-74], p. 268). Stephen Neill argues for three groups with different attitudes to Jewish observances, but uncertain how “to co-exist without friction”. “Paul is the recognized authority on all such questions; the perplexed Christians have sent a message to him asking for guidance, and the Epistle to the Romans is the result” "), _c('em', [_vm._v("(Jesus through Many Eyes")]), _vm._v(" [Philadelphia, 1976], p. 63).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_55",
      "id": "foot-55"
    }
  }, [_vm._v("55")]), _vm._v(". Cf. Karris, CBQ, XXXV, p. 172 n.73 where a number of writers are cited as raising objections to the hypothesis that the weak and the strong are Jews and Gentiles. Even if this be accepted, there are still problems: “Are the Jewish Christians legalists, liberals, apocalyptically-oriented or what? Are the Gentile Christians legalists, antinomians, Gnostic-influenced or what? What is the specific nature of the conflict between Jewish and Gentile Christians which Paul is supposed to have heard about and is trying to settle by writing Rom?” (CBQ, XXXVI [1974], p. 356; the words occur in a short article entitled “The Occasion of Romans: A Response to Professor Donfried”, "), _c('em', [_vm._v("ibid.,")]), _vm._v(" pp. 356-58).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_56",
      "id": "foot-56"
    }
  }, [_vm._v("56")]), _vm._v(". “Rom 14:1–15:13 and the Occasion of Romans” (CBQ, XXXV [1973], pp. 155-78).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_57",
      "id": "foot-57"
    }
  }, [_vm._v("57")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 177.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_58",
      "id": "foot-58"
    }
  }, [_vm._v("58")]), _vm._v(". Raymond E. Brown at one point says, “I would insist parenthetically that it is quite implausible that all Christian Jews were expelled from Rome by Claudius—only those zealous enough to be involved in disturbances (wherefore evangelists like Prisca and Aquila)” "), _c('em', [_vm._v("(Antioch and Rome,")]), _vm._v(" p. 109).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_59",
      "id": "foot-59"
    }
  }, [_vm._v("59")]), _vm._v(". Black, pp. 22, 23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_60",
      "id": "foot-60"
    }
  }, [_vm._v("60")]), _vm._v(". See above, p. 2 n.4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_61",
      "id": "foot-61"
    }
  }, [_vm._v("61")]), _vm._v(". CBQ, XXXVIII (1976), pp. 330-51.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_62",
      "id": "foot-62"
    }
  }, [_vm._v("62")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 330.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_63",
      "id": "foot-63"
    }
  }, [_vm._v("63")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" pp. 342-43.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_64",
      "id": "foot-64"
    }
  }, [_vm._v("64")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 343.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_65",
      "id": "foot-65"
    }
  }, [_vm._v("65")]), _vm._v(". Cf. Brevard S. Childs, “One is amazed by the formalistic quality of the argument which has virtually removed the interpretation from its historical and theological content” "), _c('em', [_vm._v("(The New Testament as Canon,")]), _vm._v(" p. 249).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_66",
      "id": "foot-66"
    }
  }, [_vm._v("66")]), _vm._v(". “Romans as an Ambassadorial Letter”, "), _c('em', [_vm._v("Interpretation,")]), _vm._v(" XXXVI (1982), pp. 5-20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_67",
      "id": "foot-67"
    }
  }, [_vm._v("67")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_68",
      "id": "foot-68"
    }
  }, [_vm._v("68")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_69",
      "id": "foot-69"
    }
  }, [_vm._v("69")]), _vm._v(". "), _c('em', [_vm._v("Paul the Apostle")]), _vm._v(" (Edinburgh, 1980), pp. 77, 86.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_70",
      "id": "foot-70"
    }
  }, [_vm._v("70")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 79.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_71",
      "id": "foot-71"
    }
  }, [_vm._v("71")]), _vm._v(". Cf. Kümmel, “we need not doubt that Paul himself with this extensive, argumentative, and transcending representation gives an account of his gospel which he previously preached and which he is now bringing to the far West” "), _c('em', [_vm._v("(Introduction,")]), _vm._v(" p. 222); “Romans is the theological self-confession of Paul, which arose out of a concrete necessity of his missionary work” "), _c('em', [_vm._v("(ibid,,")]), _vm._v(" p. 221). Cf. James P. Martin, “Missionary vision for the whole world dominates Paul’s description of his situation and hope at the time he wrote Romans” "), _c('em', [_vm._v("(Interpretation,")]), _vm._v(" XXV [1971], p. 303).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_72",
      "id": "foot-72"
    }
  }, [_vm._v("72")]), _vm._v(". It is objected that Romans is too great for such a purpose. A much more modest missive would have sufficed to introduce Paul. So it would. But perhaps the objection minimizes Paul’s missionary passion. His deep concern to preach in Rome and Spain meant that he spared no pains in preparing the way and perhaps said more than was strictly necessary. And if he had doubts about his capacity to survive Jerusalem (cf. Acts 20:25; 21:13), he may have wanted to make sure that his essential message was on record and would be read in Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_73",
      "id": "foot-73"
    }
  }, [_vm._v("73")]), _vm._v(". W. S. Campbell objects that Paul would not submit his gospel for approval and cites Gal. l:8ff. (ET, LXXV, p. 264). But he overlooks the fact that, while Paul would not vary his gospel to secure human acceptance, he could and did submit it for approval (Gal. 2:2).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_74",
      "id": "foot-74"
    }
  }, [_vm._v("74")]), _vm._v(". It is curious that the Jerusalem poor might raise difficulties about receiving a gift from the Gentile churches. But some conservatives there had opposed Paul at the Council of Jerusalem (Acts 15:1-2), and they may have grown stronger through the years. Conversions in Jerusalem would have been from among Jews. At the same time the Gentile churches had grown stronger and stronger. Under the leadership of men like Paul they would not have been willing to conform to Jewish attitudes to the law. Conservative Jews may well have been unwilling to countenance a Gentile-dominated church, or even a church that admitted Gentiles on equal terms. There were thousands of Jewish believers “all… zealous for the law” (Acts 21:20; cf. the request put to Paul, v. 24). They might well see acceptance of the money as countenancing an idea of unity which they did not accept. Cf. Günther Bornkamm, “Paul had to be prepared for reluctance on the part of the church in Jerusalem. They might be unwilling to go along with his demonstration of the solidarity of Jews and Gentiles. They might refuse to accept the collection” "), _c('em', [_vm._v("(The New Testament: A Guide to Its Writings")]), _vm._v(" [London, 1974], p. 109).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_75",
      "id": "foot-75"
    }
  }, [_vm._v("75")]), _vm._v(". By contrast, “In Jewish tradition, Abraham, by his constancy in trial, had become the model of justification by works” (Wilfrid J. Harrington, "), _c('em', [_vm._v("Record of the Fulfillment: The New Testament")]), _vm._v(" [London, 1968], p. 265). Paul’s example cut at the heart of the Jewish opposition to his central doctrine.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_76",
      "id": "foot-76"
    }
  }, [_vm._v("76")]), _vm._v(". Bornkamm lists 16 points in which Romans is related to the earlier Pauline writings (ABR, XI [1963], pp. 9-11).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_77",
      "id": "foot-77"
    }
  }, [_vm._v("77")]), _vm._v(". Cf. A. M. Hunter, “in Romans we have the answer to the question, ‘What is Christianity?’ by the strongest thinker in the early Church” ("), _c('em', [_vm._v("Introducing the New Testament")]), _vm._v(" [London, 1945], p. 75).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_78",
      "id": "foot-78"
    }
  }, [_vm._v("78")]), _vm._v(". Ralph P. Martin, discussing the plan of Romans, makes the point that “Much of Paul’s thought is shaped along trinitarian lines. The Father purposes both to condemn and to save; the Son’s obedience and righteousness lay the foundation of justification; and the Spirit’s new life imparts a dynamic for victory over sin and death and a new social life-style in the church and society” "), _c('em', [_vm._v("(New Testament Foundations,")]), _vm._v(" II [Exeter, 1978], p. 194).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_79",
      "id": "foot-79"
    }
  }, [_vm._v("79")]), _vm._v(". The only words which occur more frequently in Romans than θεός are the definite article (1,105 times), ϰαί 274 times, ἐν 172 times, and αὐτός 156 times. Even common words like δέ and the verb εἶναι (“to be”) occur less frequently (147 and 113 times respectively).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_80",
      "id": "foot-80"
    }
  }, [_vm._v("80")]), _vm._v(". See further my essay “The Theme of Romans” in "), _c('em', [_vm._v("Apostolic History and the Gospel,")]), _vm._v(" ed. W. Ward Gasque and Ralph P. Martin (Exeter, 1970), pp. 249-63.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_81",
      "id": "foot-81"
    }
  }, [_vm._v("81")]), _vm._v(". For Manson, see above, p. 3, and the references given there. Throughout this section I am, of course, referring to our way of dividing the epistle. In the original there would have been no chapter divisions. In time students of the epistle produced a number of ways of dividing it. The modern chapter divisions in the New Testament appear to have been drawn up by Stephen Langton during the thirteenth century (see "), _c('em', [_vm._v("The Cambridge History of the Bible,")]), _vm._v(" II, ed. G. W. H. Lampe [Cambridge, 1969], pp. 147-48).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_82",
      "id": "foot-82"
    }
  }, [_vm._v("82")]), _vm._v(". UBS cites the following as having the doxology here only: L Ψ 0209"), _c('sup', [_vm._v("vid")]), _vm._v(" 181 326 330 451 614 1175 1241 1877 1881 1984 1985 2492 2495 "), _c('em', [_vm._v("Byz Lect")]), _vm._v(" it"), _c('sup', [_vm._v("dem")]), _vm._v(" syr"), _c('sup', [_vm._v("h")]), _vm._v(" mss"), _c('sup', [_vm._v("acc. to origen lat")]), _vm._v(" Chrysostom (Theodore) Cyril Theodoret John-Damascus. It is read both here and at 16:25 by A Ρ 5 33 88 104 460"), _c('sup', [_vm._v("lat")]), _vm._v(" arm; it is read only at 15:33 by P"), _c('sup', [_vm._v("46")]), _vm._v("; it is omitted entirely by F"), _c('sup', [_vm._v("gr")]), _vm._v(" G (this MS leaves a space) 629 it"), _c('sup', [_vm._v("dc(?)[g]")]), _vm._v(" Marcion"), _c('sup', [_vm._v("acc. to Origen lat")]), _vm._v(" mss"), _c('sup', [_vm._v("acc. to Jerome [vid]")]), _vm._v("; it is read only at 16:25 by a large number of MSS led by P"), _c('sup', [_vm._v("61")]), _vm._v(" "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("א")]), _vm._v(" Β C D D"), _c('sup', [_vm._v("abs [1]")]), _vm._v(" 81 436 it"), _c('sup', [_vm._v("mss")]), _vm._v(" vg syr"), _c('sup', [_vm._v("p")]), _vm._v(" cop"), _c('sup', [_vm._v("sa.bo")]), _vm._v(" eth Clement Origen"), _c('sup', [_vm._v("lat")]), _vm._v(" mss"), _c('sup', [_vm._v("acc. to Origen lat")]), _vm._v(" Ambrosiaster.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_83",
      "id": "foot-83"
    }
  }, [_vm._v("83")]), _vm._v(". Tertullian refers to Rom. 14:10 as "), _c('em', [_vm._v("in clausula epistolae,")]), _vm._v(" “in the conclusion of the letter” "), _c('em', [_vm._v("(Adv. Marc.")]), _vm._v(" v. 14). This need not mean that these were the very last words, but it is difficult to think that more than two chapters followed. Barrett, however, refuses to press this point on the ground that in later Latin "), _c('em', [_vm._v("clausula")]), _vm._v(" could be used for any division of a document (Barrett, p. 11; here, however, it is "), _c('em', [_vm._v("clausula epistolae,")]), _vm._v(" which does not look like a division). Tertullian repeats that Marcion has made serious omissions from Romans "), _c('em', [_vm._v("(Adv. Marc.")]), _vm._v(" v.13, 14).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_84",
      "id": "foot-84"
    }
  }, [_vm._v("84")]), _vm._v(". Rufinus’s Latin version of Origen’s commentary on Romans tells us that “from that place where it is written ‘all that is not of faith is sin’” (i.e., Rom. 14:23) Marcion “cut it away up to the end "), _c('em', [_vm._v("(usque ad finem cuncta dissecuit)”")]), _vm._v(" (cited from Gamble, p. 22). There is a tiny doubt here, for "), _c('em', [_vm._v("dissecuit")]), _vm._v(" strictly means “cut in pieces”. But most take it here in the sense "), _c('em', [_vm._v("desecuit,")]), _vm._v(" “cut off”. This appears to be what Origen is saying. We have evidence of a text lacking chs. 15 and 16, but not of one with a mutilated version of these two chapters. T. Zahn, however, took the word strictly and found it unthinkable that Marcion should have discarded all of chs. 15 and 16 "), _c('em', [_vm._v("(Introduction,")]), _vm._v(" pp. 396ff.).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_85",
      "id": "foot-85"
    }
  }, [_vm._v("85")]), _vm._v(". I have cited these "), _c('em', [_vm._v("breves")]), _vm._v(" from Gamble, p. 16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_86",
      "id": "foot-86"
    }
  }, [_vm._v("86")]), _vm._v(". F. F. Bruce adduces an argument from silence. “The "), _c('em', [_vm._v("Book of Testimonies")]), _vm._v(" ascribed to Cyprian (died "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" 258) includes a collection of biblical texts which enjoin withdrawal from heretics; this collection does not include Romans 16:17, which might have been thought an apt text for his purpose. This argument from silence, which would have little weight if it stood alone, must be taken along with other pieces of evidence” (Bruce, p. 27). Gamble also draws attention to this (p. 20).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_87",
      "id": "foot-87"
    }
  }, [_vm._v("87")]), _vm._v(". Gamble, p. 17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_88",
      "id": "foot-88"
    }
  }, [_vm._v("88")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" pp. 18-19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_89",
      "id": "foot-89"
    }
  }, [_vm._v("89")]), _vm._v(". This is significant but its importance should not be exaggerated. None of the three quotes from 1 Cor. 16 either, but this is not usually seen as an argument that that chapter is unauthentic.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_90",
      "id": "foot-90"
    }
  }, [_vm._v("90")]), _vm._v(". Gamble, p. 21. The only exception he can find is the Muratorian fragment, and even here there is dispute.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_91",
      "id": "foot-91"
    }
  }, [_vm._v("91")]), _vm._v(". Cited from Alexander Souter, "), _c('em', [_vm._v("The Text and Canon of the New Testament")]), _vm._v(" (London, 1935), p. 206. There is, of course, doubt as to whether the prologues really are Marcionite, but it is usual to cite them under this name.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_92",
      "id": "foot-92"
    }
  }, [_vm._v("92")]), _vm._v(". E.g., Morton Scott Enslin, "), _c('em', [_vm._v("Christian Beginnings")]), _vm._v(" (New York and London, 1938), pp. 266ff.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_93",
      "id": "foot-93"
    }
  }, [_vm._v("93")]), _vm._v(". Gamble, however, links the two. He is impressed by “the testimony of the Pauline bilinguals, which, properly evaluated, attest the phenomena together” (Gamble, p. 33).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_94",
      "id": "foot-94"
    }
  }, [_vm._v("94")]), _vm._v(". Gamble sums up: “The evidence is geographically widespread, representing Europe (the Amiatine "), _c('em', [_vm._v("capitula,")]), _vm._v(" the "), _c('em', [_vm._v("Concordia epistularum,")]), _vm._v(" Irenaeus, the bilingual and other Old Latin witnesses), Africa (Tertullian and Cyprian), and the East (the Byzantine text and Origen), and this form of the letter can be traced back with confidence at least as far as the second century in the testimonies of Tertullian and Origen” (Gamble, p. 33).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_95",
      "id": "foot-95"
    }
  }, [_vm._v("95")]), _vm._v(". “It is to us inconceivable that St. Paul should have himself mutilated his own argument by cutting off the conclusion of it” (SH, p. xcv).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_96",
      "id": "foot-96"
    }
  }, [_vm._v("96")]), _vm._v(". Gamble, pp. 115-24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_97",
      "id": "foot-97"
    }
  }, [_vm._v("97")]), _vm._v(". Dodd has a suggestion: “there is perhaps no answer but the illimitable stupidity of editors” (Dodd, p. xvi).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_98",
      "id": "foot-98"
    }
  }, [_vm._v("98")]), _vm._v(". The Anglican "), _c('em', [_vm._v("Book of Common Prayer")]), _vm._v(" provides that Rom. 15:4-13 be read on the second Sunday in Advent (as in a number of other churches). "), _c('em', [_vm._v("An Australian Prayer Book")]), _vm._v(" (Anglican) has Rom. 16:25-27 as a reading for the fourth Sunday in Advent.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_99",
      "id": "foot-99"
    }
  }, [_vm._v("99")]), _vm._v(". “Such a concentration of material offensive to Marcion can scarcely be paralleled in the Pauline writings” (Bruce, p. 29).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_100",
      "id": "foot-100"
    }
  }, [_vm._v("100")]), _vm._v(". Dodd, p. xvii.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_101",
      "id": "foot-101"
    }
  }, [_vm._v("101")]), _vm._v(". Cranfield makes the point against Ephesus that Paul had ministered extensively in that city and that it is inconceivable that he would have had no more to say to his friends than we read in Rom. 16. They would look for “some pastoral message specially appropriate to them” and “its absence is made all the more inexplicable by the fact that Paul had time to include so many greetings to individuals” (Cranfield, p. 11).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_102",
      "id": "foot-102"
    }
  }, [_vm._v("102")]), _vm._v(". The Latin names are not a problem. Donfried draws attention to Harry Leon’s study of 551 names of Jews in Rome which shows that there were more Latin names among them than Semitic and Greek names combined. “Leon’s conclusion establishes the probability that the names in "), _c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans 16")]), _vm._v(" could easily belong to Roman Jews” (Donfried, p. 56). Roman Christianity, however, was predominantly Greek speaking until well into the second century, so that it is idle to look for too many Latin names in this church.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_103",
      "id": "foot-103"
    }
  }, [_vm._v("103")]), _vm._v(". Bruce regards this as “Perhaps the strongest case” of identification with names known at Rome, for we know of a “‘family of Narcissus’ in Rome at this very time” (Bruce, p. 256).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_104",
      "id": "foot-104"
    }
  }, [_vm._v("104")]), _vm._v(". In support of the view that considerable travel took place in the Roman Empire of the time and that it was feasible among Paul’s correspondents, Barrett cites Lietzmann for information about a migration from Asia Minor to Tusculum of a household of 500 persons, “a ‘house-church’ of initiates of Dionysius” (Barrett, p. 282).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_105",
      "id": "foot-105"
    }
  }, [_vm._v("105")]), _vm._v(". 1 Corinthians is usually held to have been written from Ephesus (cf. Kümmel, p. 205); Timothy’s knowledge of what was going on in Asia (2 Tim. 1:15; cf. 1 Tim. 1:3) seems to locate him in Ephesus.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_106",
      "id": "foot-106"
    }
  }, [_vm._v("106")]), _vm._v(". Some argue that the names point to Ephesus. But the only names which can be linked with that city are Aquila and Prisca, and perhaps Epaenetus. But the first two are connected also with Rome, as are Rufus, Narcissus, Ampliatus, and possibly Nereus and Aristobulus (Dodd, p. xxiii). The argument has little weight.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_107",
      "id": "foot-107"
    }
  }, [_vm._v("107")]), _vm._v(". It is even possible that they went back to Rome as advance agents of Paul. Thus Zahn thought it not impossible that “when Paul turned his attention toward Rome and prepared to give up his work in Ephesus, this couple left Ephesus, very soon after the sending of 1 Corinthians, at about the same time that Paul did, and returned to Rome, where they had resided earlier, in order to prepare quarters for the apostle there as they had done previously in Ephesus” "), _c('em', [_vm._v("(Introduction,")]), _vm._v(" p. 390). He thinks that Epaenetus may have accompanied them. Parry comments, “It is reasonable to conclude that when, at Ephesus, the plan of a visit to Rome was definitely formed (Acts xix.21), it was also decided that these two faithful companions and fellow workers should return to that city, to which at any rate Prisca probably belonged, prepare the way for S. Paul’s own visit, and send him information as to the state of the church there” (CGT, p. xiii). As a possible link of Prisca with Rome Dodd points out that both Acilius (or Aquillius) and Prisca are names, connected with the consul Acilius Glabrio, who “was a Christian in the time of Domitian.” It is possible that Aquila and Prisca were freed slaves of the Acilii (Dodd, pp. xxi-xxii). It is not a strong link, but it is possible.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_108",
      "id": "foot-108"
    }
  }, [_vm._v("108")]), _vm._v(". Cf. Dodd, p. xxiii.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_109",
      "id": "foot-109"
    }
  }, [_vm._v("109")]), _vm._v(". Raymond E. Brown discusses the evidence and, after considering the names, writes, “Thus, overall the 16-chapter form of Romans has every reason to be considered as original” "), _c('em', [_vm._v("(Antioch and Rome,")]), _vm._v(" p. 108).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_110",
      "id": "foot-110"
    }
  }, [_vm._v("110")]), _vm._v(". Cf. Donald Guthrie, “if Paul has no authority to commend anyone to a church where he is unknown he would equally have no authority to write to them as he has done in chapters i-xv” (“The Pauline Epistles,” "), _c('em', [_vm._v("New Testament Introduction")]), _vm._v(" [London, 1961], p. 30). The very existence of the epistle is the refutation of the objection.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_111",
      "id": "foot-111"
    }
  }, [_vm._v("111")]), _vm._v(". Gamble, p. 52. The introductory words are πα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("αϰαλῶ δὲ ὑμᾶς, ἀδελφοί.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_112",
      "id": "foot-112"
    }
  }, [_vm._v("112")]), _vm._v(". This is supported by the fact that the oldest MS of Romans, P"), _c('sup', [_vm._v("46")]), _vm._v(", has the doxology after 15:33. This is taken (e.g., by T. W. Manson) to indicate that at one time the text on which this MS is based ended with ch. 15. But it is not to be overlooked that this MS does not in fact end at ch. 15 and that there may have been some other reason than the original end of the epistle for the appearance of the doxology at this place.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_113",
      "id": "foot-113"
    }
  }, [_vm._v("113")]), _vm._v(". Cited from Dodd, p. xix. Gamble does not regard this as a strong objection; he points out that the comment is found only in the first edition (Gamble, p. 47 n.51). He further points out that those who see ch. 16 as a whole letter are able to rationalize the greetings in some way.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_114",
      "id": "foot-114"
    }
  }, [_vm._v("114")]), _vm._v(". Cf. Guthrie, “some reasonable explanation must be given for the strange preservation of the greetings and the loss of the Epistle. Common sense would suggest the reverse” "), _c('em', [_vm._v("(Introduction,")]), _vm._v(" pp. 31-32).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_115",
      "id": "foot-115"
    }
  }, [_vm._v("115")]), _vm._v(". Gamble notes some; P.Oxy. 1296, e.g., has 12 lines of greetings in a letter of 20 lines (Gamble, p. 91 n. 156). It is not the number of greetings in itself that is the problem but the number of greetings in a letter of this character. It should also be borne in mind that Paul has nothing like it elsewhere. There must be some reason for such a lengthy list of greetings in a Pauline letter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_116",
      "id": "foot-116"
    }
  }, [_vm._v("116")]), _vm._v(". This point is overlooked by many who note the existence of letters of recommendation in antiquity, e.g., A. Deissmann, LAE, pp. 170-71; J. I. H. McDonald, NTS, XVI (1969-70), pp. 369-72.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_117",
      "id": "foot-117"
    }
  }, [_vm._v("117")]), _vm._v(". Gamble, p. 87 n.137.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_118",
      "id": "foot-118"
    }
  }, [_vm._v("118")]), _vm._v(". Gamble cites a number of examples, e.g., Plato, "), _c('em', [_vm._v("Ep.")]), _vm._v(" 13, which he describes as “a lengthy letter” and which ends: “Iatrocles, who along with Myronides was set free by me, is now about to embark with those sent by me. Therefore give him some paid employment since he is well-disposed toward you; and use him for whatever you wish” ("), _c('em', [_vm._v("ibid.,")]), _vm._v(" p. 86).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_119",
      "id": "foot-119"
    }
  }, [_vm._v("119")]), _vm._v(". "), _c('em', [_vm._v("Ibid.,")]), _vm._v(" p. 87.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_120",
      "id": "foot-120"
    }
  }, [_vm._v("120")]), _vm._v(". Donfried, p. 164. Wuellner has earlier said, “The peroration has been specified in Hellenistic rhetoric ‘as the proper place for "), _c('em', [_vm._v("pathos,’")]), _vm._v(" i.e., the rousing of emotions for the purpose of stimulating the audience to action” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 163).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_121",
      "id": "foot-121"
    }
  }, [_vm._v("121")]), _vm._v(". Gamble, p. 83. Not all these elements are invariably present, but some of them always are and the sequence does not vary. Gordon J. Bahr has also given attention to the endings of Paul’s letters (“The Subscriptions in the Pauline Letters”, JBL, LXXXVII [1968], pp. 27-41). Of Romans he says, “As far as the form of ch. 16 is concerned, there is no reason to deny its authenticity” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 39).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_122",
      "id": "foot-122"
    }
  }, [_vm._v("122")]), _vm._v(". “Ch. 16 has all the earmarks of an epistolary conclusion, as can be seen by comparing it with other conclusions. The same comparison, however, reveals the distinctiveness of Rom 16, a distinctiveness which can be accounted for only on the basis of the situation presupposed in the Roman letter” (Gamble, p. 91).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_123",
      "id": "foot-123"
    }
  }, [_vm._v("123")]), _vm._v(". Gamble sums up in these words: “Thus, even though many have found considerations of content to be prohibitive of a Roman destination for ch. 16, in terms of letter-form and style everything speaks in favor of the integrity of the letter. That Paul had some acquaintances in Rome—and only a limited number of firsthand acquaintances need be supposed—is a smaller and more reasonable assumption than that ch. 16 was no original part of the Roman letter. If judgments based on content are inevitably somewhat subjective and inconclusive, the evidence of epistolary style is a much more demonstrable and reliable index for deciding literary-critical issues. In the case of Romans it provides as much certainty as can be had that Rom 1-16 preserves the original extent of Paul’s letter to the Romans” (Gamble, pp. 94-95).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_124",
      "id": "foot-124"
    }
  }, [_vm._v("124")]), _vm._v(". In an article entitled “Greetings as a New Testament Form” ("), _c('em', [_vm._v("JBL,")]), _vm._v(" LXXXVII [1968], pp. 418-26), Terence Y. Mullins looks at the usage in greetings both outside and inside the New Testament. He sees Romans as different from the other letters. As befits the longest letter, both the opening and the closing are longer than any others in the New Testament. On the basis of the greetings he thinks that the relationship between Paul and the Roman congregation “seems to be other than scholars have assumed, and no simple readjustment of our old notions is likely to bring it into focus. We can not, for example, simply lop off the last chapter or two and say that they are not part of the letter. The opening and closing are too obviously supplementary for such a solution to hold” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 426). He thinks that problems remain, but for our present purpose the point is that the greetings agree with other evidence that ch. 16 is part of the original letter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_125",
      "id": "foot-125"
    }
  }, [_vm._v("125")]), _vm._v(". Gamble, p. 92.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_126",
      "id": "foot-126"
    }
  }, [_vm._v("126")]), _vm._v(". Donfried emphasizes this strongly in his “Methodological Principles II” (Donfried, pp. 122-23).")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('em', [_vm._v("Analysis")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "list2"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('span', {
    staticClass: "pad"
  })]), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-1"
    }
  }, [_c('strong', [_vm._v("I. Introduction, 1:1-15")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec3-1"
    }
  }, [_vm._v("A. Salutation, 1:1-7")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec3-2"
    }
  }, [_vm._v("B. Prayer, 1:8-15")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "pad1"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-2"
    }
  }, [_c('strong', [_vm._v("II. Thesis, 1:16-17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-3"
    }
  }, [_c('strong', [_vm._v("III. The Way of Deliverance, 1:18–5:21")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec3-3"
    }
  }, [_vm._v("A. Universal Sinfulness, 1:18–3:20")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec4-1"
    }
  }, [_c('em', [_vm._v("1. The Condemnation of the Gentile World, 1:18-32")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Condemnation of the Jew, 2:1-16")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The danger of judging others, 2:1-3")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The need for repentance, 2:4")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Judgment, 2:5-16")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("The Jew, 2:17–3:8")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Jew’s confidence, 2:17-20")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Jew’s failure, 2:21-24")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. The inward and the outward, 2:25-29")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. The faithfulness of God, 3:1-4")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Objections, 3:5-8")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Universal Sinfulness—Proof from Scripture, 3:9-20")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Justification, 3:21–5:21")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. How Justification Is Effected, 3:21-31")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The death of Christ, 3:21-26")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Faith, 3:27-31")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('em', [_vm._v("Justification Proved from Abraham, 4:1-25")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. God’s way is grace, 4:1-8")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Faith and circumcision, 4:9-12")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Faith and law, 4:13-17")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Faith and Abraham, 4:18-25")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("The Effects of Justification, 5:1-11")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Solidarity in Adam and in Christ, 5:12-21")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IV. The Way of Godliness, 6:1–8:39")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Shall We Continue to Sin That Grace May Abound? 6:1-14")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Shall We Sin Because We Are under Grace, Not Law? 6:15–7:6")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. We Are Not Slaves, 6:15-23")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. An Illustration from Marriage, 7:1-6")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Is the Law Sin? 7:7-12")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Did the Good Law Cause Death? 7:13-25")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The Holy Spirit in the Believer, 8:1-39")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. The Opposition of Flesh and Spirit, 8:1-11")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Family of God, 8:12-17")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. The Glorious Future, 8:18-25")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. The Spirit’s Intercession, 8:26-27")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. The Purpose of God, 8:28-30")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. The Christian’s Triumph Song, 8:31-39")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "pad1"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec2-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("V. The Place of Israel, 9:1–11:36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Tragedy of Israel, 9:1-5")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. God’s Sovereign Freedom, 9:6-29")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. God Works by Election, 9:6-13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. God’s Purpose Is Mercy, 9:14-18")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. God’s Wrath and God’s Mercy, 9:19-29")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Human Responsibility, 9:30–10:21")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. The “Stumbling Stone”, 9:30-33")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec4-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Two Ways of Righteousness, 10:1-13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec4-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Worldwide Proclamation, 10:14-21")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. God’s Promises Will Be Fulfilled, 11:1-36")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. The Remnant of Israel, 11:1-10")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Restoration of Israel, 11:11-24")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. The Conversion of Israel, 11:25-32")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. The Mercy of God, 11:33-36")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec2-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VI. Christian Living, 12:1–15:13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Christian Attitude to God, 12:1-2")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Christian Attitude to Other Christians, 12:3-16")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Humility, 12:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Difference of Function, 12:4-8")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("Love of the Brothers, 12:9-10")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Some Practical Advice, 12:11-16")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Christian Attitude to Non-Christians, 12:17-21")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. The Christian Attitude to Civil Rulers, 13:1-7")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The Christian Attitude to People in General, 13:8-10")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Living in the Light, 13:11-14")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Love and Liberty, 14:1–15:13")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#sec4-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Christian Liberty, 14:1-12")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#sec4-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Way of Peace and Love, 14:13-23")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec4-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Christian Unity, 15:1-13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VII. Conclusion, 15:14–16:27")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Minister of the Gentiles, 15:14-22")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Paul’s Plans, 15:23-33")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Commendation of Phoebe, 16:1-2")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Greetings, 16:3-16")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. A Doctrinal Warning, 16:17-20")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Greetings from People with Paul, 16:21-24")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Doxology, 16:25-27")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('em', [_vm._v("Romans 1")])])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-1"
    }
  }, [_vm._v("I. INTRODUCTION, 1:1-15")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Letters in antiquity, as in every age, had a conventional form. Whereas we begin with our address and the date, after which we greet our correspondent as “Dear----------” (though he may be our worst enemy or a total stranger), the ancients had the sensible custom of starting with the name of the writer. They followed this with the name of the recipient and a greeting, giving the formula “A to B, Greeting.” There was usually a little prayer. In letters of a formal character written to strangers that was all. But titles were added to the names in official letters and expressions of warmth and esteem in more personal letters. The prayer might be no more than conventional good wishes (“May the gods preserve you”). Or it might be a genuine thanksgiving for blessings received. Here is the opening of a letter which survives: “Serenus to his beloved sister Isidora, many greetings. Before all else I pray for your health….”")]), _c('a', {
    attrs: {
      "href": "#/#foot-1",
      "id": "foot_1"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" Notice the use of the third person, which was normal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul follows the usual pattern in all his letters, though with some significant modifications."), _c('a', {
    attrs: {
      "href": "#/#foot-2",
      "id": "foot_2"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" He takes his letter openings more seriously than do his more conventional contemporaries, and he makes them the vehicles of important Christian teaching. This ordinarily means a somewhat longer introduction than was normal. Nowhere is Paul’s ability to use the framework more apparent than in Romans. This opening is longer and much more formal than in Paul’s other letters—perhaps because he was not personally known to the Roman church, perhaps also because he did not want anyone to doubt his position as an apostle. It will be convenient to divide his opening into two parts, dealing first with his greeting and then with his prayer.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_vm._v("A. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALUTATION,")]), _vm._v(" 1:1-7")]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("1")]), _vm._v("Paul, a servant of Christ Jesus, called to be an apostle and set apart for the gospel of God— "), _c('sup', [_vm._v("2")]), _vm._v("the gospel he promised beforehand through his prophets in the ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('em', [_vm._v("Holy Scriptures "), _c('sup', [_vm._v("3")]), _vm._v("regarding his Son, who as to his human nature was a descendant of David, "), _c('sup', [_vm._v("4")]), _vm._v("and who through the Spirit"), _c('sup', [_vm._v("a")]), _vm._v(" of holiness was declared with power to be the Son of God by his resurrection from the dead: fesus Christ our Lord. "), _c('sup', [_vm._v("5")]), _vm._v("Through him and for his name’s sake, we received grace and apostleship to call people from among all the Gentiles to the obedience that comes from faith. "), _c('sup', [_vm._v("6")]), _vm._v("And you also are among those who are called to belong to Jesus Christ.")])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("7")]), _vm._v("To all in Rome who are loved by God and called to be saints:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_vm._v("Grace and peace to you from God our Father and from the Lord fesus Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-source"
  }, [_c('sup', [_vm._v("a")]), _vm._v("4 Or "), _c('em', [_vm._v("who as to his spirit of holiness")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("In this opening Paul speaks of his relationship to Christ and to the gospel, of the purpose God worked out in Christ’s saving work, and of the nature of Christian service. These first seven verses are one complicated sentence in Greek (Paul often uses such long, complicated sentences).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Normally Paul associates others with himself in his opening greeting.")]), _c('a', {
    attrs: {
      "href": "#/#foot-3",
      "id": "foot_3"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" The absence of this feature marks Romans as highly personal. The name "), _c('em', [_vm._v("Paul")]), _vm._v(" is first used in Acts 13:9. The apostle’s original name, “Saul”, is from a Hebrew word with a meaning like “asked”"), _c('a', {
    attrs: {
      "href": "#/#foot-4",
      "id": "foot_4"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" (cf. Samuel, 1 Sam. 1:20). It was not uncommon for a first-century Jew to bear two names, a Greek or Roman name as well as his original Hebrew name. Since Paul was a Roman citizen he would have had three names, but it is understandable that he would not have emphasized his superior status when writing to fellow Christians who were mostly from the lower orders. “Paul” derives from the Latin "), _c('em', [_vm._v("paulus,")]), _vm._v(" meaning “little”. This may mean that the apostle was short of stature (is this meant in 2 Cor. 10:1, 10?),"), _c('a', {
    attrs: {
      "href": "#/#foot-5",
      "id": "foot_5"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" or it may be due to nothing more profound than that the name had a sound resembling Saul."), _c('a', {
    attrs: {
      "href": "#/#foot-6",
      "id": "foot_6"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" For some reason he seems to have been known generally by his Latin rather than his Hebrew name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He calls himself "), _c('em', [_vm._v("a servant of Christ Jesus, servant")]), _vm._v(" being a strong term meaning “slave”"), _c('a', {
    attrs: {
      "href": "#/#foot-7",
      "id": "foot_7"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" (used in similar fashion in Gal. 1:10; Phil. 1:1; Tit. 1:1; Jas. 1:1; 2 Pet. 1:1; Jude 1). As the Christians used it, the term conveys the idea of "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("complete and utter devotion,")]), _c('a', {
    attrs: {
      "href": "#/#foot-8",
      "id": "foot_8"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" not the abjectness which was the normal condition of the slave."), _c('a', {
    attrs: {
      "href": "#/#foot-9",
      "id": "foot_9"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Paul is affirming that he belongs to Christ without reservation."), _c('a', {
    attrs: {
      "href": "#/#foot-10",
      "id": "foot_10"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" The term is applied to Abraham (Gen. 26:24), to Moses (Josh. 1"), _c('span', {
    staticClass: "smallcaps"
  }), _vm._v(":2), and to the prophets from the time of Amos (Amos 3:7; Isa. 20:3). Paul may thus be quietly affirming that he stands in the true succession of the prophets."), _c('a', {
    attrs: {
      "href": "#/#foot-11",
      "id": "foot_11"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" If this is in mind, it may be significant that he speaks of himself as the slave, not of God (as the prophets did), but of Christ. He puts Christ in the highest possible place."), _c('a', {
    attrs: {
      "href": "#/#foot-12",
      "id": "foot_12"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The probability is that he here calls his Savior "), _c('em', [_vm._v("Christ Jesus")]), _c('a', {
    attrs: {
      "href": "#/#foot-13",
      "id": "foot_13"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" (though some hold that the order of the words should be reversed). “Christ” of course means “Messiah”, and many think that Paul normally uses the term as a title."), _c('a', {
    attrs: {
      "href": "#/#foot-14",
      "id": "foot_14"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" But Vincent Taylor argues convincingly that we should usually understand the word as a proper name in Paul."), _c('a', {
    attrs: {
      "href": "#/#foot-15",
      "id": "foot_15"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" This is supported both by the way Paul uses it and the frequency with which he employs it. In all Paul uses the term 379 times out of its 529 New Testament occurrences (65 in Romans). The highest total in any non-Pauline writing is 25 in Acts. It is thus to Paul that we owe our habit of calling our Lord simply “Christ”. The Gospels show that during his lifetime the title was used of him but rarely and that Jesus himself preferred “the Son of man”. In the other non-Pauline writings “Christ” is used on occasion, but some other name is more usual. But Paul habitually "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("used the term, and from him it has passed into the common Christian vocabulary. This does not mean that he has forgotten that it is a title with the meaning “Messiah”; sometimes he uses it in the strict sense. But usually we cannot press it. "), _c('em', [_vm._v("Jesus,")]), _vm._v(" the human name, of course, means “Savior”. Paul uses it 37 times (38 if 16:24 be accepted) in Romans and 213 (214) times in all (John with 237 references is the only writer with more). While he does not employ it as frequently as Christ, clearly Paul loves the human name. When he combines the two he prefers the order “Christ Jesus” to “Jesus Christ” by a margin of 73 to 18 (omitting 24 cases where the MSS are divided). But if he includes “Lord” the order is reversed, with “Jesus” coming first 49 times and “Christ” eight times.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("He proceeds to say that he is "), _c('em', [_vm._v("called to be an apostle.")]), _vm._v(" Since the Greek has no “to be”, we could take the words to mean “a called apostle” (as Boylan does). Nothing has to be supplied to get this meaning. But few accept it because it would imply that some other apostles were not called, and on Pauline premises this would be an absurdity. NIV is surely correct in supplying “to be”. The idea of a divine call is important for Paul, as we see from the fact that he uses the adjective "), _c('em', [_vm._v("called")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#foot-16",
      "id": "foot_16"
    }
  }, [_c('sup', [_vm._v("16")])])]), _vm._v(" in seven of its ten New Testament occurrences. It stresses the priority of the divine (“neither self-appointed nor chosen by men”, Hodge). We should notice that for Paul the idea of call includes the notion of response. The “called” are those who have not only heard but have obeyed the divine call. Paul thinks of an “effectual call”."), _c('a', {
    attrs: {
      "href": "#/#foot-17",
      "id": "foot_17"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" In stressing the thought of call Paul is not making an innovation. Many Old Testament worthies were called by God, such as Abraham (Gen. 12:1), Moses (Exod. 3:4ff.), Jeremiah (Jer. l:4ff.), Amos (Amos 7:15), and especially Isaiah (Isa. 6). Paul sees his task in life (like theirs) not as self-chosen, nor as mapped out for him by men (cf. Gal. 1:1), but as God’s own call.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His call is to be an "), _c('em', [_vm._v("apostle")]), _vm._v(" (cf. 1 Cor. 1:1)."), _c('a', {
    attrs: {
      "href": "#/#foot-18",
      "id": "foot_18"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Paul makes a good deal of use "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("of this term. Perhaps surprisingly he rarely uses it of the Twelve. Mostly he uses it of himself or of apostles generally.")]), _c('a', {
    attrs: {
      "href": "#/#foot-19",
      "id": "foot_19"
    }
  }, [_c('sup', [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The word means “someone who is sent, a messenger”. Paul had been “sent” as well as “called”. In the New Testament apostles were men of high dignity, owing their appointment directly to God (Gal. 1:1) and being mentioned first in the list of those appointed in the church (1 Cor. 12:28). They were concerned with establishing and caring for churches. The Twelve whom Jesus called were held in high honor, but Paul does not see his apostleship as in any way inferior to that of any (2 Cor. 11:5; 12:11). He had seen the Lord (1 Cor. 9:1) and had been commissioned by him (Gal. 1:1). He had manifested the signs “that mark an apostle” (2 Cor. 12:12). He had a special responsibility as “the apostle to the Gentiles” (11:13)."), _c('a', {
    attrs: {
      "href": "#/#foot-20",
      "id": "foot_20"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul says that he is "), _c('em', [_vm._v("set apart for the gospel of God.")]), _vm._v(" He uses this verb of his being set apart “from birth” (Gal. 1:15; there also it is linked with the idea of call; cf. Jer. 1:5; Acts 9:15). It is used of the setting apart of Barnabas and Saul for missionary work (Acts 13:2). Interestingly, it is connected with the root from which the Pharisees delighted to derive their name. They held that “Pharisee” means “separated one”,"), _c('a', {
    attrs: {
      "href": "#/#foot-21",
      "id": "foot_21"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" and Paul would have regarded himself in this light when he was “a Hebrew of the Hebrews; in regard to the law, a "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Pharisee” (Phil. 3:5). Now, however, he is separated to a greater purpose. We often understand separation negatively, as separation “from” something. But here it is positive. Paul is separated “to” the gospel (cf. Acts 13:2). "), _c('em', [_vm._v("Gospel")]), _vm._v(" is a definitely Pauline word (60 times in Paul out of its 76 New Testament occurrences; nine times in Romans and Philippians is the most in any one book).")]), _c('a', {
    attrs: {
      "href": "#/#foot-22",
      "id": "foot_22"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" It is found in every Pauline writing except Titus. The word basically means “good news”."), _c('a', {
    attrs: {
      "href": "#/#foot-23",
      "id": "foot_23"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" In a Christian context there is no good news to compare with the news of what God has done in Christ for man’s salvation."), _c('a', {
    attrs: {
      "href": "#/#foot-24",
      "id": "foot_24"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" It is this for which Paul is set apart. Some understand this to mean “set apart to preach the gospel”. It certainly includes this, but it is surely more. It means to be a gospel man, to live the gospel. Preaching is important, but then so is living. Paul’s call was to a way of life as well as to a task of preaching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The gospel is "), _c('em', [_vm._v("the gospel of God")]), _vm._v(" (as in Mark 1:14; Rom. 15:16; 2 Cor. 11:7; 1 Thess. 2:2, 8, 9; 1 Pet. 4:17). Elsewhere Paul sees it as “the gospel of his Son” (v. 9), “the gospel of Christ” (15:19; it centers on his saving work), and “my gospel” (2:16; 16:25; the preacher must make the gospel his own). When the gospel is spoken of as God’s, it is referred to its ultimate source. It is rooted in God’s eternal purpose. It is promised in Scripture (v. 2). It takes its origin in God’s concern for his people and his will to save them."), _c('a', {
    attrs: {
      "href": "#/#foot-25",
      "id": "foot_25"
    }
  }, [_c('sup', [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("God")]), _vm._v(" is the most important word in this epistle."), _c('a', {
    attrs: {
      "href": "#/#foot-26",
      "id": "foot_26"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" Romans is a book about God. No topic is treated with anything like the frequency of God. Everything Paul touches in this letter he relates to God. In our concern to understand what the apostle is saying about righteousness, justification, and the like we ought not to overlook his tremendous concentration on God. There is nothing like it elsewhere."), _c('a', {
    attrs: {
      "href": "#/#foot-27",
      "id": "foot_27"
    }
  }, [_c('sup', [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Paul’s emphasis on the divine continues. That the gospel is part of God’s unchanging purpose is evident from the fact that it was "), _c('em', [_vm._v("promised beforehand")])]), _c('a', {
    attrs: {
      "href": "#/#foot-28",
      "id": "foot_28"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" in the prophetic writings. It is God’s gift, part of his purpose for his people. In that he has now fulfilled what he promised it is plain that God can be trusted and the gospel accepted. Notice that the prophets are called "), _c('em', [_vm._v("his")]), _vm._v(" prophets. Paul is not speaking of men of vision in general, men who by their innate abilities could discern the signs of the times. He is speaking of men who belong to God, the vehicles of his message. When a promise is given through (not “by”) such men, then clearly it is the promise of God. We are probably right in interpreting the term "), _c('em', [_vm._v("prophets")]), _vm._v(" as not only the prophets in the strict, technical sense, but all the Old Testament writers (cf. Heb. 1:1)."), _c('a', {
    attrs: {
      "href": "#/#foot-29",
      "id": "foot_29"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" So Paul proceeds to locate the promise in "), _c('em', [_vm._v("the Holy Scriptures,")]), _vm._v(" or, more exactly, in “holy writings”."), _c('a', {
    attrs: {
      "href": "#/#foot-30",
      "id": "foot_30"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" The expression normally has the article (as NIV), but twice, in 16:26 and here, the Greek has the plural without the article, the noun being there qualified by the adjective “prophetic” and here by “holy”. This use is distinctly exceptional. It would be possible to recall the original meaning of the word and translate here by “holy writings”. But the reference to the prophets makes it clear that Paul has in mind the Old Testament. We should thus translate by “holy scriptures”. But by omitting the article Paul is emphasizing the character of these writings as “holy” (for this term see on v. 7)"), _c('a', {
    attrs: {
      "href": "#/#foot-31",
      "id": "foot_31"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" rather than following his usual practice of making them definite with the use of the article. It may well be that his gospel of grace had been misunderstood and that he had been accused of putting out teachings which destroyed the Old Testament. It was important to Paul, as to all the early Christians, that the gospel was the fulfilment of the Old Testament. It is the realization in action of what God had promised through his own prophets. It is the fulfilment of promises which had been recorded in writings which must be received with reverence, for they are holy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" That the gospel concerns the Son"), _c('a', {
    attrs: {
      "href": "#/#foot-32",
      "id": "foot_32"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" points to the central role of the Son "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("in salvation. The title is one of high dignity, as is fitting for one who accomplished so great a work. As Paul uses the term, it involves community of nature with the Father.")]), _c('a', {
    attrs: {
      "href": "#/#foot-33",
      "id": "foot_33"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" That the Messiah would be a "), _c('em', [_vm._v("descendant of David")]), _vm._v(" is taught in the Old Testament (Isa. 11:1,10; Jer. 23:5-6; Ezek. 34:23-24, etc.) and elsewhere."), _c('a', {
    attrs: {
      "href": "#/#foot-34",
      "id": "foot_34"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" The idea is found in a number of places in the New Testament. Paul’s expression here means “became"), _c('a', {
    attrs: {
      "href": "#/#foot-35",
      "id": "foot_35"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" of the seed of David according to the flesh”, “the seed of David” being referred to on a number of occasions besides the present passage (John 7:42; 2 Tim. 2:8). Jesus is also called the “Son of David” a total of 12 times,"), _c('a', {
    attrs: {
      "href": "#/#foot-36",
      "id": "foot_36"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" and there are other references of a somewhat similar character."), _c('a', {
    attrs: {
      "href": "#/#foot-37",
      "id": "foot_37"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" Jesus does not call himself “Son of David” and indeed on occasion seems to distance himself from the title (Mark 12:35-37)."), _c('a', {
    attrs: {
      "href": "#/#foot-38",
      "id": "foot_38"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" But we should not exaggerate the significance of this, for when the title was directly applied to him he did not reject it (Mark 10:47-52). The facts seem to indicate that it was widely expected that the Messiah would be of David’s line and that Jesus knew that he was of Davidic descent. But presumably because of popular messianic expectations he put no emphasis on the fact."), _c('a', {
    attrs: {
      "href": "#/#foot-39",
      "id": "foot_39"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" The Davidic "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("descent is thus of importance for an understanding of Jesus’ messiahship. It is, however, an aspect of the Messiah which evidently did not mean much to Paul, for he does not specifically mention it elsewhere (though 15:12 comes close).")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Many hold that in vv. 3b-4 Paul is not composing freely but making use of a primitive Christian creed. This is supported by the structure of the section (parallelism and the like), the reference to David, some un-Pauline vocabulary,")]), _c('a', {
    attrs: {
      "href": "#/#foot-40",
      "id": "foot_40"
    }
  }, [_c('sup', [_vm._v("40")])]), _vm._v(" and some theological implications of what is written which scholars find difficult to ascribe to Paul."), _c('a', {
    attrs: {
      "href": "#/#foot-41",
      "id": "foot_41"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" It is quite possible that Paul is referring to a traditional summary of the faith familiar to the Romans. It would make good sense for him to assure them of his orthodoxy by citing words they accepted and with which they were familiar."), _c('a', {
    attrs: {
      "href": "#/#foot-42",
      "id": "foot_42"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" But the credal hypothesis is not as certain as many assume. There is no way we can be sure of it, and in any case there are difficulties. Thus we have no real evidence for fixed credal forms until a considerably later time. Such “credal” fragments as scholars discern in the New Testament differ from one another whereas it is of the essence of creeds that they do not (there is no point in having a creed if people are free to modify it as they will). Further, the question arises as to whether the “creed” Paul uses is Roman or, say, Corinthian. If it was Roman, how did Paul come to know it? If it was Corinthian, how would the Romans recognize it? Such questions may have answers, but we should not assume that they do not "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("arise. And the possibility must be kept in mind that Paul was not so much quoting a creed as making free use of traditional expressions.")]), _c('a', {
    attrs: {
      "href": "#/#foot-43",
      "id": "foot_43"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" In any case, if Paul is quoting we have no reason for thinking anything other than that what he has quoted he has made his own."), _c('a', {
    attrs: {
      "href": "#/#foot-44",
      "id": "foot_44"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul proceeds to qualify his reference to Christ’s descent with "), _c('em', [_vm._v("as to his human nature,")]), _vm._v(" or more literally, “according to the flesh”. He uses the term “flesh” in a bewildering variety of ways and characteristically of the moral frailty which is so much a part of human life (see the note on 7:5). Here, however, the meaning will be as far as human nature, or perhaps physical descent, is concerned. On the level of flesh, of human life, Jesus really was a descendant of David (cf. 9:5). Theodoret, a fifth-century writer, pointed out that this way of expressing it carries the implication that there is more to be said. “The addition ‘according to the flesh’ is not predicated of those who are merely what they are seen to be”, and he cites the absence of the expression from Matthew’s genealogy to prove his point."), _c('a', {
    attrs: {
      "href": "#/#foot-45",
      "id": "foot_45"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" The words imply that Jesus was more than human. Otherwise it would be sufficient to say that he was of the seed of David.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" The verb rendered "), _c('em', [_vm._v("declared")]), _vm._v(" has been variously understood. Cognate with the word for a “boundary”, it means something like “bounded”, “marked out”, “designated”"), _c('a', {
    attrs: {
      "href": "#/#foot-46",
      "id": "foot_46"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" (as RSV, NASB, NEB, GNB, Goodspeed, etc.). If we accept this, we will see the meaning as that the resurrection showed Jesus to be the Son of God. Others prefer the meaning “appointed” (as in Luke 22:22; Acts 10:42, etc.). If this be accepted, it will be in the sense that he who was Son of God in weakness and lowliness during his earthly life “Through the resurrection… became the Son of God in power” (Nygren)."), _c('a', {
    attrs: {
      "href": "#/#foot-47",
      "id": "foot_47"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" Paul would not have accepted a view that Jesus was not divine until “appointed” Son of God (cf. Phil. 2:5-11)."), _c('a', {
    attrs: {
      "href": "#/#foot-48",
      "id": "foot_48"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" Leslie C. Allen stresses the link with Psalm "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("2:7 and sees the meaning as "), _c('em', [_vm._v("“decreed")]), _vm._v(" to be the Son of God”.")]), _c('a', {
    attrs: {
      "href": "#/#foot-49",
      "id": "foot_49"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" K. L. Schmidt argues that there is no great urgency to decide between “declaration or decree” and “appointment and institution” because “a divine declaration is the same as a divine appointment: God’s "), _c('em', [_vm._v("verbum")]), _vm._v(" is "), _c('em', [_vm._v("efficax.”"), _c('a', {
    attrs: {
      "href": "#/#foot-50",
      "id": "foot_50"
    }
  }, [_c('sup', [_vm._v("50")])])]), _vm._v(" It would seem that "), _c('em', [_vm._v("declared")]), _vm._v(" is the better way to understand the expression, but that “appointed” is possible in a sense which safeguards the truth that Jesus was Son of God before as well as after the resurrection."), _c('a', {
    attrs: {
      "href": "#/#foot-51",
      "id": "foot_51"
    }
  }, [_c('sup', [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is an ambiguity in that the words "), _c('em', [_vm._v("with power")]), _vm._v(" might be taken either with "), _c('em', [_vm._v("declared")]), _vm._v(" (“powerfully declared”, as NIV, GNB, SH, etc.) or with "), _c('em', [_vm._v("Son of God")]), _vm._v(" (“declared to be the powerful Son of God”, as JB, Käsemann, etc.). Grammatically either view is possible. Perhaps it is a little more likely that Paul has the latter meaning in mind. There is a sense in which Jesus was the Son of God in weakness before the resurrection but the Son of God in power thereafter. Elsewhere Paul can say that Christ “was crucified in weakness, yet he lives by God’s power” (2 Cor. 13:4), and it seems that he has in mind something of the same sort here. Jesus used the title "), _c('em', [_vm._v("Son of God")]), _vm._v(" very little (though cf. Matt. 27:43; John 10:36). He preferred “Son of man”. But Jesus’ own name for himself for some reason was not acceptable in the early church (it is found outside the Gospels only in Acts 7:56). Instead such a title as Son of God was favored, perhaps because it expressed so plainly what the early Christians thought about Jesus. The word here rendered "), _c('em', [_vm._v("power")]), _vm._v(" is used in the Synoptic Gospels for Jesus’ miracles, the “mighty works”."), _c('a', {
    attrs: {
      "href": "#/#foot-52",
      "id": "foot_52"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" Paul is fond of "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("contrasting mere words with power. The gospel does not simply offer people some bright ideas and then leave them to put them into practice as best they can. Christians live out their faith in a strength not their own, the power of God’s Holy Spirit. Here the note of power receives stress. The resurrection introduces us to that which overcomes death, a power alongside of which the mightiest of human forces is seen for the puny thing it is.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('em', [_vm._v("Through the Spirit of holiness")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#foot-53",
      "id": "foot_53"
    }
  }, [_c('sup', [_vm._v("53")])])]), _vm._v(" introduces a further ambiguity. This might mean “according to his (the Son’s) holy spirit” and refer either to the human spirit of Jesus"), _c('a', {
    attrs: {
      "href": "#/#foot-54",
      "id": "foot_54"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" or to his divine nature."), _c('a', {
    attrs: {
      "href": "#/#foot-55",
      "id": "foot_55"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" Or it might mean “according to the Holy Spirit”."), _c('a', {
    attrs: {
      "href": "#/#foot-56",
      "id": "foot_56"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" There are difficulties with all these views. The view that it refers to Jesus’ human spirit is supported by the fact that there has just been a reference to “the flesh” which, it would seem, should be balanced by one to the spirit. Lagrange argues that just as “flesh” points to Christ’s humanity, so does “spirit” to his divinity. But against such views Jesus’ human spirit is never elsewhere referred to in terms anything like “a spirit of holiness” or “a holy spirit”. This sounds so much like a reference to the Holy Spirit as to be confusing. It is objected to the view that the Holy Spirit is meant that he is not normally associated with the resurrection. This is usually reinforced by the requirement for an antithesis to “the flesh” in verse 3. Hodge, indeed, is so impressed by this that he thinks a reference to the Holy Spirit “destroys the antithesis”. Paul, however, is not such a systematic writer that this is decisive. He quite often fails to supply antitheses we might think required, and we cannot insist on one here. And, while it is true that the Holy Spirit is not normally linked with the resurrection, it seems too much to say that he never can be."), _c('a', {
    attrs: {
      "href": "#/#foot-57",
      "id": "foot_57"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" Paul seems, then, to be speaking of the power of the Holy Spirit of God as shown in the resurrection and the designation of Christ as the powerful Son of God. A less probable alternative is that the sending of the Holy Spirit by the exalted Jesus (cf. Acts 2:33) is evidence that the Son has truly been exalted in power."), _c('a', {
    attrs: {
      "href": "#/#foot-58",
      "id": "foot_58"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("The words rendered "), _c('em', [_vm._v("by his resurrection from the dead")]), _vm._v(" could also be understood in the sense “from the time of the resurrection from the dead”.")]), _c('a', {
    attrs: {
      "href": "#/#foot-59",
      "id": "foot_59"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" There is certainly some reference to time, but this is not primary. Rather, the emphasis is on the fact that the resurrection is that whereby Christ is seen to be the Son of God in power. There is no "), _c('em', [_vm._v("his")]), _vm._v(" in the Greek and the "), _c('em', [_vm._v("resurrection from the dead")]), _vm._v(" would normally be taken to refer to the general resurrection at the last day (the identical or almost identical expression is taken in this way in Matt. 22:31; Luke 20:35; Acts 17:32; 23:6; 24:21; 1 Cor. 15:12,13, 21, 42; Heb. 6:2)."), _c('a', {
    attrs: {
      "href": "#/#foot-60",
      "id": "foot_60"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" But the words apparently can mean the resurrection of one man (Acts 26:23)."), _c('a', {
    attrs: {
      "href": "#/#foot-61",
      "id": "foot_61"
    }
  }, [_c('sup', [_vm._v("61")])]), _vm._v(" This is the meaning required here. It is Jesus’ own resurrection of which Paul is writing. But we should not overlook the fact that he chooses to do this in a way more commonly used to denote the general resurrection."), _c('a', {
    attrs: {
      "href": "#/#foot-62",
      "id": "foot_62"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" As Nygren puts it: “the resurrection of Christ and the resurrection of the dead are not two totally different things…. "), _c('em', [_vm._v("For Paul the resurrection of Christ is the beginning of the resurrection of the dead.”")]), _vm._v(" Elsewhere Paul speaks of Christ as “the firstfruits of those who have fallen asleep” (1 Cor. 15:20), and it may be that it is this that is behind the present expression (cf. 8:11). Christ’s resurrection is no isolated event, but has important consequences for mankind at large. The emphasis is not, however, on this, but rather on the fact that the resurrection shows Jesus to be the powerful Son of God. In the light of the resurrection he is not to be classed with the generality of mankind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul goes on to give him the full title "), _c('em', [_vm._v("Jesus Christ our Lord.")]), _vm._v(" For "), _c('em', [_vm._v("Jesus Christ")]), _vm._v(" see on verse 1. Paul uses the title "), _c('em', [_vm._v("Lord")]), _vm._v(" 275 times (out of 718 in the New Testament). This term could be no more than a polite form of address like our “Sir”. But it could also be used of the deity one worships."), _c('a', {
    attrs: {
      "href": "#/#foot-63",
      "id": "foot_63"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The really significant background, though, is its use in the Greek translation of the Old Testament to render the divine name, Yahweh. Where the Hebrew has this name of God the LXX frequently translates with “Lord”. Christians who used this as their Bible would be familiar with the term as equivalent to deity. They were thus taking a significant step when they used it of Jesus. In referring to Jesus Paul is fond of compound expressions. He uses the combination "), _c('em', [_vm._v("Jesus Christ")]), _vm._v(" 15-19 times in this letter (the exact number depending on the resolution of textual problems) and the reverse, “Christ Jesus”, 13-16 times. "), _c('em', [_vm._v("Lord")]), _vm._v(" is "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("combined with one or both of these names 17 times, to which “our” is added 12 times and “your” once.")]), _c('a', {
    attrs: {
      "href": "#/#foot-64",
      "id": "foot_64"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" In all he uses the full expression "), _c('em', [_vm._v("Jesus Christ our Lord")]), _vm._v(" about 68 times, whereas the rest of the New Testament has it but 19 times (CGT). From all this it is clear that Paul is fond of compound names. Perhaps they helped him bring out something of the majesty of the Savior.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" "), _c('em', [_vm._v("Through him")]), _vm._v(" appears to mean that the gifts in question come from God the Father and that he gives them “through” the Son. This gives good sense and may well be right. But the Greek preposition rendered "), _c('em', [_vm._v("through")]), _c('a', {
    attrs: {
      "href": "#/#foot-65",
      "id": "foot_65"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" may on occasion denote the ultimate source (as it does in 11:36; 1 Cor. 1:9; Gal. 1:1). Paul may thus mean “from God”. But even if the preposition has this meaning, Paul seems to have in mind that Christ is the giver. These uncertainties do not affect the main sense, namely that the apostle is speaking not of human achievement but of a divine gift. He often emphasizes that he owes all to Christ (e.g., 1 Cor. 9:1; 15:8; Gal. 1:1, 12, 16).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We should probably take his "), _c('em', [_vm._v("we")]), _vm._v(" as an epistolary plural with the meaning “I” (in English we have the royal plural and the editorial plural; in Greek the writer of a letter sometimes says “we” where we would use the singular). The point is that "), _c('em', [_vm._v("apostleship")]), _vm._v(" is not a gift common to Christians at large, so that Paul can scarcely mean “you Romans and I”."), _c('a', {
    attrs: {
      "href": "#/#foot-66",
      "id": "foot_66"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" Some scholars think that the meaning is “we apostles”. This is not impossible, but it does raise the question of why Paul should drag in a reference to other apostles which he does not follow up. This would be all the more curious in the salutation of a letter from Paul alone, not from Paul and other apostles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Grace")]), _vm._v(" is a typically Pauline word. It is found in the apostle’s writings no less than 100 times out of its 155 New Testament occurrences, so that Paul uses it approximately twice out of every three times it is found in these books. He uses it 24 times in Romans, the highest number in any one book (next is 2 Corinthians with 18, then Acts with 17). The word is cognate with that for “joy”, and the basic meaning is “that which causes joy”. We still retain some of this meaning when we speak of, say, a ballet dancer moving gracefully, that is, in a pleasing, “joy-giving” manner, or when we refer to “the social graces”. In a Christian context nothing brings joy like that great, inexplicable"), _c('a', {
    attrs: {
      "href": "#/#foot-67",
      "id": "foot_67"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" saving act of God in Christ in which he freely brings about our salvation without any contribution from our side. The term thus comes to us rich with ideas of joy and bounty. Grace may be specifically opposed to what is due (4:4), or again, to works (11:6). The thought is of something completely "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("unearned and unmerited. The word may be used of salvation in general (“by grace you have been saved”, Eph. 2:8),")]), _c('a', {
    attrs: {
      "href": "#/#foot-68",
      "id": "foot_68"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" but here it is a gift for service."), _c('a', {
    attrs: {
      "href": "#/#foot-69",
      "id": "foot_69"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" It is the free, divine gift which enables Paul to carry out the task allotted to him (cf. 1 Cor. 15:10; Gal. 1:15; 1 Tim. 1:12-14). Here "), _c('em', [_vm._v("grace")]), _vm._v(" is linked with "), _c('em', [_vm._v("apostleship")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#foot-70",
      "id": "foot_70"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" The meaning may well be that Paul received "), _c('em', [_vm._v("grace")]), _vm._v(" for his work as an apostle (“grace of apostleship”), though it is also possible that he refers to "), _c('em', [_vm._v("grace")]), _vm._v(" as that which enables him to live the specifically Christian life in common with other believers, and "), _c('em', [_vm._v("apostleship")]), _vm._v(" as the peculiar gift God had given him for his ministry. Either way "), _c('em', [_vm._v("grace")]), _vm._v(" is not regarded, here or elsewhere, as a gift given for the recipient’s personal and private enjoyment. It is given in accordance with God’s will and to further God’s purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul goes on to the purpose of the gift. The word rendered "), _c('em', [_vm._v("obedience")]), _c('a', {
    attrs: {
      "href": "#/#foot-71",
      "id": "foot_71"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" is not found in pre-Christian writings (apart from one occurrence in LXX and one in Aquila). Christians did not, of course, bring the concept of obedience into the world. This virtue was known and appreciated long before, even if it found expression in other words. But certainly Christians gave it a new emphasis. Obedience follows from the truth Paul expressed in his opening line when he described himself as a “slave” of Christ. Believers belong to Christ without reserve. Therefore they owe him the most complete obedience. It is not without interest that this epistle, which puts such stress on the free salvation won for us by Christ’s atoning act, should also stress the importance of obedient response.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is further brought out with a characteristic reference to "), _c('em', [_vm._v("faith."), _c('a', {
    attrs: {
      "href": "#/#foot-72",
      "id": "foot_72"
    }
  }, [_c('sup', [_vm._v("72")])])]), _vm._v(" In the New Testament this noun normally denotes the attitude of trust, though sometimes it refers to what is believed, that is, the faith (e.g., Jude 3). In the present passage the expression is literally “to obedience of faith”,"), _c('a', {
    attrs: {
      "href": "#/#foot-73",
      "id": "foot_73"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" an expression which recurs in 16:26 and which may be taken in any one of a number of ways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("(a) The genitive may be objective and faith mean “the faith”, the body of teachings held by Christians. Thus Moffatt translates, “to promote obedience to the faith” (cf. 6:17; Acts 6:7). The absence of the article tells against this; "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("therefore some adopt the variant, “obedience to the authority of faith”, or even “obedience to God’s faithfulness”. The last two are possible, but they do not spring to the mind.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("(b) The genitive may be subjective and denote origin, “obedience which springs from faith” (BAGD), or “obedience which faith demands”.")]), _c('a', {
    attrs: {
      "href": "#/#foot-74",
      "id": "foot_74"
    }
  }, [_c('sup', [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("(c) The genitive might be epexegetic, meaning “obedience which consists in faith”"), _c('a', {
    attrs: {
      "href": "#/#foot-75",
      "id": "foot_75"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" (so Murray, Cranfield, etc.)."), _c('a', {
    attrs: {
      "href": "#/#foot-76",
      "id": "foot_76"
    }
  }, [_c('sup', [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The absence of the article makes (a) less plausible. There is more to be said for (b), and in any case it expresses an important truth. Many favor (c), but there is a problem in that, while faith and obedience go together, they are not identical. Why use two words for one meaning? It seems rather that the gospel is seen as demanding the response of faith. Accordingly, the way to obey is to believe. But obedience is more than faith, and faith is more than obedience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whichever way we take the expression, obedience is not an option (cf. 1 John 3:23-24). It is binding on all Christians. “Faith’s obedience” is a reminder that, as Paul understood it, faith is not an easy out for those who find a strict morality irksome. When anyone is saved through faith, it is with a view to obedience. The life is given in service to the Lord in whom one has come to believe. In some modern discussions Paul is seen as a charismatic, impatient of rules and institutions. Whatever be the truth about that, he clearly valued obedience. He was not free to innovate where God had made his will known.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("For his name’s sake")]), _vm._v(" means something like “for his sake”."), _c('a', {
    attrs: {
      "href": "#/#foot-77",
      "id": "foot_77"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" In New Testament times “the name” had a much fuller significance than with us. We see it as a label, a way of differentiating one from another. But in antiquity generally it was held that in some undefined way the name summed up the whole person. That is the significance of changing a person’s name. God changed people’s names at times when he bestowed a new character on them (e.g., Gen. 17:5, 15; 32:28). When one person changed another person’s name it "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("emphasized his lordship (2 Kings 24:17, etc.). Here "), _c('em', [_vm._v("name")]), _vm._v(" stands for the whole person.")]), _c('a', {
    attrs: {
      "href": "#/#foot-78",
      "id": "foot_78"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" Paul’s obedience was to all that Christ stands for."), _c('a', {
    attrs: {
      "href": "#/#foot-79",
      "id": "foot_79"
    }
  }, [_c('sup', [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Paul’s case this was to be worked out "), _c('em', [_vm._v("among all the Gentiles.")]), _vm._v(" “All” is a word of which Paul is fond, and he uses it in over one third of its New Testament occurrences."), _c('a', {
    attrs: {
      "href": "#/#foot-80",
      "id": "foot_80"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" It may perhaps indicate the largeness of his vision. He was not apt to concentrate on some insignificant segment of any matter with which he was dealing."), _c('a', {
    attrs: {
      "href": "#/#foot-81",
      "id": "foot_81"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" The word "), _c('em', [_vm._v("Gentiles")]), _vm._v(" is one he shares with Acts."), _c('a', {
    attrs: {
      "href": "#/#foot-82",
      "id": "foot_82"
    }
  }, [_c('sup', [_vm._v("82")])]), _vm._v(" Paul saw his vocation as specifically to the Gentiles (11:13; Gal. 2:9). This was a tremendous step of faith for a Jew, a Pharisee, and a Hebrew of the Hebrews (Phil. 3:4ff.). And when he turned to the Gentiles, he saw not a part only but all the Gentiles as coming within the scope of his commission. There was nothing small-minded about Paul."), _c('a', {
    attrs: {
      "href": "#/#foot-83",
      "id": "foot_83"
    }
  }, [_c('sup', [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Paul’s correspondents, whom he has not yet seen, come under the heading “Gentiles”. This may mean that the church at Rome was predominantly Gentile (so SH, Barrett, Bruce, etc.). Or it may point to its geographical location at the heart of the Roman Empire, and thus of the Gentile world (Cranfield). The former seems more likely, but either way this justifies the apostle of the Gentiles in writing to the Roman believers. Actually the Greek is not unambiguous, and it may be that we should take "), _c('em', [_vm._v("you also")]), _vm._v(" not with the preceding (“the Gentiles among whom you also are”) but with the following, as NIV, which groups the Romans with others who "), _c('em', [_vm._v("are called.")]), _vm._v(" But it seems better to take them with the preceding, as RSV, GNB, etc. In that case Paul is saying that the Romans are among the Gentiles and then goes on to refer to them as "), _c('em', [_vm._v("called.")]), _vm._v(" He used this word in verse 1 (where see note) of his own special call as an apostle. Now he balances this with the reminder that, while great apostles are certainly called by God, this is also true of every humble believer. When we think of our position as Christians we are inclined to think first of "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("what we do, and so we speak of our faith or our commitment or the like. But Paul stresses God’s initiative. Christians are people whom God has called. He goes on to speak of being called "), _c('em', [_vm._v("to belong to Jesus Christ.")]), _vm._v(" There is a responsibility attaching to call. Those called belong to Christ. Their lives are his.")]), _c('a', {
    attrs: {
      "href": "#/#foot-84",
      "id": "foot_84"
    }
  }, [_c('sup', [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" We come to the address: "), _c('em', [_vm._v("To all in Rome who are loved by God and called to be saints.")]), _vm._v(" We have already noticed Paul’s fondness for the word "), _c('em', [_vm._v("all")]), _vm._v(" (see on v. 5). He leaves out nobody as he greets the church."), _c('a', {
    attrs: {
      "href": "#/#foot-85",
      "id": "foot_85"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" He proceeds to speak of the Roman Christians as “God’s beloved”."), _c('a', {
    attrs: {
      "href": "#/#foot-86",
      "id": "foot_86"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" It is only because of God’s self-giving love that the gospel, and hence the church, exists at all (cf. 5:5, 8; 8:35ff.). That Christians are loved by God is not a truism but a truth to be received with awe and wonder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For "), _c('em', [_vm._v("called")]), _vm._v(" see on verse 1. The call of the rank and file of the Roman church balances that of the great apostle. Great leaders are called, but then so are all God’s lowly people. "), _c('em', [_vm._v("Saints")]), _vm._v(" is a term frequently used in the New Testament to denote Christians in general. Some deduce from passages like 15:25 and Ephesians 2:19 that the word was used by Jews or Jewish Christians as a self-designation to link them with the saints of the Most High (Dan. 7:22; cf. 27). If so, Paul is putting the Gentile believers in the same class. The term reminds us of the essential character of being Christian. The word"), _c('a', {
    attrs: {
      "href": "#/#foot-87",
      "id": "foot_87"
    }
  }, [_c('sup', [_vm._v("87")])]), _vm._v(" basically signifies “set apart”, “separated”. We normally use this concept in a negative way and after “separated” we naturally supply “from”. But the separation of which Paul writes is not so much a separation “from” anything as a "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("separation “to” God. It is positive, not negative. The saints are peculiarly God’s. They are set apart for him, “called to be his dedicated people” (NEB).")]), _c('a', {
    attrs: {
      "href": "#/#foot-88",
      "id": "foot_88"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" The word contains a challenge to faithful Christian service, for "), _c('em', [_vm._v("saints")]), _vm._v(" should live in accordance with the character implied in being thus set apart. At the same time their being "), _c('em', [_vm._v("saints")]), _vm._v(" at all is by virtue of their divine calling, not their own moral achievement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We should not overlook the plural. We sometimes speak of an individual man or woman as “a saint” or refer to “St. Peter”, “St. Mary”, or the like. This is not a New Testament usage. The word is never used there of any individual believer. It is always plural when used of believers, and the plural points to believers as a group, a community set apart for God. Again, the term does not convey the idea of outstanding ethical achievement which we usually understand by “saintliness”. While the importance of right living is insisted on and may even be implied with this very term, the main thrust is not there. It is rather in the notion of belonging to God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The rest of the verse contains Paul’s standard greeting, a form which other Christians apparently took over from him. While in a general way it corresponds to openings to letters at large, the precise form Paul gives it is not found before his time. The Greeks normally began with “Greeting”,"), _c('a', {
    attrs: {
      "href": "#/#foot-89",
      "id": "foot_89"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" a word which in sound, though not in meaning, is close to “grace”. “Peace” reflects the usual Hebrew salutation. Thus Paul’s opening combines features from both groups."), _c('a', {
    attrs: {
      "href": "#/#foot-90",
      "id": "foot_90"
    }
  }, [_c('sup', [_vm._v("90")])]), _vm._v(" For "), _c('em', [_vm._v("grace")]), _vm._v(" see on verse 5. The combination "), _c('em', [_vm._v("grace")]), _vm._v(" and "), _c('em', [_vm._v("peace")]), _vm._v(" is found already in Numbers 6:25-26."), _c('a', {
    attrs: {
      "href": "#/#foot-91",
      "id": "foot_91"
    }
  }, [_c('sup', [_vm._v("91")])]), _vm._v(" "), _c('em', [_vm._v("Peace")]), _vm._v(" is only slightly less Pauline than is "), _c('em', [_vm._v("grace.")]), _vm._v(" Paul has almost half the New Testament occurrences of the word."), _c('a', {
    attrs: {
      "href": "#/#foot-92",
      "id": "foot_92"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" The Greeks generally understood peace as a negative thing, the absence of war. But in the New Testament the word has much of the positive connotation of "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("the Hebrew "), _c('em', [_vm._v("shalom,")]), _vm._v(" which it constantly translates in LXX. For the Hebrews and the people of the New Testament "), _c('em', [_vm._v("peace")]), _vm._v(" was not so much the absence of war or strife as the presence of positive blessing.")]), _c('a', {
    attrs: {
      "href": "#/#foot-93",
      "id": "foot_93"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" In this greeting it always follows "), _c('em', [_vm._v("grace.")]), _vm._v(" It may not be pressing this unduly to see that it is only God’s "), _c('em', [_vm._v("grace")]), _vm._v(" that brings real "), _c('em', [_vm._v("peace.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Among Christians the characteristic name for God is "), _c('em', [_vm._v("Father."), _c('a', {
    attrs: {
      "href": "#/#foot-94",
      "id": "foot_94"
    }
  }, [_c('sup', [_vm._v("94")])])]), _vm._v(" This term is, of course, far from being confined to Christians. Pagans also used it, but for them it was not typical and for Christians it was (and is). The word expresses something of the love and tender concern that God so constantly shows his people. In the first century it also conveyed the thought of absolute rule, for the father in those days was supreme in his family (among the Romans the head of the house even had the right to put members of his household to death, even if this was done very rarely; cf. Gen. 38:24). But the main thing is the love and care which God never fails to show. As he does habitually, Paul links "), _c('em', [_vm._v("the Lord Jesus Christ")]), _vm._v(" with the "), _c('em', [_vm._v("Father")]), _vm._v(" in this salutation."), _c('a', {
    attrs: {
      "href": "#/#foot-95",
      "id": "foot_95"
    }
  }, [_c('sup', [_vm._v("95")])]), _vm._v(" We should not overlook the very natural way in which the two are linked. “St. Paul, if not formally enunciating a doctrine of the Divinity of Christ, held a view which cannot really be distinguished from it” (SH). The same writers see this as pointing to the Trinity: “There is nothing more wonderful in the history of Christian thought than the silent and imperceptible way in which this doctrine, to us so difficult, took its place without struggle and without controversy among accepted Christian truths.”"), _c('a', {
    attrs: {
      "href": "#/#foot-96",
      "id": "foot_96"
    }
  }, [_c('sup', [_vm._v("96")])]), _vm._v(" In view of later church history this may be a trifle optimistic, but the New Testament usage is noteworthy. It is impossible to think of any other than Christ as being linked to the Father in this way. The formula tells us something important about the person of Christ.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_vm._v("B. P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAYER,")]), _vm._v(" 1:8-15")]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("8")]), _vm._v("First, I thank my God through Jesus Christ for all of you, because your faith is being reported all over the world. "), _c('sup', [_vm._v("9")]), _vm._v("God, whom I serve with my whole heart in preaching the gospel of his Son, is my witness how constantly I remember you ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('em', [_c('sup', [_vm._v("10")]), _vm._v("in my prayers at all times; and I pray that now at last by God’s will the way may be opened for me to come to you.")])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("11")]), _vm._v("I long to see you so that I may impart to you some spiritual gift to make you strong— "), _c('sup', [_vm._v("12")]), _vm._v("that is, that you and I may be mutually encouraged by each other’s faith. "), _c('sup', [_vm._v("13")]), _vm._v("I do not want you to be unaware, brothers, that I planned many times to come to you (but have been prevented from doing so until now) in order that I might have a harvest among you, just as I have had among the other Gentiles.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("14")]), _vm._v("I am obligated both to Greeks and non-Greeks, both to the wise and the foolish. "), _c('sup', [_vm._v("15")]), _vm._v("That is why I am so eager to preach the gospel also to you who are at Rome.")])])]), _c('p', {
    staticClass: "indent-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Some pious expression was often found at the beginning of a first-century letter. It might be a little prayer that things would go well with the recipient(s) of the letter,")]), _c('a', {
    attrs: {
      "href": "#/#foot-97",
      "id": "foot_97"
    }
  }, [_c('sup', [_vm._v("97")])]), _vm._v(" or perhaps a thanksgiving for blessings received. Paul makes something very real of this feature of early correspondence,"), _c('a', {
    attrs: {
      "href": "#/#foot-98",
      "id": "foot_98"
    }
  }, [_c('sup', [_vm._v("98")])]), _vm._v(" and we find a thanksgiving at this point in all his letters except Galatians (which has instead, “I am astonished that you are so quickly deserting …”). It is not surprising to find him praying for his converts, but it is interesting that he here prays for the Roman Christians, whom he did not know. Clearly his prayers were wide-ranging. This prayer expresses some of the intensity of the feeling with which the apostle had longed to visit Rome to work among the Christians there and to preach the gospel to the heathen. We gather incidentally from his words something of the reputation the Roman Christians had at that time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Paul proceeds to thank God for what he had done among the Romans. The apostle begins with "), _c('em', [_vm._v("First,")]), _vm._v(" but he never does get around to a corresponding “second”."), _c('a', {
    attrs: {
      "href": "#/#foot-99",
      "id": "foot_99"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" This phenomenon may be due to a combination of the tumultuous way Paul’s thoughts tumbled out and the method of writing, by dictation to a secretary,"), _c('a', {
    attrs: {
      "href": "#/#foot-100",
      "id": "foot_100"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" a procedure which does not make for the "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("smoothing out of all grammatical irregularities. He begins with thanksgiving.")]), _c('a', {
    attrs: {
      "href": "#/#foot-101",
      "id": "foot_101"
    }
  }, [_c('sup', [_vm._v("101")])]), _vm._v(" He has used the epistolary plural in verse 5, but here, writing more personally, he uses the singular. He addresses God as "), _c('em', [_vm._v("my God,")]), _vm._v(" an expression he uses but rarely (2 Cor. 12:21; Phil. 1:3; 4:19; Phlm. 4; some MSS of 1 Cor. 1:4). It reminds us that personal relationship is important in religion, a truth brought out by the frequent use of this kind of language in the Psalms."), _c('a', {
    attrs: {
      "href": "#/#foot-102",
      "id": "foot_102"
    }
  }, [_c('sup', [_vm._v("102")])]), _vm._v(" He offers his thanksgiving "), _c('em', [_vm._v("through Jesus Christ,")]), _vm._v(" another unusual expression;"), _c('a', {
    attrs: {
      "href": "#/#foot-103",
      "id": "foot_103"
    }
  }, [_c('sup', [_vm._v("103")])]), _vm._v(" neither Paul nor anyone else can presume to approach God of himself (cf. Heb. 13:15). The matter of his thanksgiving is that the faith of the Roman Christians "), _c('em', [_vm._v("is being reported"), _c('a', {
    attrs: {
      "href": "#/#foot-104",
      "id": "foot_104"
    }
  }, [_c('sup', [_vm._v("104")])]), _vm._v(" all over the world")]), _vm._v(" (cf"), _c('em', [_vm._v(".")]), _vm._v(" 1 Thess. 1:8 and, from another standpoint, Col. 1:5-6). He uses two different words for "), _c('em', [_vm._v("all")]), _vm._v(" (in "), _c('em', [_vm._v("all of you")]), _vm._v(" and "), _c('em', [_vm._v("all over the world),"), _c('a', {
    attrs: {
      "href": "#/#foot-105",
      "id": "foot_105"
    }
  }, [_c('sup', [_vm._v("105")])])]), _vm._v("but there seems no difference in meaning; we should see the change as stylistic. Both are a trifle hyperbolic. Paul did not know all the Romans or indeed many of them. And it is possible that some parts of the world did not speak about their "), _c('em', [_vm._v("faith.")]), _vm._v(" But the statement is meaningful. It brings out the facts that Paul is happy with what he knows about the whole church and that it had a good reputation throughout the world of the day. "), _c('em', [_vm._v("Faith")]), _vm._v(" is what really matters, and clearly Paul could take it for granted that the Romans were in agreement on the point."), _c('a', {
    attrs: {
      "href": "#/#foot-106",
      "id": "foot_106"
    }
  }, [_c('sup', [_vm._v("106")])]), _vm._v(" Without it neither a person nor a church has claim to the name “Christian”. Sometimes the apostle’s words are taken to mean that the Romans were outstanding, as when Barrett sees the meaning as, “ ‘the faith "), _c('em', [_vm._v("as")]), _vm._v(" you hold it’, that is, the understanding, constancy, and charity with which you hold it.” Barth’s position is more in accordance with the text: “Paul does "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("not thank God for the piety of the Roman Christians…. He simply gives thanks for the fact that there are Christians in Rome” (so Nygren, Lagrange, Leenhardt, SH, etc.). It must have meant much to the scattered little Christian communities")]), _c('a', {
    attrs: {
      "href": "#/#foot-107",
      "id": "foot_107"
    }
  }, [_c('sup', [_vm._v("107")])]), _vm._v(" that the church was established in the world’s capital city. So they spoke of it with satisfaction, and Paul gives thanks for it. "), _c('em', [_vm._v("World")]), _vm._v(" is largely a Pauline and Johannine term in the New Testament."), _c('a', {
    attrs: {
      "href": "#/#foot-108",
      "id": "foot_108"
    }
  }, [_c('sup', [_vm._v("108")])]), _vm._v(" In Romans the word normally means the world at large, as here, or else the inhabitants of the world; it is not used of the world in opposition to God as often in John and sometimes elsewhere in Paul (e.g., 1 Cor. 1:21).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("9-10.")]), _vm._v(" Paul links this statement to the preceding in logical sequence with “For” (which NIV omits). It is a favorite word of Paul’s"), _c('a', {
    attrs: {
      "href": "#/#foot-109",
      "id": "foot_109"
    }
  }, [_c('sup', [_vm._v("109")])]), _vm._v(" and one very much at home in the argumentative style of this epistle. Here it introduces a statement explaining what the writer has just said. He is very much in earnest, as his calling of God to witness shows. This is a kind of oath, a very solemn affirmation of the truth of a statement which could be known only to God."), _c('a', {
    attrs: {
      "href": "#/#foot-110",
      "id": "foot_110"
    }
  }, [_c('sup', [_vm._v("110")])]), _vm._v(" The form is purely Pauline in the New Testament (with minor variants in 2 Cor. 1:23; 11:31; Gal. 1:20; Phil. 1:8; 1 Thess. 2:5, 10; but cf. Rev. 1:5; 3:14). On this occasion it is clearly very relevant, for (a) Paul had never yet been to Rome though for many years he had been “the Apostle of the Gentiles”, and (b) even as he wrote he was about to go off in the opposite direction, to Jerusalem. As he preaches the gospel Paul has given his life to the service"), _c('a', {
    attrs: {
      "href": "#/#foot-111",
      "id": "foot_111"
    }
  }, [_c('sup', [_vm._v("111")])]), _vm._v(" of God, this God whom he calls to witness, and this in no shallow, surface manner but "), _c('em', [_vm._v("with my whole heart,")]), _vm._v(" or more exactly, “in my spirit”."), _c('a', {
    attrs: {
      "href": "#/#foot-112",
      "id": "foot_112"
    }
  }, [_c('sup', [_vm._v("112")])]), _vm._v(" This may "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("carry with it the thought that the service of God must be carried out in the spirit rather than the letter, as some think. It certainly stresses the thought that there is nothing superficial about the apostle’s service. He serves God with his innermost being, with all his might. Hodge sees this as “opposed at once to an insincere, and to a mere external service”, while Cranfield finds a reference to “his praying as being the inward side of his apostolic service contrasted with the outward side consisting of his preaching, etc.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-113",
      "id": "foot_113"
    }
  }, [_c('sup', [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One may characterize the gospel in various ways (see on 1:1). Here Paul speaks of it as "), _c('em', [_vm._v("the gospel of his Son")]), _vm._v(" (cf. 15:19). It centers on Christ’s atoning act. Without that there would be no gospel. In a very special sense it is Christ’s own gospel. Paul speaks of his service of God as “in the gospel” (not "), _c('em', [_vm._v("in preaching the gospel;")]), _vm._v(" he says nothing about preaching, but simply that he serves in his spirit in the gospel). The gospel is central to the living out of the Christian life as Paul sees it; really to understand the gospel and accept it means a change in one’s whole life. It is central to Paul’s preaching, certainly (cf. 1"), _c('span', {
    staticClass: "smallcaps"
  }), _vm._v(" Cor. 1:17). But that is not his point here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That for which Paul calls God to witness is the way he prays for the Roman Christians: "), _c('em', [_vm._v("how constantly")]), _c('a', {
    attrs: {
      "href": "#/#foot-114",
      "id": "foot_114"
    }
  }, [_c('sup', [_vm._v("114")])]), _vm._v(" "), _c('em', [_vm._v("I remember you in my prayers.")]), _vm._v(" He never stops. "), _c('em', [_vm._v("Remember")]), _vm._v(" is more exactly “make"), _c('a', {
    attrs: {
      "href": "#/#foot-115",
      "id": "foot_115"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" mention”, and Paul uses his word for “mention”"), _c('a', {
    attrs: {
      "href": "#/#foot-116",
      "id": "foot_116"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" seven times but it is found nowhere else in the New Testament. Since Paul has no special corner on any of the other words for remembrance, this is striking, though it is not easy to see whether this has significance. It is used of remembrance in prayer on every occasion but one (1 Thess. 3:6).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("At all times"), _c('a', {
    attrs: {
      "href": "#/#foot-117",
      "id": "foot_117"
    }
  }, [_c('sup', [_vm._v("117")])])]), _vm._v(" emphasizes that Paul’s remembrance of the Romans is unvarying, not sporadic. His word for "), _c('em', [_vm._v("prayers")]), _vm._v(" is not found in the classical writers before the New Testament (though it does occur in LXX and the papyri); but the Christians found it congenial and used it often."), _c('a', {
    attrs: {
      "href": "#/#foot-118",
      "id": "foot_118"
    }
  }, [_c('sup', [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At this point we notice an ambiguity arising from the way we "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("punctuate. The most ancient manuscripts had no punctuation (or very little), and the punctuation we find in modern editions and translations is supplied by editors and translators. Paul says something very like: “how constantly mention of you I make always at my prayers asking….” We could put a comma after “make” to give the sense: “how constantly I make mention of you, always at my prayers asking….” Or we could put our comma after “prayers” thus: “how constantly I always make mention of you at my prayers, asking….” Many modern translations favor the latter (as RSV, NIV, Moffatt), though it is also possible to opt for the former (with ASV, NEB). The difficulty with the former way is that there is nothing in the first clause to indicate that prayer is in mind, and it is further urged that it is doubtful whether Paul in his prayers invariably prayed to go to Rome. The problem with the latter is that “how unceasingly” and “always” appear very awkwardly in the same clause. But, however we resolve the problem, Paul is saying two things: in the first instance he prays for the Roman Christians constantly and in the second he asks God to let him visit them.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('em', [_vm._v("I pray")]), _vm._v(" renders a word which strictly points to petition from a sense of need,")]), _c('a', {
    attrs: {
      "href": "#/#foot-119",
      "id": "foot_119"
    }
  }, [_c('sup', [_vm._v("119")])]), _vm._v(" though we should probably not stress this. Paul proceeds to pile up a group of Greek particles which are the despair of the Greek student and which NIV reduces to "), _c('em', [_vm._v("now at last.")]), _c('a', {
    attrs: {
      "href": "#/#foot-120",
      "id": "foot_120"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" Paul does not particularize the method or the time, but he does want to come to Rome. Notice, however, that he slips in the caveat, "), _c('em', [_vm._v("by God’s will.")]), _vm._v(" His primary concern is to follow God’s leading, not to fulfil plans of his own making. He wants to come to Rome, but only in the way and at the time God chooses. The verse contains an interesting combination of Paul’s longing to visit Rome"), _c('a', {
    attrs: {
      "href": "#/#foot-121",
      "id": "foot_121"
    }
  }, [_c('sup', [_vm._v("121")])]), _vm._v(" and of respect for the will of God. And it is the will of God on which the emphasis is placed."), _c('a', {
    attrs: {
      "href": "#/#foot-122",
      "id": "foot_122"
    }
  }, [_c('sup', [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('strong', [_vm._v("11.")]), _vm._v(" But the longing is there—a deep and strong desire (cf. Acts 19:21). Paul proceeds to speak of it, and he makes it clear that it is no selfish desire. He longs")]), _c('a', {
    attrs: {
      "href": "#/#foot-123",
      "id": "foot_123"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" to see his Roman friends, not primarily to get something out of them, but in order to impart something to them, "), _c('em', [_vm._v("some spiritual gift to make you strong.")]), _vm._v(" In this place "), _c('em', [_vm._v("spiritual")]), _vm._v(" can do no more than add emphasis, for the idea is already there in the noun. "), _c('em', [_vm._v("Gift")]), _vm._v(" renders "), _c('em', [_vm._v("charisma,")]), _vm._v(" the word normally used of the special gifts imparted by the Holy Spirit (such as those discussed in 1 Cor. 12; cf. also Rom. 12:6ff.), gifts of healings, miracles, speaking with tongues, prophecy, teaching, and so on. But the word may also be used in a wider and more general sense of the gift God makes to every believer (5:15; 1 Pet. 4:10). Paul speaks of each as having a gift which determines whether he should live the married or the single life (1 Cor. 7:7). There is no reason to think that Paul has the special gifts in mind here, and the indefinite form of the expression"), _c('a', {
    attrs: {
      "href": "#/#foot-124",
      "id": "foot_124"
    }
  }, [_c('sup', [_vm._v("124")])]), _vm._v(" favors the more general concept. Nor is there any indication that he could have imparted such a gift if he wished to; they seem to have been gifts given by the Holy Spirit when and how he chose. The term is used here in the more general sense of anything that builds up the spiritual life. Paul wanted the Roman Christians to be strengthened in the faith as a result of the gift God would give them through his ministry. He speaks of strengthening them (and gives that as the purpose"), _c('a', {
    attrs: {
      "href": "#/#foot-125",
      "id": "foot_125"
    }
  }, [_c('sup', [_vm._v("125")])]), _vm._v(" of his proposed visit—he was not aimless in anything he did). Life was not easy for first-century Christians. At Rome, as elsewhere, it was important that they be strong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("12.")]), _vm._v(" Paul explains his meaning a little more, for what he has just said, though sincere, might seem boastful or patronizing."), _c('a', {
    attrs: {
      "href": "#/#foot-126",
      "id": "foot_126"
    }
  }, [_c('sup', [_vm._v("126")])]), _vm._v(" Some suggest that Paul checks himself from reasons of policy, but this is not a cunning ploy, calculated to secure a desired effect. It is the simple truth. When he went to Rome the traffic would not be all one way."), _c('a', {
    attrs: {
      "href": "#/#foot-127",
      "id": "foot_127"
    }
  }, [_c('sup', [_vm._v("127")])]), _vm._v(" Paul would doubtless bring "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("something to the Roman Christians, but they would also help him. They would be "), _c('em', [_vm._v("mutually encouraged")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#foot-128",
      "id": "foot_128"
    }
  }, [_c('sup', [_vm._v("128")])]), _vm._v(" by each other’s faith."), _c('a', {
    attrs: {
      "href": "#/#foot-129",
      "id": "foot_129"
    }
  }, [_c('sup', [_vm._v("129")])])]), _vm._v(" The mutuality is strengthened by the addition “both yours and mine”"), _c('a', {
    attrs: {
      "href": "#/#foot-130",
      "id": "foot_130"
    }
  }, [_c('sup', [_vm._v("130")])]), _vm._v(" (which NIV omits, thus losing a Pauline emphasis). This is not required by the sense, for the faith in question had to be that of Paul and the Romans. But the addition makes it quite clear that the faith of both was to be a factor in the situation. Paul was sure that the Romans would help him just as he would help them. Actually the translation "), _c('em', [_vm._v("that you and I may be mutually encouraged")]), _vm._v(" slightly oversimplifies the Greek. Paul says, “that is, to be encouraged among you”. He does not specify who is to be encouraged, though clearly he means himself (there is nobody else who is to be “among you”). But at this point he is thus putting more emphasis on his receiving from the Romans than on their receiving from him. He would certainly give them all he could. But he wants to leave no doubt but that he expected to be encouraged by their faith."), _c('a', {
    attrs: {
      "href": "#/#foot-131",
      "id": "foot_131"
    }
  }, [_c('sup', [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("13.")]), _vm._v(" "), _c('em', [_vm._v("I do not"), _c('a', {
    attrs: {
      "href": "#/#foot-132",
      "id": "foot_132"
    }
  }, [_c('sup', [_vm._v("132")])]), _vm._v(" want"), _c('a', {
    attrs: {
      "href": "#/#foot-133",
      "id": "foot_133"
    }
  }, [_c('sup', [_vm._v("133")])]), _vm._v(" you to be unaware"), _c('a', {
    attrs: {
      "href": "#/#foot-134",
      "id": "foot_134"
    }
  }, [_c('sup', [_vm._v("134")])])]), _vm._v(" is an expression Paul uses four times (11:25; 1 Cor. 10:1; 12:1), while on two more occasions he differs only in "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("using the plural “we” (2 Cor. 1:8; 1 Thess. 4:13). He uses this expression as a rule when he is introducing his readers to something they might not be expected to know but which he regards as important. In this way he emphasizes it to some extent. Paul often uses "), _c('em', [_vm._v("brothers")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#foot-135",
      "id": "foot_135"
    }
  }, [_c('sup', [_vm._v("135")])])]), _vm._v(" as a form of address (in this epistle on no less than ten occasions), but it is rare outside his writings. Luke uses “men and brothers” and James “my brothers”. Normally the term carries overtones of affection, but since Paul had never been to Rome we must take this as an indication of the warmth of feeling he had for all who were kin to him in Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This leads to the statement that he had often"), _c('a', {
    attrs: {
      "href": "#/#foot-136",
      "id": "foot_136"
    }
  }, [_c('sup', [_vm._v("136")])]), _vm._v(" intended"), _c('a', {
    attrs: {
      "href": "#/#foot-137",
      "id": "foot_137"
    }
  }, [_c('sup', [_vm._v("137")])]), _vm._v(" to come to Rome (cf. Acts 19:21), but had always been "), _c('em', [_vm._v("prevented.")]), _c('a', {
    attrs: {
      "href": "#/#foot-138",
      "id": "foot_138"
    }
  }, [_c('sup', [_vm._v("138")])]), _vm._v(" He does not say what had prevented him; his emphatic term, however, implies that he had tried hard to make the trip but that circumstances beyond his control had prevented it. His aim in seeking to come to Rome was "), _c('em', [_vm._v("in order that I might have a harvest among you. Have a harvest")]), _vm._v(" is perhaps more accurately rendered, “get some fruit”"), _c('a', {
    attrs: {
      "href": "#/#foot-139",
      "id": "foot_139"
    }
  }, [_c('sup', [_vm._v("139")])]), _vm._v(" (cf. John 15:16), a term which is not further defined. There may be something of a double meaning: the harvest would be his gain and theirs. Usually in the New Testament “fruit” refers to qualities of character or the like, as when Paul speaks of the fruit of the Spirit as “love, joy, peace …” (Gal. 5:22). It may be that this is in mind here, but on the whole it seems a little more likely that he is thinking of converts. He had been the means of bringing people to believe in Christ elsewhere in the Gentile world (for “Gentile” see on v. 5). Now he looks for the same thing to happen in Rome. "), _c('em', [_vm._v("The other Gentiles")]), _vm._v(" shows that Paul had had a very extensive ministry, but we need not take it to mean that he had worked among all the other Gentiles without exception. The expression also shows that the Roman church had many Gentiles in it, perhaps that it was predominantly Gentile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("14.")]), _vm._v(" There is no connecting particle, a fact which Godet takes to indicate "), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("feeling. Paul goes straight on to "), _c('em', [_vm._v("I am bound both to Greeks and non-Greeks. I am bound")]), _vm._v(" is more literally “I am a debtor.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-140",
      "id": "foot_140"
    }
  }, [_c('sup', [_vm._v("140")])]), _vm._v(" Paul uses the concept of debt on a number of occasions (as in 8:12; 15:27; Gal. 5:3). Here he probably means that his commission as the apostle of the Gentiles put him under obligation to preach the gospel to the Gentiles, at Rome as elsewhere. For any of us to receive the gospel is to incur a debt, and Paul shared in this. “Obligation to him who died produces obligation to those for whom he died.”"), _c('a', {
    attrs: {
      "href": "#/#foot-141",
      "id": "foot_141"
    }
  }, [_c('sup', [_vm._v("141")])]), _vm._v(" Earle speaks of “a vast amount of unnumbered blessings he had received from God” and adds, “All this put him under obligation.” But we should not overlook the fact that Paul speaks of being a debtor not to God, but to the Gentiles. This gives point to Barclay’s comment: “He was debtor because of all the kindness that he had received, and he was a debtor because of his obligation to preach to them.” Cranfield rejects this and understands the words in the sense “having an obligation to them in the sense that God has laid upon him a duty toward them. “"), _c('a', {
    attrs: {
      "href": "#/#foot-142",
      "id": "foot_142"
    }
  }, [_c('sup', [_vm._v("142")])]), _vm._v(" We need not tie Paul down too tightly and insist that his words be given the narrowest possible interpretation, but is this just to the fact that he speaks of himself as debtor "), _c('em', [_vm._v("to the Gentiles ?")]), _vm._v(" It is better to see the thought as complex, certainly including all the implications of Paul’s commission to be the apostle to the Gentiles, but with a glance also at what he owes the Gentiles in so many ways. They had contributed to his understanding of life. There may also be the thought that he had “got fruit” among many nations and was thus indebted to them."), _c('a', {
    attrs: {
      "href": "#/#foot-143",
      "id": "foot_143"
    }
  }, [_c('sup', [_vm._v("143")])]), _vm._v(" It is not completely clear whether Paul’s groups of people are meant to sum up all mankind or only the Gentiles. In favor of the Gentiles is his reference to them at the end of verse 13, but his language is quite general and there seems no real reason for excluding Jews. Perhaps the best understanding of the words is to see the gospel as imposing a debt on all who receive it, a debt which calls for repayment by passing the gospel on to someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul lists some of those to whom he is indebted and begins with "), _c('em', [_vm._v("Greeks."), _c('a', {
    attrs: {
      "href": "#/#foot-144",
      "id": "foot_144"
    }
  }, [_c('sup', [_vm._v("144")])])]), _vm._v(" This term can have other meanings than “those of the Greek "), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("nation”. In the expression “Jew and Greek” it clearly means “Gentile” (cf. v. 16). Now and then it appears to mean Greek-speaking Jews or Jewish proselytes (John 12:20; Acts 17:4). At this period the Greek language and culture were widespread and people in many places had adopted both. The term could thus mean “people of culture”, which is possibly the way we should take it here. This is supported by the fact that it forms a pair with “barbarians”, and it would form a natural antithesis to see it as meaning “cultured”.")]), _c('a', {
    attrs: {
      "href": "#/#foot-145",
      "id": "foot_145"
    }
  }, [_c('sup', [_vm._v("145")])]), _vm._v(" It is possible, however, that “Greeks and barbarians” should be understood as NIV, "), _c('em', [_vm._v("Greeks and non-Greeks,")]), _vm._v(" and thus the totality of mankind. “Barbarian”"), _c('a', {
    attrs: {
      "href": "#/#foot-146",
      "id": "foot_146"
    }
  }, [_c('sup', [_vm._v("146")])]), _vm._v(" originally meant someone who did not speak the local language. But it came to mean “one who lacks culture”, just as is the case with our word “barbarian”. Greeks and barbarians form a natural pair of opposites and sum up the world."), _c('a', {
    attrs: {
      "href": "#/#foot-147",
      "id": "foot_147"
    }
  }, [_c('sup', [_vm._v("147")])]), _vm._v(" People are either cultured or uncultured."), _c('a', {
    attrs: {
      "href": "#/#foot-148",
      "id": "foot_148"
    }
  }, [_c('sup', [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul has another pair of opposites, "), _c('em', [_vm._v("the wise and the foolish.")]), _c('a', {
    attrs: {
      "href": "#/#foot-149",
      "id": "foot_149"
    }
  }, [_c('sup', [_vm._v("149")])]), _vm._v(" Paul may decry worldly wisdom (as he does, e.g., in 1 Cor. 2), but he is deeply interested in true wisdom. He often reverts to the subject as he distinguishes between the wisdom of this world which he sees as foolishness (1 Cor. 1:20) and the true wisdom that comes from God. Here he is thinking of those the world counts as wise, but he is not contrasting their kind of wisdom with that which comes from God. He is accepting it for what it is and agreeing that it has its values. It is only when people use it to reject the divine wisdom that it is to be condemned. GT cites Aristotle’s definition of wisdom as “mental excellence in its highest and fullest sense.” It is something like this that Paul has in mind here, along with the point that Trench makes, that there is an important ethical element in wisdom."), _c('a', {
    attrs: {
      "href": "#/#foot-150",
      "id": "foot_150"
    }
  }, [_c('sup', [_vm._v("150")])]), _vm._v(" By contrast, "), _c('em', [_vm._v("the foolish")]), _vm._v(" are those without "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("understanding. They are not schooled in the niceties of philosophical debate, but that does not mean that Paul owes them nothing. He is in debt to all people, and he wants to do something to discharge the debt. This second division of mankind is not identical with the first. There could be foolish Greeks and there could be wise barbarians!")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('strong', [_vm._v("15.")]), _vm._v(" "), _c('em', [_vm._v("That is why")]), _vm._v(" expresses consequence: “since I am bound to all men” (Hodge). "), _c('em', [_vm._v("I am so eager")]), _vm._v(" is perhaps a little stronger than Paul’s words, which mean rather, “I am ready”. There is a slight difficulty with the Greek, but it appears to mean something like “as concerns me there is a readiness….”")]), _c('a', {
    attrs: {
      "href": "#/#foot-151",
      "id": "foot_151"
    }
  }, [_c('sup', [_vm._v("151")])]), _vm._v(" Whatever had prevented Paul from going to Rome till now had not been his own fault. He himself was quite ready, but matters he could not control had till now prevented him from making the trip."), _c('a', {
    attrs: {
      "href": "#/#foot-152",
      "id": "foot_152"
    }
  }, [_c('sup', [_vm._v("152")])]), _vm._v(" The reason he wanted to go to Rome was "), _c('em', [_vm._v("to preach the gospel"), _c('a', {
    attrs: {
      "href": "#/#foot-153",
      "id": "foot_153"
    }
  }, [_c('sup', [_vm._v("153")])])]), _vm._v(" to the Romans. It is a revealing glimpse of his priorities. He has already said that he is separated to the gospel (v. 1), and it accords with this that when his thoughts turn to what he can do for those "), _c('em', [_vm._v("at Rome"), _c('a', {
    attrs: {
      "href": "#/#foot-154",
      "id": "foot_154"
    }
  }, [_c('sup', [_vm._v("154")])])]), _vm._v(" it is preaching the gospel on which he seizes. That is the one thing that matters. The question arises, of course, “Why preach the gospel to Christians?” Our answer should probably be that in this sense he writes to his readers as Romans rather than as Christians (so Godet)."), _c('a', {
    attrs: {
      "href": "#/#foot-155",
      "id": "foot_155"
    }
  }, [_c('sup', [_vm._v("155")])]), _vm._v(" In Rome as elsewhere it is to nonbelievers that he would bring the gospel.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_vm._v("II. THESIS, 1:16-17")]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("16")]), _vm._v("I am not ashamed of the gospel, because it is the power of God for the salvation of everyone who believes: first for the Jew, then for the Gentile. "), _c('sup', [_vm._v("17")]), _vm._v("For in ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('em', [_vm._v("the gospel a righteousness from God is revealed, a righteousness that is by faith from first to last,"), _c('sup', [_vm._v("a")]), _vm._v(" just as it is written: “The righteous will live by faith.”"), _c('sup', [_vm._v("b")])])])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "ext-source"
  }, [_c('sup', [_vm._v("a")]), _vm._v("17 Or "), _c('em', [_vm._v("is from faith to faith")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-source0"
  }, [_c('sup', [_vm._v("b")]), _vm._v("17 Hab. 2:4")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("These two verses have an importance out of all proportion to their length. The weighty matter they contain tells us much of what this epistle is about. Barrett can say, “Most commentators recognize in them the ‘text’ of the epistle; it is not wrong to see in them a summary of Paul’s theology as a whole.” We have already noticed that the theme of Romans is God. This whole epistle is a book about God. But once that is recognized these verses may be held to give us the thesis of the epistle: they sum up for us what God has done to bring us salvation. Paul declares his adherence to the gospel (which he has already said is God’s, v. 1) and points out that God’s power is at work in it. It is a revelation of God’s righteousness. Paul quotes from the prophet Habakkuk to show that it is no new-fangled fantasy, but God’s way foretold from of old through God’s prophets. All these are characteristic Pauline thoughts and will be developed as we go through the epistle.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('strong', [_vm._v("16.")]), _vm._v(" The verse is introduced by “For”, which NIV omits.")]), _c('a', {
    attrs: {
      "href": "#/#foot-156",
      "id": "foot_156"
    }
  }, [_c('sup', [_vm._v("156")])]), _vm._v(" It is perhaps a little curious that Paul writes "), _c('em', [_vm._v("I am not ashamed"), _c('a', {
    attrs: {
      "href": "#/#foot-157",
      "id": "foot_157"
    }
  }, [_c('sup', [_vm._v("157")])]), _vm._v(" of the gospel.")]), _vm._v(" Why should he feel it necessary to utter this disclaimer? He gloried in the gospel (5:2, 11; 2 Cor. 10:17; Gal. 6:14; Phil. 3:7). But it maybe that there were people in Rome who despised the simplicity of the message (there were certainly some elsewhere, Acts 17:32; 1 Cor. 1:18, 23). Such people would look down on the Christians and their unusual gospel."), _c('a', {
    attrs: {
      "href": "#/#foot-158",
      "id": "foot_158"
    }
  }, [_c('sup', [_vm._v("158")])]), _vm._v(" Whatever be the case with others, Paul emphatically stands by the message. It had brought him neither ease nor comfort: “Paul had been imprisoned in Philippi, chased out of Thessalonica, smuggled out of Beroea, laughed at in Athens. He had preached in Corinth "), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("where his message was foolishness to the Greeks and a stumbling-block to the Jews, and out of that background Paul declared that he was proud of the gospel” (Barclay). He had certainly had his share of trouble as he proclaimed the message. But the gospel had proved adequate for the needs both of himself and his hearers, and Paul was far from being ashamed of it. Some have thought that he was troubled at coming to so splendid a place as Rome, the capital city of the world, with so simple a message. But, as Adolph Schlatter pointed out, “Reasons for deliberating whether he ought to be ashamed of the gospel were as real in the lowliest house of worship of the Jews as they were in the Roman Forum. Their root lay in the message he came with, in what he called its foolishness.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-159",
      "id": "foot_159"
    }
  }, [_c('sup', [_vm._v("159")])]), _vm._v(" That might tempt Christians anywhere to be ashamed. But Paul was not of that number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("gospel")]), _vm._v(" is "), _c('em', [_vm._v("the power of God"), _c('a', {
    attrs: {
      "href": "#/#foot-160",
      "id": "foot_160"
    }
  }, [_c('sup', [_vm._v("160")])])]), _vm._v(" for salvation (for "), _c('em', [_vm._v("gospel")]), _vm._v(" see on v. 1 and for "), _c('em', [_vm._v("power")]), _vm._v(" on v. 4). Paul is fond of contrasting mere words with power (e.g., 1 Cor. 2:4; 4:19-20; 1 Thess. 1:5; power and the gospel come together again in 15:19; 1 Cor. 1:18, 24; 2:5; cf. 2 Cor. 13:4; Eph. 3:20; Col. 1:11; 2 Tim. 1:7). No such contrast is explicit here, but Paul makes it plain that he is greatly interested in the power he sees in the gospel. The gospel is not advice to people, suggesting that they lift themselves. It is power. It lifts them up. Paul does not say that the gospel brings power but that it "), _c('em', [_vm._v("is")]), _vm._v(" power, and God’s power at that. When the gospel is preached, this is not simply so many words being uttered. The power of God is at work."), _c('a', {
    attrs: {
      "href": "#/#foot-161",
      "id": "foot_161"
    }
  }, [_c('sup', [_vm._v("161")])]), _vm._v(" When the gospel enters anyone’s life, it is as though the very fire of God had come upon him. There is warmth and light in his life."), _c('a', {
    attrs: {
      "href": "#/#foot-162",
      "id": "foot_162"
    }
  }, [_c('sup', [_vm._v("162")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The power of God of which Paul writes is not aimless but directed to "), _c('em', [_vm._v("salvation.")]), _vm._v(" It issues in salvation. This is the general term of which justification, redemption, and the like are particular aspects. Leenhardt sees it as signifying “all the blessings which God alone can give in answer to the need and longing of man, who is oppressed and in anguish in face of a destiny which sharpens his need of supernatural beatitude in proportion as it does nothing to satisfy it.”"), _c('a', {
    attrs: {
      "href": "#/#foot-163",
      "id": "foot_163"
    }
  }, [_c('sup', [_vm._v("163")])]), _vm._v(" Salvation is a very positive affair; it brings a rich variety of blessings "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("from God (5:10-11; 1 Cor. 1:18; Eph. 2:13, etc.). But it also has negative aspects. People may be saved from wrath (5:9), from hostility to God (5:10) or alienation from him (Eph. 2:12), from sin (Matt. 1:21), from being lost (Luke 19:10), from futility (1 Pet. 1:18), from “a yoke of slavery” (Gal. 5:1), from demon-possession (Luke 8:36), from sickness (Luke 8:48), from danger (Matt. 8:25-26), from a “corrupt generation” (Acts 2:40). Salvation has many facets. There is a sense in which it has already been achieved (Eph. 2:5), and another in which it is a present, on-going process (1 Cor. 1:18; 2 Cor. 2:15), but often the New Testament writers see it as future (13:11; 1 Cor. 5:5; 2 Tim. 4:18, etc.).")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("The scope of salvation is universal. It is open to "), _c('em', [_vm._v("everyone who believes.")]), _vm._v(" Paul brings this out further by saying that it is "), _c('em', [_vm._v("first")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#foot-164",
      "id": "foot_164"
    }
  }, [_c('sup', [_vm._v("164")])]), _vm._v(" for the few,"), _c('a', {
    attrs: {
      "href": "#/#foot-165",
      "id": "foot_165"
    }
  }, [_c('sup', [_vm._v("165")])]), _vm._v(" then"), _c('a', {
    attrs: {
      "href": "#/#foot-166",
      "id": "foot_166"
    }
  }, [_c('sup', [_vm._v("166")])]), _vm._v(" for the Gentile")]), _vm._v(" (literally “the Greek”). The combination stands for the totality of mankind. The gospel is for all and knows no limitation by race. In the matter of salvation God puts no difference between one nation and another. Paul assigns a certain priority to the Jew but immediately balances it with his reference to the Greek. Historically the gospel came to the Jews first, but Paul seems to mean more than this. The priority was in God’s plan. An electing purpose is expressed in it. But there is not one gospel for Jews and another for Gentiles. All who are saved are saved by the one gospel and are brothers and sisters in Christ. Just as it is true that it is "), _c('em', [_vm._v("first for the Jew, then for the Gentile,")]), _vm._v(" so it is true that “There is neither Jew nor Greek … for you are all one in Christ Jesus” (Gal. 3:28). But if "), _c('em', [_vm._v("everyone")]), _vm._v(" marks the universality, a restriction is indicated by "), _c('em', [_vm._v("who believes.")]), _vm._v(" The powerful salvation of which Paul writes is not the possession of any unbeliever. Each person must make it his own by his act of faith. This does not mean that faith is like another kind of law, but easier, as though God and man were cooperating to bring about salvation. “It is not man’s faith that gives the gospel its power; quite the contrary, it is the power "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("of the gospel that makes it possible for one to believe” (Nygren).")]), _c('a', {
    attrs: {
      "href": "#/#foot-167",
      "id": "foot_167"
    }
  }, [_c('sup', [_vm._v("167")])]), _vm._v(" Paul is not saying that people achieve power by their own believing effort."), _c('a', {
    attrs: {
      "href": "#/#foot-168",
      "id": "foot_168"
    }
  }, [_c('sup', [_vm._v("168")])]), _vm._v(" He is saying that the power of God is at work in the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("17.")]), _vm._v(" Paul proceeds to an explanation, giving the grounds for what he has just said ("), _c('em', [_vm._v("For")]), _vm._v(" keeps the argument in logical sequence). The statements of v. 16 are seen to be true because of what Paul now affirms. For the "), _c('em', [_vm._v("righteousness of God")]), _vm._v(" see Additional Note A. In this passage it is not completely certain whether we should understand the expression in the sense of a quality or attribute of God or of a right standing which God gives. It makes good sense to say, “In the gospel it is revealed that God is a righteous God.” But it also makes good sense to say, “In the gospel it is revealed that people get a right standing, a status of being right, from God.”"), _c('a', {
    attrs: {
      "href": "#/#foot-169",
      "id": "foot_169"
    }
  }, [_c('sup', [_vm._v("169")])]), _vm._v(" The following reference to faith seems to show that the righteousness that God gives is primarily in mind, as does the quotation from Habakkuk. Cranfield sees as decisive the further point that the argument of the epistle as a whole supports this view. Up to 4:25 Paul is concerned with the man who by faith is just (it is only after this that he emphasizes that the just “will live”)."), _c('a', {
    attrs: {
      "href": "#/#foot-170",
      "id": "foot_170"
    }
  }, [_c('sup', [_vm._v("170")])]), _vm._v(" Here Paul is saying that in the gospel God has acted decisively for our salvation and in a way that is right. The “rightness” of the way of salvation will be further brought out in this epistle as Paul develops the concept of justification. We should further notice that the righteousness of God is here said to be “revealed” in the gospel. That is to say, it is something new, not simply a repetition of Old Testament truth (important as that is)."), _c('a', {
    attrs: {
      "href": "#/#foot-171",
      "id": "foot_171"
    }
  }, [_c('sup', [_vm._v("171")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This righteousness "), _c('em', [_vm._v("is revealed.")]), _c('a', {
    attrs: {
      "href": "#/#foot-172",
      "id": "foot_172"
    }
  }, [_c('sup', [_vm._v("172")])]), _vm._v(" It is not something that people know "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("naturally or can find out for themselves. Unless God makes it known they will never discover it. NIV repeats the word "), _c('em', [_vm._v("righteousness")]), _vm._v(" though it occurs but once in the Greek: "), _c('em', [_vm._v("a righteousness from God is revealed, a righteousness that is by faith.")]), _vm._v(" This may well be the way the passage should be understood, for righteousness and faith are certainly linked elsewhere (e.g., 3:22). But we should notice that the word order is “righteousness of God in it is revealed from faith to faith.” This makes it possible to take is "), _c('em', [_vm._v("revealed")]), _vm._v(" and "), _c('em', [_vm._v("faith")]), _vm._v(" together, with the meaning that only faith apprehends the revelation.")]), _c('a', {
    attrs: {
      "href": "#/#foot-173",
      "id": "foot_173"
    }
  }, [_c('sup', [_vm._v("173")])]), _vm._v(" While this is true, it does not appear that this is what Paul is saying. It is much more likely that we should accept the sense of NIV and see a reference to that righteousness or right standing which is ours by faith.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("NIV’s "), _c('em', [_vm._v("by faith from first to last")]), _vm._v(" is the translation of a very difficult Greek expression."), _c('a', {
    attrs: {
      "href": "#/#foot-174",
      "id": "foot_174"
    }
  }, [_c('sup', [_vm._v("174")])]), _vm._v(" It means literally “out of faith into faith” or “from faith to faith”. Some have stressed this literal meaning and have argued that Paul means that the gospel spreads by a process in which the faith of one reaches out to bring another to faith. Some see the words as pointing to growth in faith (so SH), others that faith is both ground and goal. Manson favors “a revelation that springs from God’s faithfulness and appeals to man’s faith” (similarly Barth and others). An ancient interpretation is “from an Old Testament faith (cf. the quotation from Habakkuk) to a New Testament faith (the gospel)”. There are other views. Such interpretations, however, do seem to be reading something into the expression. It seems much more likely that Paul is simply emphasizing the place of faith: “faith through and through” or, as Ronald Knox renders it, “faith first and last”. The centrality of faith is important and must be clearly seen. Dodd finely remarks that for Paul “faith is that attitude in which, acknowledging our complete insufficiency for any of the high ends of life, we rely utterly on the sufficiency of God. It is to cease from all assertion of the self, even by way of effort after righteousness, and to make room for the divine initiative.” See further on verse 5.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Following his custom Paul drives home what he is saying with a quotation from Scripture. His almost invariable habit is, as here, to introduce it with "), _c('em', [_vm._v("just as it is written."), _c('a', {
    attrs: {
      "href": "#/#foot-175",
      "id": "foot_175"
    }
  }, [_c('sup', [_vm._v("175")])])]), _vm._v(" It is not necessary for him to say where it is written. The central place assigned to Scripture in the early church made that unnecessary. On this occasion he quotes from Habakkuk 2:4 the words, "), _c('em', [_vm._v("The righteous will live by faith")]), _vm._v(" (quoted again in Gal. 3:11; Heb. 10:38)."), _c('a', {
    attrs: {
      "href": "#/#foot-176",
      "id": "foot_176"
    }
  }, [_c('sup', [_vm._v("176")])]), _vm._v(" This message has been "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("understood traditionally as “The just shall live by faith” (KJV), but many now hold that it should be taken as “He that is just by faith shall live.” Grammatically it is slightly easier to take the words as KJV.")]), _c('a', {
    attrs: {
      "href": "#/#foot-177",
      "id": "foot_177"
    }
  }, [_c('sup', [_vm._v("177")])]), _vm._v(" But the point is not decisive, all the more so since Paul is quoting and may have felt obliged to reproduce the words of the prophet in the text known to him."), _c('a', {
    attrs: {
      "href": "#/#foot-178",
      "id": "foot_178"
    }
  }, [_c('sup', [_vm._v("178")])]), _vm._v(" But a number of reasons may be urged for taking the words in the sense “he that is just by faith shall live.” First, there is the context. Paul is talking about that righteousness which is “from faith to faith”, and he is citing the prophet in support. He is not talking about the way God’s people should live. Second, there is the point made by Nygren that in chapters 1–4 the faith words (“faith”, “to believe”) occur “at least 25 times” and the life words (“life”, “to live”, “to preserve alive”) twice, whereas in chapters 5–8 the figures are exactly reversed."), _c('a', {
    attrs: {
      "href": "#/#foot-179",
      "id": "foot_179"
    }
  }, [_c('sup', [_vm._v("179")])]), _vm._v(" The inference is that at this stage of the epistle Paul is concerned "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("with the fact that it is by faith that God saves people rather than with how they live. Third, the whole teaching of Romans is such as to lead us to connect “righteous” with “faith”. Paul keeps insisting that a person is righteous only by faith (3:20, 22, 24, 28; 4:2-3, 13, etc.; 5:1 is especially important, for in summing up the argument to that point Paul speaks explicitly of being justified by faith). There is no corresponding emphasis on the righteous as living by faith.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("The traditional view is sometimes supported by an appeal to the meaning of the original. The Greek which Paul quotes reflects a Hebrew word rendered “faith” but which most agree denotes fidelity rather than trust, or, as Gifford puts it, “the faith which may be relied on, rather than the faith which relies.” But this is not decisive. Long ago J. B. Lightfoot pointed out that the two meanings are not as far apart as they may at first seem, for “constancy under temptation or danger with an Israelite could only spring from reliance on Jehovah.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-180",
      "id": "foot_180"
    }
  }, [_c('sup', [_vm._v("180")])]), _vm._v(" It should also be borne in mind that Habakkuk is contrasting the man who is “puffed up” with the man of faith. So, however we translate his words, he is speaking of an attitude of lowly dependence on God. Which is basically what Paul is saying. Bruce can say: “The terms of Habakkuk’s oracle are sufficiently general to make room for Paul’s application of them—an application which, far from doing violence to the prophet’s intention, expresses the abiding validity of his message.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is quite clear that Paul is stressing the primacy of faith."), _c('a', {
    attrs: {
      "href": "#/#foot-181",
      "id": "foot_181"
    }
  }, [_c('sup', [_vm._v("181")])]), _vm._v(" He is telling us that God’s righteousness is shown in the gospel, that gospel which tells us that people must come to God in faith. It is this that he cites Habakkuk to support. It seems, then, that we should take the words in the sense “he that is just by faith will live.”"), _c('a', {
    attrs: {
      "href": "#/#foot-182",
      "id": "foot_182"
    }
  }, [_c('sup', [_vm._v("182")])]), _vm._v(" Paul is speaking of the way a person is made righteous, namely by faith, and assuring us that it is the one who is made righteous in this way who will live."), _c('a', {
    attrs: {
      "href": "#/#foot-183",
      "id": "foot_183"
    }
  }, [_c('sup', [_vm._v("183")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_vm._v("III. THE WAY OF DELIVERANCE, 1:18–5:21")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some modern discussions reduce the Christian salvation to the level of a commonplace. God was always ready to welcome sinners, we are told, and the gospel is simply the proclamation of something already well known, "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("indeed something of a truism. God is a forgiving and compassionate God, and he is well aware of the good intentions people have even when their performance falls short. He makes allowances. All we have to do is come back to him. There is, of course, a measure of truth in this, but such ways of describing the Christian salvation overlook the fact that the gospel tells us of something that happened. The cross is at the heart of it. Christ died for us. His death is meaningful; it is God’s great saving act. That sin was a very real problem is shown by the fact that God’s Son came to die as the means whereby it would be put away. Paul will expound this gospel, but before he comes to the remedy he makes his diagnosis of the disease. He has a careful argument that we are all sinners and this despite our opportunities for better things. Salvation means being saved from real peril. It is only when we realize in the depths of our being that we are lost that we are ready to receive the salvation that God gives. Not until we come to see that our search for God is and must be completely unsuccessful will we discover that God is searching for us.")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-3"
    }
  }, [_vm._v("A. U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIVERSAL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INFULNESS,")]), _vm._v(" 1:18–3:20")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("Paul is about to expound a wonderful salvation. But first he establishes the need for it by showing that all people are sinful.")]), _c('a', {
    attrs: {
      "href": "#/#foot-184",
      "id": "foot_184"
    }
  }, [_c('sup', [_vm._v("184")])]), _vm._v(" Many of his contemporaries did not agree, with the result that his message seemed foolishness to them. Many of our contemporaries do not agree with him either, with the result that his words are incomprehensible to them, too. It has always seemed to most people that they are, on the whole, pretty decent people. They may not be perfect but they have done no great wrong. Since they are conscious of no really disastrous sin, they feel that they must be right with God. But for Paul the significant thing is not that people have met their own standard but that they have not met God’s. They have come short of his demand. They are in the greatest of danger because they are subject to his wrath.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec4",
    attrs: {
      "id": "sec4-1"
    }
  }, [_c('em', [_vm._v("1. The Condemnation of the Gentile World, 1:18-32")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("18")]), _vm._v("The wrath of God is being revealed from heaven against all the godlessness and wickedness of men who suppress the truth by their wickedness, "), _c('sup', [_vm._v("19")]), _vm._v("since what may be known about God is plain to them, because God has made it plain to them. "), _c('sup', [_vm._v("20")]), _vm._v("For since the creation of the world God’s invisible qualities—his eternal power ")]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('em', [_vm._v("and divine nature—have been clearly seen, being understood from what has been made, so that men are without excuse.")])])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("21")]), _vm._v("For although they knew God, they neither glorified him as God nor gave thanks to him, but their thinking became futile and their foolish hearts were darkened. "), _c('sup', [_vm._v("22")]), _vm._v("Although they claimed to be wise, they became fools "), _c('sup', [_vm._v("23")]), _vm._v("and exchanged the glory of the immortal God for images made to look like mortal man and birds and animals and reptiles.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("24")]), _vm._v("Therefore God gave them over in the sinful desires of their hearts to sexual impurity for the degrading of their bodies with one another. "), _c('sup', [_vm._v("25")]), _vm._v("They exchanged the truth of God for a lie, and worshiped and served created things rather than the Creator—who is forever praised. Amen.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("26")]), _vm._v("Because of this, God gave them over to shameful lusts. Even their women exchanged natural relations for unnatural ones. "), _c('sup', [_vm._v("27")]), _vm._v("In the same way the men also abandoned natural relations with women and were inflamed with lust for one another. Men committed indecent acts with other men, and received in themselves the due penalty for their perversion.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent"
  }, [_c('em', [_c('sup', [_vm._v("28")]), _vm._v("Furthermore, since they did not think it worthwhile to retain the knowledge of God, he gave them over to a depraved mind, to do what ought not to be done, "), _c('sup', [_vm._v("29")]), _vm._v("They have become filled with every kind of wickedness, evil, greed and depravity. They are full of envy, murder, strife, deceit and malice. They are gossips, "), _c('sup', [_vm._v("30")]), _vm._v("slanderers, God-haters, insolent, arrogant and boastful; they invent ways of doing evil; they disobey their parents; "), _c('sup', [_vm._v("31")]), _vm._v("they are senseless, faithless, heartless, ruthless. "), _c('sup', [_vm._v("32")]), _vm._v("Although they know God’s righteous decree that those who do such things deserve death, they not only continue to do these very things but also approve of those who practice them.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("It is usually held that throughout this section Paul has the Gentile world in mind. This seems to be indeed the case, but we should notice that he does not specifically name the Gentiles here (as he does the Jew in 2:17) and further that some of the things he says had certainly been applied to the Jews (cf. v. 23 with Ps. 106:20; Jer. 2:11). By keeping this section general Paul is really indicting all mankind. He places special stress on two evils: idolatry and immorality. The language he uses is especially applicable to the Gentiles, and we need not doubt that he has them primarily in mind. As a rule they saw no problem in sin. The religions of the day seem to have had easy-going standards, so that people were not troubled by the lives they lived. As long as they avoided the worst excesses they felt that their gods were not going to be unduly concerned. Sometimes, indeed, they thought of their gods as so remote as not to care much what their worshippers did. They were too great to be bothered with the frailties of mortal men. So mortal men were not bothered either. Paul shows that such views are shallow and superficial. Sin is real. It has dreadful consequences. Even though the Gentiles have not had God’s law revealed to them as the Jews have, they know enough about what is right and what is wrong to be in serious trouble when they reject the right way.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('strong', [_vm._v("18.")]), _vm._v(" Once again NIV omits an opening “For”. This word is important because it links this statement to the preceding one and gives a reason for ")]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("it.")]), _c('a', {
    attrs: {
      "href": "#/#foot-185",
      "id": "foot_185"
    }
  }, [_c('sup', [_vm._v("185")])]), _vm._v(" The gospel is necessary "), _c('em', [_vm._v("because")]), _vm._v(" there is such a thing as the wrath of God"), _c('sub', [_c('span', {
    staticClass: "hebrew"
  }, [_vm._v("׳")])]), _vm._v(" because only the gospel of salvation by grace through faith (vv. 16-17) brings deliverance from that wrath."), _c('a', {
    attrs: {
      "href": "#/#foot-186",
      "id": "foot_186"
    }
  }, [_c('sup', [_vm._v("186")])]), _vm._v(" Agar Beet perceptively remarks, “the entire weight of "), _c('em', [_vm._v("vv.")]), _vm._v(" 16, 17, which contain a summary of the Epistle, rests upon the assumption that all men are, apart from the Gospel, under the anger of God.”"), _c('a', {
    attrs: {
      "href": "#/#foot-187",
      "id": "foot_187"
    }
  }, [_c('sup', [_vm._v("187")])]), _vm._v(" This is the plight of mankind. Apart from this the gospel has no meaning. And since the wrath of God is being revealed against all sin, there can be no way of salvation other than the way that deals with that sin, that is, the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is the one place in Romans where we find the expression "), _c('em', [_vm._v("the wrath of God,")]), _vm._v(" but “the wrath” means much the same."), _c('a', {
    attrs: {
      "href": "#/#foot-188",
      "id": "foot_188"
    }
  }, [_c('sup', [_vm._v("188")])]), _vm._v(" Whichever way he chooses to express it, the idea of the divine wrath is important in this epistle."), _c('a', {
    attrs: {
      "href": "#/#foot-189",
      "id": "foot_189"
    }
  }, [_c('sup', [_vm._v("189")])]), _vm._v(" Paul is clear that God is not passive in the face of sin. God is implacably and vigorously opposed to every evil."), _c('a', {
    attrs: {
      "href": "#/#foot-190",
      "id": "foot_190"
    }
  }, [_c('sup', [_vm._v("190")])]), _vm._v(" Ultimately everyone must reckon with this reality. Paul’s reference to revelation, his genitive "), _c('em', [_vm._v("of God,")]), _vm._v(" and his "), _c('em', [_vm._v("from heaven")]), _vm._v(" are ways of emphasizing that the wrath is a divine activity. God is doing something in opposition to sin, not leaving sinners to their own devices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Some, however, point out that the expression "), _c('em', [_vm._v("the wrath of God")]), _vm._v(" does not occur very often in Paul (again in Eph. 5:6; Col. 3:6) and that God is never the subject of the verb “to be wrathful”. They suggest accordingly that Paul thought of wrath in more or less impersonal terms. For example, Dodd tells us that he prefers to translate “the wrath of God” rather than “God’s anger” (Moffatt) “because such an archaic phrase suits a thoroughly archaic idea.” He sees “wrath” as denoting “some process or effect in the realm of objective facts” rather than “a certain feeling or attitude of God towards us,” though he "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("admits that this is “a peculiar extension of meaning.” He sums up the process as he sees it in the writings of the prophets: “sin is the cause, disaster the effect.” Paul, he thinks, had much the same idea, and the apostle retains the concept of wrath “not to describe the attitude of God to man, but to describe an inevitable process of cause and effect in a moral universe.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-191",
      "id": "foot_191"
    }
  }, [_c('sup', [_vm._v("191")])]), _vm._v(" Views like these are widely accepted (cf. Bowen, p. 221). They fit the mood of our time. People today tend to see the truth that “God is love” as the one significant thing. They quite overlook the unyielding moral demand that runs through Scripture."), _c('a', {
    attrs: {
      "href": "#/#foot-192",
      "id": "foot_192"
    }
  }, [_c('sup', [_vm._v("192")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is, of course, true that God is love. But it is not true that this rules out any realistic view of God’s wrath. We must bear in mind that the opposite of love is not wrath, but hate. Wrath is perhaps not an ideal term, for with us it so easily comes to denote an emotion characterized by loss of self-control and a violent concern for selfish interests. But these are not necessary constituents of wrath, and both are absent from the “righteous indignation” which gives us the best human analogy."), _c('a', {
    attrs: {
      "href": "#/#foot-193",
      "id": "foot_193"
    }
  }, [_c('sup', [_vm._v("193")])]), _vm._v(" In any case “wrath” is the word the Bible uses, and we need the strongest of reasons for abandoning it. It is a term that expresses the settled and active opposition of God’s holy nature to everything that is evil."), _c('a', {
    attrs: {
      "href": "#/#foot-194",
      "id": "foot_194"
    }
  }, [_c('sup', [_vm._v("194")])]), _vm._v(" Until some better suggestion is made we do well to stick to the biblical term to convey the biblical idea. What we should not do is to abandon the idea that the wrath is personal. This leads to the position that God does not care about sin, or at least does not care enough to act. It is impossible to reconcile such a morally neutral position with the scriptural teaching about God. The Bible in general and Paul in particular see God as personally active in opposing sin."), _c('a', {
    attrs: {
      "href": "#/#foot-195",
      "id": "foot_195"
    }
  }, [_c('sup', [_vm._v("195")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We should not overlook the further fact that the revelation of the wrath of God is in this context linked with the gospel. We see some revelation of the divine wrath, it is true, in the suffering, frustration, and sheer disaster that are so often the consequence of sin. But Paul is saying rather that it is the cross "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("that shows us the measure of God’s wrath. It is in the events of the gospel that the revelation occurs. Forgiveness is no cheap gesture. It is as costly as the cross. It is meaningless without the wrath (whether we use that term or not—it is the reality that counts). Unless there is something to be saved from, there is no point in talking about salvation. There is considerable agreement that we should understand the wrath in eschatological terms (cf. 2:5-9). That is, of course, true, but we should not overlook the other truth that it is also a present reality, as this passage shows (cf. the present tense, "), _c('em', [_vm._v("is being revealed,")]), _vm._v(" and vv. 24, 26, 28).")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("The reference to revelation shows that "), _c('em', [_vm._v("the wrath of God")]), _vm._v(" is not a human discovery. It is something that God has made known. The present tense indicates that it is a continuing process. Paul has just referred to righteousness as being revealed (v. 17), and there appears to be a connection. It is part of the revelation in the gospel that God’s attitude towards sin is one of righteous wrath.")]), _c('a', {
    attrs: {
      "href": "#/#foot-196",
      "id": "foot_196"
    }
  }, [_c('sup', [_vm._v("196")])]), _vm._v(" In that situation his love brings us a righteousness we could never earn. Both the righteousness and the wrath are a matter of revelation."), _c('a', {
    attrs: {
      "href": "#/#foot-197",
      "id": "foot_197"
    }
  }, [_c('sup', [_vm._v("197")])]), _vm._v(" The present tense in both cases indicates that Paul is talking about present realities, not remote possibilities. And this wrath is divine: the use of the phrase "), _c('em', [_vm._v("from heaven")]), _vm._v(" is a reverent way of referring to God (cf. Luke 15:7, 10)."), _c('a', {
    attrs: {
      "href": "#/#foot-198",
      "id": "foot_198"
    }
  }, [_c('sup', [_vm._v("198")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("God’s wrath is aroused by "), _c('em', [_vm._v("all the godlessness and wickedness of men.")]), _vm._v(" If the two nouns are used strictly, they combine the thoughts of sin against God and sin against men."), _c('a', {
    attrs: {
      "href": "#/#foot-199",
      "id": "foot_199"
    }
  }, [_c('sup', [_vm._v("199")])]), _vm._v(" Both matter. But probably Paul is simply indicating the variety of evil and is not trying to divide it carefully. His "), _c('em', [_vm._v("all")]), _vm._v(" is important. There are no exceptions. Nothing is overlooked. We cannot say that God does not mind some evils. His wrath is revealed against every wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul characterizes sinners as those "), _c('em', [_vm._v("who suppress the truth by their wickedness.")]), _vm._v(" There is a problem with the meaning of the verb translated "), _c('em', [_vm._v("suppress."), _c('a', {
    attrs: {
      "href": "#/#foot-200",
      "id": "foot_200"
    }
  }, [_c('sup', [_vm._v("200")])])]), _vm._v(" It "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("is a compound of the verb “to have” and could possibly be taken in the sense “possess” (as Hodge, e.g., notes). This would give the sense “who possess the truth but act unrighteously”.")]), _c('a', {
    attrs: {
      "href": "#/#foot-201",
      "id": "foot_201"
    }
  }, [_c('sup', [_vm._v("201")])]), _vm._v(" The problem with this is that Paul does not appear to have in mind people who hold true beliefs but live evil lives. Rather, he is describing sinners who, far from responding to God’s truth, oppose it. "), _c('em', [_vm._v("Suppress")]), _vm._v(" (NIV, RSV, etc.) is perhaps too strong. It implies that sinners are successful. Better is “hinder” (Moffatt) or the like. These people do not like the truth and do what they can to oppose it. By repeating the word "), _c('em', [_vm._v("wickedness")]), _vm._v(" Paul brings out that their sinfulness leads to their deeds. It is not possible to have a general attitude of unrighteousness without this finding expression in deeds opposed to God’s purposes. However we translate, we should take the verb as conative. Paul is speaking of what sinners attempt, not of what they succeed in doing (cf. Hendriksen, “attempting to suppress”).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("The truth"), _c('a', {
    attrs: {
      "href": "#/#foot-202",
      "id": "foot_202"
    }
  }, [_c('sup', [_vm._v("202")])])]), _vm._v(" here is the general truth that is open to all people, not the truth God has revealed in Christ and the gospel. People are guilty because they sin against the truth they have, not the truth they do not have."), _c('a', {
    attrs: {
      "href": "#/#foot-203",
      "id": "foot_203"
    }
  }, [_c('sup', [_vm._v("203")])]), _vm._v(" Paul evidently thinks of truth as dynamic, for it can be hindered, which means that it must be doing something. This sort of thing may be in mind also when he pictures truth as rejoicing with love (1 Cor. 13:6).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("19.")]), _vm._v(" The interpretation of verses 19-20 has been the cause of endless controversy."), _c('a', {
    attrs: {
      "href": "#/#foot-204",
      "id": "foot_204"
    }
  }, [_c('sup', [_vm._v("204")])]), _vm._v(" Some maintain that they point to a revelation which God has made to all people whereby, if they give due heed to it, they will come to a place of salvation. The words are taken as a charter for a doctrine of “natural revelation”. Others take the opposite view, that Paul is denying any saving revelation of God in nature. They affirm that he sees God as known in Christ, and in Christ alone. What he speaks of here is not a saving knowledge of God at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It does seem clear that Paul is not here speaking of a saving knowledge of God. The context is concerned with the condemnation of the Gentile world, not its salvation. The apostle is arguing from the necessity of the saving work "), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("which God accomplished in Christ. He is laying it down that God has revealed enough of himself to the Gentiles for them to be blameworthy when they sin and reject his leading. He is not facing the question whether there was enough in the revelation for them to be saved. That is quite a different question, and we should not torture Paul’s words into giving an answer to a question he is not facing. It would probably be a fair paraphrase of his argument to say that people have never lived up to the highest and best that they have known. But God intends that they should. They are guilty in his eyes when they do not. And nobody can say, “I did not know.” Our condemnation in each case lies in the fact that we have sinned against the light we have, not against the light we have never received. Thus, though the Gentiles did not receive the full revelation in the law of the Old Testament, they did receive enough illumination to know what was right. And they followed the wrong.")]), _c('a', {
    attrs: {
      "href": "#/#foot-205",
      "id": "foot_205"
    }
  }, [_c('sup', [_vm._v("205")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul’s "), _c('em', [_vm._v("since"), _c('a', {
    attrs: {
      "href": "#/#foot-206",
      "id": "foot_206"
    }
  }, [_c('sup', [_vm._v("206")])])]), _vm._v(" introduces the reason for the preceding. He proposes to substantiate what he has just said. It is a matter of dispute whether the following expression is correctly rendered "), _c('em', [_vm._v("what may be known about God")]), _vm._v(" or whether it means “what is known about God”. Paul’s Greek term"), _c('a', {
    attrs: {
      "href": "#/#foot-207",
      "id": "foot_207"
    }
  }, [_c('sup', [_vm._v("207")])]), _vm._v(" strictly means “that which may be known”, “that which is knowable”. But in the New Testament it is mostly used more loosely in the sense “that which is "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("known”. Against the former suggestion it is argued that in that form the statement is simply not true. Many things about God are “knowable”, though not known to people generally since God has not revealed them. Against the latter it is urged that it is tautology (“what people know… they know”). A decision is not easy, but on the whole it seems best to take the word here strictly (as NIV, RSV, Käsemann, etc.). There are things about God which cannot be made known in the natural order, but what can be made known God has made known.")]), _c('a', {
    attrs: {
      "href": "#/#foot-208",
      "id": "foot_208"
    }
  }, [_c('sup', [_vm._v("208")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such truth "), _c('em', [_vm._v("is plain to them, because God has made it plain to them."), _c('a', {
    attrs: {
      "href": "#/#foot-209",
      "id": "foot_209"
    }
  }, [_c('sup', [_vm._v("209")])])]), _vm._v(" His action matches the result."), _c('a', {
    attrs: {
      "href": "#/#foot-210",
      "id": "foot_210"
    }
  }, [_c('sup', [_vm._v("210")])]), _vm._v(" There is a slight problem with the first "), _c('em', [_vm._v("to them,"), _c('a', {
    attrs: {
      "href": "#/#foot-211",
      "id": "foot_211"
    }
  }, [_c('sup', [_vm._v("211")])])]), _vm._v("for the Greek might well be understood as “in them” or “among them”. “In them” would signify that the revelation takes place basically in people’s minds (so R. Knox, “is clear to their minds”). On this view God is at work in them whenever natural revelation takes place. It is God who brings conviction, not some objective feature of the created universe. But some argue strongly for “among them”. The revelation in question takes place, they say, not by some inward knowledge but in the creation in the midst of which they find themselves (so, e.g., Cranfield). But we must bear in mind that Paul uses the preposition “in” very frequently (988 times; this is more than a third of the New Testament total of 2,713). He seems to use it almost from habit, and we cannot always insist on a precise meaning. Since the grammarians usually regard it here as equivalent to the dative case, we should accept "), _c('em', [_vm._v("to them")]), _vm._v(" as the meaning."), _c('a', {
    attrs: {
      "href": "#/#foot-212",
      "id": "foot_212"
    }
  }, [_c('sup', [_vm._v("212")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul proceeds to emphasize that it is God who has given them this knowledge. In this book about God it is natural that it should be made plain that it is not people’s innate ability or cunning that enables them to rise to the knowledge of God. God can be known only as he chooses to make himself known. The initiative is with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("20.")]), _vm._v(" Paul presses the point. His "), _c('em', [_vm._v("For")]), _vm._v(" explains the “God has made it plain” of verse 19; he has made it plain in that his "), _c('em', [_vm._v("invisible qualities… have been clearly seen.")]), _vm._v(" Paul takes the revelation right back to the beginning of things with his "), _c('em', [_vm._v("since the creation of the world.")]), _vm._v(" Some, it is true, argue that this expression indicates not so much the origin in time as a seeing of the universe as “the source "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("of knowledge—the basis of a deduction”.")]), _c('a', {
    attrs: {
      "href": "#/#foot-213",
      "id": "foot_213"
    }
  }, [_c('sup', [_vm._v("213")])]), _vm._v(" This is supported by the fact that the word for "), _c('em', [_vm._v("creation")]), _vm._v(" elsewhere in the New Testament seems mostly to have the meaning “what has been created” rather than “the act of creation” (though the form really points to the latter)."), _c('a', {
    attrs: {
      "href": "#/#foot-214",
      "id": "foot_214"
    }
  }, [_c('sup', [_vm._v("214")])]), _vm._v(" This leads on to an understanding like that of Gifford: “ ‘The creation of the world,’ viewed as a whole, is first presented as the "), _c('em', [_vm._v("source")]), _vm._v(" from which man derives a knowledge of the unseen God.” The more natural meaning of the Greek, however, makes the reference temporal (“being understood from what has been made” is Paul’s way of referring to creation as the source). These words mean that the universe has always borne upon it the imprint of God’s handiwork. While many translators refer to "), _c('em', [_vm._v("the world,")]), _vm._v(" Paul’s meaning is, of course, “the universe”."), _c('a', {
    attrs: {
      "href": "#/#foot-215",
      "id": "foot_215"
    }
  }, [_c('sup', [_vm._v("215")])]), _vm._v(" Order in the heavens as well as on earth bears witness to God. This whole mighty universe has always reflected its Creator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("God’s invisible qualities")]), _vm._v(" is a slightly overconfident rendering of a rather indefinite expression."), _c('a', {
    attrs: {
      "href": "#/#foot-216",
      "id": "foot_216"
    }
  }, [_c('sup', [_vm._v("216")])]), _vm._v(" KJV translates it more literally with “the invisible things of him”. The meaning we give the expression will be determined by our understanding of the following "), _c('em', [_vm._v("his eternal power and divine nature."), _c('a', {
    attrs: {
      "href": "#/#foot-217",
      "id": "foot_217"
    }
  }, [_c('sup', [_vm._v("217")])])]), _vm._v(" Paul’s word for "), _c('em', [_vm._v("eternal")]), _vm._v(" is unusual."), _c('a', {
    attrs: {
      "href": "#/#foot-218",
      "id": "foot_218"
    }
  }, [_c('sup', [_vm._v("218")])]), _vm._v(" The more common word"), _c('a', {
    attrs: {
      "href": "#/#foot-219",
      "id": "foot_219"
    }
  }, [_c('sup', [_vm._v("219")])]), _vm._v(" (found, e.g., in the expression “eternal life”) is derived from the word for “age”. Here, where Paul is speaking of God’s essential being, he may well have felt that a word with a fundamental connection with time was not quite what he wanted. He prefers a word with a meaning like “always-ness”. His word for "), _c('em', [_vm._v("divine nature")]), _vm._v(" is another unusual one, found only here in the New Testament. In distinction from "), _c('em', [_vm._v("power")]), _vm._v(" (for which see the note on v. 14), which points to “a single attribute”, it “is a summary term for those other attributes which constitute "), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("Divinity” (SH).")]), _c('a', {
    attrs: {
      "href": "#/#foot-220",
      "id": "foot_220"
    }
  }, [_c('sup', [_vm._v("220")])]), _vm._v(" Paul is laying it down that what is revealed is God himself. In nature we see something of nature’s God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Have been clearly seen"), _c('a', {
    attrs: {
      "href": "#/#foot-221",
      "id": "foot_221"
    }
  }, [_c('sup', [_vm._v("221")])])]), _vm._v(" translates a verb, found here only in the New Testament, which is used of vision with the physical eye. With such vision we see the things God has created. But “being understood” refers to inner perception. The verb means "), _c('em', [_vm._v("“to perceive")]), _vm._v(" with the mind, "), _c('em', [_vm._v("understand”")]), _vm._v(" (AS). Paul is saying that we see certain outward things and thereby perceive things invisible."), _c('a', {
    attrs: {
      "href": "#/#foot-222",
      "id": "foot_222"
    }
  }, [_c('sup', [_vm._v("222")])]), _vm._v(" What we see is defined as "), _c('em', [_vm._v("what has been made."), _c('a', {
    attrs: {
      "href": "#/#foot-223",
      "id": "foot_223"
    }
  }, [_c('sup', [_vm._v("223")])])]), _vm._v(" The expression is quite general and does not limit the revelation to any part of creation. God has left his imprint on the entire created universe. But Paul’s main point is that seeing, people do not see; perceiving, they do not perceive. They see creation (cf. Job 40:15-41; Pss. 8; 19; 104; Isa. 40:21-26, etc.)."), _c('a', {
    attrs: {
      "href": "#/#foot-224",
      "id": "foot_224"
    }
  }, [_c('sup', [_vm._v("224")])]), _vm._v(" But because they reject the knowledge of God they have thrown away the key to it all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Most translations of the concluding part of the verse give the impression that Paul is referring to the result of the preceding. But the construction normally expresses purpose rather than result."), _c('a', {
    attrs: {
      "href": "#/#foot-225",
      "id": "foot_225"
    }
  }, [_c('sup', [_vm._v("225")])]), _vm._v(" If we accept purpose here, "), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("as we apparently should, then Paul is telling us that God has so made the universe that we are responsible people. This means all people, not only those who have the Bible to guide them. God intends that they will be guilty if they reject the light given them and fall into sin.")]), _c('a', {
    attrs: {
      "href": "#/#foot-226",
      "id": "foot_226"
    }
  }, [_c('sup', [_vm._v("226")])]), _vm._v(" The sinner may plead that he is ignorant. He does not know God. But Paul’s first point is that his ignorance is culpable. God has given a revelation in nature but people have closed their eyes to it. How then could they possibly see? But it is their own fault that they do not. They are "), _c('em', [_vm._v("without excuse.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("21.")]), _vm._v(" Having made the point that there has been some revelation of God to all mankind, Paul goes on to show that this has not been followed by willing obedience."), _c('a', {
    attrs: {
      "href": "#/#foot-227",
      "id": "foot_227"
    }
  }, [_c('sup', [_vm._v("227")])]), _vm._v(" People refused to accept the way of God and suffered the inevitable result. They acted foolishly, and idolatry with all its attendant evils was the consequence. Paul’s "), _c('em', [_vm._v("For"), _c('a', {
    attrs: {
      "href": "#/#foot-228",
      "id": "foot_228"
    }
  }, [_c('sup', [_vm._v("228")])])]), _vm._v(" carries on the argument in logical sequence. He affirms that people had real knowledge"), _c('a', {
    attrs: {
      "href": "#/#foot-229",
      "id": "foot_229"
    }
  }, [_c('sup', [_vm._v("229")])]), _vm._v(" of God. It is a truth on which he is insisting, for in this passage he has said it four times in one way or another. But, having this knowledge, they reacted in the wrong way. They did not “glorify"), _c('a', {
    attrs: {
      "href": "#/#foot-230",
      "id": "foot_230"
    }
  }, [_c('sup', [_vm._v("230")])]), _vm._v(" him as God”. This means a little more than that they did not “honor” God (as RSV, etc.)."), _c('a', {
    attrs: {
      "href": "#/#foot-231",
      "id": "foot_231"
    }
  }, [_c('sup', [_vm._v("231")])]), _vm._v(" They knew enough about him to know that "), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("”glory” was his due, but they withheld it from him. They may perhaps have said polite things about him, but they did not ascribe to him the glory that was his due. They did not act on the knowledge of God they had, but preferred their own way. Presently Paul will show that this led to idolatry. People preferred a “religion” of their own making rather than the divine revelation. “Thus ‘religion’ is born, springing from a rejected knowledge of the true God and finalizing man’s seizure of God, the triumph of gods over God” (Leenhardt, on vv. 22-24). With this Paul links another negative—"), _c('em', [_vm._v("nor gave thanks to him.")]), _vm._v(" It is interesting to see thanksgiving included as a response that might have been expected to God’s revelation of himself, though not as surprising as it might be in another author, for the apostle is fond of this concept.")]), _c('a', {
    attrs: {
      "href": "#/#foot-232",
      "id": "foot_232"
    }
  }, [_c('sup', [_vm._v("232")])]), _vm._v(" He sees people, then, as always ready to take up an irreligious attitude toward the universe in which they live, despite the many marks it bears of the Creator’s hand."), _c('a', {
    attrs: {
      "href": "#/#foot-233",
      "id": "foot_233"
    }
  }, [_c('sup', [_vm._v("233")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("But"), _c('a', {
    attrs: {
      "href": "#/#foot-234",
      "id": "foot_234"
    }
  }, [_c('sup', [_vm._v("234")])]), _vm._v(" their thinking became futile.")]), _vm._v(" When people rejected God, it affected their minds as well as other things. The word for "), _c('em', [_vm._v("thinking")]), _vm._v(" (more exactly “thoughts”) is neutral in itself and may be used of all kinds of thoughts. But in the New Testament it is mostly used of evil,"), _c('a', {
    attrs: {
      "href": "#/#foot-235",
      "id": "foot_235"
    }
  }, [_c('sup', [_vm._v("235")])]), _vm._v(" which fits this context. This is the one occurrence in the New Testament of the verb “to become futile” (Phillips, “became fatuous”)."), _c('a', {
    attrs: {
      "href": "#/#foot-236",
      "id": "foot_236"
    }
  }, [_c('sup', [_vm._v("236")])]), _vm._v(" But Paul uses other words of the word group fairly often. The basic idea is that of pointlessness. The practice of idolatry is inherently futile. What else can be said of offering worship to what one’s own hands have made? Paul is about to refer to idolatry (v. 23). Idolaters are out of touch with divine reality and shut themselves up to futility.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not only was their thinking futile; it was characterized by darkness."), _c('a', {
    attrs: {
      "href": "#/#foot-237",
      "id": "foot_237"
    }
  }, [_c('sup', [_vm._v("237")])]), _vm._v(" The New Testament often sets light over against darkness and equates sin with the latter. Sin is never an enlightened procedure despite the attitude of "), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("”advanced” secularists. It always represents a darkening of some part of us. "), _c('em', [_vm._v("Foolish")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#foot-238",
      "id": "foot_238"
    }
  }, [_c('sup', [_vm._v("238")])])]), _vm._v(" signifies “unintelligent”, and this brings out another facet of sin. It is never bright to walk in the ways of evil. What is characterized as "), _c('em', [_vm._v("foolish")]), _vm._v(" is translated "), _c('em', [_vm._v("hearts")]), _vm._v(" in NIV (so RV, ARV, etc.), but “minds” in RSV, Moffatt, Phillips, etc. It is the normal word for “heart”."), _c('a', {
    attrs: {
      "href": "#/#foot-239",
      "id": "foot_239"
    }
  }, [_c('sup', [_vm._v("239")])]), _vm._v(" But whereas with us the heart is used metaphorically of the emotions, this was not the case with the Greek term. In the ancient world the emotions tended to be located lower down, in the entrails (cf. the old-fashioned “bowels of compassion”). The heart stood rather for the entire inner life; in some contexts the emotions are more prominent (e.g., 2 Cor. 6:11-12), in some the intellectual (Rom. 10:8), and in some the volitional (1 Cor. 7:37). The heart is the center of the inner life; from it the person’s direction is determined, his whole course shaped, his basic commitments formed. This passage perhaps places some emphasis on the mind, but the term is comprehensive. When anyone rejects God, not only is his thinking awry but his whole inner life has taken a jolt. His emotions and will are affected, too. The comprehensive word is significant. Dodd reminds us that instances of what Paul had in mind are not hard to find. Though the apostle was not speaking specifically about the higher forms of Greek philosophy, in practice this philosophy “easily came to terms with the grossest forms of superstition and immorality … just as it is a grave count against the lofty philosophy of Hinduism that it utters no effective protest against the most degrading practices of popular religion in India today.”"), _c('a', {
    attrs: {
      "href": "#/#foot-240",
      "id": "foot_240"
    }
  }, [_c('sup', [_vm._v("240")])]), _vm._v(" All too often in the history of mankind a high level of philosophy has been found consistent with all the degradation of polytheism. The ability to think clearly does not necessarily deliver from superstition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("22.")]), _vm._v(" People do not always recognize the realities of their situation. "), _c('em', [_vm._v("Although they claimed to be wise, they became fools")]), _vm._v(" (cf. 1 Cor. 1:21; Eph. 4:17). NEB renders, “They boast of their wisdom, but they have made fools of themselves”. “Boast” is perhaps too strong for the Greek, which rather means “affirm”."), _c('a', {
    attrs: {
      "href": "#/#foot-241",
      "id": "foot_241"
    }
  }, [_c('sup', [_vm._v("241")])]), _vm._v(" But it is not much too strong. Clearly these people prided them"), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("selves on their wisdom, as the self-sufficient so often do. In the process they "), _c('em', [_vm._v("became fools.")])]), _c('em', [_c('a', {
    attrs: {
      "href": "#/#foot-242",
      "id": "foot_242"
    }
  }, [_c('sup', [_vm._v("242")])])]), _vm._v(" This verb is used by Paul of God’s making foolish the wisdom of this world (1 Cor. 1:20); in its only other New Testament occurrences it is used of the salt losing its savor (Matt. 5:13; Luke 14:34). There is the notion of insipidity about it. Those who in their “wisdom” reject God’s revelation do not enter a wonderfully exciting new life, but a life which, in comparison with the service of God, is flat, tasteless, insipid. Their attempt to be wise makes fools out of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("23.")]), _vm._v(" The summit of their folly was realized in their acceptance of idolatry. They "), _c('em', [_vm._v("exchanged"), _c('a', {
    attrs: {
      "href": "#/#foot-243",
      "id": "foot_243"
    }
  }, [_c('sup', [_vm._v("243")])]), _vm._v(" the glory of the immortal God for images….")]), _vm._v(" Paul sees it as stupid to make a god of one’s own."), _c('a', {
    attrs: {
      "href": "#/#foot-244",
      "id": "foot_244"
    }
  }, [_c('sup', [_vm._v("244")])]), _vm._v(" It is to exchange something of real worth (the glory of God) for something of no value (an image). The word rendered "), _c('em', [_vm._v("immortal"), _c('a', {
    attrs: {
      "href": "#/#foot-245",
      "id": "foot_245"
    }
  }, [_c('sup', [_vm._v("245")])])]), _vm._v(" is more literally “not corruptible”. From the thought of not decaying it is an easy transition to immortal, so we need not cavil at the translation. But it is worth noting that Paul is speaking not so much of eternity of being as of the total absence from God of that liability to decay which is inseparable from our physical existence and which is incompatible with the glory of which he writes. “The glory of the incorruptible God” is a striking expression, bringing out something both of the greatness and the majesty of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("They exchanged all this for "), _c('em', [_vm._v("images made to look like mortal man")]), _vm._v("…, or, more literally, “for the likeness of an image of corruptible man”. The “likeness” and the “image” are much the same,"), _c('a', {
    attrs: {
      "href": "#/#foot-246",
      "id": "foot_246"
    }
  }, [_c('sup', [_vm._v("246")])]), _vm._v(" but the tautologous expression "), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("emphasizes the unreality of it all. It was for nothing more substantial than an imitation that they exchanged that wonderful reality, the glory of God. And the imitation was “corruptible”")]), _c('a', {
    attrs: {
      "href": "#/#foot-247",
      "id": "foot_247"
    }
  }, [_c('sup', [_vm._v("247")])]), _vm._v(" at that, forming a further contrast with “the incorruptible God”. When people could and should have worshipped a God not subject to decay of any sort, they chose to worship not even man, but the image of man who wastes away. But the sorry story does not end even there. To the images of man idolaters added those of "), _c('em', [_vm._v("birds")]), _vm._v(" (amply documented in Egyptian worship), "), _c('em', [_vm._v("animals")]), _vm._v(" (cf. Ps. 106:20), and of "), _c('em', [_vm._v("reptiles")]), _vm._v(" (cf. the serpent of Gen. 3; for the general concept cf. Deut. 4:16-18; Jer. 2:11). Paul links these with “and”; idolaters make all these kinds of images. It adds up to a determined substitution of their own way for that of God."), _c('a', {
    attrs: {
      "href": "#/#foot-248",
      "id": "foot_248"
    }
  }, [_c('sup', [_vm._v("248")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("24.")]), _vm._v(" People cannot reject God and go scatheless. Paul proceeds to draw out the consequences of the pagan world’s refusal to worship God as he is. He draws a horrifying picture of a variety of vices. Contemporary records show that he is not exaggerating. All he says can be documented from the world of his day, and indeed other sins could be added. It is sometimes objected that this is not a balanced picture; the pagan world could do better than this. Of course it could, and Paul shows us something of this in the next chapter. But here he is not trying to picture the total scene. He is pursuing his theological purpose of showing that all people are sinners. In pursuit of this aim he concentrates on that part of the picture which is relevant. This is not to deny that other features exist; it is simply to say that they do not belong here. The good that people do is never a problem. It is something to be thankful about, not something people must be saved from. But sin is another thing altogether. It is a problem wherever it is found. It is Paul’s purpose to show that it exists, and that it exists universally. Wherever pagans are to be found, the kinds of sin of which he speaks will be found also. People are not saved from sin by idolatry."), _c('a', {
    attrs: {
      "href": "#/#foot-249",
      "id": "foot_249"
    }
  }, [_c('sup', [_vm._v("249")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("Another feature of his treatment of the subject is his insistence that this is not simply an inevitable process of cause and effect which takes place while God stands by, more or less a spectator. God is in all of life. He does not contract out. We have already noticed that God willed that if people sin certain consequences follow (see the note on v. 18). This is a moral universe; sin has inevitable results. But three times Paul says, “God gave them up” (vv. 24, 26, 28). God is active in the process whereby sin’s consequences follow sin.")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('em', [_vm._v("Therefore")])]), _c('a', {
    attrs: {
      "href": "#/#foot-250",
      "id": "foot_250"
    }
  }, [_c('sup', [_vm._v("250")])]), _vm._v(" introduces the reason for what follows and links it with what has preceded in logical order. It was on account of their rejection of the divine revelation and of their preferring idols to the true God that God gave them up to the results of their folly. The verb "), _c('em', [_vm._v("gave them over")]), _c('a', {
    attrs: {
      "href": "#/#foot-251",
      "id": "foot_251"
    }
  }, [_c('sup', [_vm._v("251")])]), _vm._v(" shows that God is active and not passive in the process (cf. Ps. 81:12; Acts 7:42). This does not mean that he is vindictive. That would be untrue both to the facts of the case and to the apostle’s thought. Throughout this epistle Paul insists that God’s purpose is one of mercy (cf. 11:32). Elsewhere the situation is viewed from another angle: people gave themselves up to licentious behavior (Eph. 4:19); they are responsible human beings. But here the thought is that God is active in the process. He shuts people up to the consequences of their sin so that they will see their error and look to him for mercy and for a better way. Notice that Paul does not call on God to punish sinners. Rather, he has the profound thought that their immersion in their sin is itself their punishment (cf. “one is punished by the very things by which he sins”, Wis. 11:16). The first point is that they are given up "), _c('em', [_vm._v("in")]), _c('a', {
    attrs: {
      "href": "#/#foot-252",
      "id": "foot_252"
    }
  }, [_c('sup', [_vm._v("252")])]), _vm._v(" "), _c('em', [_vm._v("the sinful desires of their hearts to sexual impurity.")]), _vm._v(" Paul’s word for "), _c('em', [_vm._v("sinful desires")]), _c('a', {
    attrs: {
      "href": "#/#foot-253",
      "id": "foot_253"
    }
  }, [_c('sup', [_vm._v("253")])]), _vm._v(" is a strong one, denoting “the passionate desire for forbidden pleasure” (Barclay). The addition, "), _c('em', [_vm._v("of their hearts")]), _vm._v(" (see v. 21), shows that Paul is thinking of deep-seated desire, not a surface impulse. They were given up “to uncleanness”,"), _c('a', {
    attrs: {
      "href": "#/#foot-254",
      "id": "foot_254"
    }
  }, [_c('sup', [_vm._v("254")])]), _vm._v(" a general term suitable to this introduction. At this point Paul is not being precise about the result of people’s sins, but he leaves the reader in no doubt that it is impurity of some kind, with a strong hint at sexual impurity (NIV is too definite). The sinful desires "), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("lead to "), _c('em', [_vm._v("the degrading of their bodies.")])]), _c('a', {
    attrs: {
      "href": "#/#foot-255",
      "id": "foot_255"
    }
  }, [_c('sup', [_vm._v("255")])]), _vm._v(" People cannot give themselves to impurity and go scatheless. Consequences follow. "), _c('em', [_vm._v("Degrading,")]), _vm._v(" or more precisely “dishonoring”,"), _c('a', {
    attrs: {
      "href": "#/#foot-256",
      "id": "foot_256"
    }
  }, [_c('sup', [_vm._v("256")])]), _vm._v(" is another general term; it may indicate an insult, whether in word or thought or deed. But, though the term is general, in the context of the rejection of God’s revelation which leads to idolatry and then to the dishonoring of their bodies,"), _c('a', {
    attrs: {
      "href": "#/#foot-257",
      "id": "foot_257"
    }
  }, [_c('sup', [_vm._v("257")])]), _vm._v(" there can be little doubt but that Paul is referring to the practice of ritual prostitution which was all but universal in the idolatrous systems of the first century (he was writing from Corinth where more than a thousand sacred prostitutes were said to have been attached to one large temple). “Man has mocked the honour of God by deifying the bodies of creatures erected into idols; God therefore abandons man to passions which dishonour his own body” (Leenhardt). This represents the attempt of man to control his destiny in independence of God. He rejects the revelation God has made and this leads to idolatry as he manufactures idols in the likeness of his body. This in turn leads to immoral types of worship."), _c('a', {
    attrs: {
      "href": "#/#foot-258",
      "id": "foot_258"
    }
  }, [_c('sup', [_vm._v("258")])]), _vm._v(" In the nature cults, for example, people thought that they had the secret of fertility. By the use of appropriate rituals (which included the sex act) they held that they could secure growth and vitality. They had become masters of themselves and their environment, or so they thought. They did not realize that they had thrust themselves into the depths of degradation. In every age an equivalent mistake is possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Perhaps we should add that in the catalogue of vices which Paul here begins he is following a fairly common custom among the moralists of the time. Dodd points out that it was a usual practice to divide vices into the sensual and the antisocial ("), _c('a', {
    attrs: {
      "href": "#/009_Introduction#page_27"
    }
  }, [_vm._v("p. 27")]), _vm._v("). While there is a slight uncertainty about the "), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("precise meaning of some of the terms he uses, it seems that Paul is following some such division. He speaks of sensual sins in vv. 24-27 and of the antisocial in vv. 29-31.")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('strong', [_vm._v("25.")])]), _c('strong', [_c('a', {
    attrs: {
      "href": "#/#foot-259",
      "id": "foot_259"
    }
  }, [_c('sup', [_vm._v("259")])])]), _c('em', [_vm._v("They exchanged")]), _c('a', {
    attrs: {
      "href": "#/#foot-260",
      "id": "foot_260"
    }
  }, [_c('sup', [_vm._v("260")])]), _vm._v(" "), _c('em', [_vm._v("the truth of God for a lie")]), _vm._v(" (cf. v. 23). There are three ways to understand “the truth of God”. (1) Taking the abstract for the concrete, we might understand it as “the true God” (as NEB) (Hendriksen sees the genitive as one of apposition and renders, “God, [who is] the truth”, which is much the same). (2) It may mean the truth God has made known, or, as Cranfield puts it, “the reality consisting of God Himself and His self-revelation”."), _c('a', {
    attrs: {
      "href": "#/#foot-261",
      "id": "foot_261"
    }
  }, [_c('sup', [_vm._v("261")])]), _vm._v(" (3) Some (like RSV and Kertelge) see the expression as meaning “the truth about God”. The second view has the most to be said for it. For Paul truth is an important concept (see Additional Note B), something not known to us naturally but only as God has revealed it. It is usually connected with God himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These people might have responded to God’s leading and have entered the joy of the service of God and of all that is true. Instead they gave all this away, and for what? For what Paul calls “the lie”."), _c('a', {
    attrs: {
      "href": "#/#foot-262",
      "id": "foot_262"
    }
  }, [_c('sup', [_vm._v("262")])]), _vm._v(" Most versions read “a lie” (NIV, KJV, RSV, etc.), but Paul uses the definite article. He is not thinking of idolatry as no more than one falsehood among many. It is "), _c('em', [_vm._v("the")]), _vm._v(" lie. Elsewhere he speaks of “putting away the lie” and “speak[ing] truth” (Eph. 4:25); again he speaks of some who “will believe the lie” (2 Thess. 2:11). In each case, as here, he is contrasting the lie with the truth. He does not see heathen religion as a partial truth. It is the lie that leads people away from the truth of God. The true God stands in contrast with idols (1 Thess. 1:9). To exchange the worship of God for the lie is the final disaster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What is meant in this exchange is explained. They "), _c('em', [_vm._v("worshiped and served created things rather than the Creator.")]), _vm._v(" The verb rendered "), _c('em', [_vm._v("worshiped")]), _vm._v(" is unusual (here only in the New Testament),"), _c('a', {
    attrs: {
      "href": "#/#foot-263",
      "id": "foot_263"
    }
  }, [_c('sup', [_vm._v("263")])]), _vm._v(" but its meaning is not in doubt. They "), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("accorded religious veneration to the creature. "), _c('em', [_vm._v("Served")])]), _c('a', {
    attrs: {
      "href": "#/#foot-264",
      "id": "foot_264"
    }
  }, [_c('sup', [_vm._v("264")])]), _vm._v(" is a word which originally applied to the service of gods or people. In the New Testament, however, it is always used of the service of God, so that its meaning is much like that of the previous verb. Paul is simply emphasizing that these people worshipped in the fullest sense. And they gave their worship not to the Creator,"), _c('a', {
    attrs: {
      "href": "#/#foot-265",
      "id": "foot_265"
    }
  }, [_c('sup', [_vm._v("265")])]), _vm._v(" to whom it was due, but to the creature, in fact to that which they themselves had fashioned, idols."), _c('a', {
    attrs: {
      "href": "#/#foot-266",
      "id": "foot_266"
    }
  }, [_c('sup', [_vm._v("266")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The mention of the Creator leads Paul into a little doxology (as is not uncommon with him): "), _c('em', [_vm._v("who is forever praised. Amen")]), _vm._v(" (cf. Ps. 89:52). This is in part Paul’s protest against the failure of the heathen to give God his due. He salutes God as "), _c('em', [_vm._v("forever praised.")]), _c('a', {
    attrs: {
      "href": "#/#foot-267",
      "id": "foot_267"
    }
  }, [_c('sup', [_vm._v("267")])]), _vm._v(" All the meaning we can put into “blessing” belongs to God, and that not for a moment but forever."), _c('a', {
    attrs: {
      "href": "#/#foot-268",
      "id": "foot_268"
    }
  }, [_c('sup', [_vm._v("268")])]), _vm._v(" Paul often tacks "), _c('em', [_vm._v("Amen")]), _vm._v(" on to the end of a doxology, but it is not easy to see why. It is really the response of a congregation when a leader says something, usually a prayer, on its behalf. “Amen” is the congregation’s way of giving assent. It makes the words uttered by the leader its own."), _c('a', {
    attrs: {
      "href": "#/#foot-269",
      "id": "foot_269"
    }
  }, [_c('sup', [_vm._v("269")])]), _vm._v(" But in a doxology like this one there is nobody to respond. It is all Paul’s. It certainly ends the doxology on a solemn and devout note, and this may be its purpose; it is “the response of worship” (Murray).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("26.")]), _vm._v(" "), _c('em', [_vm._v("Because of this")]), _c('a', {
    attrs: {
      "href": "#/#foot-270",
      "id": "foot_270"
    }
  }, [_c('sup', [_vm._v("270")])]), _vm._v(" carries the argument along logically, as often in "), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("Paul. The reason in question is not, of course, given in the doxology, but in the idolatry referred to immediately before it. The punishment for the conduct involved in idolatry was their being given over to "), _c('em', [_vm._v("shameful lusts.")])]), _c('a', {
    attrs: {
      "href": "#/#foot-271",
      "id": "foot_271"
    }
  }, [_c('sup', [_vm._v("271")])]), _vm._v(" "), _c('em', [_vm._v("Shameful")]), _vm._v(" is cognate with “degrading” in v. 24, and, while there is no kinship of language, "), _c('em', [_vm._v("lusts")]), _vm._v(" recalls the “sinful desires” of that verse. Paul is still moving in the same realm of ideas. He goes on to particularize with his reference to women exchanging "), _c('em', [_vm._v("natural relations")]), _c('a', {
    attrs: {
      "href": "#/#foot-272",
      "id": "foot_272"
    }
  }, [_c('sup', [_vm._v("272")])]), _vm._v(" "), _c('em', [_vm._v("for")]), _c('a', {
    attrs: {
      "href": "#/#foot-273",
      "id": "foot_273"
    }
  }, [_c('sup', [_vm._v("273")])]), _vm._v(" "), _c('em', [_vm._v("unnatural ones.")]), _c('a', {
    attrs: {
      "href": "#/#foot-274",
      "id": "foot_274"
    }
  }, [_c('sup', [_vm._v("274")])]), _vm._v(" He uses the adjectives “female” and “male” rather than the nouns “women” and “men”, possibly because he is concentrating on sexual differentiation. Hendriksen points out that “A person’s sexual orientation, whether heterosexual or homosexual, is not the point at issue. What matters is what a person does with his sexuality!” He goes on to remind us that “According to the plain teaching of Scripture sexual intercourse was intended for a husband and his wife, for no one else!” Paul mentions the degradation of women before he deals with that of men. Hodge thinks the reason for this is that “they are always the last to be affected in the decay of morals, and their corruption is therefore proof that all virtue is lost.” There may be something to this, but it seems more likely that Paul is giving emphasis to the male perversion by putting it last and dealing with it at greater length.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("27.")]), _vm._v(" The sin was not confined to women. The males engaged in the equivalent evil."), _c('a', {
    attrs: {
      "href": "#/#foot-275",
      "id": "foot_275"
    }
  }, [_c('sup', [_vm._v("275")])]), _vm._v(" Paul’s word for "), _c('em', [_vm._v("abandoned")]), _vm._v(" is a rather strong one."), _c('a', {
    attrs: {
      "href": "#/#foot-276",
      "id": "foot_276"
    }
  }, [_c('sup', [_vm._v("276")])]), _vm._v(" It is common in the New Testament, but Paul uses it five times only. He has quite a bit of unusual vocabulary here, and his words for "), _c('em', [_vm._v("were inflamed")]), _vm._v(" and "), _c('em', [_vm._v("lust")]), _vm._v(" are found here only in the New Testament."), _c('a', {
    attrs: {
      "href": "#/#foot-277",
      "id": "foot_277"
    }
  }, [_c('sup', [_vm._v("277")])]), _vm._v(" The former word has the notion of burning and seems to be used in the literal sense much more often than in the metaphorical sense Paul is giving it here; it is a very vivid term (cf. 1"), _c('span', {
    staticClass: "smallcaps"
  }), _vm._v(" Cor. 7:9 for much the same idea, though with a different word). "), _c('em', [_vm._v("Lust")]), _vm._v(" (a word with the notion of reaching out to grasp something) signifies strong and eager desire. It can be used in a good sense but also, as here, in a bad sense. Paul is saying in strong terms that the men were burned up with a powerful but unnatural "), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("passion.")]), _c('a', {
    attrs: {
      "href": "#/#foot-278",
      "id": "foot_278"
    }
  }, [_c('sup', [_vm._v("278")])]), _vm._v(" He does not define the evil practice that resulted"), _c('a', {
    attrs: {
      "href": "#/#foot-279",
      "id": "foot_279"
    }
  }, [_c('sup', [_vm._v("279")])]), _vm._v(" but speaks only of "), _c('em', [_vm._v("indecent")]), _c('a', {
    attrs: {
      "href": "#/#foot-280",
      "id": "foot_280"
    }
  }, [_c('sup', [_vm._v("280")])]), _vm._v(" "), _c('em', [_vm._v("acts.")]), _vm._v(" But there can be no doubt about the particular kind of shamelessness he has in mind. So he says that these sinners received "), _c('em', [_vm._v("the due penalty")]), _c('a', {
    attrs: {
      "href": "#/#foot-281",
      "id": "foot_281"
    }
  }, [_c('sup', [_vm._v("281")])]), _vm._v(" of their misdeeds "), _c('em', [_vm._v("in themselves.")]), _vm._v(" Paul is not so much calling for a penalty as thinking of sexual perversion as itself a penalty (being a sinner is the punishment of sin!). This is sharply different from the general attitude among Greeks and Romans of the day, for they preferred this kind of love to heterosexual love. Paul’s language is perhaps a little stronger than "), _c('em', [_vm._v("due penalty.")]), _vm._v(" He is speaking of a requital which is “necessary”."), _c('a', {
    attrs: {
      "href": "#/#foot-282",
      "id": "foot_282"
    }
  }, [_c('sup', [_vm._v("282")])]), _vm._v(" The thought is one of compulsion. Thayer points out that it can signify “a necessity of law and command”, but he sees it here as pointing to “the recompense due by the law of God” (GT). Once more Paul is thinking of what God has decreed rather than simply of the natural result of people’s actions. He refers to such actions as “error” (NIV, "), _c('em', [_vm._v("perversion);")]), _vm._v(" sinners have wandered from the right way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("28.")]), _vm._v(" "), _c('em', [_vm._v("Since")]), _vm._v(" (perhaps “as” is better)"), _c('a', {
    attrs: {
      "href": "#/#foot-283",
      "id": "foot_283"
    }
  }, [_c('sup', [_vm._v("283")])]), _vm._v(" points to exact correspondence: “The cases are parallel; "), _c('em', [_vm._v("as")]), _vm._v(" they deserted God, so God abandoned them” (Hodge). There is nothing arbitrary about God’s actions. "), _c('em', [_vm._v("Think… worthwhile")]), _vm._v(" renders another word Paul uses often."), _c('a', {
    attrs: {
      "href": "#/#foot-284",
      "id": "foot_284"
    }
  }, [_c('sup', [_vm._v("284")])]), _vm._v(" It means first “test”, then “approve” as a result of the test, and so simply “approve”, as here, without any strict notion of test. Paul puts the word "), _c('em', [_vm._v("God")]), _vm._v(" in an emphatic position. It was no less than God whom they did not approve to “have in knowledge”. This latter is an unusual expression, found here only in the New Testament. It is stronger than “know”,"), _c('a', {
    attrs: {
      "href": "#/#foot-285",
      "id": "foot_285"
    }
  }, [_c('sup', [_vm._v("285")])]), _vm._v(" and thus a number of versions have “acknowledge”. But Paul’s thought is not so much this as that they refused to have God in their knowledge. They thrust him out of their circle of acquaintance. Their ignorance of God was not due to a lack of opportunity to know him, but to their "), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("deliberate refusal. They preferred other things to the knowledge of God. And, because they rejected the knowledge of God, God "), _c('em', [_vm._v("gave them over")]), _vm._v(" (the third use of this terrible expression) to the consequences of what they had done in both thought and action, namely to a "), _c('em', [_vm._v("depraved mind, to do what ought not to be done.")]), _vm._v(" The word "), _c('em', [_vm._v("depraved")]), _vm._v(" meant originally “that has not stood the test” (it is related to that rendered "), _c('em', [_vm._v("think … worthwhile")])]), _c('a', {
    attrs: {
      "href": "#/#foot-286",
      "id": "foot_286"
    }
  }, [_c('sup', [_vm._v("286")])]), _vm._v(" in the earlier part of the verse). It was used of coins that were substandard. The choice of words is another of Paul’s ways of bringing out the fitness of things. They did not “approve” to know God and they came to have an “unapproved” mind."), _c('a', {
    attrs: {
      "href": "#/#foot-287",
      "id": "foot_287"
    }
  }, [_c('sup', [_vm._v("287")])]), _vm._v(" Paul is not talking about an arbitrary process but about people who received the due result of their evil deeds. "), _c('em', [_vm._v("Mind")]), _vm._v(" is the usual word for the thinking faculty, but it can mean “the intellectual part of conscience” (SH). It is sometimes combined with “conscience”, as when we read of certain people that “both their minds and consciences are corrupted” (Tit. 1:15)."), _c('a', {
    attrs: {
      "href": "#/#foot-288",
      "id": "foot_288"
    }
  }, [_c('sup', [_vm._v("288")])]), _vm._v(" The result, then, of their refusal to accept the knowledge of God is seen in the way they came to think and the things that their consciences came to approve. Their minds became quite unable to make trustworthy moral judgments. Robinson remarks, “reason as much as anything requires to be justified by faith before it can function truly as reason.” They had cut themselves off from all the joys of the knowledge of God. They were delivered over in consequence to the narrow, joyless existence of base minds and improper conduct."), _c('a', {
    attrs: {
      "href": "#/#foot-289",
      "id": "foot_289"
    }
  }, [_c('sup', [_vm._v("289")])]), _vm._v(" It was the only course they left open to themselves. They continually did what is not becoming, not fitting, not acceptable."), _c('a', {
    attrs: {
      "href": "#/#foot-290",
      "id": "foot_290"
    }
  }, [_c('sup', [_vm._v("290")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('strong', [_vm._v("29.")]), _vm._v(" Paul launches into a detailed list")]), _c('a', {
    attrs: {
      "href": "#/#foot-291",
      "id": "foot_291"
    }
  }, [_c('sup', [_vm._v("291")])]), _vm._v(" of the sins he has in mind."), _c('a', {
    attrs: {
      "href": "#/#foot-292",
      "id": "foot_292"
    }
  }, [_c('sup', [_vm._v("292")])]), _vm._v(" He first speaks of the sinners as "), _c('em', [_vm._v("filled with"), _c('a', {
    attrs: {
      "href": "#/#foot-293",
      "id": "foot_293"
    }
  }, [_c('sup', [_vm._v("293")])])]), _vm._v(" wickedness, showing that he does not think of them as half-hearted about their sin. They were wholly given over to it. Their exclusion of God left room for nothing else. We should probably not try to delimit too closely the words that follow, for Paul is more concerned to bring out the truth that those who reject God give themselves over to all manner of evils than he is to tell us precisely what those evils are. There must, however, be some significance in his choice of words, and it is worth looking into them accordingly. "), _c('em', [_vm._v("Wickedness")]), _vm._v(" is a comprehensive term,"), _c('a', {
    attrs: {
      "href": "#/#foot-294",
      "id": "foot_294"
    }
  }, [_c('sup', [_vm._v("294")])]), _vm._v(" so comprehensive indeed that in the opinion of some commentators it includes all that follows. The rest of the list, then, is no more than a filling out of what is meant by wickedness. This may be going too far, but at least we can say that the term covers a great variety of evils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is some dispute about the second and fourth members of the list, "), _c('em', [_vm._v("evil")]), _vm._v(" and "), _c('em', [_vm._v("depravity.")]), _c('a', {
    attrs: {
      "href": "#/#foot-295",
      "id": "foot_295"
    }
  }, [_c('sup', [_vm._v("295")])]), _vm._v(" Some hold that the former points to an active form of wrongdoing while the latter means rather a vicious disposition. Others, however, almost reverse the distinction. It is safest, therefore, not to insist on too sharp a distinction between them."), _c('a', {
    attrs: {
      "href": "#/#foot-296",
      "id": "foot_296"
    }
  }, [_c('sup', [_vm._v("296")])]), _vm._v(" What is plain is that both terms denote "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("thoroughgoing evil and that they include both the inner disposition and the active doing of harm to others. Incidentally the two are linked again in 1 Corinthians 5:8. The remaining term, "), _c('em', [_vm._v("greed,")])]), _c('a', {
    attrs: {
      "href": "#/#foot-297",
      "id": "foot_297"
    }
  }, [_c('sup', [_vm._v("297")])]), _vm._v(" means the inordinate desire to have more. It is selfishness unlimited. Although it is often translated “covetousness” (as RSV), we not infrequently use this word in a rather restricted sense, and we should be clear that Paul is talking about the desire to have more as a settled disposition. This covetous person pursues his own desires with a complete disregard of the effect on other people. He does not care about others but is a complete egotist. Paul is talking about one who is never satisfied. He is always anxious to have more of something, and no matter what he gets he remains unsatisfied. Which is, of course, an excellent illustration of Paul’s point that the sinner is handed over to his sin. Evil is its own punishment. The word occurs in conjunction with "), _c('em', [_vm._v("evil")]), _vm._v(" again in Mark 7:22.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Full of")]), _c('a', {
    attrs: {
      "href": "#/#foot-298",
      "id": "foot_298"
    }
  }, [_c('sup', [_vm._v("298")])]), _vm._v(" introduces another list of terms denoting individual sins. The adjective probably does not differ very greatly in meaning from the participle rendered "), _c('em', [_vm._v("they have become filled")]), _vm._v(" at the beginning of the verse. It simply marks a stage in the argument. "), _c('em', [_vm._v("Envy")]), _c('a', {
    attrs: {
      "href": "#/#foot-299",
      "id": "foot_299"
    }
  }, [_c('sup', [_vm._v("299")])]), _vm._v(" reminds us that evildoers are not just one happy band of brothers. There is a divisiveness about evil which sets people apart from one another. Evil people are apt to be envious rather than appreciative. From such attitudes springs "), _c('em', [_vm._v("murder")]), _vm._v(" (cf. Mark 15:10), the ultimate outcome of "), _c('em', [_vm._v("strife,")]), _c('a', {
    attrs: {
      "href": "#/#foot-300",
      "id": "foot_300"
    }
  }, [_c('sup', [_vm._v("300")])]), _vm._v(" "), _c('em', [_vm._v("Deceit")]), _c('a', {
    attrs: {
      "href": "#/#foot-301",
      "id": "foot_301"
    }
  }, [_c('sup', [_vm._v("301")])]), _vm._v(" is basically "), _c('em', [_vm._v("“bait")]), _vm._v(" for fish … hence, "), _c('em', [_vm._v("any cunning contrivance for deceiving")]), _vm._v(" or "), _c('em', [_vm._v("catching")]), _vm._v("… in the abstract, "), _c('em', [_vm._v("craft, cunning”")]), _vm._v(" (LSJ; they point out that it was used of such stratagems as the Trojan horse). There is nothing straightforward about sin, and sinners do not hesitate to deceive one another if their purposes can be advanced. NEB renders “treachery”. "), _c('em', [_vm._v("Malice")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("(Phillips, “spite”) is “conscious and intentional wickedness.”")]), _c('a', {
    attrs: {
      "href": "#/#foot-302",
      "id": "foot_302"
    }
  }, [_c('sup', [_vm._v("302")])]), _vm._v(" Gossips,"), _c('a', {
    attrs: {
      "href": "#/#foot-303",
      "id": "foot_303"
    }
  }, [_c('sup', [_vm._v("303")])]), _vm._v(" more literally “whisperers”, is a term which may be used in a good or a neutral sense (it was an epithet of the god Hermes). Here, however, it plainly refers to slander, whispering what one does not wish to be heard openly. Some think it refers to slander of those present as against slander of those not present (which is denoted by “slanderers” in v. 30), but most see the distinction rather as between secret slanderers and open slanderers (Phillips is picturesque with his “whisperers-behind-doors” and “stabbers-in-the-back”).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("30.")]), _vm._v(" For "), _c('em', [_vm._v("slanderers")]), _c('a', {
    attrs: {
      "href": "#/#foot-304",
      "id": "foot_304"
    }
  }, [_c('sup', [_vm._v("304")])]), _vm._v(" see the note on the previous verse. The word is not attested before this passage, so Paul is not employing a well-known term. He may even have coined it himself. The meaning is clear enough. Evil people are prone to speak evil of others, and it is this to which Paul is objecting. "), _c('em', [_vm._v("Godhaters")]), _c('a', {
    attrs: {
      "href": "#/#foot-305",
      "id": "foot_305"
    }
  }, [_c('sup', [_vm._v("305")])]), _vm._v(" translates another compound word not found elsewhere in the New Testament. The meaning is not certain, for the form could mean “hated by God” (as NEB, “hateful to God”; Moffatt, “loathed by God”) or “hating God” (RSV, “haters of God”; JB, “enemies of God”). The difficulty is that in all earlier references it means something like “hateful to God”, “hated by a god”, “god-forsaken” (BAGD), but in the immediate context all the words refer to human rather than divine activity. On the whole it seems that we should understand it in this second sense, for this is a list of vices. Hating God comes under this heading, but hated by God does not."), _c('a', {
    attrs: {
      "href": "#/#foot-306",
      "id": "foot_306"
    }
  }, [_c('sup', [_vm._v("306")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The next three words are all concerned with some aspect of pride. "), _c('em', [_vm._v("Insolent")]), _c('a', {
    attrs: {
      "href": "#/#foot-307",
      "id": "foot_307"
    }
  }, [_c('sup', [_vm._v("307")])]), _vm._v(" refers to a lofty sense of superiority out of which the insolent "), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("person treats all others as beneath him. It is the pride that is totally unaware of its limitations and “goes before a fall”. "), _c('em', [_vm._v("Arrogant")])]), _c('a', {
    attrs: {
      "href": "#/#foot-308",
      "id": "foot_308"
    }
  }, [_c('sup', [_vm._v("308")])]), _vm._v(" does not differ greatly. Barclay quotes Theophrastus, who says that this vice means “a certain contempt for everyone except oneself.” "), _c('em', [_vm._v("Boastful")]), _vm._v(" derives from a word meaning “wandering”"), _c('a', {
    attrs: {
      "href": "#/#foot-309",
      "id": "foot_309"
    }
  }, [_c('sup', [_vm._v("309")])]), _vm._v(" and apparently goes back to the extravagant claims made by wandering men: merchants with something to sell, quacks with claims to heal, and wanderers in general with tall tales to tell. Since there is no way of verifying or refuting what such people say, they are sometimes given to making claims that cannot be substantiated. The word includes the thought of evil intent; it is not used of harmless, amusing exaggeration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("They invent ways of doing evil")]), _vm._v(" suggests a certain ingenuity in devising wrong."), _c('a', {
    attrs: {
      "href": "#/#foot-310",
      "id": "foot_310"
    }
  }, [_c('sup', [_vm._v("310")])]), _vm._v(" These people are not content to go on in the established paths of evil, but are eager to strike out on new and worse ways. To this Paul adds, "), _c('em', [_vm._v("they disobey their parents.")]), _vm._v(" In a world which took very seriously the obligation to honor one’s forebears this was a grievous sin. It indicates a readiness to be false to those to whom one owes the most. It implies a lack of gratitude and a contempt for family authority.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("31.")]), _vm._v(" Paul uses four adjectives, each of which commences with a prefix corresponding to the English “un-”. It is difficult to capture the force of this construction in English, though NIV’s succession of words ending in “-less” comes pretty close. "), _c('em', [_vm._v("Senseless")]), _c('a', {
    attrs: {
      "href": "#/#foot-311",
      "id": "foot_311"
    }
  }, [_c('sup', [_vm._v("311")])]), _vm._v(" means without intelligence; it refers to those who act stupidly (cf. v. 21). Lagrange asks why it is a vice to be unintelligent. The answer must be that Paul includes a moral element as well as an intellectual one. He is saying that to cut oneself off from God is a stupid and wicked procedure. "), _c('em', [_vm._v("Faithless")]), _c('a', {
    attrs: {
      "href": "#/#foot-312",
      "id": "foot_312"
    }
  }, [_c('sup', [_vm._v("312")])]), _vm._v(" is concerned at base with the breaking of agreements. When people enter into solemn undertakings, they should do what they say they will do. Satisfactory living comes to an end when people cannot be trusted to keep their pledged word. But such considerations do not trouble the wicked. Where they see personal advantage, keeping faith does not matter to them. "), _c('em', [_vm._v("Heartless")]), _c('a', {
    attrs: {
      "href": "#/#foot-313",
      "id": "foot_313"
    }
  }, [_c('sup', [_vm._v("313")])]), _vm._v(" means “without natural affection”. There is every "), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("reason to expect that members of a family (or other natural group) will be united in bonds of love and affection, and it is an evil thing when they are not. "), _c('em', [_vm._v("Ruthless,")]), _vm._v(" a word found here only in the New Testament, means “without pity”, “without mercy”. It is significant that, in an epistle that will stress God’s mercy throughout, the list of vices should be rounded off with “merciless”. This is the very depth of evil. The person who shows no mercy can scarcely go lower.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('strong', [_vm._v("32.")]), _vm._v(" We come back to the thought that these sinners do not act out of ignorance.")]), _c('a', {
    attrs: {
      "href": "#/#foot-314",
      "id": "foot_314"
    }
  }, [_c('sup', [_vm._v("314")])]), _vm._v(" Granted that no evildoer ever understands all the implications of the wrong he is doing, it still remains that he knows enough to know that he is doing wrong. It is the point that Paul has been stressing throughout this chapter, namely that God has revealed enough of himself for people to know what is right and what is wrong. "), _c('em', [_vm._v("Decree"), _c('a', {
    attrs: {
      "href": "#/#foot-315",
      "id": "foot_315"
    }
  }, [_c('sup', [_vm._v("315")])])]), _vm._v(" is a legal term. It is one of the righteousness words and has a meaning like “righteous (or just) ordinance”. It sometimes means a verdict or declaration that a person is just, but here "), _c('em', [_vm._v("decree")]), _vm._v(" is clearly the meaning. Paul affirms that the decree is God’s. God is sufficiently interested in what people do to lay down his decree for them."), _c('a', {
    attrs: {
      "href": "#/#foot-316",
      "id": "foot_316"
    }
  }, [_c('sup', [_vm._v("316")])]), _vm._v(" Paul does not, of course, mean that the Gentiles had a codified system of divine laws as the Jews did. He is not concerned at this point with the way knowledge came to them, nor with the precision with which they had apprehended it. He is concerned only with the fact that they have enough knowledge to be sure that they should not act in the way in which they were in fact acting. They know that people who act as they do "), _c('em', [_vm._v("deserve death.")]), _vm._v(" Paul uses this word "), _c('em', [_vm._v("death 22")]), _vm._v(" times in Romans, which is more than in any other book of the New Testament. Mostly he employs it in connection with sin, as he does here. Of his 22 uses of the word in this epistle, no less than 18 are related to sin (four concern the death of Christ, one of which connects also with sin, and one is linked with baptism)."), _c('a', {
    attrs: {
      "href": "#/#foot-317",
      "id": "foot_317"
    }
  }, [_c('sup', [_vm._v("317")])]), _vm._v(" Many of the “sin” passages are vivid, picturing death as a tyrant reigning over sinners. Here the thought is simply "), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("that death is the desert of sin. Some think of physical death as the meaning; it was sin that brought death. Others think of spiritual death. More probably Paul is not defining death closely but simply viewing it as a horror. It tyrannizes the human race and keeps people from the life that is life indeed, whether we think of this world or the next.")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('em', [_vm._v("Only")])]), _c('a', {
    attrs: {
      "href": "#/#foot-318",
      "id": "foot_318"
    }
  }, [_c('sup', [_vm._v("318")])]), _vm._v(" is another typical Pauline word. Here it is part of a statement that brings out the enormity of the offence. Not only do these sinners do"), _c('a', {
    attrs: {
      "href": "#/#foot-319",
      "id": "foot_319"
    }
  }, [_c('sup', [_vm._v("319")])]), _vm._v(" evil things, but they also take pleasure in other people who do"), _c('a', {
    attrs: {
      "href": "#/#foot-320",
      "id": "foot_320"
    }
  }, [_c('sup', [_vm._v("320")])]), _vm._v(" them. The Greek possibly means a little more than NIV’s "), _c('em', [_vm._v("approve.")]), _vm._v(" It is rather “have pleasure in them that do them” (KJV) or “applaud such practices” (NEB). There are thoughts not only of full support but also of enjoyment. The word certainly includes the encouragement to do wrong. Through the centuries Paul’s statement has caused difficulty."), _c('a', {
    attrs: {
      "href": "#/#foot-321",
      "id": "foot_321"
    }
  }, [_c('sup', [_vm._v("321")])]), _vm._v(" Many have felt that it is far worse to do an evil thing than simply to express approval when others do it. But Paul is not talking about people who do not practice vice themselves but simply encourage others. He is talking about those who do evil things "), _c('em', [_vm._v("(continue to do these very things).")]), _vm._v(" Then, not content with vice in themselves, they actively encourage it in others. They heap up vice beyond their own power."), _c('a', {
    attrs: {
      "href": "#/#foot-322",
      "id": "foot_322"
    }
  }, [_c('sup', [_vm._v("322")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-8"
    }
  }, [_c('strong', [_vm._v("Additional Note A: THE RIGHTEOUSNESS OF GOD")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("James P. Martin remarks that “The term "), _c('em', [_vm._v("dikaiosune theou (tou theou")]), _vm._v(" in 10:3) is crucial in Paul’s theology, central in Rom., and the subject of intense "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("discussion"), _c('strong', [_vm._v(".”")])]), _c('a', {
    attrs: {
      "href": "#/#foot-323",
      "id": "foot_323"
    }
  }, [_c('sup', [_vm._v("323")])]), _vm._v(" It is found eight times in this epistle (1:17; 3:5, 21, 22, 25, 26; 10:3 "), _c('em', [_vm._v("[bis]),")]), _vm._v(" as against twice in the other Pauline letters (2 Cor. 5:21; Phil. 3:9) and three times in the rest of the New Testament writings (Matt. 6:33; Jas. 1:20; 2 Pet. 1:1). The noun "), _c('em', [_vm._v("righteousness")]), _vm._v(" is especially characteristic of Romans where it is used 33 times, the next highest total being seven each in 2 Corinthians and Matthew. It is a term which must be understood carefully. With us it is an ethical virtue, as it was for the Greeks generally. But among the Hebrews righteousness was first and foremost a legal standing."), _c('a', {
    attrs: {
      "href": "#/#foot-324",
      "id": "foot_324"
    }
  }, [_c('sup', [_vm._v("324")])]), _vm._v(" The righteous were those who secured the verdict when they stood before God. This terminology applied even in an earthly court, and “the righteous” and “the wicked” in the Old Testament often mean much what we mean when we speak of “the innocent” and “the guilty” (cf. Deut. 25:1). In the final analysis what matters is the verdict of the heavenly court, and the man who is ultimately righteous is the one who is acquitted when tried at the bar of God’s justice. Such a man will, of course, be upright, and the righteousness words sometimes express the character involved in such conduct. But more typically they point to status. For example, a woe is pronounced on them that “take away the righteousness of the righteous from him” (Isa. 5:23, ASV; NIV paraphrases). Righteousness in the sense of moral character or ethical achievement cannot be taken from anyone. What is meant is that wicked judges will take away the “right standing”, the status of being right before the law, from people who are entitled to it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All this must, of course, be modified if the term is to be applied to God, for he is judged by no one. But even when people speak of God’s righteousness the legal flavor is not quite lost, for the term is often linked with judgment. Thus the Psalmist can say, “the heavens proclaim his righteousness, for God himself is judge” (Ps. 50:6), or again, the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" “comes, he comes to judge the earth. He will judge the world in righteousness” (Ps. 96:13). God acts in accordance with right. It is not that some law is set over him to which he must conform. The Bible always regards God as supreme and sees nothing as superior to him. Rather to act rightly is part of his very nature. “Will not the Judge of all the earth do right?” (Gen. 18:25). For the people of the Old Testament the answer was never in doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We should also notice that in the Old Testament righteousness in God is not uncommonly linked with salvation. Thus the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" says, “my salvation "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("will last forever, my righteousness will never fail” (Isa. 51:6). Again we read, “The L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" has made his salvation known and revealed his righteousness to the nations” (Ps. 98:2; this passage contains three important words found in Rom. 1:17, “salvation”, “righteousness”, and “revealed”, as does Isa. 56:1). The thought in such passages is that God will not abandon his people. Since he is righteous, he will certainly deliver them.")]), _c('a', {
    attrs: {
      "href": "#/#foot-325",
      "id": "foot_325"
    }
  }, [_c('sup', [_vm._v("325")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paul’s concentration on righteousness in Romans, and specifically on the righteousness of God, is part of the way he brings out the point that when God saves he does so in a way which accords with right. Much modern theology so stresses the note of victory in the atonement that it almost gives the impression that when God saves us, “might is right”. He is strong enough to defeat all the forces of evil (however these be understood), and he does so. God does, of course, defeat evil. That is true. And it is an important truth. But it is not the whole truth. One of the truths Paul insists on is that God is righteous in the way he saves as well as in the fact that he saves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I wonder whether perhaps Käsemann’s well-known treatment goes astray at this point. Constantly linking power with righteousness, he can sum up his interesting discussion of “The Righteousness of God in Paul” in these terms: “His doctrine of the διϰαιοσύνη θεοῦ demonstrates this: God’s power reaches out for the world, and the world’s salvation lies in its being recaptured for the sovereignty of God. For this very reason it is the gift of God and also the salvation of the individual human being when we become obedient to the divine righteousness.”"), _c('a', {
    attrs: {
      "href": "#/#foot-326",
      "id": "foot_326"
    }
  }, [_c('sup', [_vm._v("326")])]), _vm._v(" Though he elsewhere says some important things about forensic aspects of justification and righteousness, when he comes to sum it all up he omits all reference to any such thing and concentrates on power and sovereignty. Granted that power is important and sovereignty is important, neither of these is basic to the biblical concept of "), _c('em', [_vm._v("righteousness.")]), _vm._v(" The connection with right is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is important to see that the righteousness of God is shown in the death of Christ (3:25, 26; cf. 3:22). Many discussions overlook this connection and thereby go grievously astray. As James Denney puts it, “In Paul the divine righteousness which constitutes gospel for sinners exposed to the divine wrath is revealed in Christ, and nowhere else.”"), _c('a', {
    attrs: {
      "href": "#/#foot-327",
      "id": "foot_327"
    }
  }, [_c('sup', [_vm._v("327")])]), _vm._v(" We are not to understand "), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("the righteousness of God as an abstract quality or even as a general divine activity. It is preeminently to be seen in the atoning work of Christ; to overlook this is to miss a central thrust of Romans.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("The expression “the righteousness of God” is ambiguous. It could mean “the righteousness which God himself exercises”, “righteousness as an attribute of God or a quality in God”. We have seen this meaning in Genesis 18:25, and it reappears in Romans 3:5, 25, etc. But the genitive “of God” might also denote origin,")]), _c('a', {
    attrs: {
      "href": "#/#foot-328",
      "id": "foot_328"
    }
  }, [_c('sup', [_vm._v("328")])]), _vm._v(" in which case the whole expression means “a righteousness from God”, “the right standing which God gives”, a meaning which is required in Romans 3:21, 22; 10:3, etc. and is made abundantly plain by the use of the preposition in Philippians 3:9."), _c('a', {
    attrs: {
      "href": "#/#foot-329",
      "id": "foot_329"
    }
  }, [_c('sup', [_vm._v("329")])]), _vm._v(" Some passages are not quite clear as to which meaning we should understand, but the important thing is the plain fact that Paul uses the expression in certain significant passages to bring out the truth that in the death of Christ God brings about a righteousness for those who believe."), _c('a', {
    attrs: {
      "href": "#/#foot-330",
      "id": "foot_330"
    }
  }, [_c('sup', [_vm._v("330")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-9"
    }
  }, [_c('strong', [_vm._v("Additional Note B: TRUTH")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Paul has three great thoughts about truth, one of which connects it with God, a second with the gospel, and a third with the Christian way of life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("1. Truth and God.")]), _vm._v(" Paul has the notable expression “the truth of God” (confined to Romans, 1:25; 3:7; 15:8). With this we should perhaps take his reference to the judgment of God as being “based on truth” (2:2). All these passages associate truth closely with God. It is not to be understood in purely human terms but only in connection with God. Sometimes it is linked with Christ, as when Paul says that he speaks the truth in Christ (9:1) or when he protests his reliability “as truth is in Jesus” (Eph. 4:21; NIV has “the truth that "), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("is in Jesus”). This is often misquoted in the form “the truth as it is in Jesus”. But this distorts the sense. Paul is not saying that the truth is manifold and that we see part of it in Jesus. He is saying that we see truth, real truth, in Jesus (or in God), and that we see it nowhere else. Truth is inseparably connected with God.")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('em', [_vm._v("2. Truth and the Gospel.")]), _vm._v(" When Paul speaks of “the truth of the gospel” (Gal. 2:5, 14), he probably means much the same as when he refers to “the word of truth” (Eph. 1:13; cf. “truthful speech”, 2 Cor. 6:7, NIV). The same meaning is probably intended when we read of rightly dividing “the word of truth” (2 Tim. 2:15).")]), _c('a', {
    attrs: {
      "href": "#/#foot-331",
      "id": "foot_331"
    }
  }, [_c('sup', [_vm._v("331")])]), _vm._v(" There can be no doubt when we read of “the word of truth, the gospel” (Col. 1:5; better, “the word of the truth of the gospel”). Clearly Paul sees a close connection between the gospel, God’s way of saving people, and the truth, which, as we have just seen, must be understood in relation to God. The truth is seen in a special way in the gospel. This appears to be in mind also when Paul speaks of coming to the knowledge of truth (1 Tim. 2:4; 4:3; 2 Tim. 2:25; 3:7; Tit. 1:1), or of believing the truth (2 Thess. 2:12,13). It is probably not out of sight also when he speaks of recognizing the grace of God in truth (Col. 1:6). He can set side by side “the word of God” and “setting forth the truth” (2 Cor. 4:2), apparently as equivalent statements.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unfortunately, however, people do not always obey the gospel. This appears to be the case in some of Paul’s references to truth. Thus he can ask, “Who cut in on you and kept you from obeying the truth?” (Gal. 5:7). Those who reject the gospel “refused to love the truth” (2 Thess. 2:10); they “reject the truth” (Rom. 2:8). As we might have expected, false teachers have lost their hold on truth (“have been robbed of the truth”, 1 Tim. 6:5, NIV). They have turned away from the truth (2 Tim. 2:18; 4:4; Tit. 1:14). Paul declares that he is “for the truth” (2 Cor. 13:8). By contrast evil people “oppose the truth” (2 Tim. 3:8); it is difficult to imagine that the gospel is not primarily in mind in this passage, though the thought may include more. This is also the case with those wicked people who hinder the truth (Rom. 1:18).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("3. Truth and the Christian Life.")]), _vm._v(" The third large group of passages connect truth with the way Christians live or should live. Paul speaks of the new man as “created to be like God in true righteousness and holiness” (or better, “in righteousness and holiness of the truth”, Eph. 4:24); again he says that “the fruit of the light consists in all … truth” (Eph. 5:9). Paul is a teacher of the Gentiles “in faith and truth” (1 Tim. 2:7; NIV has “a teacher of the true faith”). Christians are to “keep the Festival” (a striking way of bringing out the joyful character of the Christian life) “with bread without yeast, the bread of sincerity and truth” (1 Cor. 5:8). So central to the Christian way is truth that the church may be characterized as “the pillar and foundation of the truth” (1 Tim. 3:15). And Paul can speak of the Old Testament law as “the embodiment of knowledge and truth” (Rom. 2:20). Christians should understand that the law gives guidance as they seek to live in the service of God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("There are, of course, passages in which Paul uses truth in much our sense, such as when he refers to telling the truth (2 Cor. 7:14; 12:6; Phil. 1:18). But it is clear that often he gave the term a richer and fuller meaning than we normally do. And it is equally clear that for Paul truth is given its definitive shape by what God has done in Christ.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#foot_1",
      "id": "foot-1"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('em', [_vm._v("The Oxyrhyncus Papyri,")]), _vm._v(" Part III, ed. Bernard P. Grenfell and Arthur P. Hunt (London, 1903), p. 264.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_2",
      "id": "foot-2"
    }
  }, [_vm._v("2")]), _vm._v(". Thus a letter would begin with the names of the sender (in the nominative) and the recipient (dative) and a greeting, all in one short sentence. Paul expands this and adds a sentence invoking God’s blessing or giving thanks or both. Strictly, Greek letters have their introduction in the third person, but Paul can use the first person (e.g., Gal. 1:1-2). In his differences from the Greek model Paul often conforms to Middle Eastern and specifically Jewish customs. For a study of Paul’s opening thanksgivings see Peter Thomas O’Brien, "), _c('em', [_vm._v("Introductory Thanksgivings in the Letters of Paul")]), _vm._v(" (Leiden, 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_3",
      "id": "foot-3"
    }
  }, [_vm._v("3")]), _vm._v(". Others are linked with Paul in every letter except Ephesians and the Pastorals.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_4",
      "id": "foot-4"
    }
  }, [_vm._v("4")]), _vm._v(". "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ש")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("א")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ו")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ל")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_5",
      "id": "foot-5"
    }
  }, [_vm._v("5")]), _vm._v(". According to tradition Paul was “small of stature” "), _c('em', [_vm._v("(Acts of Paul and Thecla")]), _vm._v(" 3). There is, of course, no way of knowing how reliable this tradition is.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_6",
      "id": "foot-6"
    }
  }, [_vm._v("6")]), _vm._v(". A. Deissmann argues from Σαῦλος ὁ ϰαὶ, Παῦλος (Acts 13:9) that Paul had the two names before the incident in which we first learn of them and thus that he did not adopt the second name in connection with Sergius Paulus "), _c('em', [_vm._v("(Bible Studies")]), _vm._v(" [Edinburgh, 1901], pp. 313-17). We should not see “Paul” as a new name adopted to help in his missionary work (though it was suitable, being a Roman name for the Roman world), nor as symbolizing his new nature or the like.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_7",
      "id": "foot-7"
    }
  }, [_vm._v("7")]), _vm._v(". δοῦλος. This is a very striking thought in a Greek writing. Among the Easterners it was not uncommon for people to speak of themselves as the “slaves” of their god or king, but this was not the case among the Greeks. Proud in their freedom, they eschewed the language of slavery. On this word, cf. BAGD, “‘servant’ for ‘slave’ is largely confined to Biblical transi, and early American times … in normal usage at the present time the two words are carefully distinguished.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_8",
      "id": "foot-8"
    }
  }, [_vm._v("8")]), _vm._v(". Κ. H. Rengstorf speaks of the word as pointing to “unconditional commitment”; he comments, “the goal of redemption … is obedience rather than autonomy” (TDNT, II, p. 275).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_9",
      "id": "foot-9"
    }
  }, [_vm._v("9")]), _vm._v(". Cf. T. W. Manson, “ ‘Slave’ gives the wrong emphasis: in religious usage in both OT and NT the stress is not on one person’s rights of property but on the total loyalty and unstinted service given of right to God by his prophets or to Christ by his apostles.” Many share this point of view, but it is not easy to maintain. The word does mean “slave” (see n. 7). And it is applied not only to great people like apostles, but to ordinary Christians as well (cf. 6:22; 1 Cor. 7:22; Col. 4:12; 2 Tim. 2:24).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_10",
      "id": "foot-10"
    }
  }, [_vm._v("10")]), _vm._v(". H. Moule comments, “To be a bondservant is terrible in the abstract. To be ‘Jesus Christ’s bondservant’ is Paradise, in the concrete” (p. 11).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_11",
      "id": "foot-11"
    }
  }, [_vm._v("11")]), _vm._v(". Käsemann denies that the title expresses humility or a placing of oneself on a level with other Christians. “Rather, he is using the honorific title of the OT men of God….This title expresses (as in Revelation) election as well as the submission of an instrument to the will of God.” But this overlooks its use for lowly Christians (see above, nn. 7, 9).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_12",
      "id": "foot-12"
    }
  }, [_vm._v("12")]), _vm._v(". Deissmann calls attention to the use of the term in the Emperor cult. He cites an inscription from Phrygia in the imperial period which reads, “Agathopus, slave of the lord Emperor” (LAE, p. 376).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_13",
      "id": "foot-13"
    }
  }, [_vm._v("13")]), _vm._v(". Cranfield accepts this order with Ρ"), _c('sup', [_vm._v("10")]), _vm._v(" Β "), _c('em', [_vm._v("pc c e")]), _vm._v(" vg"), _c('sup', [_vm._v("codd")]), _vm._v(" Ir Ambst Aug. He sees it as “quite probable that he adopted this order here with the intention of giving special emphasis right at the beginning of the epistle to the fact that the One, whose slave he was, was the fulfilment of God’s promises and of Israel’s age-old hope.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_14",
      "id": "foot-14"
    }
  }, [_vm._v("14")]), _vm._v(". Cranfield does this, and he cites Cullmann and Bornkamm in support (p. 51 n.3).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_15",
      "id": "foot-15"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('em', [_vm._v("The Names of Jesus")]), _vm._v(" (London, 1953), pp. 18-23. He points out, "), _c('em', [_vm._v("inter alia,")]), _vm._v(" that in the Gentile world the title was meaningless: “If Jesus was to be invoked, venerated, and worshipped, He must be called ‘Lord’ and ‘Son of God’. The name ‘Christ’ could survive only by becoming a personal designation, charged with deep religious meaning by reason of its association with these titles” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 23).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_16",
      "id": "foot-16"
    }
  }, [_vm._v("16")]), _vm._v(". ϰλητός. If the word is read in Matt. 20:16, it occurs 11 times. The present passage is noteworthy for the idea of a personal call (as in 1 Cor. 1:1). In its other occurrences the word is plural and refers to groups. The idea that God calls individuals is found in the New Testament (e.g., 1 Cor. 7:17, 20ff.; Heb. 11:8). But it is interesting that so often the common Christian calling is in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_17",
      "id": "foot-17"
    }
  }, [_vm._v("17")]), _vm._v(". Paul’s terminology differs from that in the Synoptic Gospels. There we read that “many are called, but few chosen”. Paul’s idea is not essentially different, but he does not use the term “called” in the same way. For him the call and the response go together.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_18",
      "id": "foot-18"
    }
  }, [_vm._v("18")]), _vm._v(". MM find it “not easy to point to an adequate parallel for the NT usage of this important word” (ἀπόστολος). Etymologically it should signify “messenger”, a meaning attested in two passages in Herodotus, one in LXX, and one in Symmachus. But its common use is for naval matters (see LSJ). All this makes it surprising that it is so common in the New Testament (79 times). F. Agnew cites some eighth-century secular papyri which have the word in the sense “messenger” and argues that the meaning we see in Herodotus persisted though it is not attested in the literature (CBQ, XXXVIII [1976], pp. 49-53). Perhaps the New Testament writers used an uncommon word because άγγελος was preempted for the sense “angel”, and thus another term was needed. A surprising number of commentators see the background as the Jewish "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ש")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ל")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("י")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ח")]), _vm._v("; they often appeal to Rengstorf, TDNT, I, pp. 413ff. But this official is not attested for the New Testament period, not earlier in fact than the third and fourth centuries. G. W. H. Lampe can say, “The institution which we know in the fourth century almost certainly came into existence later than the time of the New Testament, and the ‘shaliachate’ in this sense is not likely to have contributed anything to the development of the Christian apostolate” "), _c('em', [_vm._v("(Some Aspects of the New Testament Ministry")]), _vm._v(" [London, 1949], pp. 15-16). In a Foreword to E. R. Fairweather and R. F. Hettlinger, "), _c('em', [_vm._v("Episcopacy and Reunion")]), _vm._v(" (London, 1953), A. M. Ramsey commends Dr. Fairweather because he “discards the "), _c('em', [_vm._v("shaliach")]), _vm._v(" argument used by the authors of "), _c('em', [_vm._v("The Apostolic Ministry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_19",
      "id": "foot-19"
    }
  }, [_vm._v("19")]), _vm._v(". The term ἀπόστολος is found 34 times in Paul out of the New Testament total of 79; the highest elsewhere is Acts with 28. The Gospels use the word rarely: Matthew, Mark, and John once each, Luke six times. In Romans it is found only here and in 11:13; 16:7. Paul uses the term in the following ways:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Of himself Rom. 1:1; 11:13; 1 Cor. 1:1; 9:1, 2; 2 Cor. 1:1; Gal. 1:1; Eph. 1:1; Col. 1:1; 1 Thess. 2:7; 1 Tim. 1:1; 2:7; 2 Tim. 1:1, 11; Tit. 1:1.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("General Rom. 16:7; 1 Cor. 4:9; 9:5; 12:28, 29; 15:9 ("), _c('em', [_vm._v("bis")]), _vm._v("); 2 Cor. 11:5, 13; 12:11, 12; Eph. 2:20; 3:5; 4:11.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("The Twelve 1 Cor. 15:7; Gal. 1:17, 19.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Apostles of the churches 2 Cor. 8:23.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Epaphroditus Phil. 2:25.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid80"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('td', {
    staticClass: "wid15"
  }, [_c('p', {
    staticClass: "t-right"
  }, [_vm._v("34")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_20",
      "id": "foot-20"
    }
  }, [_vm._v("20")]), _vm._v(". For apostles see further my "), _c('em', [_vm._v("Ministers of God")]), _vm._v(" (London, 1964), ch. III and the literature there cited.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_21",
      "id": "foot-21"
    }
  }, [_vm._v("21")]), _vm._v(". The verb is ἀφο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ίζω. But it is not clear from whom or what they were separated. They may have been separated from uncleanness in their devotion to the law, or the Hasidim may have used the term of their separation from the Maccabees. Some have seen a separation from priestly interpreters of the law. Others hold that the name really means “Persian” and was a nickname given on account of what their critics saw as Persian innovations. Cf. Matthew Black, IDB, III, p. 776, and for the literature, Joachim Jeremias, "), _c('em', [_vm._v("Jerusalem in the Time of Jesus")]), _vm._v(" (London, 1969), p. 246. Whatever the truth of the origin of the name, there is no doubt that in the first century the Pharisees firmly believed that they were in a special sense God’s “separated ones”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_22",
      "id": "foot-22"
    }
  }, [_vm._v("22")]), _vm._v(". Normally the word εὐαγγέλιον has the article. It is without it in the New Testament only here, in 2 Cor. 11:4; Gal. 1:6 (both of which refer to “another” gospel), and in Rev. 14:6. Käsemann points out that the article is sometimes omitted in technical expressions (cf. BAGD in n. 31 below). But it is not easy to see why it should be omitted on this occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_23",
      "id": "foot-23"
    }
  }, [_vm._v("23")]), _vm._v(". There are some unsolved problems about the word. The combination of εὐ and ἄγγελος points to “good news”, though the word seems often to have been used simply of “news”, or “message” (it was also used of the reward given the bearer of good news). But there is no doubt that in the New Testament good news is in mind (though cf. Rev. 14:6). The absolute use, so frequent in Paul, is new. Paul finds the content of the word so central that he can assume that his readers know what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_24",
      "id": "foot-24"
    }
  }, [_vm._v("24")]), _vm._v(". In the Roman Empire εὐαγγέλιον was linked with the Emperor cult. It was “good news” when an heir was born or came to the throne. Deissmann quotes from an inscription dated 9 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C")]), _vm._v(". concerning the birthday of the Emperor Augustus: “But the birthday of the god was for the world the beginning of tidings of joy on his account” (LAE, p. 366). Cf. also G. Friedrich, TDNT, II, pp. 724-25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_25",
      "id": "foot-25"
    }
  }, [_vm._v("25")]), _vm._v(". The genitive θεοῦ might conceivably mean that the gospel is good news about God. But while there is truth in this, the expression more naturally refers to origin (BDF 163). The gospel is from God. Cranfield sees Barrett’s the Good News “God is now setting forth” as “an unwarranted limitation of the sense”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_26",
      "id": "foot-26"
    }
  }, [_vm._v("26")]), _vm._v(". See Introduction, p. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_27",
      "id": "foot-27"
    }
  }, [_vm._v("27")]), _vm._v(". E.g., in Matthew, Mark, and John “Jesus” is referred to more often than is “God”. In Luke “God” is used more often than “Jesus” (122 times and 89 times respectively), but here the words for “man” occur as often as “God” (ἄνθ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ωπος 95, ἀνή"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" 27), and this total is exceeded by those for verbs like εἰπεῖν (294) and εἶναι (361). There are no comparable phenomena in Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_28",
      "id": "foot-28"
    }
  }, [_vm._v("28")]), _vm._v(". The verb π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("οεπαγγέλλομαι is not common in the New Testament; it is found elsewhere only in 2 Cor. 9:5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_29",
      "id": "foot-29"
    }
  }, [_vm._v("29")]), _vm._v(". So Lagrange, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_30",
      "id": "foot-30"
    }
  }, [_vm._v("30")]), _vm._v(". γ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("αφή is found 14 times in the Pauline writings. It most commonly occurs in the singular with the article, “the scripture” (Rom. 4:3; 9:17; 10:11; 11:2; Gal. 3:8, 22; 4:30; 1 Tim. 5:18), while once we find “all scripture” (or “every scripture”, 2 Tim. 3:16). Sometimes we have the plural with the article (Rom. 15:4; 1 Cor. 15:3, 4). It is unusual to have scripture characterized as “holy” (though cf. 7:12; 2 Tim. 3:15), and G. Schrenk can say: “We may thus conclude that the phrase αἱ ἱε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("αὶ γ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("αφαί perpetuates in the Church a Jewish and Hellenistic rather than a specifically early Christian usage” (TDNT, I, p. 751).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_31",
      "id": "foot-31"
    }
  }, [_vm._v("31")]), _vm._v(". “The absence of the article with γ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("αφαῖς ἁγίαις emphasises the peculiar holiness of the Old Testament Scriptures” (Boylan; Schrenk, however, sees the absence of the article as “of no significance” [TDNT, I, p. 751 n. 7]). BAGD comment on ἱε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ὰ γ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άμματα, (2 Tim. 3:15), “because of the technical character of the expression no article is needed” ("), _c('em', [_vm._v("sub")]), _vm._v(" γ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άμμα 2.c).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_32",
      "id": "foot-32"
    }
  }, [_vm._v("32")]), _vm._v(". Paul uses υἱός 12 times in Romans, of which seven refer to Christ. They are all qualified (“his”, “God’s”, etc.), and the absolute use, “the Son”, which is so common in John, is not found at all. Another difference from John is that Paul does not hesitate to use the term to denote the sonship to God that people may have. John prefers to speak of τέϰνα θεοῦ, and he brings out some of the uniqueness of Christ by reserving the term υἱός for him alone. Perhaps Paul’s use of the term points to the divine condescension in admitting the saved into membership in his family.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_33",
      "id": "foot-33"
    }
  }, [_vm._v("33")]), _vm._v(". Cf. Käsemann, “Provisionally one might state that no NT author understood the unique divine sonship of Jesus otherwise than in a metaphysical sense”; he finds Son of God “as rare in Judaism as it is common in Hellenism”. Robinson notices that Paul is the only one said in Acts to preach Jesus as the Son of God (Acts 9:20; 13:33;cf. Gal. 1:16). He asks, “Is this presentation peculiarly remembered as having been associated with Paul?” See also jeremias, "), _c('em', [_vm._v("Prayers of Jesus,")]), _vm._v(" pp. 11-19; "), _c('em', [_vm._v("Abba,")]), _vm._v(" pp. 15-33.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_34",
      "id": "foot-34"
    }
  }, [_vm._v("34")]), _vm._v(". It is attested in the Qumran literature, as in the commentary on Isa. 11:1-3: “(Interpreted this concerns the Branch) of David who shall arise at the end” (G. Vermes, "), _c('em', [_vm._v("The Dead Sea Scrolls in English")]), _vm._v(" [Penguin, 1972], p. 227; cf. pp. 224, 246). So also in the Psalms of Solomon, “Behold, Ο Lord, and raise up to them their king, the Son of David … and let Him reign over Israel thy servant” (17:23; J. Rendel Harris, "), _c('em', [_vm._v("The Odes and Psalms of Solomon")]), _vm._v(" [Cambridge, 1911], p. 155).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_35",
      "id": "foot-35"
    }
  }, [_vm._v("35")]), _vm._v(". γενομένου. The verb γίνομαι is an exceedingly common verb (Paul uses it 35 times in Romans and 141 times in all). It has no necessary connection with descent, apparently being concerned rather with “transition from one state or mode of subsistence to another” (T. S. Evans, "), _c('em', [_vm._v("Speaker’s Commentary")]), _vm._v(" on 1 Cor. 1:30). But this transition may be from the womb to the world and the verb may thus be used of being born, though it is not the usual way of denoting birth. It is used in this way of Abraham (John 8:58), as well as of Christ (Gal. 4:4). This may well be the way we should understand it here (as ARV, Moffatt, Way, etc.), though some suggest it means from a previous mode of existence (in heaven) to “coming to be” in human form. But this may be too subtle.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_36",
      "id": "foot-36"
    }
  }, [_vm._v("36")]), _vm._v(". Matt. 1:1; 9:27; 12:23; 15:22; 20:30, 31; 21:9, 15 (a total of eight); Mark 10:47, 48 (two); Luke 18:38, 39 (two). This is probably implied in another three cases, Matt. 1:20; Mark 12:35; Luke 20:41. I have not included the occurrences in parallel passages.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_37",
      "id": "foot-37"
    }
  }, [_vm._v("37")]), _vm._v(". Jesus’ descent from David is mentioned now and then without being emphasized (Acts 2:29ff.; 13:22-23, 34; Rev. 5:5; 22:16).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_38",
      "id": "foot-38"
    }
  }, [_vm._v("38")]), _vm._v(". Black comments, “Jesus himself appears to have found difficulty with this popular belief, and to have taken exception to it; he never used the term ‘son of David’ of himself”. But Bruce can say that Jesus’ “question about the scribal exegesis of Psalm 110.1 (Mk. 12.35-37) should not be construed as a repudiation of Davidic descent.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_39",
      "id": "foot-39"
    }
  }, [_vm._v("39")]), _vm._v(". James D. G. Dunn has a good deal to say about this text in an important article, “Jesus—Flesh and Spirit: An Exposition of Romans 1:3-4” (JTS, N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v(".S")]), _vm._v(". XXIV [1973], pp. 40-68). He argues that we should not take ϰατὰ σά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ϰα here or elsewhere in a neutral sense, for Paul uses it pejoratively. He says, "), _c('em', [_vm._v("“it must be judged highly probable that for Paul ϰατὰ σά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ϰα in Rom. i.3 carries its normal note of depreciation”")]), _vm._v(" (p. 49). He holds that “Paul does not affirm the Davidic sonship of Jesus without qualification. He does not deny it either, but he makes it clear that to describe Jesus as ‘born of the seed of David’ is a dangerously defective and misleading half-truth” (p. 51). He sees the ϰατὰ σά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ϰα, ϰατὰ πνεῦμα antithesis as important here and remarks that these two expressions “denote not successive and mutually exclusive spheres of power, but modes of existence and relationships which overlap and coincide in the earthly Jesus” (p. 54). I am not sure that Dr. Dunn has allowed sufficiently for the possibility of neutrality in some of the examples of ϰατὰ σά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ϰα, but his article is thought-provoking. The idea that the earthly Jesus knew what it was during his time in the flesh to live ϰατὰ πνεῦμα, thus setting us an example, is very valuable.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_40",
      "id": "foot-40"
    }
  }, [_vm._v("40")]), _vm._v(". Notably the verb ὁ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ίζω, which Paul uses nowhere else (Luke and Hebrews have it once each, Acts five times), and the expression πνεῦμα ἁγιωσύνης (not found elsewhere in the New Testament). Other features, such as “Son” and ϰατὰ σά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ϰα, are quite Pauline, however. See a concise summary of the evidence for the use of “an earlier statement” in Dunn, JTS, XXIV, p. 40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_41",
      "id": "foot-41"
    }
  }, [_vm._v("41")]), _vm._v(". Thus it is suggested that the formula expresses a pre-Pauline, adoptionist christology. Paul, it is said, does not refer to Christ’s Davidic descent elsewhere (2 Tim. 2:8 is regarded as credal), nor does he connect Christ’s status as Son of God with his exaltation. But (a) the words do not necessarily point to adoptionism, and (b) Paul certainly did not understand them in that way. In any case we should be very cautious about labelling anything in the New Testament “pre-Pauline”. The date of Paul’s conversion is estimated by competent authorities as c. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.D")]), _vm._v(". 32, so there cannot have been much Christianity before him.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_42",
      "id": "foot-42"
    }
  }, [_vm._v("42")]), _vm._v(". Käsemann has a good discussion of the issues; see also R. Bultmann, "), _c('em', [_vm._v("Theology of the New Testament,")]), _vm._v(" I (London, 1952), p. 49. See also Paul Beasley-Murray, “Romans 1:3f: An Early Confession of Faith in the Lordship of Jesus”, "), _c('em', [_vm._v("Tyndale Bulletin,")]), _vm._v(" 31 (1980), pp. 147-54 and the article by Dunn noted earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_43",
      "id": "foot-43"
    }
  }, [_vm._v("43")]), _vm._v(". Cf. V. S. Poythress, “Is Romans 1"), _c('sup', [_vm._v("3-4")]), _vm._v(" a "), _c('em', [_vm._v("Pauline")]), _vm._v(" Confession After All?” (ET, LXXXVII [1975-76], pp. 180-83).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_44",
      "id": "foot-44"
    }
  }, [_vm._v("44")]), _vm._v(". Dunn rejects the idea that we can go back to an earlier form of the formula to determine Paul’s meaning: “the primary object must be to discover what "), _c('em', [_vm._v("Paul")]), _vm._v(" understood by the saying. Only then can we begin to ask whether and how he has adapted and moulded the earlier formula” (JTS, XXIV, p. 43).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_45",
      "id": "foot-45"
    }
  }, [_vm._v("45")]), _vm._v(". Cited from an unpublished thesis by Elmer Leroy Birney, "), _c('em', [_vm._v("An Annotated Translation of Theodoret’s Commentary on Romans 1–5")]), _vm._v(" (in the library of Trinity Evangelical Divinity School, Deerfield, Illinois), May 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_46",
      "id": "foot-46"
    }
  }, [_vm._v("46")]), _vm._v(". ὅ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ος = “boundary”; ὁ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ίζω = “to separate, mark off by boundaries” (AS). BAGD give the meaning here as “declared to be the powerful Son of God”. Some of the Fathers, whose language was Greek, take the word in this sense. Thus Chrysostom, “What then is the being ‘declared’? being shown, being manifested, being judged, being confessed, by the feeling and suffrage of all” (p. 340).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_47",
      "id": "foot-47"
    }
  }, [_vm._v("47")]), _vm._v(". In Acts 2:36 Jesus is “made” both Lord and Christ at the resurrection, although he has already been approved by signs, etc. (2:22).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_48",
      "id": "foot-48"
    }
  }, [_vm._v("48")]), _vm._v(". Some take the words in the sense “appointed” and hold that they express an adoptionist christology, the view that Jesus was at first no more than a man, but that at the resurrection God “adopted” him into the heavenly family or “installed” or “appointed” him as a member. Thus Käsemann holds that the formula is pre-Pauline and that unlike Paul “the formula does not presuppose the pre-existence and divine sonship of the earthly Jesus…. Jesus receives the dignity of divine sonship only with his exaltation and enthronement” (p. 12); “The reference here is to the enthronement of Christ as Son of God, and the Spirit of holiness was the power which accomplished this” (p. 11). If the words are understood in this way, they express without much precision the thought that it was the resurrection that showed Christ to be God’s Son. Dodd speaks of it as “pre-theological”. It is difficult to find evidence that any New Testament thinker really held an adoptionist position, and certainly in quoting these words Paul did not understand them in such a sense.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_49",
      "id": "foot-49"
    }
  }, [_vm._v("49")]), _vm._v(". NTS, XVII (1970-71), pp. 104-8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_50",
      "id": "foot-50"
    }
  }, [_vm._v("50")]), _vm._v(". TDNT, V, p. 453. He goes on, “But behind the dispute there is an important point, for in the christological passages adduced, Ac. 10:42 and 17:31 as well as R. 1:4, the appointment of Jesus (Christ) as what He is to be must be equated with what He already is from the very beginning of the world, from all eternity in God’s decree.” Godet, however, rejects “declared” as insufficient: “For the resurrection of Jesus not only manifested or demonstrated what He was; it wrought a real transformation in His mode of being.” He argues for “establishing”. Moule uses the illustration of a coronation: one who is king by right of birth is yet “made” king by being crowned (p. 17). Geerhardus Vos has an important note on this passage "), _c('em', [_vm._v("(The Pauline Eschatology")]), _vm._v(" [Grand Rapids, 1953], p. 155 n.10). He says, “The resurrection (both of Jesus and of believers) is therefore according to Paul the entering upon a new phase of sonship characterized by the possession and exercise of unique supernatural power.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_51",
      "id": "foot-51"
    }
  }, [_vm._v("51")]), _vm._v(". Murray rejects the meaning “declared” for the verb in favor of “appointed”. But he avoids an adoptionist view by taking “with power” closely with “Son of God”: “The apostle is dealing with some particular event in the history of the Son of God incarnate by which he was "), _c('em', [_vm._v("instated")]), _vm._v(" in a position of sovereignty and invested with power.” He sees Acts 2:36 as analogous.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_52",
      "id": "foot-52"
    }
  }, [_vm._v("52")]), _vm._v(". δύναμις. We might have expected that it would be primarily a Gospel word. But the greatest number of occurrences in any of the Gospels is 15 in Luke, whereas Paul uses it 48 times (eight in Romans).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_53",
      "id": "foot-53"
    }
  }, [_vm._v("53")]), _vm._v(". ἁγιωσύνη is found elsewhere in the New Testament only in 2 Cor. 7:1; 1 Thess. 3:13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_54",
      "id": "foot-54"
    }
  }, [_vm._v("54")]), _vm._v(". Cf. Earle, “it seems best to take it as referring to Jesus’ human spirit, which was completely holy”; so SH.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_55",
      "id": "foot-55"
    }
  }, [_vm._v("55")]), _vm._v(". So Haldane, Hodge, etc. Cf. GNB, “as to his divine holiness”. Murray notices and rejects the view that the expression refers to “the divine nature” of Christ. He sees it rather as characterizing “the phase which came to be through the resurrection”; “the lordship in which he was instated by the resurrection is one all-pervasively conditioned by pneumatic powers.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_56",
      "id": "foot-56"
    }
  }, [_vm._v("56")]), _vm._v(". "), _c('em', [_vm._v("“The Spirit of holiness")]), _vm._v(" is the regular Hebrew way of saying ‘the Holy Spirit’; Paul here reproduces the Hebrew idiom in Greek” (Bruce); “We should not try to be too subtle about the phrase ‘Spirit of holiness’ … Πνεῦμα ἁγιωσύνης is the exact replica of ‘Holy Spirit’” (Leenhardt).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_57",
      "id": "foot-57"
    }
  }, [_vm._v("57")]), _vm._v(". Black holds that “According to common Jewish belief, the resurrection of the dead was to be the work of the Holy Spirit.” He cites I. Hermann in support. He sees the meaning here as “Christ was divinely decreed Son of God ‘in power’, i.e. miraculously, by a mighty act of God, through the work of the Holy Spirit effecting his Resurrection”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_58",
      "id": "foot-58"
    }
  }, [_vm._v("58")]), _vm._v(". ἁγιωσύνη might refer to spirit as holy (Cranfield cites Ps. 51:11 [13]; Isa. 63:10-11; Test. Levi 18:7; Qumran scrolls, etc.), or if the latter view be held (as Cranfield suggests), to the work of sanctification the Spirit accomplishes in believers.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_59",
      "id": "foot-59"
    }
  }, [_vm._v("59")]), _vm._v(". The expression is ἐξ ἀναστάσεως νεϰ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ῶν and the point at issue the meaning to be attached to ἐϰ. It certainly can have a time reference, as we see from John 9:1, 32; Acts 24:10, etc. But since this is not its normal meaning, NIV is to be preferred. Only if the preceding words refer to the exaltation is the time reference to be accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_60",
      "id": "foot-60"
    }
  }, [_vm._v("60")]), _vm._v(". S. H. Hooke objects to translations which concentrate on Jesus’ own resurrection and argues that Paul is saying “that it is the ἀνάστασις νεϰ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ῶν, the resurrection of the dead, now made possible by the resurrection of Christ, that marks him out as Son of God” (NTS, IX [1962-63], pp. 371-72).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_61",
      "id": "foot-61"
    }
  }, [_vm._v("61")]), _vm._v(". Sometimes 1 Pet. 1:3 is also cited, but the expression there is slightly different: δι’ ἀναστάσεως Ἰησοῦ Χ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστοῦ ἐϰ νεϰ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ῶν.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_62",
      "id": "foot-62"
    }
  }, [_vm._v("62")]), _vm._v(". Cf. Bengel, “it is intimated, that the resurrection of all is intimately connected with the resurrection of Christ”. Cf. Acts 4:2; 23:6; 26:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_63",
      "id": "foot-63"
    }
  }, [_vm._v("63")]), _vm._v(". Cf. an invitation to dinner in the Oxyrhyncus Papyri, “Antonius son of Ptolemaeus invites you to dine with him at the table of the lord Sarapis …” "), _c('em', [_vm._v("(The Oxyrhyneus Papyri,")]), _vm._v(" Part III, ed. Bernard P. Grenfell and Arthur S. Hunt [London, 1903], p. 260).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_64",
      "id": "foot-64"
    }
  }, [_vm._v("64")]), _vm._v(". “When, as here, a personal pronoun in the genitive is combined with it, the sense of personal commitment and allegiance is brought out” (Cranfield).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_65",
      "id": "foot-65"
    }
  }, [_vm._v("65")]), _vm._v(". διά.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_66",
      "id": "foot-66"
    }
  }, [_vm._v("66")]), _vm._v(". It is possible, however, to reason from the fact that “grace” applies to all Christians: “άποστολήν evidently applies to Paul himself, but the addressees and all Christians (4 τοῦ ϰυ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ίου ἡμῶν) are included in χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ις, so that he could not have written ἔλαβον χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιν” (BDF 280).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_67",
      "id": "foot-67"
    }
  }, [_vm._v("67")]), _vm._v(". Cf. Barth, “Grace is the incomprehensible fact that God is well pleased with a man, and that a man can rejoice in God. Only when grace is recognized to be incomprehensible is it grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_68",
      "id": "foot-68"
    }
  }, [_vm._v("68")]), _vm._v(". Cf. Cranfield, grace “characteristically denotes … God’s undeserved love revealed in Christ and so may be said to sum up the whole gospel in a single word” (on v. 7).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_69",
      "id": "foot-69"
    }
  }, [_vm._v("69")]), _vm._v(". Moule brings out these two aspects: “grace is God for us, grace is God in us” (p. 22).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_70",
      "id": "foot-70"
    }
  }, [_vm._v("70")]), _vm._v(". ἀποστολή is a rather rare word, found only four times in the New Testament, three being in Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_71",
      "id": "foot-71"
    }
  }, [_vm._v("71")]), _vm._v(". ὑπαϰοή. AS notes that “The word is not found except in LXX, NT and eccl.”. In the New Testament it occurs 15 times, 11 of which are in Paul, seven in Romans. Thus unusual attention is given to it in this letter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_72",
      "id": "foot-72"
    }
  }, [_vm._v("72")]), _vm._v(". πίστις is another Pauline word, for the apostle uses it 142 times out of the New Testament total of 243. Romans with 40 occurrences has it more than any other book (next is Hebrews with 32). Paul has a similar preponderance with πιστός, which might be translated “faithful” or “believing” (33 times out of 67; it is not used at all in Romans). Curiously this is not the case with the verb “to believe”, which Paul uses but 54 times out of 241.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_73",
      "id": "foot-73"
    }
  }, [_vm._v("73")]), _vm._v(". εἰς ὑπαϰοὴν πίστεως. Cf. 10:3; 16:26; Gal. 3:2; 2 Thess. 1:8; 1 Pet. 1:22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_74",
      "id": "foot-74"
    }
  }, [_vm._v("74")]), _vm._v(". Cf. Black, “The words define the purpose and sphere of Paul’s special apostleship: it was to bring the Gentile world to an obedience which springs from faith, in contradistinction to an obedience based on the external observance of the Law.” JB has a note, “Subjective genitive: the obedience implicit in the virtue of faith”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_75",
      "id": "foot-75"
    }
  }, [_vm._v("75")]), _vm._v(". Cf. G. Kittel, “the message of πίστις which consists or works itself out in ὑπαϰοή” (TDNT, I, p. 224). But these are not quite the same; “consists” is (c), but “works itself out” is (b).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_76",
      "id": "foot-76"
    }
  }, [_vm._v("76")]), _vm._v(". Cf. Käsemann, “the obedience of faith means acceptance of the message of salvation … the characteristic linking of faith and obedience in Paul has a meaning which is not primarily ethical but, as is especially clear in 2 Cor 10:4-6, eschatological: When the revelation of Christ is accepted, the rebellious world submits again to its Lord”. Cf. 15:18; 16:19; 2 Cor. 10:5, 6; 9:13; 1 Thess. 1:8-10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_77",
      "id": "foot-77"
    }
  }, [_vm._v("77")]), _vm._v(". The preposition ὑπέ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" is characteristically Pauline, being found in the Pauline corpus 99 times out of its 149 New Testament occurrences (17 in Romans; the most in one book is 33 in 2 Corinthians, while the most in any non-Pauline writing is 13 in John). Paul often uses it to express the truth that Christ’s death was substitutionary (see my "), _c('em', [_vm._v("The Apostolic Preaching of the Cross"), _c('sup', [_vm._v("3")])]), _vm._v(" [London and Grand Rapids, 1965], pp. 62-64). In the present passage, however, the more general sense, “on behalf of”, is required.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_78",
      "id": "foot-78"
    }
  }, [_vm._v("78")]), _vm._v(". Cf. Kertelge, ‘“his name’ here means his ‘person’”. On the similar expression in 3 John 7 Westcott comments, “it is evident that ‘the Name’ is ‘Jesus Christ’” "), _c('em', [_vm._v("(The Epistles of St John")]), _vm._v(" [London], 1892], p. 238). A little later he says, “This ‘Name’ is in essence the sum of the Christian Creed (comp. 1 Cor. xii.3; Rom. x.9).”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_79",
      "id": "foot-79"
    }
  }, [_vm._v("79")]), _vm._v(". Michel takes the name to be that of God.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_80",
      "id": "foot-80"
    }
  }, [_vm._v("80")]), _vm._v(". Paul uses πᾶς 460 times out of the New Testament total of 1,226. It is found 152 times in Luke, 170 times in Acts, and 128 times in Matthew, these being the only books which have more than 100.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_81",
      "id": "foot-81"
    }
  }, [_vm._v("81")]), _vm._v(". Minear holds that the word “all” in this letter “carries a strong polemical thrust. He was fighting with his partisan readers and trying to persuade them to draw a much wider circle in their conception of the boundaries of the community of faith. As Paul saw it, that community embraced the two most hostile factions” (Minear, p. 45 n.4). But this depends on accepting Minear’s view of the faction-ridden state of the Roman church (which is improbable), and it overlooks the fact that πᾶς is frequent throughout the Pauline writings, not only in Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_82",
      "id": "foot-82"
    }
  }, [_vm._v("82")]), _vm._v(". ἔθνος is found 162 times in the New Testament, of which 54 occurrences are in Paul (29 in Romans) and 43 in Acts. The highest number elsewhere is 23 in Revelation. This points to the truth that in Acts we see the Gentile mission at work and in Romans the theology that underlay that mission.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_83",
      "id": "foot-83"
    }
  }, [_vm._v("83")]), _vm._v(". Notice how the thought of this verse recurs in 15:15-16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_84",
      "id": "foot-84"
    }
  }, [_vm._v("84")]), _vm._v(". Some understand the expression ϰλητοὶ Ἰησοῦ Χ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστοῦ to mean “called by Jesus Christ”; they point out that the verbal adjective may take the genitive of agent (as in 3 Kings 1:49 [LXX], where this very word, ϰλητός, is used). Cranfield sees the refusal to accept this as “doctrinaire”. Alford also accepts it, but most reject it (as SH, Lagrange, Barrett, NEB, etc.). The point is that normally Paul sees the Father rather than the Son as calling people (4:17; 8:30; 11:29; 1 Cor. 1:9; 2 Tim. 1:9). BDF 183 expressly differentiate this passage from those where the verbal adjective takes the genitive of agent because “the one calling is God”. “Called to belong to Jesus Christ” is the meaning. Deissmann notes the use of the simple genitive Καίσα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ος, “belonging to the Emperor” (LAE, p. 377), which may be part of the background against which the expression is to be understood (cf. 1 Cor. 1:12; 2 Cor. 10:7; Gal. 3:29; 5:24, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_85",
      "id": "foot-85"
    }
  }, [_vm._v("85")]), _vm._v(". The words ἐν Ῥώμῃ are omitted in G 1739"), _c('sup', [_vm._v("mg")]), _vm._v(" 1908"), _c('sup', [_vm._v("mg")]), _vm._v(" it"), _c('sup', [_vm._v("g")]), _vm._v(" Or. Most of these authorities are late, and the words should certainly be read. See above, p. 3, for the support this reading lends to the theory of a circular letter. The reading ἐν ἀγάπῃ θεοῦ for ἀγαπητοῖς θεοῦ (G it"), _c('sup', [_vm._v("codd")]), _vm._v(" Ambstr Pel) is probably an attempt to smooth the text after ἐν ἀγάπῃ was omitted. The words are preceded by the participle οὖσιν, for which there seems no particular reason. But Paul uses this participle more than anyone else in the New Testament (61 times out of 152, 18 in Romans). He does not use the verb εἶναι as a whole in this way (560 times out of 2,450). We should take the presence of the participle accordingly as a mark of Paul’s style rather than as having some profound meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_86",
      "id": "foot-86"
    }
  }, [_vm._v("86")]), _vm._v(". The construction is like that with ϰλητοί in v. 6. “God’s beloved” seems to be the meaning. But NIV’s "), _c('em', [_vm._v("loved by God")]), _vm._v(" is possible if we see this as an example of the verbal adjective taking the genitive to denote the agent as in, say, Luke 7:28 (cf. M, III, p. 234). ἀγαπητός is another word of which Paul is fond (27 times out of 61 in the New Testament).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_87",
      "id": "foot-87"
    }
  }, [_vm._v("87")]), _vm._v(". ἅγιος is of course used of things as well as people. Thus it is used of scripture (v. 2), of the law and the commandment (7:12), of the firstfruits and the root (11:16), of the kiss with which Christians should greet one another (16:16). Its most notable uses are for the holy people (the saints) and for the Holy Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_88",
      "id": "foot-88"
    }
  }, [_vm._v("88")]), _vm._v(". “When Paul writes to ‘all God’s beloved in Rome who are called to be saints’, he is writing, not to people likely to figure in stained-glass windows, but to a somewhat motley collection of shop-keepers, minor civil servants, converted prostitutes, prize-fighters and slaves. These are the people called to be God’s ‘holy ones’” (S. Clive Thexton, ET, LXXXVIII [1976-77], p. 26).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_89",
      "id": "foot-89"
    }
  }, [_vm._v("89")]), _vm._v(". χαί"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ειν is used in this way in Acts 15:23; 23:26; Jas. 1:1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_90",
      "id": "foot-90"
    }
  }, [_vm._v("90")]), _vm._v(". Käsemann, however, regards this view as “outmoded”: “Paul is, rather, modifying an oriental-Jewish formula which remains intact in 2 "), _c('em', [_vm._v("Apoc. Bar.")]), _vm._v(" 78:2 and Gal 6:16: ‘Mercy and peace be with you.’” But Käsemann’s two examples both have “mercy” and not “grace”; they lack the critical word. We need not doubt that Paul’s starting point was “an oriental-Jewish formula”. But he modified it in a way which inevitably reminded readers of the Greek salutation.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_91",
      "id": "foot-91"
    }
  }, [_vm._v("91")]), _vm._v(". Though we should notice that in LXX we have ἐλεήσαι, “have mercy”, rather than “grace”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_92",
      "id": "foot-92"
    }
  }, [_vm._v("92")]), _vm._v(". Paul has 43 examples of εἰ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ἡνη out of 91 in the New Testament. Gamble points out that the word tends to occur mostly in “the epistolary framework, that is, in the opening salutations and the concluding peace-wishes”. He does not see it as frequent in “the primary vocabulary of Pauline preaching” (Gamble, p. 68). But we should not overlook Paul’s frequent designation of God as “the God of peace” (15:33; 16:20; 1 Cor. 14:33; 2 Cor. 13:11; Phil. 4:9; 1 Thess. 5:23; cf. 2 Thess. 3:16). Peace was an important concept for him. He finds the making of peace a most important aspect of the work of Christ, who made peace through the blood of the cross (Col. 1:20). Indeed, he himself is “our peace” (Eph. 2:14; the whole section Eph. 2:11-18 is important for this concept).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_93",
      "id": "foot-93"
    }
  }, [_vm._v("93")]), _vm._v(". Cf. Hunter, peace “was the normal Jewish greeting, but on Paul’s lips it must mean that inner serenity which belongs to those who, through Christ, have made their peace with God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_94",
      "id": "foot-94"
    }
  }, [_vm._v("94")]), _vm._v(". Turner points out that normally when there is apposition a proper noun is anarthrous, while the apposition has the article (M, III, p. 206). He cites this passage as an example of the omission of the article “because a formula” (p. 174).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_95",
      "id": "foot-95"
    }
  }, [_vm._v("95")]), _vm._v(". It is also Paul’s normal practice not to have the article with either term. Colossians is an exception, for there most MSS omit any reference to Christ. 1 and 2 Timothy differ only in that the words “our Lord” are put after “Christ Jesus”, while Titus reads instead, “Christ Jesus our Savior”. In 1 Thessalonians the greeting ends at εἰ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ήνη. Paul’s practice is thus not uniform, though reasonably consistent. Since the expression here is the standard form, perhaps it should not be pressed. There may be a glance at the quality of the two as Father and Lord rather than a stress on their individuality, but we can scarcely say more.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_96",
      "id": "foot-96"
    }
  }, [_vm._v("96")]), _vm._v(". Cf. Black, “here is the germ of Trinitarian doctrine.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_97",
      "id": "foot-97"
    }
  }, [_vm._v("97")]), _vm._v(". George Milligan gives the text of an early third-century letter which begins: “Serapias to her children Ptolemaeus and Apolinaria and Ptolemaeus, heartiest greeting. Above all I pray that you may be in health, which is for me the most necessary of all things. I make my obeisance to the lord Serapis, praying that I may receive word that you are in health, even as I pray for your general welfare” "), _c('em', [_vm._v("(Here and There among the Papyri")]), _vm._v(" [London, 1922], p. 35).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_98",
      "id": "foot-98"
    }
  }, [_vm._v("98")]), _vm._v(". P. T. O’Brien has a detailed examination of this thanksgiving in his "), _c('em', [_vm._v("Introductory Thanksgivings in the Letters of Paul")]), _vm._v(" (Leiden, 1977), pp. 197-230.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_99",
      "id": "foot-99"
    }
  }, [_vm._v("99")]), _vm._v(". BDF see the omission as “excusable or even good classical usage”, perhaps “from the very outset” (447 [4]). Cf. 1 Cor. 11:18 and for a similar construction with τὰ μέν 2 Cor. 12:12. Some hold that we should see the meaning here as “first of all” or “before all” (as Boylan), but others think the corresponding second idea is found in v. 10 (as Godet). Lagrange rejects this solution.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_100",
      "id": "foot-100"
    }
  }, [_vm._v("100")]), _vm._v(". It is uncertain how a secretary was used in antiquity. Many scholars hold that a trusted secretary took a rough copy on a wax tablet, wrote out the letter on papyrus with some freedom in the way the thought was expressed, then brought it to the author for correction, final approval, and the addition of a personal greeting. See, e.g., E. Earle Ellis, NTS, 26 (1979-80), pp. 498-99. Gamble cites a number of authorities on modes of dictation, all of whom “wish to allow for a considerable compositional role on the part of the amanuensis.” While agreeing that there is room for “a fresh investigation” of the possible uses of amanuenses, he says, “the vigor, individuality, and consistency of style in the undisputed letters, which often bears the marks of oral speech, favor the view that these were dictated in the verbatim mode” (Gamble, p. 76 n.94). It is not easy to dispute this verdict.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_101",
      "id": "foot-101"
    }
  }, [_vm._v("101")]), _vm._v(". εὐχα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστέω is yet another characteristically Pauline word, being found in the Pauline writings no less than 24 times out of its 38 occurrences in the New Testament (five in Romans).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_102",
      "id": "foot-102"
    }
  }, [_vm._v("102")]), _vm._v(". Cf. Chrysostom, “with how much feeling he gives thanks: for he saith not ‘to God,’ but ‘to my God’”; he adds “which also the Prophets do, so making that which is common to all their own.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_103",
      "id": "foot-103"
    }
  }, [_vm._v("103")]), _vm._v(". O’Brien points out that this is the only occurrence of this formula in Paul’s thanksgivings. He sees it as meaning that “Christ is, in some sense, the Mediator of the thanksgiving” "), _c('em', [_vm._v("(Introductory Thanksgivings,")]), _vm._v(" p. 204). Cf. Bruce, “As it is through Christ that God’s grace is conveyed to human beings (verse 5), so it is through Christ that their gratitude is conveyed to God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_104",
      "id": "foot-104"
    }
  }, [_vm._v("104")]), _vm._v(". ϰαταγγέλλεται. The word is used of proclaiming Christ (Phil. 1:18; Acts 17:3), the resurrection (Acts 4:2), the word of God (Acts 13:5), the gospel (1 Cor. 9:14), the Lord’s death (1 Cor. 11:26), the mystery of God (1 Cor. 2:1), forgiveness of sins (Acts 13:38), and the way of salvation (Acts 16:17). It is thus the right verb to use of a serious and important proclamation. Shedd sees in the use of the verb “a proof that the Roman church had been in existence for some time.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_105",
      "id": "foot-105"
    }
  }, [_vm._v("105")]), _vm._v(". πε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ὶ πάντων ὑμῶν but ἐν ὅλῳ τῷ ϰόσμῳ. For πᾶς see on v. 5. ὅλος is not such a favorite word of Paul’s (14 times out of 108 in the New Testament; four times in Romans).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_106",
      "id": "foot-106"
    }
  }, [_vm._v("106")]), _vm._v(". Cf. O’Neill, “the opening thanksgiving for their faith is a sign that he can assume agreement about the fundamentals: the saints in Rome, as everywhere, live by faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_107",
      "id": "foot-107"
    }
  }, [_vm._v("107")]), _vm._v(". Paul is, of course, referring to what was known among believers. As for non-Christians we have the verdict of the Jewish leaders in Rome at a slightly later date, “people everywhere are talking against this sect” (Acts 28:22).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_108",
      "id": "foot-108"
    }
  }, [_vm._v("108")]), _vm._v(". ϰόσμος occurs 185 times in the New Testament, of which 78 are in John, 24 in the Johannine epistles, and 47 in Paul (nine in Romans). Outside these two writers the most in any one book is eight in Matthew.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_109",
      "id": "foot-109"
    }
  }, [_vm._v("109")]), _vm._v(". Paul uses γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" 454 times out of a New Testament total of 1,036. It occurs 143 times in Romans, while the most in any non-Pauline writing is 124 in the much longer Gospel of Matthew, γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" never stands first in its clause, its usual position being second. But it may come third (v. 19) or even fourth (2 Cor. 1:19). LSJ note examples of its occurring fifth, sixth, or even seventh. Modern translations for some reason often omit the term. Thus in Romans NIV omits it 58 times (more than 40% of the whole), and RSV 43 times. This tendency often obscures the connections in Paul’s thought and prevents the reader from appreciating a Pauline distinctive. It is true that sometimes γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" may legitimately be omitted in translation (BAGD, “oft. in questions, where the English idiom leaves the word untransl.”). But these translations go too far and obscure the connections in Paul’s argument.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_110",
      "id": "foot-110"
    }
  }, [_vm._v("110")]), _vm._v(". “Paul appeals to God, as to a witness in court, since God is the one who can testify or "), _c('em', [_vm._v("prove")]), _vm._v(" that Paul always thinks of the Romans when he prays” (TH).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_111",
      "id": "foot-111"
    }
  }, [_vm._v("111")]), _vm._v(". Paul’s word for "), _c('em', [_vm._v("serve,")]), _vm._v(" λατ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("εύω, may mean “serve for hire” in secular writings (cf. λάτ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ον, “hire”; λάτ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ις, “hired servant”), but in the Bible it is nearly always used of the service of God or a god or gods (Deut. 28:48 is an exception). In LXX it is narrower than λειτου"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γέω in this respect, for the latter may be used when men receive the service (1 Kings 1:4; 19:21, etc.). But it is broader in that it is more often used of the service rendered by laypeople as well as priests (λειτου"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γέω usually, though not invariably, refers to the service of priests and Lévites).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_112",
      "id": "foot-112"
    }
  }, [_vm._v("112")]), _vm._v(". ἐν τῷ πνεύματί μου.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_113",
      "id": "foot-113"
    }
  }, [_vm._v("113")]), _vm._v(". Michel sees prayer and preaching as particular forms of priestly service for Paul. Other suggestions are that his whole person is involved, that the reference is to the Holy Spirit, that his spirit (as opposed to the rest of him) accomplishes the service, and that Christians’ service is spiritual whereas in other religions it is carnal. Hodge’s view seems the best.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_114",
      "id": "foot-114"
    }
  }, [_vm._v("114")]), _vm._v(". ἀδιαλείπτως does not mean “without intermission”. MM cite its use of a cough. Paul uses it elsewhere of constant prayer (1 Thess. 1:2; 2:13; 5:17).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_115",
      "id": "foot-115"
    }
  }, [_vm._v("115")]), _vm._v(". “Make” is ποιοῦμαι. The middle of this verb is used “mostly as a periphrasis of the simple verbal idea” (BAGD; cf. Eph. 1:16; 1 Thess. 1:2; Phlm. 4).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_116",
      "id": "foot-116"
    }
  }, [_vm._v("116")]), _vm._v(". μνεία.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_117",
      "id": "foot-117"
    }
  }, [_vm._v("117")]), _vm._v(". πάντοτε is another Pauline word. It is used by Paul 27 times out of 41 in the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_118",
      "id": "foot-118"
    }
  }, [_vm._v("118")]), _vm._v(". The noun is π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("οσευχή. It occurs 36 times in the New Testament, of which Paul can claim the respectable total of 14 (he uses the corresponding verb only 19 times out of 86). He does not use the verb rendered "), _c('em', [_vm._v("pray")]), _vm._v(" in v. 10 (δέομαι) very often, but it yields another noun for prayer (δέησις) which he uses 12 times out of its 18 New Testament occurrences. Clearly Paul is more than a little interested in prayer. Perhaps we should notice that he says ἐπὶ τῶν π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("οσευχῶν μου, which SH point out means “at my prayers”; it is not “in my prayers”, but “when I pray”, “at the time of” or “on the occasion of” (cf. Eph. 1:16; 1 Thess. 1:2; Phlm. 4).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_119",
      "id": "foot-119"
    }
  }, [_vm._v("119")]), _vm._v(". δέομαι.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_120",
      "id": "foot-120"
    }
  }, [_vm._v("120")]), _vm._v(". εἴ πως ἤδη ποτέ. εἰ = if; enclitic πως = somehow, perhaps; ἤδη = already; enclitic ποτε = at some time (Cranfield thinks this term “expresses the feeling that there has been enough time of waiting”). This is a formidable list, and it conveys an eager desire to come to Rome at any time God wills. Murray cites Meyer for the rendering, “if perhaps at length on some occasion.” Harrisville sees “a cluster of conjunctions and adverbs here which yield the picture of a man champing at the bit”. This accords with Käsemann’s view that there is a suggestion of impatience. O’Brien similarly finds uncertainty and perhaps impatience "), _c('em', [_vm._v("(Introductory Thanksgivings,")]), _vm._v(" p. 217). Robertson includes the expression among those that show “the witchery of the old Greek particles” and thinks that ἤδη ποτέ has “more the notion of culmination (‘now at last’) than of time” (Robertson, pp. 1145, 1147). SH hold that “ἤδη = ‘now, after all this waiting’: ποτέ makes the moment more indefinite”; they render, “some near day at last. “ Clearly the complex expression brings out Paul’s eagerness to get to Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_121",
      "id": "foot-121"
    }
  }, [_vm._v("121")]), _vm._v(". Paul is greatly concerned with God’s will, and he uses θέλημα 24 times, somewhat curiously only four times in Romans, a book which is full of God. εὐοδόω means literally “make a good way”, “be led along a good road”, but in the New Testament the literal sense does not occur. It means rather “to prosper, be prospered, be successful” (AS). NIV brings out something of the original flavor with "), _c('em', [_vm._v("the way may be opened.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_122",
      "id": "foot-122"
    }
  }, [_vm._v("122")]), _vm._v(". O’Brien comments, “Because of the uncertainty of journeys in ancient times, frequent and intensive prayers were offered to the gods for safe travel. Yet these requests were accompanied with very little assurance on the part of the person praying, so in order to account for any unforeseen circumstances, the rider ἐὰν θεοὶ θέλωσι was added.” The difference in the case of Paul was that for him “God’s will was not capricious, for it was through the will of God that he had been called to be an apostle…. Paul might therefore commend specific details of that apostolic calling (such as a journey to Rome) to God’s will with true confidence” "), _c('em', [_vm._v("(Introductory Thanksgivings,")]), _vm._v(" p. 220).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_123",
      "id": "foot-123"
    }
  }, [_vm._v("123")]), _vm._v(". This verse is full of characteristic Pauline language. Paul uses ἐπιποθέω seven out of its nine times in the New Testament, πνευματιϰός 24 out of 26, and χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ισμα 16 out of 17. This last mentioned is, of course, connected with χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ις, “a concrete instance of God’s χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ις, a gift of God” (CGT). The combination χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ισμα πνευματιϰόν is found here only. Perhaps we should add ἵνα to the list of Pauline words. It is, of course, a common word and might be found anywhere. But Paul uses it more than anyone, 249 times out of 673; John is next with 147, a long way behind Paul’s total.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_124",
      "id": "foot-124"
    }
  }, [_vm._v("124")]), _vm._v(". ἵνα τι μεταδῶ χά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ισμα. On the position of τί BDF comments, “Unemphatic (enclitic) pronouns and the like are placed as near the beginning of the sentence as possible … (they are not, however, placed first)” (473 [1]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_125",
      "id": "foot-125"
    }
  }, [_vm._v("125")]), _vm._v(". For εἰς with the accusative of the infinitive see the note on v. 20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_126",
      "id": "foot-126"
    }
  }, [_vm._v("126")]), _vm._v(". Paul uses the various forms of οὗτος quite often (268 times). He is far and away the greatest user of τοῦτο, which he has 114 times out of a New Testament total of 315, more than a third of the whole. We should thus add this to the characteristic Pauline language of this part of the epistle. The expression τοῦτο δέ ἐστιν is found here only in the New Testament. Leenhardt says that it “has not the meaning of τοῦτ’ ἔστίν (that is to say) (cf. 7:18). It introduces not an explanation but a complement” (Cranfield accepts this, though Robertson, p. 705, finds no difference).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_127",
      "id": "foot-127"
    }
  }, [_vm._v("127")]), _vm._v(". Cf. Calvin, “Note how modestly he expresses what he feels by not refusing to seek strengthening from inexperienced beginners. He means what he says, too, for there is none so void of gifts in the Church of Christ who cannot in some measure contribute to our spiritual progress.” So also Cragg, “It may have been a wise approach, but it was an attitude dictated more by the nature of the gifts of which he writes than by the strategy which governed his mission. Benefit is never one-sided…. It is impossible to bless without being blessed.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_128",
      "id": "foot-128"
    }
  }, [_vm._v("128")]), _vm._v(". συμπα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("αϰαλέω may have the meaning “comfort” (as KJV) or “encourage”; it “is used of the inner strengthening of mind and spirit imparted by God” (Black). Hodge thinks that the word “expresses all that excitement and strengthening of faith and pious feeling, as well as consolation, which is wont to flow from the communion of saints.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_129",
      "id": "foot-129"
    }
  }, [_vm._v("129")]), _vm._v(". Paul “piles up phrases to emphasise the reciprocity of benefit (συν., ἐν, ἀλλ., ὑ.ϰ.ἐ.)” (CGT).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_130",
      "id": "foot-130"
    }
  }, [_vm._v("130")]), _vm._v(". “Emphatic ἐμοῦ does not appear in NT except in combination with another gen.” (BDF 284 [2]). The meaning will be, “each through the faith of the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_131",
      "id": "foot-131"
    }
  }, [_vm._v("131")]), _vm._v(". Käsemann, who sees “uncertainty and embarrassment” here, discerns a “sudden change from the stylized certainty of the prescript and the dignity of the thanksgiving”; “The planned visit is … definitely divested of any official character, in obvious contradiction of the real plans of the apostle and of the claims raised in v. 5” (p. 19). He rejects explanations like Paul’s modesty, humility, tact and sensitivity, or caution induced by opposition. Instead he finds this to be Paul’s reaction to widespread rejection of his apostolic claim. But this reads a good deal into the passage and is a far from obvious explanation of the words. Certainly some of the explanations Käsemann rejects are more convincing than the one he accepts. What "), _c('em', [_vm._v("evidence")]), _vm._v(" is there that Paul’s claims were rejected at Rome?")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_132",
      "id": "foot-132"
    }
  }, [_vm._v("132")]), _vm._v(". Paul makes a good deal of use of the negative. He uses οὐ, οὐϰ 121 times in Romans and 483 times in all (1,619 in the New Testament); next is John with 286. He is also far and away the largest user of μή, 77 times in Romans and 354 times in all (1,055 in the New Testament); next is Luke with 142. Paul has some resounding negatives, the reverse side of his positive message.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_133",
      "id": "foot-133"
    }
  }, [_vm._v("133")]), _vm._v(". For οὐ θέλω some MSS, such as D* G d e g Ambrosiaster, Pelagius, read οὐϰ οἴομαι. Tasker, explaining the rejection of the latter, says that the majority of his committee “thought that it was out of place for Paul to say that he believed the Roman church to be well informed about his movements; the required sense being that he wishes now to give such information to a church to which he was a stranger” (Tasker, p. 434).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_134",
      "id": "foot-134"
    }
  }, [_vm._v("134")]), _vm._v(". Paul uses ἀγνοέω 15 times out of 21 in the New Testament, six being in Romans. Paul may also complain, “You do not know” (2:4; 6:3, etc.), while his “we know” assumes knowledge shared with his readers (2:2; 3:19, etc.). Now and then he has “I know” (14:14; 15:29).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_135",
      "id": "foot-135"
    }
  }, [_vm._v("135")]), _vm._v(". ἀδελφός is another Pauline word, for Paul uses it in 133 of its 343 New Testament occurrences. Käsemann sees it as “a primitive Christian term for a member of the community which has both Jewish and pagan analogies (Lietzmann)” (p. 20).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_136",
      "id": "foot-136"
    }
  }, [_vm._v("136")]), _vm._v(". πολλάϰις shows that the Roman church had been in existence for quite some time.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_137",
      "id": "foot-137"
    }
  }, [_vm._v("137")]), _vm._v(". Cranfield thinks π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("οεθέμην is “stronger than βούλεσθαι or θέλειν”; the implication “is that on a number of occasions Paul’s wish to see them has actually been transformed into a more or less definite plan to visit them.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_138",
      "id": "foot-138"
    }
  }, [_vm._v("138")]), _vm._v(". ϰωλύω is a strong term (GT, “cut off”). MM cite its use in senses like “stop” and “forbidden by law”. In 1 Thess. 2:18 Paul speaks of having been hindered by Satan, but that is not said here. Indeed, he seems to mean that it was God who had stopped him because it was not yet time (cf. v. 10). In Acts 16:6 the apostle’s movements were prevented by the Holy Spirit. A number of students hold that 15:22ff. may point us to the answer (e.g., Hunter, Hendriksen).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_139",
      "id": "foot-139"
    }
  }, [_vm._v("139")]), _vm._v(". τινὰ ϰα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("πὸν σχῶ. CGT comments, “σχῶ, ‘get,’ as always.” The metaphor of harvest is often used of the eschatological judgment (e.g, Isa. 27:12; Joel 3:13; Matt. 3:12; 13:30, 39; Mark 4:29), but also of the evangelistic activities of Christ’s servants (Matt. 9:37-38; John 4:35-38).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_140",
      "id": "foot-140"
    }
  }, [_vm._v("140")]), _vm._v(". ὀφειλέτης εἰμί.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_141",
      "id": "foot-141"
    }
  }, [_vm._v("141")]), _vm._v(". Minear, p. 104. He later says, “To the extent that Paul was indebted to God for this call, to that very extent he was indebted to those Gentiles for whose sake God had called him.” On the same page he cites A. Schlatter’s suggestion “that the principle which Jesus had made binding on his disciples had become binding on Paul—that his purpose in giving a gift to one disciple was that he might give it to another. This is why Paul was indebted to all.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_142",
      "id": "foot-142"
    }
  }, [_vm._v("142")]), _vm._v(". He adds, “His debt to them is constituted by the fact that God had appointed him ἐθνῶν ἀπόστολος.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_143",
      "id": "foot-143"
    }
  }, [_vm._v("143")]), _vm._v(". Parry rejects Ramsay’s view of a general benefit which Paul repays by preaching the gospel or a reference to 1 Cor. 9:16: “It is best taken in close connexion with ϰα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("πὸν σχῶ; cf. Phil, iv.17. He has already ‘got fruit’ from these classes: he pays the debt by sowing the seed more widely among such” (CGT). But the relevance of Phil. 4:17 is not obvious; it refers to credit the Philippians might claim for their service, not to any obligation resting on them.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_144",
      "id": "foot-144"
    }
  }, [_vm._v("144")]), _vm._v(". Paul uses “Ελλην in exactly half its New Testament occurrences (13 out of 26). An interesting feature of his use is that he never employs it with the article: it is always “Greeks”, never “the Greeks”. This puts an emphasis on the quality (“people like Greeks”). His use is “because the emphasis is always on the distinctive quality (‘people like the Greeks’ …) and not on the existing group as a collective whole, while in classical Greek the arthrous form is the rule” (BDF 262 [2]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_145",
      "id": "foot-145"
    }
  }, [_vm._v("145")]), _vm._v(". TH renders, “to the civilized and to the savage, to the educated and to the ignorant”, and comments, “In the first two expressions, "), _c('em', [_vm._v("civilized … savage")]), _vm._v(" (literally ‘Greeks … barbarians’), the distinction is not racial or national, but cultural…. The next two terms, "), _c('em', [_vm._v("educated … ignorant,")]), _vm._v(" do not refer to innate intellectual capacities, but rather to degrees of learning.” But this is surely going beyond the evidence.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_146",
      "id": "foot-146"
    }
  }, [_vm._v("146")]), _vm._v(". βά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("βα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ος seems to have been an onomatopoeic term, meaning someone whose language is unintelligible; it sounds like “bar bar.” Cf. 1 Cor. 14:11. But the barbarians on Malta (Acts 28:2, 4) seem to have spoken Greek, so the linguistic significance was perhaps not strictly applied.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_147",
      "id": "foot-147"
    }
  }, [_vm._v("147")]), _vm._v(". H. Windisch thinks that Paul “perhaps groups the Spaniards to whom he plans to journey from Rome” along with others under this heading (TDNT, I, p. 552). Leenhardt sees it as “certainly an allusion to Spain and the missionary plans of the apostle.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_148",
      "id": "foot-148"
    }
  }, [_vm._v("148")]), _vm._v(". Does Paul class the Romans as “Greeks” or “barbarians”? It is perhaps relevant that the church of Rome was Greek-speaking, as the very existence of this letter shows. It was not until the third century that it seems to have become genuinely Latin. But Haldane’s comment is relevant: “He does not inquire or decide whether they ought to be reckoned among the Barbarians or the Greeks, the wise or unwise; he was ready to preach the Gospel to them all.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_149",
      "id": "foot-149"
    }
  }, [_vm._v("149")]), _vm._v(". σοφός is another of Paul’s characteristic words, being found in his writings in 16 of its 20 New Testament occurrences. He has ἀνόητος five times out of six.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_150",
      "id": "foot-150"
    }
  }, [_vm._v("150")]), _vm._v(". “If σοφία includes the striving after the best ends as well as the using of the best means, is mental excellence in its highest and fullest sense (cf. Aristotle, "), _c('em', [_vm._v("Ethic. Nic.")]), _vm._v(" vi.7.3), there can be no wisdom disjoined from goodness, even as Plato had said long ago "), _c('em', [_vm._v("(Menex.")]), _vm._v(" 19)” "), _c('em', [_vm._v("(Synonyms,")]), _vm._v(" p. 283). He sees the use of ἀνόητος as significant, “for, while the ἀσύνετος need not be more than intellectually deficient, in the ἀνόητος there is always a moral fault lying behind the intellectual” "), _c('em', [_vm._v("(ibid.).")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_151",
      "id": "foot-151"
    }
  }, [_vm._v("151")]), _vm._v(". BDF notes ϰατά + accusative as “a circumlocution for the possessive or subjective gen…. it is virtually limited to pronouns in the NT”; “τὸ ϰατ’ ἐμὲ π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("όθυμον = ἡ ἐμὴ π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("οθυμία (τό π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("όθυμον = ἡ π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("οθυμία)” (224 [1]). Cranfield sees three possibilities: (i) τὸ ϰατ’ ἐμέ is subject and π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("όθυμον is predicate; (ii) ἐγώ (understood) is subject and τὸ ϰατ’ ἐμέ is adverbial, “so far as it rests with me”; (iii) all four words are subject and (ἐστιν) … εὐαγγελίσασθαι is predicate, “my eager desire is….” He accepts (iii).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_152",
      "id": "foot-152"
    }
  }, [_vm._v("152")]), _vm._v(". Robert Jewett sees “I am eager, etc.” as “a well-established bureaucratic formula for being prompt in following orders” "), _c('em', [_vm._v("(Interpretation,")]), _vm._v(" XXXVI [1982], p. 15).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_153",
      "id": "foot-153"
    }
  }, [_vm._v("153")]), _vm._v(". Paul does not use the verb εὐαγγελίζω in the overwhelming majority of cases as he does the noun “gospel” (for which see on v. 1), but he still uses it appreciably often, namely 21 times out of 54 in the New Testament (next is Acts with 15).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_154",
      "id": "foot-154"
    }
  }, [_vm._v("154")]), _vm._v(". The words ἐν Ῥώμῃ are omitted here by fewer MSS than in v. 7, namely G it"), _c('sup', [_vm._v("g")]), _vm._v(" Or"), _c('sup', [_vm._v("lat")]), _vm._v(". It seems that the words should be accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_155",
      "id": "foot-155"
    }
  }, [_vm._v("155")]), _vm._v(". Turner disposes of the problem by understanding the verb as “tell”; he takes the text in the sense, “I am anxious to tell you in Rome also my own point of view” "), _c('em', [_vm._v("(Grammatical Insights,")]), _vm._v(" p. 92). But this is an unnatural meaning for the verb as Paul uses it, and it does not fit the context where εὐαγγέλιον in the sense “gospel” occurs five words later.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_156",
      "id": "foot-156"
    }
  }, [_vm._v("156")]), _vm._v(". This γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" is important because it links what follows with what precedes and gives a reason. Cf. Chamberlain, in vv. 16 and 17 γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" “occurs three times: the first instance introduces the reason for Paul’s eagerness to preach the gospel in Rome; the second, his reason for not being ashamed of the gospel; the third, the reason for the dynamic of the gospel” (Chamberlain, p. 154). Harrisville holds that the construction “for … not” reflects a pattern in this epistle. Except in 6:14, he says, it introduces an argument; it is often preceded or followed by another clause with “for”, “indeed”, or “but”; often there is a “whoever” and usually the copula (one or more of these characteristics is sometimes absent) (Harrisville, p. 254 n. l).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_157",
      "id": "foot-157"
    }
  }, [_vm._v("157")]), _vm._v(". Jesus recognized the possibility that some would be ashamed of him: “If anyone is ashamed of me and my words in this adulterous and sinful generation, the Son of Man will be ashamed of him when he comes in his Father’s glory with the holy angels” (Mark 8:38); cf. also, “do not be ashamed to testily about our Lord”; “I am not ashamed, because I know whom I have believed …” (2 Tim. 1:8, 12). The natural man is repelled by “the offence of the cross” (Gal. 5:11), and such scriptural warnings are much to the point.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_158",
      "id": "foot-158"
    }
  }, [_vm._v("158")]), _vm._v(". “The gospel of a crucified carpenter in the streets of Imperial Rome—is not the idea so incongruous as to make one ashamed at the prospect? No, he is not ashamed, for the gospel is a divine POWER …” (Hunter). Chrysostom comments, “Paul was going to preach Jesus, who was thought to be the carpenter’s son, who was brought up in Judea, and that in the house of a mean woman, who had no body guards, who was not encircled in wealth, but even died as a culprit with robbers, and endured many other inglorious things”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_159",
      "id": "foot-159"
    }
  }, [_vm._v("159")]), _vm._v(". Cited in Nygren.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_160",
      "id": "foot-160"
    }
  }, [_vm._v("160")]), _vm._v(". Luther comments, “ ‘power of God’ does not mean that power by which he is powerful in himself but that power by which he makes powerful and strong”; for examples he cites Luke 1:35; 24:49; Acts 1:8; 4:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_161",
      "id": "foot-161"
    }
  }, [_vm._v("161")]), _vm._v(". The word for "), _c('em', [_vm._v("power")]), _vm._v(" is δὐναμις (from which we derive words like “dynamic”). Knox comments that Paul “thinks of the message, the preaching, as he calls it in 1 Cor. l:21ff., as being itself a part of the continuing dynamic event.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_162",
      "id": "foot-162"
    }
  }, [_vm._v("162")]), _vm._v(". Theodoret remarked that “many things have their own operation hidden from the senses.” He chooses pepper as an illustration, for “pepper outwardly seems to be cold, and to those who are unaware it gives no outward appearance of heat. But the person who crunches it between his teeth experiences the sensation of burning fire” "), _c('em', [_vm._v("(Commentary,")]), _vm._v(" pp. 29-30). The illustration might not strike us all as obvious, but it certainly makes the point.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_163",
      "id": "foot-163"
    }
  }, [_vm._v("163")]), _vm._v(". Cf. Moule, “The word is here probably used in its largest meaning, including the whole process of mercy from the time of belief onwards; deliverance from doom, sin, and death” (CBSC; he goes on to notice future and present positive aspects and notes that the meaning is concerned with rescue rather than amelioration).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_164",
      "id": "foot-164"
    }
  }, [_vm._v("164")]), _vm._v(". π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ῶτον assigns priority to the Jew, but this is balanced with τε ϰαί, which coordinates the two. Curiously Lenski takes π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ῶτον to apply to both, “in the first place for both Jew and Greek” (understanding “Greek” in terms of culture, he reasons that the gospel goes first to the combination of religious Jews and cultured Greeks; if even they needed it, so did “the lower classes”). This is unconvincing. The word π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ῶτον is missing from some MSS, namely Β G g sah Tertullian Ephraem. The best suggestion is that it was omitted by Marcion, who would have found it quite unacceptable (so, e.g., Metzger). It is interesting that Paul, the apostle of the Gentiles, writing to a group made up largely of Gentiles (v. 13), should not hesitate to speak of the priority of the Jew. Cf. Matt. 15:24; Luke 24:47; John 4:22; Acts 1:8; 13:46. John H. Stek examines the priority of the Jew, mostly in material from the Gospels, in “To the Jew First”, "), _c('em', [_vm._v("Calvin Theological Journal, 7")]), _vm._v(" (1972), pp. 15-52.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_165",
      "id": "foot-165"
    }
  }, [_vm._v("165")]), _vm._v(". Ἰουδαῖος occurs 11 times in Romans, the most in any Pauline writing. The apostle is greatly concerned with the Jews in this letter. But the term is much more frequent in other writers (Acts has it 79 times and John 71).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_166",
      "id": "foot-166"
    }
  }, [_vm._v("166")]), _vm._v(". ϰαί. GT notes that ϰαι “is conjunctive, τέ "), _c('em', [_vm._v("ad")]), _vm._v("junctive…. ϰαί introduces something new under the same aspect yet as an external addition, whereas τέ marks it as having an inner connection with what precedes” "), _c('em', [_vm._v("(sub")]), _vm._v(" τέ). Cranfield comments, “The word τε (though its presence is simply ignored by RV, RSV, NEB and JB) is suggestive of the fundamental equality of Jew and Gentile in the face of the gospel (the gospel is the power of God unto salvation for believing Jew and believing Gentile alike)”. BDF (444 [2]) draw attention to ϰαὶ … ϰαί in 1 Cor. 10:32, “where the distinction between the members is retained, whereas with τε ϰαί the distinction is rather set aside.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_167",
      "id": "foot-167"
    }
  }, [_vm._v("167")]), _vm._v(". Cf. Cranfield, “it is of the very essence of faith as Paul understands it, that it is opposed to human deserving, all human establishing of claims on God…. For Paul man’s salvation is altogether—not almost altogether—God’s work; and the faith spoken of here is the openness to the gospel which God Himself creates.” He later says, “And yet this faith, as God’s work in a man, is in a real sense more truly and fully the man’s own personal decision than anything which he himself does of himself; for it is the expression of the freedom which God has restored to him—the freedom to obey God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_168",
      "id": "foot-168"
    }
  }, [_vm._v("168")]), _vm._v(". O’Neill seems to countenance such views by saying things like “the men who live by faith live righteously in God’s sight”; “To the objection that Paul wants to speak only of God’s action and not at all of man, I answer that this context is about faith, what man has to do if he would live before God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_169",
      "id": "foot-169"
    }
  }, [_vm._v("169")]), _vm._v(". Cf. Lenski, “Διϰαιοσύνη θεοῦ is "), _c('em', [_vm._v("the status of righteousness into which faith and the believer are placed by the judicial verdict of God”")]), _vm._v(" (Lenski’s italics).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_170",
      "id": "foot-170"
    }
  }, [_vm._v("170")]), _vm._v(". Hodge sees righteousness as both ἐϰ θεοῦ (Phil. 3:9) and πα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ὰ τῷ θεῷ (2:13; 3:20; Gal. 3:11). Here he sees both “a righteousness, which God gives, and which he approves”. But this seems tautological. How could God give a righteousness of which he did not approve?")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_171",
      "id": "foot-171"
    }
  }, [_vm._v("171")]), _vm._v(". NEB renders, “God’s way of righting wrong”. Black sees it as “the triumph of God (over Satan, sin and death)”. But this perhaps relies too much on connecting these words with certain Old Testament passages such as Judg. 5:11; Ps. 103:6, which link righteousness and deliverance. From another point of view Käsemann speaks of “the fact that the διϰαιοσύνη θεοῦ appears in Rom. 1:17; 10:3ff. in personified form as Power” "), _c('em', [_vm._v("(New Testament Questions of Today")]), _vm._v(" [London, 1969], p. 169). But his “fact” goes beyond the evidence. Paul does not say that God’s righteousness is power, but that the gospel is power.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_172",
      "id": "foot-172"
    }
  }, [_vm._v("172")]), _vm._v(". The present tense ἀποϰαλύπτεται points to an ongoing process. We proclaim the gospel, but the revelation is something God does. The verb is found in Paul in exactly half its New Testament occurrences (13 out of 26).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_173",
      "id": "foot-173"
    }
  }, [_vm._v("173")]), _vm._v(". Murray, e.g., finds it “more natural… to couple ‘from faith to faith’ with the word ‘revealed’.” He is not arguing that revelation depends on faith, but that it is made known only through faith.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_174",
      "id": "foot-174"
    }
  }, [_vm._v("174")]), _vm._v(". ἐϰ πίστεως εἰς πίστιν. Similar constructions are ἐϰ δυνάμεως εἰς δύναμιν (Ps, 83:8 [85:7]); ἐϰ θανάτου εἰς θανάτον … ἐϰ ζωῆς εἰς ζωήν (2 Cor. 2:16); cf. ἀπὸ δόξης εἰς δόξαν (2 Cor. 3:18).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_175",
      "id": "foot-175"
    }
  }, [_vm._v("175")]), _vm._v(". ϰαθὼς (or ϰαθάπε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(") γέγ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("απται occurs 14 times in Romans and simple γέγ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("απται twice. In 10:5 Paul has Μωϋσῆς γὰ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" γ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άφει.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_176",
      "id": "foot-176"
    }
  }, [_vm._v("176")]), _vm._v(". The passage was clearly regarded as important in some later circles in Judaism. Thus we are told that R. Simlai saw the 613 commandments in the law as reduced to 11 by David (Ps. 15), to six by Isaiah (Isa. 33:15-16), to three by Micah (Mic. 6:8), to two by Isaiah again (Isa. 56:1), and to one by Amos (Amos 5:4). But R. Nahman demurred and saw the reduction to one as effected by Habakkuk, citing our text (Makk. 24a). But these are third- and fourth-century rabbis, and we have no way of knowing how far back this kind of exegesis goes.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_177",
      "id": "foot-177"
    }
  }, [_vm._v("177")]), _vm._v(". The Greek is Ὁ δὲ δίϰαιος ἐϰ πίστεως ζήσεται. Strictly, if the sense “he that is just by faith” were required, ἐϰ πίστεως should be between the article and δίϰαιος or else have an article of its own. But such an article is not invariable in the New Testament and the point cannot be insisted upon. Lightfoot summarizes the reasons in favor of taking the words in the sense of KJV as follows: “(1) the original seems certainly so to intend it; and in the LXX … it appears so to be taken. This is also the construction in the Targum Jonathan. (2) Ἐϰ πίστεως here corresponds to ἐϰ πίστεως in the former part of the verse, where it belongs, not to the predicate, but to the subject. It is here separated from ὁ δίϰαιος, as it is there separated from διϰαιοσύνη. (3) Ὁ δίϰαιος ἐϰ πίστεως is not a natural phrase, and, I think, has no parallel in St Paul. (4) The other construction takes the emphasis off ‘faith,’ which the context shows to be the really emphatic word, and lays it on the verb ‘live.’” The reading has eminent support; see, e.g., ASV, Moffatt, Hendriksen, Leenhardt, Michel, Murray, SH. R. M. Moody has a strong defence of this understanding of the text (ET, 92 [1980-81], pp. 205-8).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_178",
      "id": "foot-178"
    }
  }, [_vm._v("178")]), _vm._v(". It is not certain exactly what text Paul had. The Hebrew means “the righteous will live because of his faith (or faithfulness)” and appears to signify that the servant of God must await God’s time for deliverance. Till then his trust in God must sustain him. In our text of LXX μου is attached to πίστεως, which might mean (with God as the speaker) “because of my faithfulness” or “because of his faith in me”. Paul lacks the μου both here and in Gal. 3:11. It is not clear whether he had a different text or whether he understood the passage in a different way.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_179",
      "id": "foot-179"
    }
  }, [_vm._v("179")]), _vm._v(". I am not sure whence Nygren derives his statistics (except that he tells us that he does not include the life words in “the thematic verse”). But the words occur as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_vm._v("Chs. 1–4: πίστις is found in 1:5, 8, 12, 17 "), _c('em', [_vm._v("(ter);")]), _vm._v(" 3:3, 22, 25, 26, 27, 28, 30 "), _c('em', [_vm._v("(bis),")]), _vm._v(" 31; 4:5, 9, 11, 12,13, 14,16 "), _c('em', [_vm._v("(bis),")]), _vm._v(" 19, 20, a total of 25. πιστεύω is found in 1:16; 3:2, 22; 4:3, 5,11,17,18, 24, nine times in all. The total of the faith words is thus 34. ζωή occurs in 2:7, ζάω in 1:17, and ζοῳποιέω in 4:17, a total of three.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_vm._v("Chs. 5–8: πίστις is found in 5:1, 2 and πιστεύω in 6:8, a total of three, ζωή occurs in 5:10,17,18,21; 6:4, 22,23; 7:10; 8:2, 6, 20, 38, a total of 12. ζάω is found in 6:2, 10 "), _c('em', [_vm._v("(bis),")]), _vm._v(" 11, 13; 7:1, 2, 3, 9; 8:12,13 "), _c('em', [_vm._v("(bis),")]), _vm._v(" which totals 12, while ζῳοποιέω is found in 8:11, which makes the total of the life words in these chapters 25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_vm._v("The figures then appear to be")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_vm._v("chs. 1–4 faith words, 34; life words, 3")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_vm._v("chs. 5–8 faith words, 3; life words, 25")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_vm._v("Some allowance must be made for textually doubtful passages (I have simply cited Moulton and Geden). But when this is done, it is plain that the figures favor Nygren’s position somewhat more strongly than he says, even if there is not an exact reversal.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_180",
      "id": "foot-180"
    }
  }, [_vm._v("180")]), _vm._v(". "), _c('em', [_vm._v("Saint Paul’s Epistle to the Galatians")]), _vm._v(" (London, 1902), p. 155.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_181",
      "id": "foot-181"
    }
  }, [_vm._v("181")]), _vm._v(". Contrast the interpretation of the Qumran sect. The commentary on Habakkuk explains the words “The righteous shall live by his faith” in this way: “this concerns all those who observe the Law in the House of Judah, whom God will deliver from the House of Judgment because of their suffering and because of their faith in the Teacher of Righteousness” (Vermes, p. 239). It is the Law that matters, specifically in the way the Teacher expounded it.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_182",
      "id": "foot-182"
    }
  }, [_vm._v("182")]), _vm._v(". So RSV, GNB, Black, Bruce, Feuillet (NTS, 6 [1959-60], pp. 52ff.), Hunter, Lagrange, Nygren, Harrison, Robinson, Wuest, TH, etc. JB renders, “The upright man finds life through faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_183",
      "id": "foot-183"
    }
  }, [_vm._v("183")]), _vm._v(". The verb ζάω is used 23 times in Romans, the most in any one book (140 times in the New Testament; 17 in John). It can refer to physical life, but it is also used “of the supernatural life of the child of God” (BAGD; they class this passage under “have eternal life”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_184",
      "id": "foot-184"
    }
  }, [_vm._v("184")]), _vm._v(". O’Neill maintains that Paul was not the author of 1:18–2:29. If the argument were that all Gentiles are sinners he thinks there would perhaps be a connection, “but the writer is not arguing that all Gentiles are sinners. The argument is that idolaters are prone to immorality, not that all Gentiles are immoral.” But this ignores the fact that the section is introduced with the revelation of God’s wrath “against all the godlessness and wickedness of men” (v. 18). Idolaters are certainly castigated, but the language includes other sinners as well (cf. vv. 28-32). O’Neill is isolated in his view. Barrett is much more representative when he says, “Paul’s argument is developed in a clear and consistent way. The Gospel rests upon a manifestation of righteousness; to those who believe, it proves to be the power of God unto salvation (cf. 1 Cor. i. 18); to those who do not believe, but are disobedient and rebellious, it means God’s wrath (cf. 2 Cor. ii. 16).”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_185",
      "id": "foot-185"
    }
  }, [_vm._v("185")]), _vm._v(". Cf. Shedd, γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" “introduces the reason why God has revealed the διϰαιοσύνη spoken of: namely, because he had previously revealed his ο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γή. This shows that mercy is meaningless except in relation to justice, and that the attempt, in theology, to retain the doctrine of the divine love, without the doctrine of the divine wrath, is illogical.” This may be getting a bit much out of the conjunction, but the point is worth pondering.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_186",
      "id": "foot-186"
    }
  }, [_vm._v("186")]), _vm._v(". Curiously Moffatt translates γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" with “But”, and even more curiously Dodd bases his comment on the mistranslation: “The adversative conjunction ‘but’ in i.18 shows that the revelation of God’s ‘anger’ is contrasted, and not identified, with the revelation of His righteousness.” It is true that γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" can very occasionally have some adversative force. Thus when in a response a “No” is omitted, γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" may supply the reason for the omitted negative (see examples in LSJ). Clearly there is nothing of the sort here. This is rather a typical case of giving a reason for the foregoing. Barrett renders, “A clear signal of the revealing of God’s righteousness is the fact that his wrath….” This may be something of an overtranslation, but it indicates the force of the word.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_187",
      "id": "foot-187"
    }
  }, [_vm._v("187")]), _vm._v(". "), _c('em', [_vm._v("A Commentary on St. Paul’s Epistle to the Romans"), _c('sup', [_vm._v("8")])]), _vm._v(" (London, 1892), "), _c('em', [_vm._v("in loc.")]), _vm._v(" Cf. G. Bornkamm, in Rom. 1:18-3:20 “the keyword is the ‘revelation of God’s wrath’” ("), _c('em', [_vm._v("Paul")]), _vm._v(" [London, 1971], p. 122).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_188",
      "id": "foot-188"
    }
  }, [_vm._v("188")]), _vm._v(". Cf. Barrett, “When Paul speaks of wrath, it is in general quite clear from the context that the wrath is God’s; so, for example, iii.5; ix.22. Wrath is God’s personal (though never malicious or, in a bad sense, emotional) reaction against sin.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_189",
      "id": "foot-189"
    }
  }, [_vm._v("189")]), _vm._v(". Paul uses ὀ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γή in 21 of its 36 New Testament occurrences, of which 12 come in Romans; all 12 appear to refer to the divine wrath.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_190",
      "id": "foot-190"
    }
  }, [_vm._v("190")]), _vm._v(". Cf. Manson, “The ‘wrath’ is the obverse of the ‘righteousness of God’: his creative goodness is matched by his inflexible opposition to evil.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_191",
      "id": "foot-191"
    }
  }, [_vm._v("191")]), _vm._v(". Käsemann categorically rejects such views: “Our starting point should be that the manifestation of this wrath is described in w. 24ff…. The thrice-repeated πα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("έδωϰεν αὐτούς shows incontestably … that in the apparently purely immanent causal connection God himself is at work…” (p. 37).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_192",
      "id": "foot-192"
    }
  }, [_vm._v("192")]), _vm._v(". Cf. Hunter, “The truth is that we dislike the phrase because we have sentimentalized our conception of God in a quite un-biblical way. Wrath—the strong and continuous reaction of the holy God against evil in every shape and form—a wrath operative now and not only at the Last Judgment, is an essential part of any truly biblical idea of God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_193",
      "id": "foot-193"
    }
  }, [_vm._v("193")]), _vm._v(". Cf. Trench, God “would not love good, unless He hated evil, the two being so inseparable, that He must do both or neither” "), _c('em', [_vm._v("(Synonyms,")]), _vm._v(" p. 134).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_194",
      "id": "foot-194"
    }
  }, [_vm._v("194")]), _vm._v(". Cf. BAGD, wrath is “the divine reaction toward evil; it is thought of not so much as an emotion as in terms of the outcome of an angry frame of mind "), _c('em', [_vm._v("(judgment).”")]), _vm._v(" The lexicon goes on to point out that this is “a legitimate feeling on the part of a judge”. God is doing something in opposition to sin, not leaving sin to work out its consequences. Cf. Nygren, “wrath is also God’s own work, which He himself discloses from heaven. It is God and not some alien powers, who has laid the old aeon under condemnation.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_195",
      "id": "foot-195"
    }
  }, [_vm._v("195")]), _vm._v(". See further my "), _c('em', [_vm._v("Apostolic Preaching,")]), _vm._v(" chs. V and VI; R. V. G. Tasker, "), _c('em', [_vm._v("The Biblical Doctrine of the Wrath of God")]), _vm._v(" (London, 1951); NIDNTT, I, pp. 105-13; TDNT, V, pp. 382-447; H. Ridderbos, "), _c('em', [_vm._v("Paul,")]), _vm._v(" pp. 108-14.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_196",
      "id": "foot-196"
    }
  }, [_vm._v("196")]), _vm._v(". Boylan, however, denies that this revelation is made in the gospel: “The revelation of God’s anger is made in the moral degradation of the Gentiles depicted in "), _c('em', [_vm._v("vv.")]), _vm._v(" 24ff.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_197",
      "id": "foot-197"
    }
  }, [_vm._v("197")]), _vm._v(". Cf. Robinson, “the full laying bare of the fearful truth and final consequences of the alienation of human society from God is but the other side of the very same revelation which is God’s way of righting wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_198",
      "id": "foot-198"
    }
  }, [_vm._v("198")]), _vm._v(". G. Dalman examines “Evasive or Precautionary Modes of Referring to God” and gives attention to the use of “heaven” "), _c('em', [_vm._v("(The Words of Jesus")]), _vm._v(" [Edinburgh, 1902], pp. 206-20). Specifically he sees “from heaven” in its usage in the Gospels as signifying “derivation from God” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" pp. 219-20). It will not differ here.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_199",
      "id": "foot-199"
    }
  }, [_vm._v("199")]), _vm._v(". ἀσέβεια is strictly “impiety” or “lack of reverence for God”, and ἀδιϰία “lawlessness” or “wickedness”. Some commentators see them used strictly here to give such meanings as “impiety against God and injustice against man. Thus humanity is at once a religious and a moral failure” (Griffith-Thomas). But most see them here as pointing to much the same thing; e.g., Hendriksen, both mean “sin, rebellion against God”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_200",
      "id": "foot-200"
    }
  }, [_vm._v("200")]), _vm._v(". ϰατέχω has a number of meanings. (1) The ϰατά may have perfective force, giving the meaning “possess” (as in 2 Cor. 6:10) or “hold fast” (in a good sense, Luke 8:15; in a bad sense, Rom. 7:6). (2) This may lead to the thought of occupying a place (Luke 14:9). (3) The ϰατά may signify “down”, giving the meaning “hold down” or “hold back” (2 Thess. 2:6, 7), “restrain”, “hinder” (Luke 4:42).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_201",
      "id": "foot-201"
    }
  }, [_vm._v("201")]), _vm._v(". Parry notes that ϰατέχω means (1) to possess, and (2) less frequently to restrain. He comments, “Here the sequence of thought is decisive in favour of the first meaning; it is essential to the argument that the primary condition which makes an act or state sinful, should be set down here; namely, that the sinner knows what he is doing” (CGT). But this is not convincing. Translations like “suppress” or “hinder” also presuppose that the suppressor or hinderer knows what he is suppressing or hindering.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_202",
      "id": "foot-202"
    }
  }, [_vm._v("202")]), _vm._v(". ἀλήθεια occurs 109 times in the New Testament, of which Paul accounts for 47, John’s Gospel 25, and John’s epistles 20. Paul does not use the word very often in any one writing, but it occurs in all his epistles except 1 Thessalonians and Philemon. See further Additional Note B.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_203",
      "id": "foot-203"
    }
  }, [_vm._v("203")]), _vm._v(". Cf. Lenski, “Ἀλήθεια is ‘truth’ in the sense of ‘reality,’ that which is actually so”; Calvin, "), _c('em', [_vm._v("“The truth")]), _vm._v(" of God means the true knowledge of God”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_204",
      "id": "foot-204"
    }
  }, [_vm._v("204")]), _vm._v(". Richard N. Longenecker examines the question of whether Paul is indebted to Hellenism for his approach. He points to coincidences of language and thought but decides that such parallels are secondary. Basically what Paul says comes from Hebraic sources "), _c('em', [_vm._v("(Paul, Apostle of Liberty")]), _vm._v(" [New York, 1964], pp. 54-58).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_205",
      "id": "foot-205"
    }
  }, [_vm._v("205")]), _vm._v(". Some see a contradiction with the report of Paul’s speech at Athens (Acts 17:22-31). But this is surely overreaction. There he is appealing to pagans for a hearing; here he is writing to believers. A difference in emphasis is inevitable. The point in the Athenian address is that God has given sufficient revelation for people to “seek him and perhaps reach out for him and find him” (v. 27). This had led to their altar “to an unknown god”, whom Paul proceeds to proclaim to them (v. 23). Here he is saying that God has revealed himself to all people clearly enough for them to be guilty when they make their idols. It is like the approach to the people of Lystra: God “has not left himself without testimony” (Acts 14:17).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_206",
      "id": "foot-206"
    }
  }, [_vm._v("206")]), _vm._v(". διότι is equivalent to διὰ τοῦτο ὅτι, “on this account”, “for”. Other possibilities have been pointed out (“wherefore” or “that”), but in the New Testament it seems always to mean “because”. It is found 24 times, of which ten are in Paul, five being in Romans. “Because” may refer back to the earlier part of v. 18 and give the reason for saying the wrath is revealed. Or it may refer to the immediately preceding words and give the reason for affirming that people hinder the truth in unrighteousness. Either is grammatically possible and both give good sense, but the second seems more probable.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_207",
      "id": "foot-207"
    }
  }, [_vm._v("207")]), _vm._v(". The verbal adjective γνωστός. Cf. W. Gunion Rutherford, “The verbal adjective in -τός normally denotes that the action expressed by the verb is possible”; he contrasts it with that in -τέος, which marks obligation. He gives as examples a form ending in -τός, yielding the meaning “the river may be crossed”; the corresponding form in -τέος means “the river must be crossed” (First "), _c('em', [_vm._v("Greek Grammar Syntax")]), _vm._v(" [London, 1935], p. 153). Neither form is very common in the New Testament. When γνωστός is used in other New Testament passages it means “known”. This is the one place where Paul uses it, and thus we do not know whether he employs it in the same way as do other writers or not. Bultmann thinks that “the meaning is perhaps ‘clearly recognisable’” (TDNT, I, p. 719). BDF have a note on another aspect of the use here: “Peculiar to Paul (Heb) is the use of a neuter sing, adjective like an abstract mostly with a dependent gen.” They cite Origen, “what is known (knowable) of (or about) God is manifest to them” (263 [2]). Turner notes that the construction is characteristic of Paul and Luke, infrequent in the Gospels, and not attested in the papyri (M, III, p. 13).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_208",
      "id": "foot-208"
    }
  }, [_vm._v("208")]), _vm._v(". Barth insists on the reality of the knowledge: “When we rebel, we are in rebellion not against what is foreign to us but against that which is most intimately ours…. Our memory of God accompanies us always as problem and as warning.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_209",
      "id": "foot-209"
    }
  }, [_vm._v("209")]), _vm._v(". Note that the adjective φανε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("όν and the verb ἐφανέ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ωσεν are from the same root.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_210",
      "id": "foot-210"
    }
  }, [_vm._v("210")]), _vm._v(". For γά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" see on v. 9. Its position after ὀ θεός puts a little more emphasis on θεός than if the more normal order had been followed.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_211",
      "id": "foot-211"
    }
  }, [_vm._v("211")]), _vm._v(". ἐν αὐτοῖς.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_212",
      "id": "foot-212"
    }
  }, [_vm._v("212")]), _vm._v(". Cf. BDF, “Occasionally ἐν appears also to stand for the customary dat. proper”. They see this passage as “probably” an example (220 [1]). BAGD hold that ἐν with the dative stands for the ordinary dative and cite Aesop here, τ. φανε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ὸν ἐν πᾶσιν = “evident to all” (ἐν IV.4a).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_213",
      "id": "foot-213"
    }
  }, [_vm._v("213")]), _vm._v(". Moule, IBNTG, p. 73. The problem is the meaning of ἀπό. It can be used in a causal or instrumental sense, but most take it here of time.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_214",
      "id": "foot-214"
    }
  }, [_vm._v("214")]), _vm._v(". Nouns in -σις denote activity, while nouns in -μα (ϰτίσμα) properly point to the result of the action. But the distinction is often blurred, and usage, not formation, is decisive, ϰτίσις is used of (1) the act of creating (Mark 10:6), (2) the totality of what was created (Col. 1:15), or (3) an individual created thing (Rom. 8:39).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_215",
      "id": "foot-215"
    }
  }, [_vm._v("215")]), _vm._v(". ϰόσμος originally meant “ornament” and was used of the universe as the greatest jewel. Since for people the most important part of the universe is this world, the same term came to denote “the world”. But here the wider meaning is required.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_216",
      "id": "foot-216"
    }
  }, [_vm._v("216")]), _vm._v(". τὰ γὰ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v(" ἀό"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ατα αὐτοῦ. For verbal adjectives see on v. 19; ἀό"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ατος strictly means “that cannot be seen”, “invisible”, though it may be used loosely in the sense, “that is not seen”. Most understand it here in some such sense as “his invisible attributes” (NEB, Phillips); RSV has “his invisible nature”. Bultmann sees the meaning as “He the Invisible” (TDNT, I, p. 719), which Turner quotes approvingly "), _c('em', [_vm._v("(Grammatical Insights, p.")]), _vm._v(" 132).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_217",
      "id": "foot-217"
    }
  }, [_vm._v("217")]), _vm._v(". ἥ τε ἀῖδιος αὐτοῦ δύναμις ϰαὶ θειότης. For τέ see on v. 16. Hodge points out that ἥ τε is explanatory; it does not add a new idea.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_218",
      "id": "foot-218"
    }
  }, [_vm._v("218")]), _vm._v(". ἀῖδιος. It is derived from ἀεί, “always”, and occurs in the New Testament again only in Jude 6. In LXX it occurs only in Wis. 7:26 and as a variant in 4 Mace. 10:15. In Greek generally it is found from early times (LSJ). According to MM it is frequent in inscriptions but rare in the papyri.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_219",
      "id": "foot-219"
    }
  }, [_vm._v("219")]), _vm._v(". αἰώνιος.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_220",
      "id": "foot-220"
    }
  }, [_vm._v("220")]), _vm._v(". SH see θειότης as denoting “Divine nature and properties”, whereas θεότης (Col. 2:9) is “Divine Personality”. Earle supports the distinction, but the two words are translated by the same English term in KJV and RSV. They seem to differ only as much as “divinity” and “deity”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_221",
      "id": "foot-221"
    }
  }, [_vm._v("221")]), _vm._v(". The Greek is νοούμενα ϰαθο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ᾶται. ϰαθο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άω is found here only in the New Testament, νοέω 14 times (five times in Paul). It is not easy to bring out in English the play on words, ἀό"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ατα … ϰαθο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ᾶται; it is something like “his unseeable things … are clearly seen”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_222",
      "id": "foot-222"
    }
  }, [_vm._v("222")]), _vm._v(". Cf. Boylan, “By looking on the visible world they can see the invisible” (on , v. 19). Cranfield.,however, points out that the action of the participle is naturally understood as prior to or contemporaneous with that of the verb in the indicative; he rejects the idea that it is subsequent. Thus νοούμενα and ϰαθο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ᾶται both point to physical sight, though noting that usage favors mental perception in νοούμενα. NEB prefers mental perception, rendering “visible … to the eye of reason”; cf. Murray, “it is the seeing of understanding, of intelligent conception”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_223",
      "id": "foot-223"
    }
  }, [_vm._v("223")]), _vm._v(". τοῖς ποιήμασιν is dative of means or instrument. The visible is the means of our perception of the invisible.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_224",
      "id": "foot-224"
    }
  }, [_vm._v("224")]), _vm._v(". Wisdom 13 is often adduced as a parallel, but there the thought is slightly different. The writer says, “For from the greatness and beauty of created things comes a corresponding perception of their Creator” (v. 5). But he is referring to man’s search after God (“as they live among his works they keep searching”, v. 7), Paul to God’s revelation of himself. In Wisdom if man does not come to know God that is simply a mistake, in Paul it is the rejection of what God has made known.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_225",
      "id": "foot-225"
    }
  }, [_vm._v("225")]), _vm._v(". εἰς τό + infinitive. Moulton finds this construction three times in Matthew, once each in Mark, Luke, and Acts, twice each in James and 1 Peter, eight times in Hebrews, and 43 times in Paul. It is thus very much a Pauline construction. And Paul almost always uses it to express purpose. This is not invariable (cf. 12:3), but we need a reason if we are to see consequence. Specifically in the present passage Moulton says we must see purpose, “for this belongs to the category of passages dealing with Divine action, in which contemplated and actual results, final and consecutive clauses, necessarily lose their differentia” (M, I, p. 219; earlier he has quoted Westcott, “ἵνα appears to mark in each case the direct and immediate end, while εἰς τό indicates the more remote result aimed at or reached” "), _c('em', [_vm._v("[ibid.,")]), _vm._v(" p. 218]). It would be expected that if ἵνα can lose its telic force even more so could εἰς τό, but on the whole this does not appear to be the case. SH see here “not direct and primary purpose but indirect, secondary or conditional purpose. God did not design that man should sin; but He did design that if they sinned they should be without excuse.” Lenski argues strongly for result: if it were purpose, “the purpose would be monstrous”; if it be regarded as conditional, then “Paul left out an essential point—a thing he never does.” But this is not the way it appears to quite a few commentators. Thus Nygren says, “according to Paul it is actually the will of God that he who turns away from God be without excuse”. Cf. Turner, here “it is better to retain the usual near-final meaning of εἰς τό, whatever theologians may say: i.e. RV text is correct against RSV and NEB” (M, III, p. 143; in "), _c('em', [_vm._v("Grammatical Insights,")]), _vm._v(" pp. 12-13 he argues that the construction does not always express “the result of strict causality” in Romans). Cranfield, Burton, Lagrange, Hendriksen, etc., however, favor result.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_226",
      "id": "foot-226"
    }
  }, [_vm._v("226")]), _vm._v(". Cf. Barclay, “In the world we can see God. It is Paul’s argument—and it is completely valid—that if we look at the world "), _c('em', [_vm._v("suffering follows sin.")]), _vm._v(" Break the laws of agriculture—the harvest fails. Break the laws of architecture—your building collapses. Break the laws of health—your body suffers. Paul was saying ‘Look at the world! See how it is constructed! From a world like that you know what God is like.’ The sinner is left without excuse.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_227",
      "id": "foot-227"
    }
  }, [_vm._v("227")]), _vm._v(". The tenses in this section are mostly aorist, but GNB consistently uses the present: “The force of the Greek aorist in this context is to indicate that these actions are typical of what men have done at all times throughout history; for the English reader the present tense is more natural in expressing such events” (ΤΗ). I doubt whether this is justified.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_228",
      "id": "foot-228"
    }
  }, [_vm._v("228")]), _vm._v(". διότι = because. It explains the previous statement (and covers v. 21-23).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_229",
      "id": "foot-229"
    }
  }, [_vm._v("229")]), _vm._v(". The aorist participle γνόντες means “having come to know”. This preceded their failure and made it more blameworthy. The knowledge of God in the sense of v. 20 is in mind, not a knowledge like that of John 17:3. Paul makes a good deal of the concept of knowledge. He uses γινώσϰω a total of 50 times. John uses it 56 times, while another 26 occurrences are in the Joh’annine epistles. It is thus very much a Pauline and Johannine word (221 times in the New Testament).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_230",
      "id": "foot-230"
    }
  }, [_vm._v("230")]), _vm._v(". δοξάζω is another word Paul shares with John: Paul has it 12 times, John 23 times; next is Luke with nine. Paul uses the corresponding noun, δόξα, 77 times, so it is clear that he is quite interested in glory.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_231",
      "id": "foot-231"
    }
  }, [_vm._v("231")]), _vm._v(". ὡς θεόν receives emphasis both from its position and from coming so soon after τὸν θεόν.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_232",
      "id": "foot-232"
    }
  }, [_vm._v("232")]), _vm._v(". He uses εὐχα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστέω 24 times out of its 38 New Testament occurrences, and the corresponding noun 12 times out of 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_233",
      "id": "foot-233"
    }
  }, [_vm._v("233")]), _vm._v(". Cf. Dodd, “their attitude to life and the world is an irreligious one, though the impulse to religion was present in the very "), _c('em', [_vm._v("data")]), _vm._v(" of life and the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_234",
      "id": "foot-234"
    }
  }, [_vm._v("234")]), _vm._v(". The strong adversative ἀλλ’ (in Paul 311 times out of 635 times in the New Testament; Romans has it 69 times).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_235",
      "id": "foot-235"
    }
  }, [_vm._v("235")]), _vm._v(". διαλογισμός. Cf. G. Schrenk, “The sense of ‘evil thoughts’ is predominant in the NT…. In view of the more flexible LXX usage, it is striking that the NT uses διαλογισμός only in the negative sense for evil thoughts or anxious reflection” (TDNT, II, p. 97). W. F. Howard cites H. A. A. Kennedy for the view that ἐν here is causal; he cites this verse among passages meaning “because of, by reason of, for the sake of” (M, II, p. 463).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_236",
      "id": "foot-236"
    }
  }, [_vm._v("236")]), _vm._v(". The verb is ματαιόω (used of turning to idolatry in LXX of Jer. 2:5). The μάταιος word group is especially characteristic of Paul. For its meaning cf. Ο. Bauernfeind, who notes that it is “what is against the norm, unexpected, offending what ought to be. ϰενός means worthless, because without content, μάταιος worthless because deceptive or ineffectual” (TDNT, IV, p. 519). μάταιος is used of idols in Acts 14:15 (cf. 2 Kings 17:15; Amos 2:4, LXX).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_237",
      "id": "foot-237"
    }
  }, [_vm._v("237")]), _vm._v(". Cf. Shedd, “The relation between sin and mental blindness is that of action and re-action. Each is alternately cause and effect.” Parry comments, “missing the true aim, they lost the true light.” Salvation means rescue from darkness (cf. Col. 1:13).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_238",
      "id": "foot-238"
    }
  }, [_vm._v("238")]), _vm._v(". ἀσύνετος is from alpha-privative and σύνετος, and σύνετος from συνιέναι, "), _c('em', [_vm._v("“bring")]), _vm._v(" or "), _c('em', [_vm._v("set together”")]), _vm._v(" (LSJ).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_239",
      "id": "foot-239"
    }
  }, [_vm._v("239")]), _vm._v(". ϰα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("δία. The singular is used here in a distributive sense. “Contrary to normal Greek and Latin practice, the NT sometimes follows the Aram, and Heb. preference for a distributive sing.” (M, III, p. 23). Paul has the singular here, but he prefers the plural of ϰα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("δία in such constructions (20 times including a quotation from LXX; he has the singular eight times; also in some MSS of Col. 3:16). In Romans the only other passage Turner includes with the singular in this construction is that with σῶμα in 8:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_240",
      "id": "foot-240"
    }
  }, [_vm._v("240")]), _vm._v(". Cf. Godet, “all the labour of the sages did not prevent the most civilized nations, Egyptians, Greeks, Romans from being at the same time the most idolatrous of antiquity.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_241",
      "id": "foot-241"
    }
  }, [_vm._v("241")]), _vm._v(". φάσϰω, which Paul uses only here (its only other New Testament occurrences are in Acts 24:9; 25:19). It is cognate with φήμι. The construction is an example of the omission of the subject with a dependent infinitive when it is identical with that of the main verb. We should also notice that the predicate σοφοί is nominative even though it goes with the infinitive, since it refers to the main subject (cf. Turner, M, III, p. 146; BDF 405).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_242",
      "id": "foot-242"
    }
  }, [_vm._v("242")]), _vm._v(". ἐμω"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άνθησαν. In the classics the word signifies “to be foolish” (LSJ); in the New Testament it means “to make foolish” (or “flat” or “tasteless”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_243",
      "id": "foot-243"
    }
  }, [_vm._v("243")]), _vm._v(". ἀλλάσσω = “to other”, either by exchanging (as here) or by transforming. The construction is normally ἀ. τί τινος or ἀ. τί ἀντί τινος. ἐν is unusual. It may be instrumental (“they ‘othered’ God by means of images”) or an imitation of the Hebrew "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ה")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("י")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("מ")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("י")]), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ר")]), _vm._v(" "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("ב")]), _vm._v(" (as in Ps. 106:20). A number of scholars agree that the construction is Hebraic but point to the same thing in Sophocles (e.g., BDF 179 [2]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_244",
      "id": "foot-244"
    }
  }, [_vm._v("244")]), _vm._v(". In the manner of Isa. 40:19-20; 44:9-20 the author of Wisdom ridicules the idolater. He speaks of the woodcutter as making something useful from the wood of a tree: “But a castoff piece from among them, useful for nothing, a stick crooked and full of knots” he shapes in his leisure time into the likeness of a man or animal, “giving it a coat of red paint and coloring its surface red and covering every blemish in it with paint”. He makes a niche for it: “So he takes thought for it, that it may not fall, because he knows that it cannot help itself…. For health he appeals to a thing that is weak; for life he prays to a thing that is dead; for aid he entreats a thing that is utterly inexperienced; for a prosperous journey, a thing that cannot take a step; for money-making and work and success with his hands he asks strength of a thing whose hands have no strength” (Wis. 13:11-14). Such polemic effectively illustrates the point Paul is making—the folly of idol worship.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_245",
      "id": "foot-245"
    }
  }, [_vm._v("245")]), _vm._v(". ἄφθα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("τος. It occurs four times in Paul and three times in 1 Peter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_246",
      "id": "foot-246"
    }
  }, [_vm._v("246")]), _vm._v(". ὁμοιώματι εἰϰόνος. The former word is Pauline in five of its six New Testament occurrences, four being in Romans; the latter is Pauline nine times, while Revelation has it 20 times and no other New Testament writing more than once, εἰϰών can be used of the “likeness” of the Emperor on a coin, but it is also used often of an image, as here. G. Kittel sees ὁμοίωμα as the copy and εἰϰών as what is copied, to give the meaning “the copy of the figure of men and animals” (TDNT, II, p. 395). Käsemann, however, sees the distinction as pedantic (p. 45). Boylan sees perhaps an identity, “a likeness which is an idol”. Better is Barrett’s view, “the mere shadowy image”. He comments, “Perhaps he uses the two words but means no more than either would have suggested separately; perhaps (as the translation suggests) the reduplication emphasizes the inferior, shadowy character of that which is substituted for God.” Morna Hooker has an article, “Adam in Romans 1” (NTS, VI [1959-60], pp. 297-306), in which she draws attention to a number of links between Paul’s language in this chapter and the Adam story. Specifically she says, “our examination has lent additional weight to C. K. Barrett’s point that the words convey the impression of the shadowy nature of that which is substituted for God” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 303). She has a further note (NTS, XIII [1966-67], pp. 181-83) in which she argues that Ps. 106 is behind the present passage and the following verses. Harold Roberts also argues that we must see the Genesis reference to “image” as the background to this passage (ET, LXI [1949-50], pp. 74-77).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_247",
      "id": "foot-247"
    }
  }, [_vm._v("247")]), _vm._v(". ϕθα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("τός, “perishable, corruptible” (AS). Cf. also D. J. W. Milne, “Genesis 3 in the Letter to the Romans”, RThR, XXXIX (1980), pp. 10-18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_248",
      "id": "foot-248"
    }
  }, [_vm._v("248")]), _vm._v(". William Baird sums it up this way: “The act of God which ought to be most meaningful to the pagan, then, is creation, for this has to do with the very nature of man himself. Here perceptive man should see that he is creature, that his very existence is dependent upon the Creator. Yet man has sinned; he has rejected this revelation; he has turned from the Creator to the creature” "), _c('em', [_vm._v("(Paul’s Message and Mission")]), _vm._v(" [New York, 1960], p. 35).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_249",
      "id": "foot-249"
    }
  }, [_vm._v("249")]), _vm._v(". In Wis. 14:27 the worship of idols is “the beginning and cause and end of every evil.” Like Paul, the writer has a long list of specific sins associated with idolatry.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_250",
      "id": "foot-250"
    }
  }, [_vm._v("250")]), _vm._v(". διό is another word of which Paul is fond; he uses it 27 times out of its 53 New Testament occurrences.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_251",
      "id": "foot-251"
    }
  }, [_vm._v("251")]), _vm._v(". πα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("αδίδωμι means “to give or hand over”. It is used for a number of ways of viewing the giving of Jesus over to his death. See the note on 8:32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_252",
      "id": "foot-252"
    }
  }, [_vm._v("252")]), _vm._v(". Turner comments, “There may be a causal ἐν in Ro 1"), _c('sup', [_vm._v("24")]), _vm._v(" "), _c('em', [_vm._v("(because of the lusts of their hearts)”")]), _vm._v(" (M, III, p. 262). Or the meaning may be, “immersed in their lusts”; cf. Lenski, “God finds them "), _c('em', [_vm._v("in")]), _vm._v(" these lusts and so hands them over "), _c('em', [_vm._v("to")]), _vm._v(" uncleanness.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_253",
      "id": "foot-253"
    }
  }, [_vm._v("253")]), _vm._v(". ἐπιθυμία is Pauline in exactly half its New Testament occurrences (19 out of 38). It denotes strong desire, occasionally for good (e.g., 1 Thess. 2:17), but usually for evil, so that it frequently means “lust”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_254",
      "id": "foot-254"
    }
  }, [_vm._v("254")]), _vm._v(". εἰς ἀϰαθα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("σίαν. Paul uses the noun in no less than nine of its ten New Testament occurrences. It is linked with πο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("νεία in 2 Cor. 12:21; Gal. 5:19; Eph. 5:3; Col. 3:5. Paul is probably not unmindful of the sexual immorality that was such a common accompaniment of idol worship. But the term is a wide one and will not be limited to this.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_255",
      "id": "foot-255"
    }
  }, [_vm._v("255")]), _vm._v(". τοῦ + infinitive probably expresses result here. The construction is found 23 times in Luke, 21 times in Acts, and 13 times in Paul. Elsewhere Matthew has it six times, Hebrews twice, and James, 1 Peter, and Revelation once each. It is thus Lukan and to a less extent Pauline. In Greek writers generally it denotes purpose, but Moulton finds no certain example of purpose in Paul (though purpose is possible in some passages; M, I, pp. 216ff). “So as to” will usually express Paul’s meaning. Some take it here as purpose (Lagrange, Godet), and others see it as epexegetic (Moulton, Shedd, Murray), but we should probably see it as result (as BDF 400 [2]; BAGD ["), _c('em', [_vm._v("sub")]), _vm._v(" ὁ II.4.b. γ]; Turner [M, III, p. 141]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_256",
      "id": "foot-256"
    }
  }, [_vm._v("256")]), _vm._v(". The form ἀτιμάζεσθαι could be either middle or passive. Cranfield points out that the use of this verb in the middle is not found in ancient Greek and prefers to see it as passive, a view which should probably be accepted. But Lenski asks, “Who does this dishonoring?” It cannot be God; it must be the people themselves. He reasons, then, that if we take the verb as passive, it must be in the sense of the middle. Murray sees it as passive, “that their bodies should be dishonored among themselves”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_257",
      "id": "foot-257"
    }
  }, [_vm._v("257")]), _vm._v(". NIV’s "), _c('em', [_vm._v("with one another")]), _vm._v(" is based on accepting ἐν ἑαυτοῖς (with D"), _c('sup', [_vm._v("c")]), _vm._v(" E F G Κ L Ρ etc.), a view supported by RSV, GNB, and others. Hodge sees the possibility of accepting this reading and taking it as equivalent to ἐν ἀλλήλοις (cf. v. 27), i.e., “they dishonored one another, as to their bodies”. However, there seems good reason for accepting ἐν αὐτοῖς (with "), _c('span', {
    staticClass: "hebrew"
  }, [_vm._v("א")]), _vm._v(" A Β C D* etc.), which gives the sense “among them” (so SH, Cranfield, UBS, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_258",
      "id": "foot-258"
    }
  }, [_vm._v("258")]), _vm._v(". Cf. Num. 25:1-2. We see the idea also in the Wisdom of Solomon: “the idea of making idols was the beginning of fornication” (Wis. 14:12).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_259",
      "id": "foot-259"
    }
  }, [_vm._v("259")]), _vm._v(". There is a dispute about connections here. Cranfield starts a new paragraph with v. 25 (though noting that SH, Lagrange, and Michel connect it with v. 24), since v. 24 already has been given a reason by its διό, which looks back to vv. 22-23. Further, διὰ τοῦτο (v. 26) connects with vv. 25 and 26. He renders οἵτινες “They actually” (with the other division it would mean “seeing that they”). The reasons he gives for separating v. 25 from v. 24, however, scarcely seem adequate. It is better to retain the more usual division. The relative of quality is frequent in Paul (44 times), almost always in the nominative. BAGD class it here under the heading “to emphasize a characteristic quality, by which a preceding statement is to be confirmed” and translate “since indeed they had exchanged”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_260",
      "id": "foot-260"
    }
  }, [_vm._v("260")]), _vm._v(". “Exchanged” here renders μετήλλαξαν (in the New Testament only here and in v. 26), which scarcely differs from ἢλλαξαν in v. 23. The same construction with ἐν is found there as here.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_261",
      "id": "foot-261"
    }
  }, [_vm._v("261")]), _vm._v(". Käsemann comments, “ἀλήθεια again means the self-disclosing reality of God, not an attribute of God nor his ‘true nature.’ Hence τò ψεῦδος is not the false conduct of man, nor abstractedly the false god, but the deception which objectively conceals the truth, especially in Gentile religion” (p. 48). Parry sees the expression as comprehensive, “the truth about God and themselves and their relation to Him”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_262",
      "id": "foot-262"
    }
  }, [_vm._v("262")]), _vm._v(". For idolatry as ψεῦδος cf. Isa. 44:20; Jer. 13:25; as ψευδής cf. Jer. 10:14; 16:19.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_263",
      "id": "foot-263"
    }
  }, [_vm._v("263")]), _vm._v(". ἐσεβάσθησαν. The usual word is σἐβομαι, but no difference of meaning is apparent.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_264",
      "id": "foot-264"
    }
  }, [_vm._v("264")]), _vm._v(". λατ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("εύω meant originally “serve for hire” (λάτ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ον) and then generally “to serve” either gods or people. It was used alike of the service of slaves and free people.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_265",
      "id": "foot-265"
    }
  }, [_vm._v("265")]), _vm._v(". πα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ά in the sense “rather than”, “instead of” (BAGD III.3; Cranfield doubts whether all the instances cited are acceptable, but agrees for this passage). Cf. Luke 18:14. Phillips has “instead of” the Creator.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_266",
      "id": "foot-266"
    }
  }, [_vm._v("266")]), _vm._v(". Barth sees something like this still, for “In their general view of the world scientists and historians are in far closer agreement with philosophers and theologians than is normally recognized. It is not merely that the world exists side by side with God: it has taken His place, and has itself become God, and demands ‘the same devotion which the old-fashioned believer offered to his God’ (Dr. F. Strauss).”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_267",
      "id": "foot-267"
    }
  }, [_vm._v("267")]), _vm._v(". εὐλογητός. The form of the verbal adjective might give the meaning “capable of being blessed”, but the usage of the verb shows that it means simply “blessed”. In the Old Testament it may be used of blessing people (e.g., Gen. 12:2; 1 Sam. 15:13), but in the New it always refers to God or Christ (μαϰά"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιος is the word for people, 4:7, 8; 14:22). As to its meaning, H. W. Beyer says, “We best bring out its religious significance along the lines of Luther that God is praised in Himself but that we pray here that He may be praised among us” (TDNT, II, p. 764).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_268",
      "id": "foot-268"
    }
  }, [_vm._v("268")]), _vm._v(". εἰς τοὺς αἰῶνας, “into the ages”. Paul uses the noun 38 times, so it is a congenial term. Sometimes he uses the singular “into the age” (1 Cor. 8:13; 2 Cor. 9:9), but he prefers the plural (9:5; 11:36; 2 Cor. 11:31), while he uses the more sonorous εἰς τοὺς αἰῶνας τῶν αἰώνων (16:27, vl.; Gal. 1:5; Phil. 4:20; 1 Tim. 1:17; 2 Tim. 4:18; all these are doxologies). Behind all these forms is the idea that the present age is to be followed by a final age or ages. Anything that lasts from now into that age (or ages) lasts “forever”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_269",
      "id": "foot-269"
    }
  }, [_vm._v("269")]), _vm._v(". ἀμήν is the transliteration of a Hebrew expression of which A. Jepsen says, “The form of this word is qa"), _c('span', {
    staticClass: "charis"
  }, [_vm._v("ṭ")]), _vm._v("il, which could suggest an adjectival meaning. However, the use of this word in certain passages suggests that it is to be interpreted as a particle, so that no certain conclusion can be drawn about the meaning of "), _c('em', [_vm._v("‘amen")]), _vm._v(" from its form” (TDOT, I, p. 320). It was used to give assent to what someone else had said, and specifically it was used liturgically as the assent of the congregation to a prayer uttered by the leader of worship.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_270",
      "id": "foot-270"
    }
  }, [_vm._v("270")]), _vm._v(". διὰ τοῦτο.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_271",
      "id": "foot-271"
    }
  }, [_vm._v("271")]), _vm._v(". πάθη ἀτιμίας, where the genitive is a genitive of quality, πάθος is found three times in the New Testament, all in Paul. BAGD define the word as “1. that which is endured or experienced, "), _c('em', [_vm._v("suffering")]), _vm._v(" … 2. "), _c('em', [_vm._v("passion …")]), _vm._v(" esp. of a sexual nature”, here “disgraceful passions”. GT sees it as the passive side of a vice, whereas ἐπιθυμία is the active: “ἐπ. is (evil) desire, π. ungovernable desire”. See further my NICNT commentary on 1 and 2 Thessalonians, pp. 124-25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_272",
      "id": "foot-272"
    }
  }, [_vm._v("272")]), _vm._v(". For χ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ῆσις used of sexual relations see BAGD 3. It occurs only in vv. 26 and 27 in the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_273",
      "id": "foot-273"
    }
  }, [_vm._v("273")]), _vm._v(". For πα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ά in the sense “instead of” see n. 265 above.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_274",
      "id": "foot-274"
    }
  }, [_vm._v("274")]), _vm._v(". Paul uses both ϕυσιϰός, “natural”, and ϕύσις, “nature”, more than anyone else in the New Testament (the former two out of three times; the latter 11 out of 12). ϕύσις is connected with ϕύω, “grow”, and indicates “what things grow into”, “essential nature”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_275",
      "id": "foot-275"
    }
  }, [_vm._v("275")]), _vm._v(". τε … τε “places the elements so connected in a parallel relationship (often = ‘as … so’)” (BDF 444 [1]; here they prefer the variant δἐ, perhaps wrongly).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_276",
      "id": "foot-276"
    }
  }, [_vm._v("276")]), _vm._v(". ἀϕίημι.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_277",
      "id": "foot-277"
    }
  }, [_vm._v("277")]), _vm._v(". ἐϰϰαίω and ὄ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("εξις (cf. ὀ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ἐγω, “to stretch out” [AS]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_278",
      "id": "foot-278"
    }
  }, [_vm._v("278")]), _vm._v(". Barclay makes the point that what Paul says is all documented in Roman writers: “There is nothing that Paul said about the heathen world that the heathen moralist "), _c('em', [_vm._v("(sic)")]), _vm._v(" had not themselves already said. And vice did not stop with the crude and natural vices. Society from top to bottom was riddled with unnatural vice.” He adds, “Fourteen out of the first fifteen Roman Emperors were homosexuals.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_279",
      "id": "foot-279"
    }
  }, [_vm._v("279")]), _vm._v(". The verb ϰατε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γάζομαι is frequent in Romans (11 times; in Paul 20 out of 22 times in the New Testament). In form it is stronger than ἐ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γάζομαι (having ϰατά perfective prefixed), giving meanings like “carry out”, “accomplish”. But in practice the two verbs are often synonymous.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_280",
      "id": "foot-280"
    }
  }, [_vm._v("280")]), _vm._v(". ἀσχημοσύνη is a strong word. Elsewhere in the New Testament it occurs only in Rev. 16:15; there it refers to the private parts.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_281",
      "id": "foot-281"
    }
  }, [_vm._v("281")]), _vm._v(". ἀντιμισθία is found only in the New Testament and Christian authors. The preposition stresses the idea of requital.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_282",
      "id": "foot-282"
    }
  }, [_vm._v("282")]), _vm._v(". ἔδει. Paul and Luke are the great users of this verb. It occurs 102 times in the New Testament—18 in Luke, 22 in Acts, and 25 in Paul. But it is not prominent in Romans (three times).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_283",
      "id": "foot-283"
    }
  }, [_vm._v("283")]), _vm._v(". ϰαθώς, a frequent word in Paul (84 times out of 178 in the New Testament). It means “just as” = “since” (BDF 453 [2]).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_284",
      "id": "foot-284"
    }
  }, [_vm._v("284")]), _vm._v(". δοϰιμάζω is found in Paul 17 times out of 22 in the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_285",
      "id": "foot-285"
    }
  }, [_vm._v("285")]), _vm._v(". The noun is ἐπίγνωσις (in Paul 15 times out of 20 in the New Testament). It may denote knowledge directed towards (ἐπί) a particular object but in usage does not differ significantly from γνῶσις. It is the combination ἔχειν ἐν ἐπιγνώσει that is striking and significant.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_286",
      "id": "foot-286"
    }
  }, [_vm._v("286")]), _vm._v(". It is not easy to bring out in English the wordplay ἐδοϰίμασαν… ἀδόϰιμον. The effect is to indicate that there was nothing arbitrary about their punishment. Cf. Denney, “As they did not think fit, after trial made … to keep God in their knowledge, God gave them up to a mind which cannot stand trial”. Paul took care that he himself should not be ἀδόϰιμος (1 Cor. 9:27).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_287",
      "id": "foot-287"
    }
  }, [_vm._v("287")]), _vm._v(". Cf. C. S. Lewis, “In creating beings with free will, omnipotence from the outset submits to the possibility of such defeat. What you call defeat, I call miracle: for to make things which are not Itself, and thus to become, in a sense, capable of being resisted by its own handiwork, is the most astonishing and unimaginable of all the feats we attribute to the Deity. I willingly believe that the damned are, in one sense, successful, rebels to the end; that the doors of hell are locked on the "), _c('em', [_vm._v("inside.")]), _vm._v(" I do not mean that the ghosts may not "), _c('em', [_vm._v("wish")]), _vm._v(" to come out of hell, in the vague fashion wherein an envious man ‘wishes’ to be happy: but they certainly do not will even the first preliminary stages of that self-abandonment through which alone the soul can reach any good. They enjoy forever the horrible freedom they have demanded, and are therefore self-enslaved” "), _c('em', [_vm._v("(The Problem of Pain")]), _vm._v(" [London, 1943], pp. 115-16). Both God’s activity and man’s are involved, and either can receive the stress in a given passage. Here God’s act is emphasized.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_288",
      "id": "foot-288"
    }
  }, [_vm._v("288")]), _vm._v(". Cf. Foreman, “The worst penalty for sin is to love sin”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_289",
      "id": "foot-289"
    }
  }, [_vm._v("289")]), _vm._v(". The Stoic moralists used τò ϰαθῆϰον as a technical term for what is seemly. H. Schlier points out that Paul is not using the exact technical term, for “what is contrary to ϰαθῆϰον is always τò πα"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ὰ τò ϰαθῆϰον” (TDNT, III, p. 440). He gives Paul’s meaning as “that which is offensive to man even according to the popular moral sense of the Gentiles, i.e., what even natural human judgment regards as vicious and wrong.” Paul’s expression is not found elsewhere in the New Testament, but there are similar words in Acts 22:22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_290",
      "id": "foot-290"
    }
  }, [_vm._v("290")]), _vm._v(". For Paul’s use of negatives see on v. 13. This is his first use of μή.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_291",
      "id": "foot-291"
    }
  }, [_vm._v("291")]), _vm._v(". He has lists of vices in 13:13; 1 Cor. 5:10-11; 6:9-10; 2 Cor. 12:20; Gal. 5:19-21; Eph. 4:19, 31; 5:3-5; Col. 3:5, 8; 1 Tim. 1:9-10; 6:4-5; 2 Tim. 3:2-5; Tit. 3:3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_292",
      "id": "foot-292"
    }
  }, [_vm._v("292")]), _vm._v(". The way to group the vices in the list is a matter of dispute. Some even hold that there is no order; Paul has simply put down unconnected vices as they occurred to him. Minor variations in word order in the MSS only compound the problem. Thus some MSS read πο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("νεία in v. 29 (cf. KJV), but this should be rejected; the attestation is insufficient and the vice has already been covered. Paul begins with πεπλη"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ωμένοις, and attaches four vices to it (each is in the dative, giving the meaning “filled with”). Then comes μεστούς, followed by five more (each in the genitive, “full of”). Next is a group of 12 (in the accusative in apposition to αὐτούς). Some take the last four as a subgroup or a group of their own (each begins with alpha-privative). It is possible to see further groupings, e.g., by taking some consecutive terms together, such as “god-hated insolents” (v. 30). What is clear is that Paul has constructed his list with some care. He may have meant such refinements as the last-mentioned, but we cannot be sure. Of the 4-5-12 division we can be certain, but it is difficult to go beyond that. There are no references to sexual sin in the list, but these have been dealt with earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_293",
      "id": "foot-293"
    }
  }, [_vm._v("293")]), _vm._v(". πεπλη"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ωμένοις may go with αὐτούς, “He gave them up, filled with all unrighteousness”, or with ποιεῖν, “so that, filled with all unrighteousness, they should do….” There is not a great deal of difference.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_294",
      "id": "foot-294"
    }
  }, [_vm._v("294")]), _vm._v(". ἀδιϰία is here “put first in the list of offences as ‘violation of the divine law and its norm’” (G. Schrenk, TDNT, I, p. 155).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_295",
      "id": "foot-295"
    }
  }, [_vm._v("295")]), _vm._v(". πονη"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ία and ϰαϰία. It is perhaps worth noting that πονη"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ός, the adjective corresponding to the first term, is commonly used of Satan, who is “the evil one”, and that it occurs in the Lord’s Prayer, “deliver us from evil” (Matt. 6:13).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_296",
      "id": "foot-296"
    }
  }, [_vm._v("296")]), _vm._v(". G. Harder notices a number of suggested distinctions between the two words and rejects them all. He points out that both terms occur in LXX as translations for the same Hebrew words. “The translators of the various books show preferences for the one term or the other but no fundamental distinction is made between πονη"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ία and ϰαϰία” (TDNT, VI, p. 564). BAGD class ϰαϰία here under the heading, “a special kind of moral inferiority … someth. like "), _c('em', [_vm._v("malice, ill-will, malignity”.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_297",
      "id": "foot-297"
    }
  }, [_vm._v("297")]), _vm._v(". πλεονεξία, from πλἐον + ἔχω, means, in the first instance, “having more” (i.e., than one’s fair share), “receiving more”, then “the desire to have more”. In the New Testament this word and its two cognates are basically Pauline (15 out of 19 occurrences). G. Delling holds that here it is “one of the basic facts in which the total abandonment of the human race by God works itself out. It occurs in a group of four nouns which comprehensively describe the power of sin in the ravaging of human relationships” (TDNT, VI, p. 272). Covetousness is idolatry (Col. 3:5), and the covetous person an idolater (Eph. 5:5; cf. 1 Cor. 5:10, 11; 6:9-10). All this is to be seen in the context of Jesus’ words about the impossibility of serving God and mammon (Luke 16:13). MM cite examples of the word, including one in an “illiterate” papyrus, and speak of it as “a true vernacular word”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_298",
      "id": "foot-298"
    }
  }, [_vm._v("298")]), _vm._v(". μεστός, “full”, may refer to material objects (John 19:29; 21:11), but it is also used metaphorically (Matt. 23:28; Rom. 15:14, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_299",
      "id": "foot-299"
    }
  }, [_vm._v("299")]), _vm._v(". ϕθόνου and ϕόνου are apparently placed beside one another because of the similarity in sound. But we should not overlook the fact that envy can lead to murder; there is a connection.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_300",
      "id": "foot-300"
    }
  }, [_vm._v("300")]), _vm._v(". ἔ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ις signifies “strife, wrangling, contention” (AS). MM cite it in a papyrus of the second century "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("B.C")]), _vm._v(". They translate, “know that I have a heart unconquerable when hate takes hold upon me”, an interesting example of that glorying in sin which Paul is deploring. In the New Testament the word is confined to Paul (nine times).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_301",
      "id": "foot-301"
    }
  }, [_vm._v("301")]), _vm._v(". δόλος is used of craftiness or deceit in LXX as in the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_302",
      "id": "foot-302"
    }
  }, [_vm._v("302")]), _vm._v(". W. Grundmann, TDNT, III, p. 485. The term is ϰαϰοήθεια. SH, Michel, and others, following Aristotle, see it as “the tendency to put the worst construction upon everything”. Cranfield, however, rejects this as “clearly a special connotation” and favors “its ordinary general sense of ‘malice’, ‘malignity’, ‘spite’”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_303",
      "id": "foot-303"
    }
  }, [_vm._v("303")]), _vm._v(". ψιθυ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστής. Theodoret, the fifth-century commentator, takes the term to mean “those who whisper in the ear and speak ill of some who are present”, while he sees ϰαταλάλους as “those who unscrupulously make false accusations against those who are absent”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_304",
      "id": "foot-304"
    }
  }, [_vm._v("304")]), _vm._v(". ϰαταλάλους. Both this word and the preceding ψιθυ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστάς are found only here in the New Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_305",
      "id": "foot-305"
    }
  }, [_vm._v("305")]), _vm._v(". θεοστυγεῖς.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_306",
      "id": "foot-306"
    }
  }, [_vm._v("306")]), _vm._v(". Cf. Calvin, “The word θεοστυγεῖς undoubtedly means "), _c('em', [_vm._v("haters of Cod,")]), _vm._v(" for there is no reason to take it in its passive sense "), _c('em', [_vm._v("(hated by God),")]), _vm._v(" since Paul is here proving men’s guilt by their obvious wickedness.” Turner argues that “we should take the word passively in a subjective, not an objective sense: "), _c('em', [_vm._v("out of favour with God”")]), _vm._v(" (M, III, p. 234). But he appears to be arguing simply from the form of the word and taking no account of context. Some solve the problem by taking the term closely with the following words to give the sense, “god-hated insolents” (e.g., Lenski). Others appeal to its use in 1 Clement, but that passage is not very helpful, as Kirsopp Lake’s translation shows. Clement speaks of casting away “evil-speaking, hatred of God (θεοστυγίαν), pride…. For those who do these things are hateful to God (στυγητοὶ τῷ θεῷ)” (1 Clem, xxxv.5-6).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_307",
      "id": "foot-307"
    }
  }, [_vm._v("307")]), _vm._v(". Cranfield points to its use in classical Greek tragedy for the insolent pride that brings νέμεσις, “the retribution of the gods”, upon the person who exercises it. According to G. Bertram, ὑβ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστής “denotes a man who, sinfully overestimating his own powers and exaggerating his own claims, is insolent in word and deed in relation to gods and men” (TDNT, VIII, p. 296). Here he takes it closely with θεοστυγείς and says, “The expression θεοστυγείς ὑβ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστάς presupposes rebellion against God, for the reference is to the disruption of human fellowship as a result of ungodliness” "), _c('em', [_vm._v("(ibid.,")]), _vm._v(" p. 306). Paul had formerly been ὑβ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ιστής (1 Tim. 1:13).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_308",
      "id": "foot-308"
    }
  }, [_vm._v("308")]), _vm._v(". ὑπε"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ήϕανος may be used in a good sense, “pre-eminent, splendid” (AS). But in Scripture it is always used in the sense “arrogant”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_309",
      "id": "foot-309"
    }
  }, [_vm._v("309")]), _vm._v(". ἀλαζών is connected with ἂλη, "), _c('em', [_vm._v("“wandering")]), _vm._v(" or "), _c('em', [_vm._v("roaming")]), _vm._v(" without home or hope of rest” (LSJ). The transition from wanderer to vagrant to charlatan to boaster is a series of easy steps.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_310",
      "id": "foot-310"
    }
  }, [_vm._v("310")]), _vm._v(". ἐϕευ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ετὰς ϰαϰῶν (Moffatt, “inventive in evil”). Cf. the address to Antiochus Epiphanes, “you who have contrived all sorts of evil (πάσης ϰαϰίας εὑ"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("ετής) against the Hebrews” (2 Mace. 7:31).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_311",
      "id": "foot-311"
    }
  }, [_vm._v("311")]), _vm._v(". ἀσύνετος means "), _c('em', [_vm._v("“senseless, foolish,")]), _vm._v(" implying also a lack of high moral quality” (BAGD); cf. Manson, “‘Foolish’ implies lack of conscience even more than of common sense”.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_312",
      "id": "foot-312"
    }
  }, [_vm._v("312")]), _vm._v(". ἀσύνθετος, here only in the New Testament, means not keeping συνθῆϰαι, “covenant-breaking”. The term is used of faithless Judah in Jer. 3:7 (LXX).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_313",
      "id": "foot-313"
    }
  }, [_vm._v("313")]), _vm._v(". ἀστό"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γους. It means “people lacking στο"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("γή”, a term for love which does not occur in the New Testament (for its meaning see my "), _c('em', [_vm._v("Testaments of Love")]), _vm._v(" [Grand Rapids, 1981], pp. 114-17). But this passage, along with 2 Tim. 3:3, shows that the virtue it denotes was prized. It is the love that binds people in a natural grouping, notably the family. Many draw attention to the fact that in the pagan world it was an accepted practice to expose babies whom the parents did not wish to keep. Such killing forms an excellent illustration of the meaning of Paul’s word. The Christians repudiated all such practices.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_314",
      "id": "foot-314"
    }
  }, [_vm._v("314")]), _vm._v(". οἵτινες denotes the class. Cf. Parry, “οἵτινες ϰ.τ.λ. define once more the root of the evil—rejection of known truth—here as to the fixed judgment of God on such acts and persons” (CGT).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_315",
      "id": "foot-315"
    }
  }, [_vm._v("315")]), _vm._v(". διϰαίωμα, which Paul uses five times in Romans (ten times in the New Testament). AS says that it means “a concrete expression of righteousness, the expression and result of the act of διϰάιωσις, ‘a declaration that a thing is δίϰαιον, or that a person is δίϰαιος’ “. From this he derives the meanings “ordinance” and “sentence” (of acquittal or condemnation).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_316",
      "id": "foot-316"
    }
  }, [_vm._v("316")]), _vm._v(". Cf. G. Schrenk, “In Paul’s eyes it is important to emphasise that there is for the Gentiles a recognisable divine order which is to be embraced, not as a sum of commands, but (in the sing.) as the one divine will” (TDNT, II, p. 221).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_317",
      "id": "foot-317"
    }
  }, [_vm._v("317")]), _vm._v(". The word is linked with sin in 1:32; 5:12 "), _c('em', [_vm._v("(bis),")]), _vm._v(" 14, 17, 21; 6:9, 16, 21, 23; 7:5, 10, 13 ("), _c('em', [_vm._v("bis")]), _vm._v("), 24; 8:2, 6, 38; with the death of Christ in 5:10; 6:3, 5, 9; and with baptism in 6:4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_318",
      "id": "foot-318"
    }
  }, [_vm._v("318")]), _vm._v(". μόνον is found in Paul in 36 of its 66 New Testament occurrences. It is not easy to see why a word like “only” should be used more by Paul than by others, but we should notice that he uses “not only” often when he is adding another point to the preceding.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_319",
      "id": "foot-319"
    }
  }, [_vm._v("319")]), _vm._v(". Most of the verbs from v. 24 on are in the aorist, but Paul finishes the section with two present tenses, ποιοῦσιν and συνευδοϰοῦσιν. There is some emphasis on the habitual attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_320",
      "id": "foot-320"
    }
  }, [_vm._v("320")]), _vm._v(". Paul uses two words which do not greatly differ in meaning and which NIV here translates as "), _c('em', [_vm._v("do")]), _vm._v(" (ποιέω) and "), _c('em', [_vm._v("practice")]), _vm._v(" (π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άσσω). It is often said that the latter means “to do habitually” and the former simply “to do”, but this is not easy to establish from the usage of the two terms. It may perhaps be more relevant that π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άσσω is often used of actions that are blameworthy. C. Maurer points out that the verb is never used of God’s actions: “This colourless word is used only with reference to man’s action, and a predominantly negative judgment is implied.” Here he comments, “the oἱ π"), _c('span', {
    staticClass: "deja"
  }, [_vm._v("ϱ")]), _vm._v("άσσοντες of v. 32 refers to the mass of those who are rotting in the general swamp of pagan vices. On the other hand, the action of those who know God’s righteous demands involves wilful transgression, and ποιεῖν is used for this” (TDNT, VI, pp. 635, 636).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_321",
      "id": "foot-321"
    }
  }, [_vm._v("321")]), _vm._v(". O’Neill is an example of a recent scholar who sees a problem. He regards the statement as “a gloss that has crept into the text from the margin”. There is, of course, no evidence for this, and it has every appearance of a desperate determination to get rid of it.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_322",
      "id": "foot-322"
    }
  }, [_vm._v("322")]), _vm._v(". Cf. Murray, who says that when we do these things, “To put it bluntly, we are not only bent on damning ourselves but we congratulate others in the doing of those things that we know have their issue in damnation. We hate others as we hate ourselves….”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_323",
      "id": "foot-323"
    }
  }, [_vm._v("323")]), _vm._v(". "), _c('em', [_vm._v("Interpretation,")]), _vm._v(" XXV (1971), pp. 308-9 n. 15. This footnote gives an excellent summary of much in recent discussions.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_324",
      "id": "foot-324"
    }
  }, [_vm._v("324")]), _vm._v(". Cf. Käsemann, “in biblical usage righteousness, which is essentially forensic, denotes a relation in which one is set, namely, the ‘recognition’ in which one, for example, is acknowledged to be innocent.” He adds, “In Jewish apocalyptic this understanding is applied to the verdict of justification at the last judgment” (p. 24), and he finds the eschatological approach very important. I find it difficult to go along with Käsemann’s emphasis on apocalyptic. Granted that Paul (in common with the men of Qumran) is interested in apocalyptic, it does not follow that this permeates his view of “the righteousness of God”. Closer to the facts is Günther Bornkamm’s view that, while Paul “sounds the note of apocalyptic”, the truth that the gospel is God’s power for salvation “does not fit into any apocalyptic pattern” "), _c('em', [_vm._v("(Paul")]), _vm._v(" [London, 1971], pp. 114, 115; see also T. W. Wright in "), _c('em', [_vm._v("Themelios, 7")]), _vm._v(" [1981-82], p. 10).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_325",
      "id": "foot-325"
    }
  }, [_vm._v("325")]), _vm._v(". See further my "), _c('em', [_vm._v("The Apostolic Preaching of the Cross")]), _vm._v(" (London and Grand Rapids, 1965), ch. VIII. It is perhaps worth adding that the Qumran sect on occasion produced profound sayings expressive of the grace of God in salvation. Thus in the Hymns we read, “I know (that) righteousness is Thine, that in Thy mercies there is (hope for me), but without Thy grace (destruction) without end” (Vermes, p. 186); “By Thy goodness alone is man righteous” (Vermes, p. 192); “I lean on Thy grace and on the multitude of Thy mercies, for Thou wilt pardon iniquity, and through Thy righteousness (Thou wilt purify man) of his sin” (Vermes, p. 164). Unfortunately this standpoint is not uniformly maintained; cf. the note on 1:17. H. Conzelmann has an interesting comment after quoting passages from Qumran, “Here the pious admits his sinfulness in radical fashion and knows himself to be fully dependent on God’s ‘righteousness.’ But Qumran knows no ‘from faith alone’; here justification means radical submission to the law and not liberation from it” "), _c('em', [_vm._v("(Interpretation,")]), _vm._v(" XXII [1968], p. 182).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_326",
      "id": "foot-326"
    }
  }, [_vm._v("326")]), _vm._v(". "), _c('em', [_vm._v("New Testament Questions of Today")]), _vm._v(" (London, 1969), pp. 181-82. The link between righteousness and power runs right through this discussion.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_327",
      "id": "foot-327"
    }
  }, [_vm._v("327")]), _vm._v(". "), _c('em', [_vm._v("The Christian Doctrine of Reconciliation")]), _vm._v(" (London, 1918), p. 151.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_328",
      "id": "foot-328"
    }
  }, [_vm._v("328")]), _vm._v(". BDF 163 see God as the originator. Cf. BAGD, "), _c('em', [_vm._v("“the righteousness bestowed by God.")]), _vm._v(" … In this area it closely approximates "), _c('em', [_vm._v("salvation”.")]), _vm._v(" Bruce cites H. K. Moulton’s comment on the Pidgin translation of the New Testament for New Guinea, “We salute strokes of genius such as the translation of ‘Justification’: ‘God ‘e spik em olrite’ “ (p. 74 n.2).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_329",
      "id": "foot-329"
    }
  }, [_vm._v("329")]), _vm._v(". ἐϰ θεοῦ.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_330",
      "id": "foot-330"
    }
  }, [_vm._v("330")]), _vm._v(". On 1:17 Luther remarks, “Here, too, "), _c('em', [_vm._v("‘the righteousness of God’")]), _vm._v(" must not be understood as that righteousness by which he is righteous in himself, but as that righteousness by which we are made righteous (justified) by Him”. Parry, however, comments, “‘God’s righteousness’ i.e. righteousness as belonging to the character of God and consequently required by Him in the character of men” (CGT). SH argue strongly that we should understand both senses. Denney draws attention to an important consideration favoring the position of Luther: “The righteousness of God, conceived as a Divine attribute, may have appeared to Paul the great difficulty in the way of the justification of sinful men. God’s righteousness in this sense is the sinner’s condemnation…. What is wanted (always in consistency with God’s righteousness as one of His inviolable attributes—the great point elaborated in iii.24-26) is a righteousness which, as man cannot produce it, must be from God….” The divine attribute of righteousness means opposition to all unrighteousness and is bad news for sinful man. The passage requires the sense “that righteousness by which we are made righteous.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#foot_331",
      "id": "foot-331"
    }
  }, [_vm._v("331")]), _vm._v(". So, e.g., the commentaries by D. Guthrie, M. Dibelius, J. N. D. Kelly, "), _c('em', [_vm._v("in loc.")]), _vm._v(" That it means the Old Testament is less likely."), _c('a', {
    attrs: {
      "id": "page_106"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  })])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467451444',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(139)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(141);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 141 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.a403e6440b8962d645da.js